<template>

    <div class="client-root">
      <!-- 【P120-fix】销售端（#/client）是**手机端**：手机与 PC 一律使用手机版登录样式，
         登录后也回手机端（ClientLogin 的 onClientLoginSuccess → ./client）。
         ⚠️ 不要在这里按宽度切成 PcLogin —— 那会让 PC 上误进 PC 端。 -->
    <client-login v-if="showLogin" @success="onLoginSuccess" />

      <div v-if="active==0" class="room-status-page">
        <div class="room-status-board">


        <div class="header" @click="handleDialogDate">
          <div class="header__date">
            <van-icon name="calendar-o" class="header__cal" />
            <span class="header__range">{{roomDateRangeValue[0]}} <i>~</i> {{roomDateRangeValue[1]}}</span>
          </div>
          <div class="header__btn">更换日期 <van-icon name="arrow" /></div>
        </div>
        
        <div class="store-wrap">
            <div
              class="store-item"
              :class="{ active: storeSN == item.sn }"
              @click="searchStore(item.sn)"
              v-for="item in storesData"
              :key="item.sn"
            >
            {{ item.name }}
          </div>
        </div>

        <div class="scroll-wrapper">
          <div class="scroll-content"  :style="'width:'+tableContainerWith+'px;'">
    
            <!-- 日期表头 --> 
            <div class="date-header">

              <div class="date-item"
                :class="{ today: item.isToday }"
                v-for="item in roomData['dateRange']"
                :key="item.date"
              >
                {{ item.date }}<br>{{ item.weekday }}
              </div>
        
            </div>


            <!--有合同，有定金:蓝色                1 #409EFF-->
            <!--有合同，没有支付单:黄色             2 #E6A23C-->
            <!--有合同，有支付单，确定付款:绿色     3 #67C23A -->
            <!--预留会议室:红色                    4 #F56C6C-->

            <!-- 房态列表 -->
            <div class="room-list">
                  
              <div class="room-row" v-for="(item, idx) in roomData['rooms']" :key="idx">
                <div class="room-name"> {{item.room_number}} </div>
                <div class="room-days">
                   <div class="day-cell" v-for="(item2, dIdx) in item['dateRange']" :key="dIdx">

                      <div v-for=" (item3,index,key) in item2['dateArry']">

                            <div  class="status status--empty" v-if="!item3['order']" >
                                  <span class="status--empty__txt">未使用</span>
                            </div>

                            <div @click="handlDetail(item3['order']['sn'])" v-if="item3['order'] && item3['order']['contracts'] && item3['order']['contracts']['receivables']>0"   class="status content_status_1 status_color">
                                <div class="item_name" :title="item3['order']['customer_name']">{{item3['order']['customer_name']}}</div>
                                <div class="item_name">{{item3['order']['number_people']}}人</div>
                                <div class="item_name">{{item3['order']['start_time']}}</div>
                            </div>

                            <div @click="handlDetail(item3['order']['sn'])"  v-if="item3['order'] && (!item3['order']['contracts']) && item3['order']['amount']>0"   class="status content_status_2 status_color">
                                <div class="item_name" :title="item3['order']['customer_name']">{{item3['order']['customer_name']}}</div>
                                <div class="item_name">{{item3['order']['number_people']}}人</div>
                                <div class="item_name">{{item3['order']['start_time']}}</div>

                            </div>

                            <div @click="handlDetail(item3['order']['sn'])"  v-if="item3['order'] && item3['order']['contracts'] && item3['order']['contracts']['receivables'] <= 0"   class="status content_status_3 status_color">
                                <div class="item_name" :title="item3['order']['customer_name']">{{item3['order']['customer_name']}}</div>
                                <div class="item_name">{{item3['order']['number_people']}}人</div>
                                <div class="item_name">{{item3['order']['start_time']}}</div>
                            </div>

                            <div  @click="handlDetail(item3['order']['sn'])"  v-if="item3['order'] && (!item3['order']['contracts']) && item3['order']['amount']==0"   class="status content_status_4 status_color">
                                <div class="item_name" :title="item3['order']['customer_name']">{{item3['order']['customer_name']}}</div>
                                <div class="item_name">{{item3['order']['number_people']}}人</div>
                                <div class="item_name">{{item3['order']['start_time']}}</div>
                            </div>

                      </div>

                    </div>
                </div>
              </div>

            </div>

          </div>
        </div>

        <van-dialog v-model="dialogDatePop" title="选择时间" show-cancel-button  @confirm="searchConfirm"> 
  
          <div class="dialogDate">
              <div class="dialogDateRow" @click="selectDate(0)"> <span class="dialogDateLable">开始时间</span> <span class="dialogDateValue">{{beignDate}}</span></div>
              <div class="dialogDateRow" @click="selectDate(1)"> <span class="dialogDateLable">结束时间</span> <span class="dialogDateValue">{{endDate}}</span></div>
          </div>

        </van-dialog>

        <van-popup v-model="dialogDate" round position="bottom" :style="{ height: '50%' }" >
          <van-datetime-picker
            @confirm="dateConfirm" 
            @cancel="dateCancel"
            v-model="currentDate"
            type="date"
          />
        </van-popup>

        <van-popup v-model="dialogDetail" round position="bottom" class="detail-popup" :style="{ height: '82%' }" >
          <div class="detail-sheet">
            <div class="detail-sheet__hd">
              <div class="detail-sheet__title">会议室订单详情</div>
              <van-icon name="cross" class="detail-sheet__close" @click="dialogDetail=false" />
            </div>

            <div class="detail-sheet__body">
              <!-- 客户 / 销售 概览 -->
              <div class="detail-hero">
                <div class="detail-hero__main">
                  <div class="detail-hero__name">{{orderDetailData['customers'] || '未知客户'}}</div>
                  <div class="detail-hero__sub">销售负责人：{{orderDetailData['staff'] || '-'}}</div>
                </div>
                <div class="detail-hero__actions">
                  <!-- 【P38】直达该会议室订单所在销售合同的详情页（仅当对该合同有可见权限时渲染） -->
                  <div class="detail-hero__action detail-hero__action--ghost"
                       v-if="detailCanViewContract===1" @click="openContractFromRoomOrder('detail')">销售合同</div>
                  <!-- 【P37】「编辑」按归属控制：非本人订单只读（与后端 RoomOrder::assertOwnership 同口径） -->
                  <div class="detail-hero__action" v-if="detailCanEdit===1" @click="openEditRoom">编辑</div>
                  <div class="detail-hero__action detail-hero__action--disabled" v-else-if="detailCanEdit===0">无权编辑</div>
                </div>
              </div>

              <!-- 常用联系人 -->
              <div class="detail-sec">
                <div class="detail-sec__title"><span class="detail-sec__bar"></span>常用联系人</div>
                <div v-if="orderDetailData['contact'] && orderDetailData['contact'].length" class="detail-cards">
                  <div class="detail-card" v-for="(c,ci) in orderDetailData['contact']" :key="ci">
                    <div class="detail-card__row"><span class="detail-card__label">姓名</span><span class="detail-card__val">{{c.name}}</span></div>
                    <div class="detail-card__row"><span class="detail-card__label">手机</span><span class="detail-card__val">{{c.phone}}</span></div>
                    <div class="detail-card__row"><span class="detail-card__label">微信</span><span class="detail-card__val">{{c.wx}}</span></div>
                  </div>
                </div>
                <div v-else class="detail-empty">暂无联系人</div>
              </div>

              <!-- 会议室预定信息 -->
              <div class="detail-sec">
                <div class="detail-sec__title"><span class="detail-sec__bar"></span>会议室预定信息</div>
                <div v-if="orderDetailData['orders_meeting_room'] && orderDetailData['orders_meeting_room'].length" class="detail-cards">
                  <div class="detail-card" v-for="(m,mi) in orderDetailData['orders_meeting_room']" :key="mi">
                    <div class="detail-card__head">{{m.meeting_room_name}} <em>{{m.meeting_room_room_number}}</em></div>
                    <div class="detail-card__row"><span class="detail-card__label">类型</span><span class="detail-card__val">{{m.order_type_name}}</span></div>
                    <div class="detail-card__row"><span class="detail-card__label">桌型</span><span class="detail-card__val">{{m.table_types}}</span></div>
                    <div class="detail-card__row"><span class="detail-card__label">设备</span><span class="detail-card__val">{{m.option_service}}</span></div>
                    <div class="detail-card__row"><span class="detail-card__label">日期</span><span class="detail-card__val">{{m.on_site_time}}</span></div>
                    <!-- 【P312 需求002】时间类型 / 时段 拆成两行独立字段（PC 是两个字段，H5 原挤在一行） -->
                    <div class="detail-card__row"><span class="detail-card__label">时间类型</span><span class="detail-card__val">{{m.time_type_name || '—'}}</span></div>
                    <div class="detail-card__row"><span class="detail-card__label">时段</span><span class="detail-card__val">{{m.start_time || '—'}}</span></div>
                    <!-- 【P312 需求002】人数：后端 field 里已含 number_people，此前前端未渲染 -->
                    <div class="detail-card__row"><span class="detail-card__label">人数</span><span class="detail-card__val">{{m.number_people || '—'}}</span></div>
                    <!-- 【P442】销售价格（会议室订单 t_pro_orders_meeting_room.amount）
                         H5 销售端：全员可见 —— 后端不做权限过滤，此处只判字段是否存在（运营端被后端剔除时不会渲染） -->
                    <div class="detail-card__row" v-if="m.amount !== undefined && m.amount !== null && m.amount !== ''"><span class="detail-card__label">销售价格</span><span class="detail-card__val">¥{{ m.amount }}</span></div>
                    <!-- 【P312 需求002】备注（富文本）：v-html 渲染，与 PC 的 remark 同源 -->
                    <div class="detail-card__row" v-if="m.remark">
                      <span class="detail-card__label">备注</span>
                      <span class="detail-card__val detail-rich" v-html="m.remark"></span>
                    </div>
                    <!-- 【P95】三.3.05 回款计划（后端 getOrderDetail 已挂 payment_plans） -->
                    <div class="detail-card__row" v-if="m.payment_plans && m.payment_plans.length">
                      <span class="detail-card__label">回款计划</span>
                      <span class="detail-card__val">
                        <span v-for="(p,pi) in m.payment_plans" :key="'pp-'+pi" class="detail-plan">{{ p.date || '—' }}　¥{{ p.amount || '0' }}<br></span>
                      </span>
                    </div>
                  </div>
                </div>
                <div v-else class="detail-empty">暂无预定信息</div>
              </div>

              <!-- 增值业务 -->
              <div class="detail-sec">
                <div class="detail-sec__title"><span class="detail-sec__bar"></span>增值业务</div>
                <div v-if="orderDetailData['added_services'] && orderDetailData['added_services'].length" class="detail-cards">
                  <div class="detail-card detail-card--sm" v-for="(a,ai) in orderDetailData['added_services']" :key="ai">
                    <div class="detail-card__row"><span class="detail-card__label">时间</span><span class="detail-card__val">{{a.on_date}}</span></div>
                    <div class="detail-card__row"><span class="detail-card__label">类型</span><span class="detail-card__val">{{a.value_added_services_name}}</span></div>
                    <div class="detail-card__row"><span class="detail-card__label">名称</span><span class="detail-card__val">{{a.value_added_services_goods_name}}</span></div>
                    <div class="detail-card__row"><span class="detail-card__label">数量</span><span class="detail-card__val">{{a.quantity}}</span></div>
                  </div>
                </div>
                <div v-else class="detail-empty">暂无增值业务</div>
              </div>
            </div>
          </div>
        </van-popup>


        </div>

      </div>

      <div v-if="active==1">
        <div class="customer-header" ref="custHeader">
          <div class="customer-header__top">
            <div class="customer-header__left">
              <span class="customer-header__title">客户管理</span>
            </div>
            <div class="customer-header__search">
              <el-input v-model="searchText" class="search-input" placeholder="请输入搜索内容" @change="search()">
                <i slot="prefix" class="el-icon-search"></i>
              </el-input>
            </div>
            <div class="customer-header__actions">
              <div class="customer-header__btn" @click="onSortClick">
                <i class="el-icon-s-unfold"></i>
                <span>筛选</span>
              </div>
              <div class="customer-header__btn" :class="{'customer-header__btn--primary': batchMode}" @click="toggleBatch">
                <i class="el-icon-finished"></i>
                <span>{{ batchMode ? '取消批量' : '批量' }}</span>
              </div>
              <div class="customer-header__btn customer-header__btn--primary" @click="openCustomerAdd">
                <i class="el-icon-plus"></i>
                <span>新增</span>
              </div>
            </div>
          </div>
          <!-- 批量模式：二级分类（仅管理人员）+ 全选条 -->
          <div class="batch-bar" v-if="batchMode">
            <!-- 【P140】管理人员：01 我的待接收 / 02 分配客户；普通销售不渲染，固定为「我的待接收」 -->
            <div class="batch-bar__tabs" v-if="batchIsManager">
              <div class="batch-bar__tab" :class="{'batch-bar__tab--on': batchSub==='pending'}" @click="setBatchSub('pending')">01 我的待接收</div>
              <div class="batch-bar__tab" :class="{'batch-bar__tab--on': batchSub==='assign'}" @click="setBatchSub('assign')">02 分配客户</div>
            </div>
            <van-checkbox :value="allPendingSelected" @input="toggleSelectAll">
              {{ batchSub==='pending' ? '全选待接收' : '全选本页' }}
            </van-checkbox>
            <span class="batch-bar__count">已选 {{ selectedCustomers.length }} 个</span>
          </div>
          <div class="customer-header__tabs">
            <div v-for="(tab, idx) in customerFilterTabs" :key="idx"
                 class="customer-header__tab"
                 :class="{'customer-header__tab--active': customerFilterTab.label===tab.label}"
                 @click="onCustomerFilterTabClick(tab, idx)">
              {{tab.label}}
            </div>
          </div>
          <!-- 【P204 S5】搜索条件标签集合：与商机/合同/会议室页的 .filter-status-bar 同构，
               但客户页维度更多（关键词 + 12 项高级筛选 + 销售人员），故列出**逐项标签**而非仅计数。
               —— 每一项均可单独点 × 移除；右侧「清空全部」一次性复位。 -->
          <div class="filter-status-bar filter-status-bar--tags" v-if="customerFilterTags.length>0">
            <div class="filter-status-bar__tags">
              <span class="filter-tag" v-for="(t, ti) in customerFilterTags" :key="ti">
                <span class="filter-tag__label">{{t.label}}</span>
                <i class="filter-tag__close el-icon-close" @click="removeCustomerFilterTag(t)"></i>
              </span>
            </div>
            <span class="filter-status-bar__clear" @click="clearCustomerFilter">清空全部</span>
          </div>
          <!-- 【P204 S4】销售人员独立筛选胶囊：与状态 tab 解耦，常驻可见（不再藏在 tab[0] 的小箭头里）。
               仅管理人员（有下属）显示；非「全部客户」时自动清除该维度，避免口径歧义。 -->
          <div class="customer-scope-bar" v-if="showStaffScopeBar">
            <div class="customer-scope-bar__pill"
                 :class="{'customer-scope-bar__pill--on': staffFilter !== 'all'}"
                 @click="staffSheetShow = true">
              <i class="el-icon-user"></i>
              <span>筛选销售人员：{{ staffFilterLabel }}</span>
              <i class="el-icon-arrow-down"></i>
            </div>
            <div class="customer-scope-bar__clear"
                 v-if="staffFilter !== 'all'"
                 @click="clearStaffScope">清除</div>
          </div>
          <van-popup v-model="staffSheetShow" round position="bottom">
            <van-picker
              show-toolbar
              title="筛选销售人员"
              :columns="staffPickerColumns"
              @confirm="onSelectStaff"
              @cancel="staffSheetShow=false"
            />
          </van-popup>
        </div>

          <div class="customer-header-spacer" v-show="customerHeaderH" :style="{height: customerHeaderH + 'px'}"></div>

          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <div class="list-box customer-list-box" :class="{'customer-list-box--batch': batchMode && selectedCustomers.length>0}">
            <van-list
                      v-model:loading="loading"
                      :finished="finished"
                      finished-text="没有更多了"
                      @load="onLoad"
                    >

                      <div v-for="(item, idx) in customersList" :key="idx"  class="crm-item customer-item" :class="{'batch-on': batchMode}">
                        <van-checkbox
                          v-if="batchMode"
                          class="customer-item__check"
                          :value="isSelected(item.sn)"
                          @input="(val)=>onSelectCustomer(item.sn, val)"
                        />

                        <div class="item-head customer-card">
                            <div class="customer-card__main" @click="!batchMode && openCustomerDetail(item)">
                                <div class="customer-card__content">
                                    <div class="customer-card__header">
                                        <div class="customer-card__name-wrap">
                                            <span class="customer-card__name">{{item.item.name}}</span>
                                            <span class="customer-card__role">{{item.item.type_name || '客户'}}</span>
                                        </div>
                                        <span v-if="item.publish_status==1" class="status-tag tag-pending">{{item.item.publish_status_name}}</span>
                                        <span v-if="item.publish_status==2" class="status-tag tag-receive">{{item.item.publish_status_name}}</span>
                                        <span v-if="item.publish_status==0" class="status-tag tag-danger">{{item.item.publish_status_name || '已拒绝'}}</span>
                                    </div>
                                    <div class="customer-card__row">联系人：{{item.item.customer_name || '-'}}  {{item.item.customer_phone}}</div>
                                    <div class="customer-card__row customer-card__row--muted">负责人：{{item.item.owner_name || '-'}}  ·  来源：{{item.item.source_name || '-'}}</div>
                                    <div class="customer-card__req" v-if="item.item.use_name || item.item.use_date || item.item.number_people || item.item.store_sn">
                                        <span class="customer-card__req-label">需求</span>
                                        <div class="customer-card__req-body">
                                            <span v-if="item.item.use_name">用途：{{item.item.use_name}}</span>
                                            <span v-if="item.item.use_date">使用时间：{{item.item.use_date}}</span>
                                            <span v-if="item.item.number_people">人数：{{item.item.number_people}}</span>
                                            <span v-if="item.item.store_sn || item.item.store_name">门店：{{item.item.store_name || item.item.store_sn}}</span>
                                        </div>
                                    </div>
                                    <div class="customer-card__tags" v-if="item.item.industry_name || item.item.source_name">
                                        <span class="customer-card__tag-label">标签</span>
                                        <span class="customer-card__tag" v-if="item.item.industry_name">{{item.item.industry_name}}</span>
                                        <span class="customer-card__tag" v-if="item.item.source_name && item.item.source_name !== item.item.industry_name">{{item.item.source_name}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="customer-card__actions">
                                <!-- 【P128】待接收（分配给我但未接收）时只能接收/拒绝，不提供编辑 -->
                                <div v-if="!(item.publish_status==1 && item.owner_id == currentStaffId)"
                                     class="btn-action btn-action--secondary" @click="openCustomerEdit(idx)">✎ 编辑</div>
                                <template v-if="item.publish_status==1 && item.owner_id == currentStaffId">
                                  <div class="btn-action btn-action--primary" :class="{'is-disabled':allocLoading}" @click="allocOne(item.sn,'receive')">接收</div>
                                  <div class="btn-action btn-action--danger" :class="{'is-disabled':allocLoading}" @click="allocOne(item.sn,'reject')">拒绝</div>
                                </template>
                                <div class="btn-action btn-action--primary" @click="onMore(idx)">
                                    <span v-if="item.item.is_show==0">▼ 更多</span>
                                    <span v-if="item.item.is_show==1">▲ 收起</span>
                                </div>
                            </div>
                        </div>

                        <div v-if="item.item.is_show==1" class="item-detail">

                            <div class="info-row">
                                <div v-for="(title, idx2) in data.title" :key="idx2"  v-if="title.main==0"  class="info-col">
                                  <span class="label">{{title.lable}}：</span>
                                  {{item.item[title.value]}}
                                </div>

                            </div>
                

                            <div class="record-block">
                                <div class="record-title"><span style="display:inline-block;width:3px;height:12px;border-radius:2px;background:#2b5fd9;margin-right:6px;vertical-align:-1px;"></span>回访记录</div>
                                <div class="record-item" v-if="item.item.last_visit_content" style="color:#646a73;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ item.item.last_visit_content }}</div>
                                <div class="record-item" v-else style="color:#c0c4cc;">暂无回访记录</div>
                            </div>

                        </div>


                    </div>



              </van-list>
          </div>
          </van-pull-refresh>

          <van-popup v-model="dialogCustomer" round position="bottom" :style="{ height: '88%' }">
            <div class="form-page">

              <div class="form-title">{{customerForm.sn ? '编辑客户' : '新增客户'}}</div>

              <div class="form-body">

                <van-field v-model="customerForm.name" label="客户名称" placeholder="请输入客户名称" required />
                <!-- 【P204 M1】编辑客户时展示「当前负责人」（只读）。
                     数据来自 customersDetail 的 owner_name（后端优先按 owner_id 查 staff 真名，
                     再兜底历史 owner_text）；新增客户时 owner_name 为空 ⇒ 整个字段不渲染。 -->
                <van-field v-if="customerForm.sn && customerForm.owner_name"
                          :value="customerForm.owner_name"
                          label="当前负责人"
                          readonly
                          placeholder="未分配" />
                <van-field label="行业" :value="customerText('industry',customerForm.industry)" placeholder="请选择" required readonly is-link @click="onCustomerPick('industry')" />
                <van-field label="来源" :value="customerText('source',customerForm.source)" placeholder="请选择" required readonly is-link @click="onCustomerPick('source')" />
                <van-field label="询价时间" :value="customerForm.enquiry_data" placeholder="请选择" readonly is-link @click="openCustomerDate('enquiry_data','询价时间')" />

                <div class="form-divider">联系人信息</div>

                <van-field v-model="customerForm.customer_name" label="联系人" placeholder="请输入联系人姓名" />
                <van-field v-model="customerForm.customer_phone" label="手机" placeholder="请输入手机号" type="tel" />
                <van-field v-model="customerForm.customer_wx" label="微信" placeholder="请输入微信号" />

                <div class="form-divider">需求</div>

                <!-- 【P95】一.01 人数改 TEXT：不做数字校验，写了就算（DB 本就是 varchar(255)） -->
                <van-field v-model="customerForm.number_people" label="人数" placeholder="请输入人数（可填文字）" />
                <van-field label="用途" :value="customerText('use',customerForm.use)" placeholder="请选择" readonly is-link @click="onCustomerPick('use')" />
                <van-field label="使用时间" :value="customerForm.use_date" placeholder="请选择" readonly is-link @click="openCustomerDate('use_date','使用时间')" />
                <van-field label="意向门店" :value="customerForm.store_name" placeholder="请选择意向门店" readonly is-link @click="openCustStorePick" />
                <div class="rich-block">
                  <div class="rich-label">备注</div>
                  <Toolbar :editor="editorRemark" :defaultConfig="toolbarConfigRemark" :mode="modeRemark" class="rich-toolbar" />
                  <Editor v-model="customerForm.remark" :defaultConfig="editorConfigRemark" :mode="modeRemark" @onCreated="onRemarkCreated" class="rich-editor" />
                </div>

              </div>

              <div class="form-footer">
                <van-button block plain @click="closeCustomer">取消</van-button>
                <van-button block type="info" :loading="customerSaving" loading-text="保存中" @click="submitCustomer">保存</van-button>
              </div>

            </div>
          </van-popup>

          <van-popup v-model="customerPickerShow" round position="bottom">
            <van-picker
              show-toolbar
              :title="customerPickerTitle"
              :columns="customerPickerColumns"
              @confirm="onCustomerPickerConfirm"
              @cancel="customerPickerShow=false"
            />
          </van-popup>

          <van-popup v-model="custStorePickShow" round position="bottom">
            <van-picker
              show-toolbar
              title="选择意向门店"
              :columns="custStorePickColumns"
              @confirm="onCustStorePickConfirm"
              @cancel="custStorePickShow=false"
            />
          </van-popup>

          <van-popup v-model="dialogCustomerDate" round position="bottom">
            <van-datetime-picker
              type="date"
              v-model="customerCurrentDate"
              @confirm="onCustomerDateConfirm"
              @cancel="dialogCustomerDate=false"
            />
          </van-popup>

          <!-- 筛选弹层 -->
          <van-popup v-model="dialogCustomerFilter" round position="bottom" :style="{ height: '82%' }">
            <div class="form-page">
              <div class="form-title">筛选条件</div>
              <div class="form-body">
                <div class="filter-field">
                  <div class="filter-label">来源</div>
                  <van-field :value="customerText('source', customerFilterForm.source)" placeholder="请选择来源" readonly is-link @click="openFilterPicker('source','客户来源')" />
                </div>
                <div class="filter-field">
                  <div class="filter-label">行业</div>
                  <van-field :value="customerText('industry', customerFilterForm.industry)" placeholder="请选择行业" readonly is-link @click="openFilterPicker('industry','所属行业')" />
                </div>
                <div class="filter-field">
                  <div class="filter-label">创建时间</div>
                  <div class="filter-range">
                    <van-field :value="customerFilterForm.create_start" placeholder="开始" readonly is-link @click="openFilterDate('create_start','创建开始')" />
                    <span class="filter-tilde">~</span>
                    <van-field :value="customerFilterForm.create_end" placeholder="结束" readonly is-link @click="openFilterDate('create_end','创建结束')" />
                  </div>
                </div>
                <div class="filter-field">
                  <div class="filter-label">更新时间</div>
                  <div class="filter-range">
                    <van-field :value="customerFilterForm.update_start" placeholder="开始" readonly is-link @click="openFilterDate('update_start','更新开始')" />
                    <span class="filter-tilde">~</span>
                    <van-field :value="customerFilterForm.update_end" placeholder="结束" readonly is-link @click="openFilterDate('update_end','更新结束')" />
                  </div>
                </div>
                <div class="filter-field">
                  <div class="filter-label">询价时间</div>
                  <div class="filter-range">
                    <van-field :value="customerFilterForm.enquiry_start" placeholder="开始" readonly is-link @click="openFilterDate('enquiry_start','询价开始')" />
                    <span class="filter-tilde">~</span>
                    <van-field :value="customerFilterForm.enquiry_end" placeholder="结束" readonly is-link @click="openFilterDate('enquiry_end','询价结束')" />
                  </div>
                </div>
                <div class="filter-field">
                  <div class="filter-label">首单时间</div>
                  <div class="filter-range">
                    <van-field :value="customerFilterForm.first_order_start" placeholder="开始" readonly is-link @click="openFilterDate('first_order_start','首单开始')" />
                    <span class="filter-tilde">~</span>
                    <van-field :value="customerFilterForm.first_order_end" placeholder="结束" readonly is-link @click="openFilterDate('first_order_end','首单结束')" />
                  </div>
                </div>
                <div class="filter-field">
                  <div class="filter-label">复购时间</div>
                  <div class="filter-range">
                    <van-field :value="customerFilterForm.second_order_start" placeholder="开始" readonly is-link @click="openFilterDate('second_order_start','复购开始')" />
                    <span class="filter-tilde">~</span>
                    <van-field :value="customerFilterForm.second_order_end" placeholder="结束" readonly is-link @click="openFilterDate('second_order_end','复购结束')" />
                  </div>
                </div>
              </div>
              <div class="form-footer">
                <van-button block plain @click="onFilterReset">重置</van-button>
                <van-button block type="info" @click="onFilterConfirm">确定</van-button>
              </div>
            </div>
          </van-popup>


          <!-- 批量操作底部栏：按钮随二级分类切换（【P140】普通销售只有「我的待接收」） -->
          <div class="alloc-batch-bar" v-if="batchMode && selectedCustomers.length>0">
            <span class="alloc-batch-bar__count">已选 {{ selectedCustomers.length }} 个</span>
            <div class="alloc-batch-bar__actions">
              <template v-if="batchSub==='pending'">
                <van-button type="primary" :loading="allocLoading" @click="batchAlloc('receive')">批量接收</van-button>
                <van-button type="danger" :loading="allocLoading" @click="batchAlloc('reject')">批量拒绝</van-button>
              </template>
              <van-button v-else type="warning" :loading="assignLoading" @click="openBatchAssign">分配</van-button>
            </div>
          </div>

          <!-- 批量分配：选择目标销售人员 -->
          <van-popup v-model="assignPopupShow" round position="bottom">
            <div class="assign-popup">
              <div class="assign-popup__title">分配给销售人员</div>
              <van-radio-group v-model="assignStaffId">
                <van-cell-group>
                  <van-cell v-for="s in managedStaffList" :key="s.id" :title="s.name + (s.phone ? '（'+s.phone+'）' : '')" clickable @click="assignStaffId=s.id">
                    <template #right-icon>
                      <van-radio :name="s.id" />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
              <div class="assign-popup__actions">
                <van-button block @click="assignPopupShow=false">取消</van-button>
                <van-button block type="primary" :loading="assignLoading" @click="confirmBatchAssign">确认分配给 {{assignStaffName}}</van-button>
              </div>
            </div>
          </van-popup>

      </div>

          <!-- 筛选相关弹层：提升到根级，避免被客户 tab 的 v-if 包裹导致商机/合同 tab 下无法渲染 -->
          <van-popup v-model="filterPickerShow" round position="bottom">
            <van-picker
              show-toolbar
              :title="filterPickerTitle"
              :columns="filterPickerColumns"
              @confirm="onFilterPickerConfirm"
              @cancel="filterPickerShow=false"
            />
          </van-popup>

          <van-popup v-model="filterDateShow" round position="bottom">
            <van-datetime-picker
              type="date"
              v-model="filterDateValue"
              @confirm="onFilterDateConfirm"
              @cancel="filterDateShow=false"
            />
          </van-popup>

          <!-- 商机筛选弹层 -->
          <van-popup v-model="oppFilterShow" round position="bottom" :style="{ height: '82%' }">
            <div class="form-page">
              <div class="form-title">商机筛选</div>
              <div class="form-body">
                <div class="filter-field">
                  <div class="filter-label">阶段</div>
                  <van-field :value="filterText(oppStageOptions, oppFilterForm.stage)" placeholder="请选择阶段" readonly is-link @click="openSelect('opp','stage','商机阶段', oppStageOptions)" />
                </div>
                <div class="filter-field">
                  <div class="filter-label">负责人</div>
                  <van-field :value="ownerFilterLabel('opp')" placeholder="请选择负责人" readonly is-link @click="openOwnerSelect('opp')" />
                </div>
                <div class="filter-field">
                  <div class="filter-label">创建时间</div>
                  <div class="filter-range">
                    <van-field :value="oppFilterForm.start_time" placeholder="开始" readonly is-link @click="openDateSelect('opp','start_time','创建开始')" />
                    <span class="filter-tilde">~</span>
                    <van-field :value="oppFilterForm.end_time" placeholder="结束" readonly is-link @click="openDateSelect('opp','end_time','创建结束')" />
                  </div>
                </div>
                <div class="filter-field">
                  <div class="filter-label">金额（元）</div>
                  <div class="filter-range">
                    <van-field v-model="oppFilterForm.amount_min" type="number" placeholder="最小" />
                    <span class="filter-tilde">~</span>
                    <van-field v-model="oppFilterForm.amount_max" type="number" placeholder="最大" />
                  </div>
                </div>
              </div>
              <div class="form-footer">
                <van-button block plain @click="onOppFilterReset">重置</van-button>
                <van-button block type="info" @click="onOppFilterConfirm">确定</van-button>
              </div>
            </div>
          </van-popup>

          <!-- 合同筛选弹层 -->
          <van-popup v-model="orderFilterShow" round position="bottom" :style="{ height: '82%' }">
            <div class="form-page">
              <div class="form-title">合同筛选</div>
              <div class="form-body">
                <div class="filter-field">
                  <div class="filter-label">阶段</div>
                  <van-field :value="filterText(orderStageOptions, orderFilterForm.stage)" placeholder="请选择阶段" readonly is-link @click="openSelect('order','stage','合同阶段', orderStageOptions)" />
                </div>
                <div class="filter-field">
                  <div class="filter-label">审核状态</div>
                  <van-field :value="filterText(orderStatusOptions, orderFilterForm.status)" placeholder="请选择状态" readonly is-link @click="openSelect('order','status','审核状态', orderStatusOptions)" />
                </div>
                <div class="filter-field">
                  <div class="filter-label">负责人</div>
                  <van-field :value="ownerFilterLabel('order')" placeholder="请选择负责人" readonly is-link @click="openOwnerSelect('order')" />
                </div>
                <div class="filter-field">
                  <div class="filter-label">合同起始时间</div>
                  <div class="filter-range">
                    <van-field :value="orderFilterForm.start_time" placeholder="开始" readonly is-link @click="openDateSelect('order','start_time','起始开始')" />
                    <span class="filter-tilde">~</span>
                    <van-field :value="orderFilterForm.end_time" placeholder="结束" readonly is-link @click="openDateSelect('order','end_time','起始结束')" />
                  </div>
                </div>
                <!-- 【P24-0-2】增加「签约时间」筛选（signing_date 区间） -->
                <div class="filter-field">
                  <div class="filter-label">签约时间</div>
                  <div class="filter-range">
                    <van-field :value="orderFilterForm.signing_date_begin" placeholder="开始" readonly is-link @click="openDateSelect('order','signing_date_begin','签约开始')" />
                    <span class="filter-tilde">~</span>
                    <van-field :value="orderFilterForm.signing_date_end" placeholder="结束" readonly is-link @click="openDateSelect('order','signing_date_end','签约结束')" />
                  </div>
                </div>
              </div>
              <div class="form-footer">
                <van-button block plain @click="onOrderFilterReset">重置</van-button>
                <van-button block type="info" @click="onOrderFilterConfirm">确定</van-button>
              </div>
            </div>
          </van-popup>

          <!-- ============================================================
               【P419】会议室订单筛选：改用全站公共组件 RoomFilter
                 维度与顺序与原自研面板完全一致（10 项），但由公共组件统一维护：
                   使用时间 / 时段 / 是否收费 / 审核状态 / 会议室 / 门店 /
                   客户 / 商机 / 销售合同 / 财务合同
                 · 顺手修掉老问题：原「会议室」取 roomOrder/getFormData 的
                   d.meeting_room / d.rooms，该接口**不返回会议室列表** ⇒ 选项恒空。
                   组件改用 /getRooms{storeSN, roomDateRangeValue}，并做门店→会议室二级联动。
                 · 键名映射在 onRoomFilterApply 里集中处理（room_sn→meeting_room_sn 等），
                   列表接口 getRoomOrderList 不用改。
               ============================================================ -->
          <room-filter
            v-model="roomOrderFilterShow"
            api-prefix="client"
            title="筛选会议室订单"
            :applied="roomOrderFilterApplied"
            :applied-meta="roomOrderFilterMeta"
            @apply="onRoomFilterApply"
          />

          <!-- 【P95】三.3.02 财务合同选择器（可搜索） -->
          <van-popup v-model="dialogFcPick" round position="bottom" :style="{ height: '70%' }">
            <div class="form-page">
              <div class="form-title">选择财务合同</div>
              <div class="pick-search">
                <el-input v-model="fcPickKeyword" class="search-input" placeholder="搜索财务合同名称/编号" @change="loadFcPick()"></el-input>
              </div>
              <div class="pick-body">
                <div v-if="fcPickLoading" class="pick-empty">加载中…</div>
                <div v-else-if="fcPickList.length==0" class="pick-empty">暂无财务合同</div>
                <div v-for="(row, i) in fcPickList" :key="'fc'+i" class="pick-item" @click="onFcPickSelect(row)">
                  <div class="pick-name">{{row.name || row.title || row.serial_number}}</div>
                  <div class="pick-sub">{{row.customer_name || ''}} {{row.serial_number || ''}}</div>
                </div>
              </div>
              <div class="form-footer">
                <van-button block plain @click="dialogFcPick=false">取消</van-button>
              </div>
            </div>
          </van-popup>

          <!-- 【P32-#4】会议室选择器 -->
          <van-popup v-model="roomOrderRoomSheetShow" round position="bottom">
            <van-picker
              show-toolbar
              title="选择会议室"
              :columns="roomOrderRoomColumns"
              @confirm="onRoomOrderRoomConfirm"
              @cancel="roomOrderRoomSheetShow=false"
            />
          </van-popup>

          <!-- 【P32-#4】通用单选选择器 -->
          <van-popup v-model="roomOrderPickerShow" round position="bottom">
            <van-picker
              show-toolbar
              :title="roomOrderPickerTitle"
              :columns="roomOrderPickerColumns"
              @confirm="onRoomOrderPickerConfirm"
              @cancel="roomOrderPickerShow=false"
            />
          </van-popup>

          <!-- 【P32-#4】会议室筛选日期选择 -->
          <van-popup v-model="roomOrderDateShow" round position="bottom">
            <van-datetime-picker
              type="date"
              :title="roomOrderDateTitle"
              :min-date="new Date(2000, 0, 1)"
              :max-date="new Date(2040, 11, 31)"
              @confirm="onRoomOrderDateConfirm"
              @cancel="roomOrderDateShow=false"
            />
          </van-popup>

          <!-- 【P33】会议室订单「使用时间」滑动选择器（默认 08:30 / 20:30） -->
          <van-popup v-model="roomOrderTimeShow" round position="bottom">
            <van-datetime-picker
              v-model="roomOrderTimeValue"
              type="time"
              title="选择使用时间"
              @confirm="onRoomOrderTimeConfirm"
              @cancel="roomOrderTimeShow=false"
            />
          </van-popup>

      <div v-if="active==2">
       <div class="customer-header" ref="oppHeader">
         <div class="customer-header__top">
           <div class="customer-header__left">
             <span class="customer-header__title">商机管理</span>
           </div>
           <div class="customer-header__search">
             <el-input v-model="searchText" class="search-input" placeholder="搜索客户名称/商机名称" @change="search()">
               <i slot="prefix" class="el-icon-search"></i>
             </el-input>
           </div>
          <div class="customer-header__actions">
            <div class="customer-header__btn" @click="openOppFilter">
              <van-icon name="filter-o" />
              <span>筛选</span>
            </div>
            <div class="customer-header__btn customer-header__btn--primary" @click="openOpportunityAdd">
              <i class="el-icon-plus"></i>
              <span>新增商机</span>
            </div>
          </div>
         </div>
          <!-- 商机列表：阶段 TAB（全部/待执行/沟通报价/合同预定/签约付款/失单） -->
          <div class="customer-header__tabs customer-header__tabs--scroll">
            <div v-for="(tab, idx) in oppFilterTabs" :key="idx"
                 class="customer-header__tab"
                 :class="{'customer-header__tab--active': oppFilterTab.label===tab.label}"
                 @click="onOppFilterTabClick(tab, idx)">
              {{tab.label}}
            </div>
          </div>
       </div>
       <div class="filter-status-bar" v-if="oppFilterActiveCount>0">
         <span class="filter-status-bar__txt">已筛选 {{oppFilterActiveCount}} 项条件</span>
         <span class="filter-status-bar__clear" @click="clearOppFilter">清除筛选</span>
       </div>
       <div class="customer-header-spacer" v-show="customerHeaderH" :style="{height: customerHeaderH + 'px'}"></div>

          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <div class="list-box list-box--gap">
              <van-list
                        v-model:loading="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                      >

                      <div v-for="(item, idx) in opportunitiesList" :key="idx"  class="crm-item opp-item">

                        <div class="item-head customer-card opp-card">

                            <div class="customer-card__main" @click="openOpportunityDetail(idx)">
                <div class="customer-card__content">
                                    <div class="customer-card__header">
                                        <div class="customer-card__name-wrap">
                                            <span class="customer-card__name">{{item.item.name}}</span>
                                            <span class="customer-card__role">{{item.item.source_name || '商机'}}</span>
                                        </div>
                                        <span v-if="item.stage==1" class="status-tag tag-wait">{{item.item.stage_name}}</span>
                                        <span v-if="item.stage==2" class="status-tag tag-wait">{{item.item.stage_name}}</span>
                                        <span v-if="item.stage==3" class="status-tag tag-allot">{{item.item.stage_name}}</span>
                                        <span v-if="item.stage==4" class="status-tag tag-receive">{{item.item.stage_name}}</span>
                                        <span v-if="item.stage==5" class="status-tag tag-danger">{{item.item.stage_name}}</span>
                                    </div>
                                    <div class="customer-card__row">客户：{{item.item.customer_name || '-'}} · 编号：{{item.item.serial_number || '-'}}</div>
                                    <div class="customer-card__row customer-card__row--muted">询价：{{item.item.inquiry_data || '-'}}</div>
                                    <div class="customer-card__amount">
                                        <span class="customer-card__amount-label">销售金额</span>
                                        <span class="customer-card__amount-value">{{ (item.item.sales_amount !== null && item.item.sales_amount !== '' && item.item.sales_amount !== undefined) ? '¥' + item.item.sales_amount : '-' }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="customer-card__actions">
                                <div class="btn-action btn-action--secondary" @click="openOpportunityEdit(idx)">✎ 编辑</div>
                                <!-- 【P108f】删除入口已从列表移除，统一放到「商机详情」页（仅管理人员可见） -->
                                <div class="btn-action btn-action--primary" @click="onMore(idx)"><span v-if="item.item.is_show==0">▼ 快速了解</span><span v-if="item.item.is_show==1">▲ 收起</span></div>
                            </div>

                        </div>

                        <div v-if="item.item.is_show==1" class="item-detail">

                            <div class="info-row">
                                <div v-for="(title, idx2) in data.title" :key="idx2"  v-if="title.main==0"    :class="title.row==1 ?'info-col1':'info-col'">
                                  <span class="label">{{title.lable}}：</span>
                                  <div class="html-container" v-html="item.item[title.value]"></div> 
                                </div>
                            </div>
              
                        </div>

                    </div>



              </van-list>
          </div>
          </van-pull-refresh>

          <van-popup v-model="dialogOpportunity" round position="bottom" :style="{ height: '88%' }">
            <div class="form-page">
              <div class="form-title">{{opportunityForm.sn ? '编辑商机' : '添加商机'}}</div>
              <div class="form-body">

                <div class="form-divider">基本信息</div>
                <van-field label="所属客户" :value="opportunityForm.customer_name" placeholder="请选择" required readonly is-link @click="openCustPick('opportunity')" />
                <van-field label="目前阶段" :value="opportunityStageText" placeholder="请选择" readonly is-link @click="opportunityStageShow=true" />

                <!-- 【P95】二.03 失单原因移到「基础信息」正下方（原来在表单最底部）；失单类型为滑动选择 -->
                <template v-if="opportunityForm.stage==5">
                  <div class="form-divider form-divider--lost">失单原因</div>
                  <van-field label="失单类型" :value="oppLostReasonText" placeholder="请选择" required readonly is-link @click="openLostReasonPicker" />
                  <!-- 【P440】失单说明仅在「其他原因（30）」时出现；其他选项隐藏该字段，DB 原值由后端保留不动 -->
                  <van-field v-if="Number(opportunityForm.lost_reason_type2)===30" v-model="opportunityForm.lost_reason" label="失单说明" type="textarea" rows="2" placeholder="请填写失单说明（其他原因请具体描述）" />
                </template>

                <div class="form-divider">商机信息</div>
                <van-field label="门店" :value="opportunityForm.store" placeholder="请选择门店" readonly is-link @click="openOppStorePick" />
                <van-field v-model="opportunityForm.sales_amount" label="销售价格" type="number" placeholder="请输入销售价格">
                  <template #button><span style="color:#8a93a6;font-weight:700;">¥</span></template>
                </van-field>
                <!-- 【P95】二.01 会议人数改 TEXT：不做数字校验（DB 本就是 varchar(20)） -->
                <van-field v-model="opportunityForm.number_people" label="会议人数" placeholder="请输入会议人数（可填文字）" />
                <van-field label="询价时间" :value="opportunityForm.inquiry_data" placeholder="请选择" readonly is-link @click="openDatePick('opportunity','inquiry_data','询价时间')" />

                <div class="form-divider">服务与提醒</div>
                <van-field label="上门服务时间" :value="opportunityForm.on_site_time" placeholder="请选择" readonly is-link @click="openDatePick('opportunity','on_site_time','上门服务时间')" />
                <van-field label="服务结束时间" :value="opportunityForm.off_site_time" placeholder="请选择" readonly is-link @click="openDatePick('opportunity','off_site_time','服务结束时间')" />

                <div class="form-divider">跟进信息</div>
                <!-- 【P108】提醒时间：由「日期」升级为「日期+时间」（落库 remind_datetime） -->
                <van-field label="提醒时间" :value="opportunityForm.remind_datetime" placeholder="请选择" required readonly is-link @click="openRemindPick()" />
                <div class="rich-block">
                  <div class="rich-label">跟进内容</div>
                  <Toolbar :editor="editorFollow" :defaultConfig="toolbarConfigFollow" :mode="modeFollow" class="rich-toolbar" />
                  <Editor v-model="opportunityForm.follow_up_Content" :defaultConfig="editorConfigFollow" :mode="modeFollow" @onCreated="onFollowCreated" class="rich-editor" />
                </div>
                <div class="rich-block">
                  <div class="rich-label">下一步计划</div>
                  <Toolbar :editor="editorNext" :defaultConfig="toolbarConfigNext" :mode="modeNext" class="rich-toolbar" />
                  <Editor v-model="opportunityForm.next_plan" :defaultConfig="editorConfigNext" :mode="modeNext" @onCreated="onNextCreated" class="rich-editor" />
                </div>
                <div class="rich-block">
                  <div class="rich-label">备注</div>
                  <Toolbar :editor="editorOppRemark" :defaultConfig="toolbarConfigOppRemark" :mode="modeOppRemark" class="rich-toolbar" />
                  <Editor v-model="opportunityForm.remark" :defaultConfig="editorConfigOppRemark" :mode="modeOppRemark" @onCreated="onOppRemarkCreated" class="rich-editor" />
                </div>

              </div>
              <div class="form-footer">
                <van-button block plain @click="closeOpportunity">取消</van-button>
                <van-button block type="info" :loading="opportunitySaving" loading-text="保存中" @click="submitOpportunity">保存</van-button>
              </div>
            </div>
          </van-popup>

          <!-- 【P108】商机提醒时间（日期+时间）滚动选择器 -->
          <van-popup v-model="remindPickShow" round position="bottom">
            <van-datetime-picker
              type="datetime"
              v-model="remindPickValue"
              title="提醒时间"
              @confirm="onRemindPickConfirm"
              @cancel="remindPickShow=false"
            />
          </van-popup>

          <van-popup v-model="opportunityStageShow" round position="bottom">
            <van-picker show-toolbar title="选择阶段" :columns="opportunityStageColumns" @confirm="onOpportunityStageConfirm" @cancel="opportunityStageShow=false" />
          </van-popup>

          <van-popup v-model="oppLostReasonShow" round position="bottom">
            <van-picker ref="oppLostPicker" show-toolbar title="失单类型" :columns="oppLostReasonColumns" @confirm="onOppLostReasonConfirm" @cancel="oppLostReasonShow=false" />
          </van-popup>

          <van-popup v-model="oppStorePickShow" round position="bottom">
            <van-picker
              show-toolbar
              title="选择门店"
              :columns="oppStorePickColumns"
              :loading="oppStorePickLoading"
              @confirm="onOppStorePickConfirm"
              @cancel="oppStorePickShow=false"
            />
          </van-popup>

          <!-- 商机详情 -->
          <van-popup v-model="dialogOpportunityDetail" position="right" :style="{width:'100%',height:'100%'}" class="cust-detail-pop">
            <div class="cust-detail">
              <div class="cust-detail__nav">
                <div class="cust-detail__back" @click="closeOpportunityDetail">‹ 返回</div>
                <div class="cust-detail__title">商机详情</div>
                <div class="cust-detail__spacer"></div>
              </div>

              <div class="cust-detail__body" v-if="opportunityDetail.sn">
                <!-- hero -->
                <div class="opp-hero">
                  <span class="opp-hero__cust">🏢 {{opportunityDetail.customer_name || '—'}}</span>
                  <div class="opp-hero__name">{{opportunityDetail.name}}</div>
                  <div class="opp-hero__code" v-if="opportunityDetail.serial_number">编号：{{opportunityDetail.serial_number}}</div>
                  <div class="opp-hero__row">
                    <div>
                      <div class="opp-hero__amount"><small>¥</small>{{fmtNum(opportunityDetail.sales_amount)}}</div>
                      <div class="opp-hero__exact">精确 ¥{{formatMoney(opportunityDetail.sales_amount)}}</div>
                    </div>
                    <span class="status-tag" :class="oppStageTagClass(opportunityDetail.stage)">{{oppStageName(opportunityDetail.stage)}}</span>
                  </div>
                </div>

                <!-- 基本信息 -->
                <div class="card">
                  <div class="card__title"><span class="dot"></span>基本信息</div>
                  <div class="info-list">
                    <div class="info-item"><span class="info-item__label">所属客户</span><span class="info-item__value">{{opportunityDetail.customer_name || '-'}}</span></div>
                    <div class="info-item"><span class="info-item__label">门店</span><span class="info-item__value">{{opportunityDetail.store || '-'}}</span></div>
                    <div class="info-item"><span class="info-item__label">销售金额</span><span class="info-item__value amt">¥{{fmtNum(opportunityDetail.sales_amount)}}<span class="exact">精确 ¥{{formatMoney(opportunityDetail.sales_amount)}}</span></span></div>
                    <div class="info-item"><span class="info-item__label">会议人数</span><span class="info-item__value">{{opportunityDetail.number_people || '-'}}</span></div>
                    <div class="info-item"><span class="info-item__label">询价时间</span><span class="info-item__value">{{opportunityDetail.inquiry_data || '-'}}</span></div>
                    <div class="info-item"><span class="info-item__label">提醒时间</span><span class="info-item__value">{{opportunityDetail.remind_datetime || opportunityDetail.remind_date || '-'}}</span></div>
                    <div class="info-item"><span class="info-item__label">当前阶段</span><span class="info-item__value"><span class="status-tag" :class="oppStageTagClass(opportunityDetail.stage)">{{oppStageName(opportunityDetail.stage)}}</span></span></div>
                  </div>
                </div>

                <!-- 跟进信息 -->
                <div class="card">
                  <div class="card__title"><span class="dot" style="background:#7c5cf6;"></span>跟进信息</div>
                  <div class="info-list">
                    <div class="info-item"><span class="info-item__label">跟进内容</span><span class="info-item__value" v-html="opportunityDetail.follow_up_Content || '—'"></span></div>
                    <div class="info-item"><span class="info-item__label">下一步计划</span><span class="info-item__value" v-html="opportunityDetail.next_plan || '—'"></span></div>
                  </div>
                </div>

                <!-- 阶段时间线 -->
                <div class="card">
                  <div class="card__title"><span class="dot" style="background:#1aa260;"></span>阶段时间线</div>
                  <div class="tl">
                    <div class="tl-item" v-for="(s,si) in opportunityStageList" :key="si" :class="{'cur': s.main==1}">
                      <div class="dot" :class="'s'+s.stage"></div>
                      <div class="tl-name">{{s.stage_name}} <span class="cur-badge" v-if="s.main==1">当前</span></div>
                      <div class="tl-time">{{s.create_time}} · {{s.owner_name}}</div>
                    </div>
                    <div class="tl-empty" v-if="opportunityStageList.length==0">暂无阶段记录</div>
                  </div>
                </div>

                <!-- 备注 -->
                <div class="card" v-if="opportunityDetail.remark">
                  <div class="card__title"><span class="dot" style="background:#e94752;"></span>备注</div>
                  <div class="info-list">
                    <div class="info-item info-item--remark"><span class="info-item__label">备注</span><span class="info-item__value" v-html="opportunityDetail.remark"></span></div>
                  </div>
                </div>
              </div>

              <div class="cust-detail__loading" v-else>加载中…</div>

              <!-- 【P108f】商机详情操作条（删除 + 编辑）—— 这是「详情页删除」的基准样式；
                   删除仅管理人员可见（后端 opportunitiesDelete 同口径强校验） -->
              <div class="cust-detail__bar">
                <button v-if="canManageDelete" class="btn btn--secondary opp-del"
                        :disabled="opportunityDeleting" @click="askDeleteOpportunity">
                  <span v-if="opportunityDeleting">删除中…</span><span v-else>删除</span>
                </button>
                <button class="btn btn--primary" @click="editFromDetail">编辑商机</button>
              </div>
            </div>
          </van-popup>

          <!-- 删除确认（全站统一版：ConfirmDialog 居中弹窗） -->
          <ConfirmDialog
            v-model="oppDelShow"
            :desc="'确定要删除「' + (opportunityDetail.name || '') + '」吗？关联的阶段记录与参与人将一并移除，删除后不可恢复。'"
            :loading="opportunityDeleting"
            loading-text="删除中"
            @confirm="confirmDeleteOpportunity"
          />

      </div>

      <div v-if="active==3">
       <div class="customer-header" ref="orderHeader">
         <div class="customer-header__top">
           <div class="customer-header__left">
             <span class="customer-header__title">合同管理</span>
           </div>
           <div class="customer-header__search">
             <el-input v-model="searchText" class="search-input" placeholder="搜索客户名称/合同名称" @change="search()">
               <i slot="prefix" class="el-icon-search"></i>
             </el-input>
           </div>
          <div class="customer-header__actions">
            <div class="customer-header__btn" @click="openOrderFilter">
              <van-icon name="filter-o" />
              <span>筛选</span>
            </div>
            <div class="customer-header__btn customer-header__btn--primary" @click="openOrderAdd">
              <i class="el-icon-plus"></i>
              <span>新增合同</span>
            </div>
          </div>
         </div>
          <div class="customer-header__tabs">
            <div v-for="(tab, idx) in orderFilterTabs" :key="idx"
                 class="customer-header__tab"
                 :class="{'customer-header__tab--active': orderFilterTab.label===tab.label}"
                 @click="onOrderFilterTabClick(tab, idx)">
              {{tab.label}}
              <i v-if="idx===0 && managedStaffList.length>0" class="el-icon-arrow-down customer-header__tab-arrow"></i>
            </div>
          </div>
          <van-popup v-model="orderStaffSheetShow" round position="bottom">
            <van-picker
              show-toolbar
              title="选择要查看的合同范围"
              :columns="orderStaffPickerColumns"
              @confirm="onSelectOrderStaff"
              @cancel="orderStaffSheetShow=false"
            />
          </van-popup>
       </div>
       <div class="filter-status-bar" v-if="orderFilterActiveCount>0">
         <span class="filter-status-bar__txt">已筛选 {{orderFilterActiveCount}} 项条件</span>
         <span class="filter-status-bar__clear" @click="clearOrderFilter">清除筛选</span>
       </div>
       <div class="customer-header-spacer" v-show="customerHeaderH" :style="{height: customerHeaderH + 'px'}"></div>

          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <div class="list-box list-box--gap">
              <van-list
                        v-model:loading="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                      >

                      <div v-for="(item, idx) in orderList" :key="idx"  class="crm-item order-item">

                        <div class="item-head customer-card order-card">

                            <div class="customer-card__main" @click="goContractDetail(idx)">
                <div class="customer-card__content">
                                    <div class="customer-card__header">
                                        <div class="customer-card__name-wrap">
                                            <span class="customer-card__name">{{item.item.name}}</span>
                                            <span class="customer-card__role">{{ contractTypeLabel(item.item.type) }}</span>
                                        </div>
                                        <span v-if="item.stage==1" class="status-tag tag-wait">{{item.item.stage_name}}</span>
                                        <span v-if="item.stage==2" class="status-tag tag-wait">{{item.item.stage_name}}</span>
                                        <span v-if="item.stage==3" class="status-tag tag-allot">{{item.item.stage_name}}</span>
                                        <span v-if="item.stage==4" class="status-tag tag-receive">{{item.item.stage_name}}</span>
                                        <span v-if="item.stage==5" class="status-tag tag-danger">{{item.item.stage_name}}</span>
                                    </div>
                                    <!-- 【P32-#1】销售合同审核状态标签（审核中/审核通过/审核驳回） -->
                                    <div class="customer-card__row contract-status-row" v-if="item.item.status_name">
                                      <span class="status-tag" :class="contractStatusClass(item.item.status)">{{item.item.status_name}}</span>
                                    </div>
                                    <div class="customer-card__row">客户：{{item.item.customer_name || '-'}} · 编号：{{item.item.serial_number || '-'}}</div>
                                    <div class="customer-card__row customer-card__row--muted customer-card__row--dates">
                                        <span>签约：{{item.item.signing_date || '-'}}</span>
                                        <span>起：{{item.item.start_date || '-'}}</span>
                                        <span>止：{{item.item.end_date || '-'}}</span>
                                    </div>
                                    <div class="customer-card__amount">
                                        <span class="customer-card__amount-label">销售金额</span>
                                        <span class="customer-card__amount-value">{{ (item.item.sales_amount !== null && item.item.sales_amount !== '' && item.item.sales_amount !== undefined) ? '¥' + item.item.sales_amount : '-' }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="customer-card__actions">
                                <div class="btn-action btn-action--secondary" @click="openOrderEdit(idx)">✎ 编辑</div>
                                <!-- 【P108f】删除入口已从列表移除，统一放到「合同详情」页（仅管理人员可见） -->
                                <div class="btn-action btn-action--primary" @click="onMore(idx)"><span v-if="item.item.is_show==0">▼ 快速了解</span><span v-if="item.item.is_show==1">▲ 收起</span></div>
                            </div>

                        </div>

                        <div v-if="item.item.is_show==1" class="item-detail">

                            <div class="info-row">
                                <div class="info-col1">
                                  <span class="label">当前余额：</span>
                                  <span>¥{{ item.item.balance_amount !== null && item.item.balance_amount !== undefined && item.item.balance_amount !== '' ? item.item.balance_amount : '0.00' }}</span>
                                </div>
                                <div v-for="(title, idx2) in data.title" :key="idx2"  v-if="title.main==0"    :class="(title.row==1 || title.value=='create_time' || title.value=='update_time') ?'info-col1':'info-col'">
                                  <span class="label">{{title.lable}}：</span>
                                  <div class="html-container" v-html="item.item[title.value]"></div>
                                </div>
                            </div>

                        </div>

                      </div>



              </van-list>
          </div>
          </van-pull-refresh>

          <van-popup v-model="dialogOrder" round position="bottom" :style="{ height: '88%' }">
            <div class="form-page">

              <div class="form-title">{{orderForm.sn ? '编辑合同' : '新增合同'}}</div>

              <div class="form-body">

                <van-field label="所属客户" :value="orderForm.customer_name" placeholder="请选择" required readonly is-link @click="openCustPick('order')" />
                <van-field label="合同名称" :value="orderForm.name" placeholder="选择客户后自动生成" readonly />
                <!-- 【P348】关联商机由「选填」改为**必选**（用户 10-14 需求）。
                     placeholder 改为「请选择」，required 显示红星。 -->
                <van-field label="关联商机" :value="orderForm.opportunitie_name" placeholder="请选择" required readonly is-link @click="openOppPick" />

                <div class="form-divider">时间</div>

                <van-field label="签订日期" :value="orderForm.signing_date" placeholder="请选择" readonly is-link @click="openDatePick('order','signing_date','签订日期')" />
                <van-field label="开始时间" :value="orderForm.start_date" placeholder="请选择" readonly is-link @click="openDatePick('order','start_date','开始时间')" />
                <van-field label="结束时间" :value="orderForm.end_date" placeholder="请选择" readonly is-link @click="openDatePick('order','end_date','结束时间')" />

                <div class="form-divider">其他</div>

                <!-- 【P205 1.1.01】备注改「简易富文本」（自研 RichEditor，替代笨重的 wangEditor） -->
                <div class="rich-block">
                  <div class="rich-label">备注</div>
                  <RichEditor v-model="orderForm.remark" placeholder="请输入备注..." />
                </div>

              </div>

              <div class="form-footer">
                <van-button block plain @click="closeOrder">取消</van-button>
                <van-button block type="info" :loading="orderSaving" loading-text="保存中" @click="submitOrder">保存</van-button>
              </div>

            </div>
          </van-popup>

      </div>

      <div v-if="active==4">

        <!-- 快捷入口九宫格 -->
        <div v-if="quickSub==='grid'" class="quick-entry">
          <div class="quick-hero">
            <div class="quick-hero__top">
              <span class="quick-hero__avatar">{{ avatarText }}</span>
              <div class="quick-hero__id">
                <div class="quick-hero__name">{{ profile.staff_name || profile.name || '—' }}</div>
                <div class="quick-hero__dept">{{ deptText || '—' }}</div>
              </div>
              <span class="quick-hero__role" v-if="roleText">{{ roleText }}</span>
            </div>
          </div>
          <!-- 【P112】下拉刷新：宫格页没有列表，刷的是「角标」（未读消息数等） -->
          <van-pull-refresh v-model="quickGridRefreshing" @refresh="onQuickGridRefresh">
          <div class="quick-section">
            <div class="quick-section__tit">常用功能</div>
            <div class="quick-grid">
              <div class="quick-tile" v-for="q in quickTileList" :key="q.key" @click="quickGo(q)">
                <div class="quick-tile__ic" v-html="q.icon"></div>
                <div class="quick-tile__label">{{ q.label }}</div>
                <div class="quick-badge" v-if="q.key==='message' ? msgUnread : q.badge">{{ q.key==='message' ? msgUnread : q.badge }}</div>
              </div>
            </div>
          </div>
          <!-- 账号：退出登录（P46） -->
          <div class="quick-section quick-section--acct">
            <div class="quick-section__tit">账号</div>
            <div class="acct-list">
              <div class="acct-row" @click="askLogout">
                <span class="acct-row__ic">
                  <svg viewBox="0 0 24 24">
                    <path d="M15 4h3.5v16H15" />
                    <path d="M10.5 8 6.5 12l4 4" />
                    <path d="M6.5 12H15" />
                  </svg>
                </span>
                <span class="acct-row__txt">
                  <span class="acct-row__label">退出登录</span>
                  <span class="acct-row__sub">退出后需重新登录</span>
                </span>
                <van-icon name="arrow" class="acct-row__arrow" />
              </div>
            </div>
          </div>

          <div class="quick-tip">点击图标可直达对应单据；数据为您名下全部单据</div>
          <div class="quick-ver" v-if="buildTag">{{ buildTag }}</div>
          </van-pull-refresh>
        </div>

        <!-- 消息列表（快捷入口子视图） -->
        <!-- 消息列表（快捷入口子视图 · 新 UI） -->
        <div v-if="quickSub==='message'" class="msg-page">
          <div class="top-nav">
            <span class="top-nav__back" @click="quickSub='grid'">‹ 返回</span>
            消息列表
            <span class="top-nav__cnt" v-if="msgUnread>0">未读 {{msgUnread}}</span>
          </div>

          <!-- 【P109】消息分类 tab（全部 / 未读 / 待处理） -->
          <div class="msg-tabs">
            <!-- 【P154】切 tab 走方法：需重置分页并由服务端按 msg_tab 重新过滤 -->
            <div v-for="t in msgTabs" :key="t.value"
                 class="msg-tab" :class="{ 'msg-tab--active': msgTab === t.value }"
                 @click="switchMsgTab(t.value)">
              <!-- 【P248】文字与角标分离：角标绝对定位到右上角，不再挤占文字宽度 -->
              <span class="msg-tab__tx">{{ t.label }}</span>
              <em class="msg-tab__dot" v-if="msgTabCount(t.value)">{{ msgTabCount(t.value) }}</em>
            </div>
          </div>

          <!-- 【B4-02】批量操作二次确认：改用**全站统一自研** ConfirmDialog
               （不再用原生 $confirm —— 原生弹窗样式与全站不一致、且不可控） -->
          <ConfirmDialog
            v-model="dialogMsgBatch"
            :title="msgBatchTitle"
            :desc="msgBatchDesc"
            :loading="msgBatchBusy"
            :loading-text="msgBatchLoadingText"
            :confirm-text="msgBatchConfirmText"
            @confirm="doMsgBatch"
          />

          <!-- 【P247】批量操作条：仅「未读」「全部」两个 Tab 显示
               未读 → 批量已读；全部 → 批量删除。默认全部不勾选。 -->
          <div class="msg-batch" v-if="msgBatchMode">
            <label class="msg-batch__all">
              <input type="checkbox" :checked="msgPickedAll" @change="togglePickAll" />
              <span>全选</span>
            </label>
            <span class="msg-batch__n">已选 <b>{{ msgPicked.length }}</b> / {{ msgRows.length }} 条</span>
            <button class="msg-batch__btn" :disabled="!msgPicked.length || msgBatchBusy"
                    @click="onMsgBatch">
              {{ msgBatchBusy ? '处理中…' : (msgTab === 'unread' ? '批量已读' : '批量删除') }}
            </button>
          </div>

          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <div class="list-box msg-list-box">
              <van-list
                v-model:loading="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
              >
                <div
                  v-for="(row, idx) in filteredMessageList"
                  :key="idx"
                  class="crm-item msg-card"
                  :class="{'msg-card--read': isMsgRead(row)}"
                  @click="onMsgCardClick(row)"
                >
                  <!-- 【P247】批量模式下的勾选框（点击不触发行点击） -->
                  <label class="msg-card__pick" v-if="msgBatchMode" @click.stop>
                    <input type="checkbox" :checked="isMsgPicked(row)" @change="togglePickOne(row)" />
                  </label>
                  <div class="msg-top">
                    <span class="msg-badge" :style="msgBadgeStyle(row)"><i></i>{{ msgBadgeText(row) }}</span>
                    <span class="status-tag" :class="msgStatus(row).cls">{{ msgStatus(row).text }}</span>
                    <span class="msg-time">{{ msgTimeText(row) }}</span>
                    <span v-if="!isMsgRead(row)" class="msg-dot"></span>
                  </div>

                  <div class="msg-title">{{ msgTitle(row) }}</div>
                  <div class="msg-text" v-if="msgBody(row)">{{ msgBody(row) }}</div>

                  <div class="msg-chips" v-if="msgChips(row).length">
                    <span v-for="(c, ci) in msgChips(row)" :key="ci" class="msg-chip" :class="{key: c.key}">{{ c.text }}</span>
                  </div>

                  <div class="msg-foot">
                    <span class="msg-foot__sp"></span>
                    <span class="msg-go">{{ msgJumpable(row) ? '去处理' : '查看详情' }} ›</span>
                  </div>
                </div>
              </van-list>
            </div>
          </van-pull-refresh>

          <!-- 消息详情弹层 -->
          <van-popup v-model="msgDetailShow" round position="bottom" class="msg-detail-pop" :style="{maxHeight:'74%'}">
            <div class="msg-detail" v-if="msgDetailRow">
              <div class="msg-detail__hd">
                <span class="msg-badge" :style="msgBadgeStyle(msgDetailRow)"><i></i>{{ msgBadgeText(msgDetailRow) }}</span>
                <span class="status-tag" :class="msgStatus(msgDetailRow).cls">{{ msgStatus(msgDetailRow).text }}</span>
                <span class="msg-detail__time">{{ msgTimeText(msgDetailRow) }}</span>
                <van-icon name="cross" class="msg-detail__close" @click="msgDetailShow=false" />
              </div>
              <div class="msg-detail__title">{{ msgTitle(msgDetailRow) }}</div>
              <div class="msg-detail__body">{{ msgRaw(msgDetailRow) }}</div>
              <div class="msg-detail__ft">
                <van-button block plain @click="msgDetailShow=false">关闭</van-button>
                <van-button v-if="msgJumpable(msgDetailRow)" block type="info" @click="jumpMsg(msgDetailRow)">去处理</van-button>
              </div>
            </div>
          </van-popup>
        </div>

        <!-- 统计报表（快捷入口子视图） -->
        <div v-if="quickSub==='stat'" class="stat-page-wrap">
          <div class="top-nav stat-nav">
            <span class="top-nav__back" @click="quickSub='grid'">‹ 返回</span>
            统计报表
          </div>

          <!-- 筛选条：时间 / 人员 -->
          <div class="stat-filter">
            <div class="stat-filter__row">
              <span class="stat-filter__lab">时间</span>
              <div class="stat-chips">
                <span v-for="t in statTimeOpts" :key="t.val" class="stat-chip" :class="{on:statTimeType===t.val}" @click="onStatTime(t.val)">{{ t.label }}</span>
              </div>
            </div>
            <div class="stat-filter__row" v-if="statPersonPickerColumns.length>1" style="margin-bottom:12px;">
              <div class="stat-person" @click="statPersonSheetShow=true">
                <span class="stat-person__lab">人员</span>
                <span class="stat-person__val">{{ statOwnerLabel }}</span>
                <span class="stat-person__chev">▾</span>
              </div>
            </div>
          </div>

          <!-- 人员滚轮选择器 -->
          <van-popup v-model="statPersonSheetShow" round position="bottom">
            <van-picker
              show-toolbar
              title="选择人员"
              :columns="statPersonPickerColumns"
              :default-index="statPersonDefaultIndex"
              @confirm="onStatPersonPick"
              @cancel="statPersonSheetShow=false"
            />
          </van-popup>

          <!-- 【P112】下拉刷新：重拉「当前筛选（时间/人员）」下的统计看板 -->
          <van-pull-refresh v-model="statRefreshing" @refresh="onStatRefresh">
          <div class="stat-body">
            <van-loading v-if="statLoading" class="stat-loading" type="spinner" color="#2b5fd9" />
            <template v-else-if="statData">
              <!-- 01 数据简报 -->
              <div class="stat-sec">
                <div class="stat-sec__tit">数据简报</div>
                <div class="stat-cards">
                  <div class="stat-card" v-for="b in statData.brief" :key="b.key">
                    <div class="stat-card__value" :class="{'is-pct': b.unit==='%'}">{{ fmtNum(b.value) }}<i class="stat-card__unit" v-if="b.unit==='%'">%</i></div>
                    <div class="stat-card__label">{{ b.label }}</div>
                    <div class="stat-card__bar" v-if="b.unit==='%'"><span :style="{width: clampPct(b.value)+'%'}"></span></div>
                  </div>
                </div>
              </div>

              <!-- 02 业绩指标月份对比 -->
              <div class="stat-sec" v-if="statData.monthComparison.length">
                <div class="stat-sec__tit">业绩指标月份对比 <span class="stat-sec__tip">单位：万元</span></div>
                <div class="mc-list">
                  <div class="mc-row" v-for="(m,idx) in statData.monthComparison" :key="m.ym">
                    <div class="mc-month">{{ m.ym.slice(5) }}月</div>
                    <div class="mc-main">
                      <div class="mc-line">
                        <span class="mc-label">目标</span>
                        <div class="mc-track"><i class="bar-t" :style="{width: barPct(m.target, monthMax)+'%'}"></i></div>
                        <div class="mc-val">{{ m.target>0 ? fmtNum(m.target) : '—' }}</div>
                      </div>
                      <div class="mc-line">
                        <span class="mc-label">销售</span>
                        <div class="mc-track"><i class="bar-s" :style="{width: barPct(m.sales, monthMax)+'%'}"></i></div>
                        <div class="mc-val">{{ fmtNum(m.sales) }}</div>
                      </div>
                    </div>
                    <div class="mc-badge">
                      <span class="mc-pct" :class="m.target>0 ? (m.completion_pct>=100 ? 'ok' : (m.completion_pct>=80 ? 'warn' : 'danger')) : 'gray'">{{ m.target>0 ? m.completion_pct+'%' : '无目标' }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 03 销售人员目标对比 -->
              <div class="stat-sec" v-if="statData.staffTargets.length">
                <div class="stat-sec__tit">销售人员目标对比 <span class="stat-sec__tip">按目标金额</span></div>
                <div class="rank-list">
                  <div class="rank-row" v-for="(s,idx) in statData.staffTargets" :key="s.staff_id">
                    <div class="rank-idx" :class="{gold: idx===0, silver: idx===1, bronze: idx===2}">{{ idx+1 }}</div>
                    <div class="rank-name">{{ s.staff_name }}</div>
                    <div class="rank-barwrap">
                      <div class="rank-track"><i :style="{width: barPct(s.target, staffTargetMax)+'%'}"></i></div>
                    </div>
                    <div class="rank-val">{{ fmtNum(s.target) }}</div>
                  </div>
                </div>
              </div>

              <!-- 04 商机分布 -->
              <div class="stat-sec" v-if="statData.oppDist.length">
                <div class="stat-sec__tit">商机分布</div>
                <div class="stat-stack">
                  <i v-for="(s,idx) in statData.oppDist" :key="s.stage" class="stat-stack__seg" :style="{width: stackPct(s.cnt, oppDistTotal)+'%', background: stageColors[idx%stageColors.length]}"></i>
                </div>
                <div class="stat-legend">
                  <span v-for="(s,idx) in statData.oppDist" :key="s.stage" class="stat-legend__it"><i :style="{background: stageColors[idx%stageColors.length]}"></i>{{ s.label }} {{ s.cnt }}</span>
                </div>
              </div>

              <!-- 05 输单原因分布 -->
              <div class="stat-sec" v-if="statData.lostReason.length">
                <div class="stat-sec__tit">输单原因分布</div>
                <div class="stat-donut-row">
                  <div class="stat-donut" :style="{background: donutGradient(statData.lostReason)}"></div>
                  <div class="stat-legend">
                    <span v-for="(r,idx) in statData.lostReason" :key="r.type" class="stat-legend__it"><i :style="{background: lostColors[idx%lostColors.length]}"></i>{{ r.label }} {{ r.cnt }}</span>
                  </div>
                </div>
              </div>
              <div class="stat-note" v-else>当前筛选下无输单数据</div>

              <!-- 06 商机漏斗个数 -->
              <div class="stat-sec" v-if="statData.funnelCount.length">
                <div class="stat-sec__tit">商机漏斗（个数）</div>
                <div class="stat-hbars">
                  <div class="stat-hbar" v-for="f in statData.funnelCount" :key="'c'+f.stage">
                    <span class="stat-hbar__name">{{ f.label }}</span>
                    <i class="stat-hbar__fill bar-f" :style="{width: barPct(f.cnt, funnelCntMax)+'%'}"></i>
                    <b>{{ f.cnt }}</b>
                  </div>
                </div>
              </div>

              <!-- 07 商机漏斗金额（万元） -->
              <div class="stat-sec" v-if="statData.funnelAmt.length">
                <div class="stat-sec__tit">商机漏斗金额（万元）</div>
                <div class="stat-hbars">
                  <div class="stat-hbar" v-for="f in statData.funnelAmt" :key="'a'+f.stage">
                    <span class="stat-hbar__name">{{ f.label }}</span>
                    <i class="stat-hbar__fill bar-f2" :style="{width: barPct(f.amt_wan, funnelAmtMax)+'%'}"></i>
                    <b>{{ f.amt_wan }}</b>
                  </div>
                </div>
              </div>

              <!-- 08 销售人员商机对比 -->
              <div class="stat-sec" v-if="statData.staffOpps.length">
                <div class="stat-sec__tit">销售人员商机对比 <span class="stat-sec__tip">按商机数</span></div>
                <div class="rank-list">
                  <div class="rank-row" v-for="(s,idx) in statData.staffOpps" :key="s.staff_id">
                    <div class="rank-idx" :class="{gold: idx===0, silver: idx===1, bronze: idx===2}">{{ idx+1 }}</div>
                    <div class="rank-name">{{ s.staff_name }}</div>
                    <div class="rank-barwrap">
                      <div class="rank-track o"><i :style="{width: barPct(s.opp_cnt, staffOppMax)+'%'}"></i></div>
                    </div>
                    <div class="rank-val">{{ s.opp_cnt }}</div>
                  </div>
                </div>
              </div>

              <!-- 合同执行：四流合一 -->
              <div class="stat-sec" v-if="statFlow && statFlow.list && statFlow.list.data && statFlow.list.data.length">
                <div class="stat-sec__tit">合同执行 <span class="cf-tag">四流合一</span></div>
                <div class="cf-sum">
                  <div class="s"><div class="n">{{ fmtNum(statFlow.total_amount) }}</div><div class="l">合同额</div></div>
                  <div class="s ok"><div class="n">{{ fmtNum(statFlow.total_paid) }}</div><div class="l">已回款</div></div>
                  <div class="s warn"><div class="n">{{ fmtNum(statFlow.total_invoice) }}</div><div class="l">已开票</div></div>
                  <div class="s danger"><div class="n">{{ fmtNum(statFlow.total_refund) }}</div><div class="l">退款</div></div>
                </div>

                <div class="crm-item" v-for="c in statFlow.list.data" :key="c.sn" :class="{'is-open': flowDetailSn===c.sn}" @click="toggleFlowDetail(c.sn)">
                  <div class="cf-top"><span class="cf-cust">{{ c.customer || c.name }}</span><span class="cf-caret" :class="{'up': flowDetailSn===c.sn}"></span></div>
                  <div class="cf-sn">{{ c.sn }}</div>
                  <div class="cf-amt">¥{{ fmtNum(c.amount) }} <small>合同额</small></div>
                  <div class="cf-flow"><span class="cf-lab">回款</span><span class="cf-bar paid"><i :style="{width: clampPct(c.paid_rate)+'%'}"></i></span><span class="cf-v">¥{{ fmtNum(c.paid) }}</span></div>
                  <div class="cf-flow"><span class="cf-lab">开票</span><span class="cf-bar inv"><i :style="{width: clampPct(c.invoice_rate)+'%'}"></i></span><span class="cf-v">¥{{ fmtNum(c.invoice) }}</span></div>
                  <div class="cf-metrics">
                    <div class="cf-m ok"><div class="n">{{ c.paid_rate }}%</div><div class="l">回款率</div></div>
                    <div class="cf-m warn"><div class="n">{{ c.invoice_rate }}%</div><div class="l">开票率</div></div>
                    <div class="cf-m danger"><div class="n">¥{{ fmtNum(c.unpaid) }}</div><div class="l">未回款</div></div>
                    <div class="cf-m"><div class="n">¥{{ fmtNum(c.refund) }}</div><div class="l">退款</div></div>
                  </div>
                  <!-- 展开明细：点击卡片显示回款/发票/退款 -->
                  <div class="cf-detail" v-if="flowDetailSn===c.sn" @click.stop>
                    <div v-if="flowDetailLoading" class="cf-dl">明细加载中…</div>
                    <template v-else-if="flowDetail && flowDetail.allowed">
                      <div class="cf-dblock">
                        <div class="cf-dh"><span>回款（{{ flowDetail.payments.length }}）</span><span class="cf-damt">¥{{ fmtNum(sumFlow(flowDetail.payments,'amount')) }}</span></div>
                        <div v-if="!flowDetail.payments.length" class="cf-dempty">暂无回款记录</div>
                        <div v-for="(p,idx) in flowDetail.payments" :key="'p'+idx" class="cf-drow">
                          <div class="cf-dr1"><span class="cf-dsn">{{ p.sn }}</span><span class="cf-st" :class="statusCls('pay',p.status)">{{ p.status_label }}</span></div>
                          <div class="cf-dr2"><span>{{ p.date }}</span><span class="cf-dm">{{ p.method }}</span><span class="cf-da">¥{{ fmtNum(p.amount) }}</span></div>
                        </div>
                      </div>
                      <div class="cf-dblock">
                        <div class="cf-dh"><span>发票（{{ flowDetail.invoices.length }}）</span><span class="cf-damt">¥{{ fmtNum(sumFlow(flowDetail.invoices,'amount')) }}</span></div>
                        <div v-if="!flowDetail.invoices.length" class="cf-dempty">暂无开票记录</div>
                        <div v-for="(iv,idx) in flowDetail.invoices" :key="'iv'+idx" class="cf-drow">
                          <div class="cf-dr1"><span class="cf-dsn">{{ iv.sn }}</span><span class="cf-it">{{ iv.type_label }}</span><span class="cf-st" :class="statusCls('inv',iv.status)">{{ iv.status_label }}</span></div>
                          <div class="cf-dr2"><span>{{ iv.date }}</span><span class="cf-dbuyer">{{ iv.buyer }}</span><span class="cf-da">¥{{ fmtNum(iv.amount) }}</span></div>
                        </div>
                      </div>
                      <div class="cf-dblock">
                        <div class="cf-dh"><span>退款（{{ flowDetail.refunds.length }}）</span><span class="cf-damt danger">¥{{ fmtNum(sumFlow(flowDetail.refunds,'amount')) }}</span></div>
                        <div v-if="!flowDetail.refunds.length" class="cf-dempty">暂无退款记录</div>
                        <div v-for="(rf,idx) in flowDetail.refunds" :key="'rf'+idx" class="cf-drow">
                          <div class="cf-dr1"><span class="cf-dsn">{{ rf.sn }}</span><span class="cf-st" :class="statusCls('ref',rf.status)">{{ rf.status_label }}</span></div>
                          <div class="cf-dr2"><span>{{ rf.date }}</span><span class="cf-dm">{{ rf.name }}</span><span class="cf-da danger">¥{{ fmtNum(rf.amount) }}</span></div>
                        </div>
                      </div>
                    </template>
                    <div v-else class="cf-dl">无权限或暂无明细</div>
                  </div>
                </div>

                <div class="cf-more" v-if="statFlow.list.current_page < statFlow.list.last_page">
                  <span class="cf-more__btn" @click="loadContractFlowMore">加载更多（{{ statFlow.list.data.length }}/{{ statFlow.list.total }}）</span>
                </div>
              </div>
              <div class="stat-note" v-else-if="statFlow && (!statFlow.list || !statFlow.list.data || !statFlow.list.data.length)">当前筛选下无合同数据</div>

              <div class="stat-note" v-if="statNote">{{ statNote }}</div>
            </template>
            <div class="stat-note" v-else>暂无数据</div>
          </div>
          </van-pull-refresh>
        </div>

        <!-- 单据统一列表（快捷入口子视图）
             【P92】8 类共用 BillList 组件：与「合同详情内」的会议室订单/增值订单/支付订单/
             回款订单/余额明细/财务合同/发票/退款列表**骨架、搜索、状态筛选、合计、卡片、
             状态标签、分页、详情弹层完全一致**，差别仅在 scope（此处=指定全部）。
             销售端 scope=self（我创建的）；市场端改走 market 前缀并放开全量。
             【P205 1.2.002】会议室订单（billKey=room）去掉头部「金额合计」。
             【P205 1.2.004】会议室订单改用独立卡片样式（room-card）：标题+金额胶囊+状态胶囊 /
             审核状态 / 编号·日期 / 所属客户·所属商机 / 编辑·删除两个等宽大按钮。 -->
        <!-- 【P439】客户回收站（快捷入口子视图 · 仅销售总经理 / 销售部负责人可达）
             删除客户只软删 is_delete=1，名下商机/合同/发票/会议室订单/联系人/回访一律不动；
             这里可「恢复」回客户列表，也可「彻底删除」（名下有单据时二次确认后才会真删）。 -->
        <div v-if="quickSub==='recycle'" class="recycle-page">
          <div class="top-nav">
            <span class="top-nav__back" @click="quickSub='grid'">‹ 返回</span>
            客户回收站
            <span class="top-nav__cnt" v-if="recycleTotal>0">共 {{ recycleTotal }} 个</span>
          </div>

          <div class="recycle-search">
            <div class="recycle-search__box">
              <van-icon name="search" class="recycle-search__ic" />
              <input
                v-model="recycleSearch"
                type="search"
                class="recycle-search__ipt"
                placeholder="搜索客户名称 / 编号"
                @keyup.enter="onRecycleSearch"
              />
              <span v-if="recycleSearch" class="recycle-search__clr" @click="clearRecycleSearch">✕</span>
            </div>
            <button class="recycle-search__btn" @click="onRecycleSearch">搜索</button>
          </div>

          <van-pull-refresh v-model="recycleRefreshing" @refresh="onRecycleRefresh" class="recycle-body">
            <div class="list-box recycle-list-box">
              <van-list
                :loading="recycleLoading"
                :finished="recycleFinished"
                finished-text="没有更多了"
                @load="getRecycleList"
              >
                <div class="crm-item recycle-card" v-for="row in recycleRows" :key="row.sn">
                  <div class="recycle-card__title">{{ row.name || '（未命名客户）' }}</div>
                  <div class="recycle-card__meta">
                    <span v-if="row.serial_number">编号 {{ row.serial_number }}</span>
                    <span v-if="row.owner_name">负责人 {{ row.owner_name }}</span>
                  </div>
                  <div class="recycle-card__meta recycle-card__meta--del">
                    <span>删除人 {{ row.delete_user_name || '—' }}</span>
                    <span>删除时间 {{ row.delete_time || '—' }}</span>
                  </div>
                  <div class="recycle-card__acts">
                    <button
                      class="rc-btn rc-btn--restore"
                      :disabled="recycleBusySn===row.sn"
                      @click="askRestore(row)"
                    >{{ recycleBusySn===row.sn ? '处理中…' : '恢复' }}</button>
                    <button
                      class="rc-btn rc-btn--purge"
                      :disabled="recycleBusySn===row.sn"
                      @click="askPurge(row)"
                    >彻底删除</button>
                  </div>
                </div>
              </van-list>

              <div v-if="!recycleLoading && !recycleRows.length" class="recycle-empty">
                <svg class="recycle-empty__ic" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M4 7h16" />
                  <path d="M9.5 7V4.5h5V7" />
                  <path d="M6.5 7l1 12.5h9L17.5 7" />
                </svg>
                <div class="recycle-empty__tx">{{ recycleSearch ? '没有匹配的客户' : '回收站是空的' }}</div>
                <div class="recycle-empty__sub">
                  {{ recycleSearch ? '换个关键字试试' : '删除的客户会暂存在这里，可随时恢复' }}
                </div>
              </div>
            </div>
          </van-pull-refresh>
        </div>

        <bill-list
          v-if="quickSub==='billlist'"
          ref="billList"
          :key="quickBillType"
          :bill-type="quickBillType"
          scope="self"
          api-prefix="client"
          :show-amount="quickBillType !== 'room'"
          :room-card="quickBillType === 'room'"
          filter-engine="sales"
          @back="quickSub='grid'"
          @edit="onQuickBillEdit"
          @delete="onQuickBillDelete"
        />

      </div>

      <!-- ============ 会议室订单：列表 + 新增/编辑/删除 ============ -->
      <div v-if="active==0 && roomSub==='meeting'" class="room-meeting-wrap">
       <div class="customer-header" ref="roomOrderHeader">
         <div class="customer-header__top">
           <div class="customer-header__left">
             <span class="customer-header__title">会议室订单</span>
           </div>
           <div class="customer-header__search">
             <el-input v-model="searchText" class="search-input" placeholder="搜索客户/门店/会议室" @change="search()">
               <i slot="prefix" class="el-icon-search"></i>
             </el-input>
           </div>
           <div class="customer-header__actions">
             <!-- 【P32-#4】会议室订单筛选（使用时间/时段/是否收费/会议室） -->
             <div class="customer-header__btn" @click="openRoomOrderFilter">
               <van-icon name="filter-o" />
               <span>筛选</span>
             </div>
             <div class="customer-header__btn customer-header__btn--primary" @click="openRoomOrderAdd">
               <i class="el-icon-plus"></i>
               <span>新增订单</span>
             </div>
           </div>
         </div>
         <!-- 【P32-#2】审核状态 tab：全部 / 审核中 / 审核通过 / 审核驳回 -->
         <div class="customer-header__tabs">
           <div v-for="(tab, idx) in roomOrderTabs" :key="idx"
                class="customer-header__tab"
                :class="{'customer-header__tab--active': roomOrderTab === tab.value}"
                @click="onRoomOrderTabClick(tab)">
             {{tab.label}}
           </div>
         </div>
       </div>
       <div class="filter-status-bar" v-if="roomOrderFilterLabels.length">
         <span class="filter-status-bar__txt">筛选：{{ roomOrderFilterLabels.join(' · ') }}</span>
         <span class="filter-status-bar__clear" @click="clearRoomOrderFilter">清除</span>
       </div>
       <div class="customer-header-spacer" v-show="customerHeaderH" :style="{height: customerHeaderH + 'px'}"></div>

       <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
         <div class="list-box">
           <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
             <!-- 【P419】卡片改用全站公共组件 RoomCard（本页 roomorder-item 的公共实现）：
                  标题独占整行完整显示、状态标签独立一行且同字去重、左侧无蓝条、
                  「更多」展开区 6 项与原来一致。
                  编辑/删除的可见性仍由行级 can_edit 决定；审核中（status=0）时编辑按钮
                  置灰不可点（与后端 save/delete 的 403 拦截同口径，双层防护）。 -->
             <room-card
               v-for="(item, idx) in roomOrderList"
               :key="item.sn || idx"
               :item="item"
               :can-edit="Number(item.can_edit)===1"
               :can-delete="Number(item.can_edit)===1"
               :edit-disabled="Number(item.status)===0"
               @edit="onRoomOrderEdit(idx)"
               @delete="onRoomOrderDelete(idx)"
             />
           </van-list>
         </div>
       </van-pull-refresh>


      </div>

       <van-popup v-model="dialogRoomOrder" round position="bottom" :style="{ height: '90%' }">
         <div class="form-page form-page--roomorder">
           <div class="form-title">{{ roomOrderTitle }}</div>
           <div class="form-body">

             <div class="form-group">
               <div class="form-group__hd">基础信息</div>
              <!-- 【P36】合同：已关联销售合同的订单置为只读（与「销售合同 → 会议室预订单」Tab 编辑口径一致）；
                   未关联时仍可选填，选定后由后端按表关联自动带出 客户 / 商机 / 财务合同号 -->
              <div class="ro-field" :class="{'ro-field--lock':roomOrderContractLocked}"
                   @click="roomOrderContractLocked ? null : openOrderPick('roomorder')">
                <div class="ro-label">合同</div>
                <div class="ro-val" :class="{placeholder:!roomOrderForm.order_name}">{{roomOrderForm.order_name || '选填，关联销售合同'}}</div>
                 <span class="ro-arrow" v-if="!roomOrderContractLocked">›</span>
                 <span class="ro-lock" v-else><van-icon name="lock" /></span>
               </div>
               <!-- 【P38】直达「当前会议室订单所在销售合同」详情页。
                    仅当该销售合同对当前账号可见时开放（口径同销售合同列表：部门级 / 本人），
                    无权限时不渲染入口，避免出现「点得进去但看不到」的错觉。 -->
               <div class="ro-contract-link"
                    v-if="roomOrderForm.parent_sn && roomOrderCanViewContract===1"
                    @click="openContractFromRoomOrder">
                 <van-icon name="orders-o" class="ro-contract-link__ico" />
                 <span class="ro-contract-link__txt">查看销售合同详情</span>
                 <span class="ro-contract-link__arrow">›</span>
               </div>
               <!-- 【P354】所属客户改为**锁定不可改**（用户 10-14 需求，与 contractDetail 口径一致）。
                    客户必须与上级销售合同一致，否则「订单客户 ≠ 合同客户」造成数据口径分裂；
                    值由选销售合同时自动带入（见 onOrderPickSelect）。 -->
               <div class="ro-field ro-field--lock">
                 <div class="ro-label"><span class="required">*</span>所属客户</div>
                 <div class="ro-val" :class="{placeholder:!roomOrderForm.customer_name}">{{roomOrderForm.customer_name || '请先选择销售合同（自动带出，不可修改）'}}</div>
                 <span class="ro-lock"><van-icon name="lock" /></span>
               </div>
              <!-- 【P348 / P351】所属商机**继承上级销售合同、只读不可选**（用户 10-14 需求）。
                   ★【P351 修正】用户反馈「没锁定也没数据」—— 实际是「直接新增（尚未选合同）」场景下：
                     · 只有 `ro-field--lock` 的灰字，**没有锁图标** ⇒ 视觉上完全不像只读；
                     · 提示文案「选择销售合同后自动带出」也看不出这是不可编辑的字段。
                   改法：① 补 `.ro-lock` 锁图标（与 contractDetail 的只读 select 同一视觉语言）；
                        ② 提示文案改为「请先选择销售合同（自动带出，不可修改）」，明确不可选。 -->
              <div class="ro-field ro-field--lock">
                <div class="ro-label"><span class="required">*</span>所属商机</div>
                <div class="ro-val" :class="{placeholder:!roomOrderForm.opportunitie_name}">{{roomOrderForm.opportunitie_name || '请先选择销售合同（自动带出，不可修改）'}}</div>
                <span class="ro-lock"><van-icon name="lock" /></span>
              </div>
               <div class="ro-field" @click="openStorePick">
                 <div class="ro-label"><span class="required">*</span>所属门店</div>
                 <div class="ro-val" :class="{placeholder:!roomOrderForm.store_name}">{{roomOrderForm.store_name || '请选择门店'}}</div>
                 <span class="ro-arrow">›</span>
               </div>
               <div class="ro-field" @click="openRoomPick">
                 <div class="ro-label"><span class="required">*</span>会议室</div>
                 <div class="ro-val" :class="{placeholder:!roomOrderForm.room_name}">{{roomOrderForm.room_name || '请先选门店与日期'}}</div>
                 <span class="ro-arrow">›</span>
               </div>
             </div>

             <div class="form-group">
               <div class="form-group__hd">时间</div>
               <div class="ro-field" @click="openDatePick('roomorder','on_site_time','使用日期')">
                 <div class="ro-label"><span class="required">*</span>使用日期</div>
                 <div class="ro-val" :class="{placeholder:!roomOrderForm.on_site_time}">{{roomOrderForm.on_site_time || '请选择日期'}}</div>
                 <span class="ro-arrow">›</span>
               </div>
               <div class="ro-field" @click="dialogTimeTypePick=true">
                 <div class="ro-label"><span class="required">*</span>时段</div>
                 <div class="ro-val" :class="{placeholder:!timeTypeText}">{{timeTypeText || '请选择时段'}}</div>
                 <span class="ro-arrow">›</span>
               </div>
               <div class="ro-field">
                 <div class="ro-label">使用时间</div>
                 <!-- 【P33 修复】由裸文本输入框改为滑动时间选择器（默认 08:30 / 20:30）。
                      原输入框允许任意字符，用户输成 "0830"（少冒号）会直接落库成
                      start_time=["0830","20:30"]，与老系统口径不符。 -->
                 <div class="ro-range">
                   <div class="ro-input ro-input--pick" @click="openRoomOrderTimePick('begin')">
                     <span :class="{placeholder:!roomOrderForm.start_time_begin}">{{roomOrderForm.start_time_begin || '08:30'}}</span>
                   </div>
                   <span class="ro-tilde">~</span>
                   <div class="ro-input ro-input--pick" @click="openRoomOrderTimePick('end')">
                     <span :class="{placeholder:!roomOrderForm.start_time_end}">{{roomOrderForm.start_time_end || '20:30'}}</span>
                   </div>
                 </div>
               </div>
               <div class="ro-field">
                 <div class="ro-label"><span class="required">*</span>人数</div>
                 <!-- 【P95】三.3.01 人数改 TEXT：不校验数字，写了就算（DB 本就是 varchar(50)） -->
                 <input class="ro-input" v-model="roomOrderForm.number_people" placeholder="请输入人数（可填文字）">
               </div>
             </div>

             <div class="form-group">
               <div class="form-group__hd">金额</div>
               <div class="ro-field">
                 <div class="ro-label">市场价格</div>
                 <input class="ro-input" type="number" v-model="roomOrderForm.price" placeholder="自动带出 / 可改">
               </div>
              <div class="ro-field">
                <div class="ro-label"><span class="required" v-if="Number(roomOrderForm.is_free)!==2">*</span>销售价格</div>
                <input class="ro-input" type="number" v-model="roomOrderForm.amount" :placeholder="Number(roomOrderForm.is_free)===2 ? '免费单无需填写' : '请输入销售价格'">
              </div>
               <div class="ro-field">
                 <div class="ro-label">折扣率</div>
                 <div class="ro-val" :class="{placeholder:!roomOrderDiscountText}">{{roomOrderDiscountText || '自动计算'}}</div>
               </div>
             </div>

             <div class="form-group">
               <div class="form-group__hd">配置</div>
               <div class="ro-chips-wrap">
                 <div class="ro-chips-label">桌型 <span class="required">*</span></div>
                 <div class="ro-chips">
                   <span v-for="t in roomOrderFormData.table_types" :key="t.id" class="ro-chip" :class="{'ro-chip--on':isChipOn(roomOrderForm.table_types, t.id)}" @click="toggleTableType(t.id)">{{t.name}}</span>
                 </div>
                 <div v-if="roomOrderFormData.table_types.length==0" class="pick-empty">桌型加载中…</div>
               </div>
               <div class="ro-chips-wrap">
                 <div class="ro-chips-label">增值服务</div>
                 <div class="ro-chips">
                   <span v-for="s in roomOrderFormData.option_service" :key="s.id" class="ro-chip" :class="{'ro-chip--on':isChipOn(roomOrderForm.option_service, s.id)}" @click="toggleOptionService(s.id)">{{s.name}}</span>
                 </div>
                 <div v-if="roomOrderFormData.option_service.length==0" class="pick-empty">服务加载中…</div>
               </div>
               <div class="ro-field" @click="dialogIsFreePick=true">
                 <div class="ro-label">是否免费</div>
                 <div class="ro-val" :class="{placeholder:!isFreeText}">{{isFreeText || '否'}}</div>
                 <span class="ro-arrow">›</span>
               </div>
             </div>

            <div class="form-group">
              <div class="form-group__hd">回款计划</div>
              <!-- 【P95】三.3.06 免费单也允许编辑回款计划（原来 v-if/v-else 只显示一行提示 →
                   用户反馈「编辑的时候没有回款计划的编辑」）。保留提示但不再锁死。 -->
              <div v-if="Number(roomOrderForm.is_free)===2" class="ro-free-hint">当前为免费订单，通常无需填写回款计划；如需填写可直接添加</div>
              <div class="ro-pay">
                <div v-for="(p,idx) in roomOrderForm.payment" :key="idx" class="ro-payrow">
                  <div class="ro-cell" :class="{placeholder:!p.payment_date}" @click="openPaymentDatePick(idx)">{{p.payment_date || '回款日期'}}</div>
                  <input class="ro-cell ro-cell--input" type="number" v-model="p.amount" placeholder="金额（元）">
                  <div class="ro-del" @click="removeRoomOrderPayment(idx)">×</div>
                </div>
                <div class="ro-addpay" @click="addRoomOrderPayment">+ 添加回款计划</div>
              </div>
            </div>

             <div class="form-group">
               <div class="form-group__hd">备注</div>
               <div class="ro-textarea">
                 <textarea v-model="roomOrderForm.remark" placeholder="选填"></textarea>
               </div>
             </div>

           </div>
           <!-- 【P214】新增「保存并继续」：保存后不关弹层、表单清空，可直接录下一单 -->
           <div class="form-footer">
             <div class="ro-btn ro-btn--cancel" @click="closeRoomOrder">取消</div>
             <div class="ro-btn ro-btn--cont" :class="{'ro-btn--busy':roomOrderSaving}" @click="submitRoomOrder(true)">
               {{roomOrderSaving ? '保存中…' : '保存并继续'}}
             </div>
             <div class="ro-btn ro-btn--save" @click="submitRoomOrder(false)">{{roomOrderSaving ? '保存中…' : '保存'}}</div>
           </div>
         </div>
       </van-popup>

       <!-- 门店选择器 -->
       <van-popup v-model="dialogStorePick" round position="bottom" :style="{ height: '70%' }">
         <div class="form-page">
           <div class="form-title">选择门店</div>
           <div class="pick-search">
             <el-input v-model="storePickKeyword" class="search-input" placeholder="搜索门店" @change="loadStorePick()"></el-input>
           </div>
           <div class="pick-body">
             <div v-if="storePickList.length==0" class="pick-empty">暂无门店</div>
             <div v-for="(row, i) in storePickList" :key="i" class="pick-item" @click="onStorePickSelect(row)">
               <div class="pick-name">{{row.title || row.name}}</div>
             </div>
           </div>
           <div class="form-footer"><van-button block plain @click="dialogStorePick=false">取消</van-button></div>
         </div>
       </van-popup>

       <!-- 会议室选择器（依赖门店 + 日期） -->
       <van-popup v-model="dialogRoomPick" round position="bottom" :style="{ height: '70%' }">
         <div class="form-page">
           <div class="form-title">选择会议室</div>
           <div class="pick-body">
             <div v-if="roomPickList.length==0" class="pick-empty">请先选择门店与日期</div>
             <div v-for="(row, i) in roomPickList" :key="i" class="pick-item" @click="onRoomPickSelect(row)">
               <div class="pick-name">{{row.room_number}} <span v-if="row.name">{{row.name}}</span></div>
             </div>
           </div>
           <div class="form-footer"><van-button block plain @click="dialogRoomPick=false">取消</van-button></div>
         </div>
       </van-popup>

       <!-- 时段选择 -->
       <van-popup v-model="dialogTimeTypePick" round position="bottom" :style="{ height: '60%' }">
         <div class="form-page">
           <div class="form-title">选择时段</div>
           <div class="pick-body">
             <div v-for="(t, i) in roomOrderFormData.time_type" :key="i" class="pick-item" @click="roomOrderForm.time_type=t.value; dialogTimeTypePick=false">
               <div class="pick-name">{{t.label}}</div>
             </div>
           </div>
         </div>
       </van-popup>

       <!-- 是否免费选择 -->
       <van-popup v-model="dialogIsFreePick" round position="bottom" :style="{ height: '60%' }">
         <div class="form-title">是否免费</div>
         <div class="pick-body">
           <div v-for="(t, i) in roomOrderFormData.is_free" :key="i" class="pick-item" @click="roomOrderForm.is_free=t.value; dialogIsFreePick=false">
             <div class="pick-name">{{t.label}}</div>
           </div>
         </div>
       </van-popup>

       <!-- 删除确认（全站统一版：ConfirmDialog 居中弹窗） -->
       <ConfirmDialog
         v-model="dialogRoomOrderDelete"
         desc="确定要删除该会议室订单吗？删除后不可恢复。"
         @confirm="confirmRoomOrderDelete"
       />

      <!-- 公共：客户选择器（商机 / 合同 表单共用） -->
      <van-popup v-model="dialogCustPick" round position="bottom" :style="{ height: '70%' }">
        <div class="form-page">
          <div class="form-title">选择客户</div>
          <div class="pick-search">
            <el-input v-model="custPickKeyword" class="search-input" placeholder="搜索客户名称" @change="loadCustPick()"></el-input>
          </div>
          <div class="pick-body">
            <div v-if="custPickList.length==0" class="pick-empty">暂无客户</div>
            <div v-for="(row, i) in custPickList" :key="i" class="pick-item" @click="onCustPickSelect(row)">
              <div class="pick-name">{{row.item ? row.item.name : row.name}}</div>
              <div class="pick-sub">{{row.item && row.item.customer_name ? row.item.customer_name : ''}} {{row.item && row.item.customer_phone ? row.item.customer_phone : ''}}</div>
            </div>
          </div>
          <div class="form-footer">
            <van-button block plain @click="dialogCustPick=false">取消</van-button>
          </div>
        </div>
      </van-popup>

      <!-- 公共：商机选择器（合同 / 会议室订单 共用） -->
      <van-popup v-model="dialogOppPick" round position="bottom" :style="{ height: '70%' }">
        <div class="form-page">
          <div class="form-title">选择商机</div>
          <div class="pick-search">
            <el-input v-model="oppPickKeyword" class="search-input" placeholder="搜索商机名称/客户名称" @change="loadOppPick()"></el-input>
          </div>
          <div class="pick-body">
            <div v-if="oppPickList.length==0" class="pick-empty">暂无商机</div>
            <div v-for="(row, i) in oppPickList" :key="i" class="pick-item" @click="onOppPickSelect(row)">
              <div class="pick-name">{{row.item ? row.item.name : row.name}}</div>
              <div class="pick-sub">{{row.item && row.item.customer_name ? row.item.customer_name : ''}}</div>
            </div>
          </div>
          <div class="form-footer">
            <van-button block plain @click="dialogOppPick=false">取消</van-button>
          </div>
        </div>
      </van-popup>

      <!-- 公共：合同选择器（会议室订单用） -->
      <van-popup v-model="dialogOrderPick" round position="bottom" :style="{ height: '70%' }">
        <div class="form-page">
          <div class="form-title">选择销售合同</div>
          <div class="pick-search">
            <el-input v-model="orderPickKeyword" class="search-input" placeholder="搜索合同名称/客户名称" @change="loadOrderPick()"></el-input>
          </div>
          <div class="pick-body">
            <div v-if="orderPickList.length==0" class="pick-empty">暂无合同</div>
            <div v-for="(row, i) in orderPickList" :key="i" class="pick-item" @click="onOrderPickSelect(row)">
              <div class="pick-name">{{row.item ? row.item.name : row.name}}</div>
              <div class="pick-sub">{{row.item && row.item.customer_name ? row.item.customer_name : ''}}</div>
            </div>
          </div>
          <div class="form-footer">
            <van-button block plain @click="dialogOrderPick=false">取消</van-button>
          </div>
        </div>
      </van-popup>

      <!-- 公共：日期选择器 -->
      <van-popup v-model="dialogDatePick" round position="bottom">
        <van-datetime-picker
          type="date"
          v-model="datePickValue"
          :title="datePickTitle"
          @confirm="onDatePickConfirm"
          @cancel="dialogDatePick=false"
        />
      </van-popup>

      <!-- 删除确认（全站统一版：ConfirmDialog 居中弹窗） -->
      <ConfirmDialog
        v-model="delDialogShow"
        :desc="'确定要删除「' + (delName || '') + '」吗？删除后不可恢复。'"
        :loading="delDoing"
        loading-text="删除中"
        @confirm="confirmDelete"
      />

      <!-- 【P439】删除客户（移入回收站）确认 —— 文案会按名下单据数量动态补充 -->
      <ConfirmDialog
        v-model="custDelShow"
        title="删除客户"
        :desc="custDelDesc"
        :loading="custDelBusy"
        loading-text="删除中"
        confirm-text="移入回收站"
        @confirm="confirmDeleteCustomer"
      />

      <!-- 【P439】彻底删除（物理删除）确认 —— 名下有单据时后端返回 409，这里再确认一次走 force=1 -->
      <ConfirmDialog
        v-model="purgeShow"
        title="彻底删除"
        :desc="purgeDesc"
        :loading="purgeBusy"
        loading-text="删除中"
        confirm-text="彻底删除"
        @confirm="confirmPurgeCustomer"
      />

      <!-- 退出登录确认（P46，同一套 ConfirmDialog） -->
      <ConfirmDialog
        v-model="logoutShow"
        title="退出登录"
        desc="确认退出当前账号？退出后需重新登录才能继续使用。"
        confirm-text="退出"
        @confirm="doLogout"
      />

      <!-- 【P204 S2】联系人「全网重复」确认（同一套 ConfirmDialog；用户点「仍要保存」= 强制落库） -->
      <ConfirmDialog
        v-model="contactDupShow"
        title="联系方式重复提醒"
        :desc="contactDupDesc"
        :loading="contactSaving"
        loading-text="保存中"
        confirm-text="仍要保存"
        cancel-text="返回修改"
        @confirm="forceSaveContact"
      />

      <!-- 回款计划日期选择器 -->
      <van-popup v-model="dialogPaymentDatePick" round position="bottom">
        <van-datetime-picker
          type="date"
          v-model="datePickValue"
          title="回款日期"
          @confirm="onPaymentDateConfirm"
          @cancel="dialogPaymentDatePick=false"
        />
      </van-popup>

      <!-- 【P120】登录态下隐藏底栏：否则 PC/H5 的登录页底部会露出「房态/客户/商机…」 -->
      <van-tabbar v-if="!showLogin" v-model="active" @change="onTabbarChange" active-color="#2b5fd9" inactive-color="#969799">
        <van-tabbar-item>
          <template #icon="{ active }">
            <svg viewBox="0 0 24 24" :style="tabIco(active)"><path d="M3 21V10l9-7 9 7v11H3z"/></svg>
          </template>
          房态
        </van-tabbar-item>
        <van-tabbar-item>
          <template #icon="{ active }">
            <svg viewBox="0 0 24 24" :style="tabIco(active)"><circle cx="12" cy="8" r="3.5"/><path d="M5 21a7 7 0 0 1 14 0"/></svg>
          </template>
          客户
        </van-tabbar-item>
        <van-tabbar-item>
          <template #icon="{ active }">
            <svg viewBox="0 0 24 24" :style="tabIco(active)"><path d="M3 17h18"/><path d="M5 13l4-4 4 4 6-6"/></svg>
          </template>
          商机
        </van-tabbar-item>
        <van-tabbar-item>
          <template #icon="{ active }">
            <svg viewBox="0 0 24 24" :style="tabIco(active)"><path d="M7 3h7l4 4v14H7z"/><path d="M14 3v4h4M9 12h5M9 15h5"/></svg>
          </template>
          合同
        </van-tabbar-item>
        <van-tabbar-item :dot="msgUnread > 0">
          <template #icon="{ active }">
            <svg viewBox="0 0 24 24" :style="tabIco(active)"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>
          </template>
          快捷
        </van-tabbar-item>
      </van-tabbar>

      <!-- 合同详情内嵌遮罩：返回只关闭遮罩，不跳路由 -->
      <div class="contract-detail-overlay" v-if="contractDetailVisible">
        <contract-detail
          :contract-sn="contractDetailSn"
          :pending-bill="pendingBillKey"
          :pending-edit-sn="pendingEditSn"
          :pending-room-sn="contractDetailRoomSn"
          :embedded="true"
          @back="closeContractDetail"
          @edit="onContractEdit"
          @deleted="onContractDeleted"
          @changed="onContractChanged"
        />
      </div>

      <!-- ===== 客户详情 子视图 ===== -->
      <van-popup v-model="detailShow" position="right" :style="{width:'100%',height:'100%'}" class="cust-detail-pop">
        <div class="cust-detail">
          <div class="cust-detail__nav">
            <div class="cust-detail__back" @click="closeCustomerDetail">‹ 返回</div>
            <div class="cust-detail__title">客户详情</div>
            <div class="cust-detail__spacer"></div>
            <div class="cust-detail__action" @click="openChangeLog">变更记录</div>
          </div>

          <div class="cust-detail__body" v-if="!detailLoading">
            <!-- hero -->
            <div class="cust-hero">
              <div class="cust-hero__name">{{detailCustomer.name}}</div>
              <div class="cust-hero__code" v-if="detailCustomer.serial_number">客户编号：{{detailCustomer.serial_number}}</div>
              <div class="cust-hero__tags">
                <span class="pill" v-if="detailCustomer.type">{{customerText('type', detailCustomer.type)}}</span>
                <span class="pill" v-if="detailCustomer.publish_status==1">待接收</span>
                <span class="pill" v-else-if="detailCustomer.publish_status==2">已发布</span>
                <span class="pill" v-else>未发布</span>
              </div>
            </div>

            <!-- 客户信息 -->
            <div class="card">
              <div class="card__title"><span class="dot"></span>客户信息</div>
              <div class="info-list">
                <div class="info-item"><span class="info-item__label">行业</span><span class="info-item__value">{{detailCustomer.industry_text || customerText('industry', detailCustomer.industry) || '-'}}</span></div>
                <div class="info-item"><span class="info-item__label">来源渠道</span><span class="info-item__value">{{customerText('source', detailCustomer.source) || '-'}}</span></div>
                <div class="info-item"><span class="info-item__label">负责人</span><span class="info-item__value" :class="{'empty':!detailCustomer.owner_name}">{{detailCustomer.owner_name || '-'}}</span></div>
                <div class="info-item"><span class="info-item__label">意向门店</span><span class="info-item__value">{{detailCustomer.store_name || detailCustomer.store_sn || '-'}}</span></div>
                <div class="info-item"><span class="info-item__label">询价日期</span><span class="info-item__value" :class="{'empty':!detailCustomer.enquiry_data}">{{detailCustomer.enquiry_data || '-'}}</span></div>
                <div class="info-item"><span class="info-item__label">用途 / 人数</span><span class="info-item__value">{{customerText('use', detailCustomer.use) || '-'}}{{detailCustomer.number_people ? ' / '+detailCustomer.number_people+'人' : ''}}</span></div>
                <div class="info-item info-item--remark" v-if="detailCustomer.address_text"><span class="info-item__label">地址</span><span class="info-item__value">{{detailCustomer.address_text}}</span></div>
                <div class="info-item info-item--remark" v-if="detailCustomer.remark"><span class="info-item__label">备注</span><span class="info-item__value" v-html="detailCustomer.remark"></span></div>
              </div>
            </div>

            <!-- 联系人 -->
            <div class="sec"><div class="sec__title"><span class="bar" style="background:#7c5cf6;"></span>联系人 <span class="sec__count">{{detailContacts.length}} 人</span></div></div>
            <div v-if="detailContacts.length===0" class="empty">暂无联系人</div>
            <div v-for="(c,ci) in detailContacts" :key="'ct-'+(c.sn||ci)" class="card" :class="{'is-open': contactExpanded[c.sn]}">
              <div class="contact" @click="toggleContactExpand(c)">
                <div class="contact__avatar">{{(c.name||'?').slice(0,1)}}</div>
                <div class="contact__main">
                  <div class="contact__name">
                    <span class="contact__name-txt">{{c.name}}</span>
                    <span class="tag-imp" v-if="c.is_important">重要</span>
                    <van-icon name="arrow-down" class="contact__caret" :class="{up: contactExpanded[c.sn]}" />
                  </div>
                  <div class="contact__sub" v-if="c.department||c.position">{{c.department}}{{c.department&&c.position?' · ':''}}{{c.position}}</div>
                  <div class="contact__rows" v-if="c.phone || c.wx">
                    <div class="contact__row" v-if="c.phone"><van-icon name="phone-o" class="ic" />{{c.phone}}</div>
                    <div class="contact__row" v-if="c.wx"><van-icon name="comment-o" class="ic" />{{c.wx}}</div>
                  </div>
                  <!-- 展开详情：联系方式之外的字段 + 邮箱 -->
                  <div class="contact__detail" v-if="contactExpanded[c.sn]" @click.stop>
                    <div class="info-list" v-if="c.gender || c.birthday || c.email || c.remark">
                      <div class="info-item" v-if="c.gender"><span class="info-item__label">性别</span><span class="info-item__value">{{ c.gender===1 ? '男' : (c.gender===2 ? '女' : c.gender) }}</span></div>
                      <div class="info-item" v-if="c.birthday"><span class="info-item__label">生日</span><span class="info-item__value">{{c.birthday}}</span></div>
                      <div class="info-item" v-if="c.email"><span class="info-item__label">邮箱</span><span class="info-item__value">{{c.email}}</span></div>
                      <div class="info-item info-item--remark" v-if="c.remark"><span class="info-item__label">备注</span><span class="info-item__value">{{c.remark}}</span></div>
                    </div>
                    <div class="contact__detail-empty" v-else>暂无更多资料</div>
                  </div>
                </div>
              </div>
              <div class="card__actions">
                <button v-if="!(detailCustomer.publish_status==1 && detailCustomer.owner_id == currentStaffId)" class="act act--edit" @click="openContactSheet(c)">编辑</button>
                <button v-if="!(detailCustomer.publish_status==1 && detailCustomer.owner_id == currentStaffId)" class="act act--del" @click="askDelete('contact', c)">删除</button>
              </div>
            </div>

            <!-- 回访 -->
            <div class="sec"><div class="sec__title"><span class="bar" style="background:#1aa260;"></span>客户回访 <span class="sec__count">{{detailVisits.length}} 条</span></div></div>
            <div v-if="detailVisits.length===0" class="empty">暂无回访记录</div>
            <div v-for="(v,vi) in detailVisits" :key="'vs-'+(v.sn||vi)" class="card">
              <div class="visit__head"><div class="visit__title">{{v.title}}</div><div class="visit__date" v-if="v.visit_time">{{v.visit_time}}</div></div>
              <div class="visit__who" v-if="v.contact_sn">回访对象：{{visitContactName(v.contact_sn)}}</div>
              <div class="visit__content" v-if="v.content">{{v.content}}</div>
              <div class="visit__next" v-if="v.next_plan"><van-icon name="arrow" class="ic" />{{v.next_plan}}</div>
              <div class="card__actions">
                <button v-if="!(detailCustomer.publish_status==1 && detailCustomer.owner_id == currentStaffId)" class="act act--edit" @click="openVisitSheet(v)">编辑</button>
                <button v-if="!(detailCustomer.publish_status==1 && detailCustomer.owner_id == currentStaffId)" class="act act--del" @click="askDelete('visit', v)">删除</button>
              </div>
            </div>
          </div>

          <div class="cust-detail__loading" v-else>加载中…</div>

          <div class="cust-detail__bar">
            <!-- 【P125】待接收：客户尚未归属我，此时主操作是「接收 / 拒绝」，
                 用它们替换「＋联系人 / ＋回访 / 编辑客户」，与列表页卡片口径一致 -->
            <template v-if="detailCustomer.publish_status==1 && detailCustomer.owner_id == currentStaffId">
              <button class="btn btn--primary" :disabled="allocLoading" @click="allocOneFromDetail('receive')">接收</button>
              <button class="btn btn--danger" :disabled="allocLoading" @click="allocOneFromDetail('reject')">拒绝</button>
            </template>
            <template v-else>
              <button class="btn btn--secondary" @click="openContactSheet">＋ 联系人</button>
              <button class="btn btn--secondary" @click="openVisitSheet">＋ 回访记录</button>
              <button class="btn btn--primary" @click="editCustomerFromDetail">编辑客户</button>
              <!-- 【P439】删除客户（仅销售总经理 / 销售部负责人可见）；
                   图标按钮，避免 4 个等宽文字按钮在 375px 屏上挤爆 -->
              <button
                v-if="canCustomerDelete"
                class="btn btn--icon-del"
                aria-label="删除客户"
                title="删除客户"
                @click="askDeleteCustomer"
              >
                <svg viewBox="0 0 24 24">
                  <path d="M4 7h16" />
                  <path d="M9.5 7V4.5h5V7" />
                  <path d="M6.5 7l1 12.5h9L17.5 7" />
                  <path d="M10 10.5v6M14 10.5v6" />
                </svg>
              </button>
            </template>
          </div>
        </div>
      </van-popup>

      <!-- ===== 变更记录（右滑）【P122 重做】 ===== -->
      <van-popup v-model="changeLogShow" position="right" :style="{width:'100%',height:'100%'}" class="chg-pop">
        <div class="cl">
          <div class="chg__nav">
            <div class="chg__back" @click="closeChangeLog"><van-icon name="arrow-left" /></div>
            <div class="chg__title">变更记录</div>
            <div class="chg__count" v-if="logTotal">{{ logTotal }} 条</div>
            <div class="chg__spacer" v-else></div>
          </div>

          <div class="chg__filter">
            <div v-for="f in logFilters()" :key="f.value" class="chg__fitem"
                 :class="{ 'is-on': logFilter === f.value }" @click="logFilter = f.value">
              {{ f.label }}<span class="chg__fnum" v-if="f.count">{{ f.count }}</span>
            </div>
          </div>

          <div class="chg__body">
            <van-pull-refresh v-model="logRefreshing" @refresh="onLogRefresh" class="chg__pr">
              <van-list v-model="logLoading" :finished="logFinished" finished-text="没有更多了" @load="loadChangeLog" :immediate-check="false">

                <div v-if="!logLoading && logFilteredList().length === 0" class="chg__empty">
                  <van-icon name="records" class="chg__empty-icon" />
                  <div class="chg__empty-t">暂无变更记录</div>
                  <div class="chg__empty-s">客户信息被修改后，这里会留下完整痕迹</div>
                </div>

                <div v-for="g in logGrouped()" :key="g.day" class="chg__group">
                  <div class="chg__day">
                    <span class="chg__day-t">{{ g.day }}</span>
                    <span class="chg__day-line"></span>
                  </div>

                  <div v-for="item in g.items" :key="item.id" class="chg-card" :class="'is-' + item.action">
                    <div class="chg-card__ico"><van-icon :name="item._icon" /></div>
                    <div class="chg-card__main">
                      <div class="chg-card__head">
                        <span class="chg-card__act" :class="'is-' + item.action">{{ item._actionText }}</span>
                        <span class="chg-card__mod">{{ item._moduleText }}</span>
                        <span class="chg-card__time">{{ item._timeShort }}</span>
                      </div>
                      <div class="chg-card__title" v-if="item.title">{{ item.title }}</div>
                      <div class="chg-card__who"><van-icon name="manager-o" />{{ item.staff_name || '系统' }}</div>

                      <div v-if="item.action === 'delete' && item._snapRows.length" class="chg-snap">
                        <div class="chg-snap__h">删除时整行快照</div>
                        <div v-for="(r, ri) in item._snapRows" :key="ri" class="chg-snap__row">
                          <span class="chg-snap__k">{{ r.k }}</span><span class="chg-snap__v">{{ r.v }}</span>
                        </div>
                      </div>
                      <div v-else-if="item._changes.length" class="chg-diff">
                        <!-- 【P127】新增（add）只呈现字段值；编辑（edit）呈现「旧 → 新」对比。
                             原先新增也画「空 → 值」，既占宽又无意义。 -->
                        <div v-for="(c, ci) in item._changes" :key="ci"
                             class="chg-diff__row" :class="{ 'is-add': item.action === 'add' }">
                          <span class="chg-diff__f">{{ c.label }}</span>
                          <div class="chg-diff__vals">
                            <template v-if="item.action === 'add'">
                              <span class="chg-diff__a">{{ c.after === '' || c.after === null ? '空' : c.after }}</span>
                            </template>
                            <template v-else>
                              <span class="chg-diff__b">{{ c.before === '' || c.before === null ? '空' : c.before }}</span>
                              <van-icon name="arrow" class="chg-diff__ar" />
                              <span class="chg-diff__a">{{ c.after === '' || c.after === null ? '空' : c.after }}</span>
                            </template>
                          </div>
                        </div>
                      </div>
                      <div v-else class="chg-card__none">无字段明细</div>
                    </div>
                  </div>
                </div>

              </van-list>
            </van-pull-refresh>
          </div>
        </div>
      </van-popup>

      <!-- ===== 商机漏斗统计（右滑） ===== -->
      <van-popup v-model="oppStatShow" position="right" :style="{width:'100%',height:'100%'}" class="opp-stat-pop">
        <div class="opp-stat">
          <div class="opp-stat__nav">
            <div class="opp-stat__back" @click="oppStatShow=false">‹ 返回</div>
            <div class="opp-stat__title">商机漏斗</div>
            <div class="opp-stat__spacer"></div>
          </div>

          <div class="opp-stat__body" v-if="!oppStatLoading">
            <!-- hero 3 cells -->
            <div class="opp-hero">
              <div class="opp-hero__cell">
                <div class="opp-hero__num">{{oppStat.summary.total || 0}}</div>
                <div class="opp-hero__label">商机总数</div>
              </div>
              <div class="opp-hero__cell">
                <div class="opp-hero__num">¥{{fmtMoney(oppStat.summary.pipeline)}}</div>
                <div class="opp-hero__label">管线金额</div>
              </div>
              <div class="opp-hero__cell">
                <div class="opp-hero__num opp-hero__num--green">{{oppStat.summary.winRate || 0}}%</div>
                <div class="opp-hero__label">赢单率</div>
              </div>
            </div>

            <!-- 漏斗 -->
            <div class="sec"><div class="sec__title"><span class="bar" style="background:#2b5fd9;"></span>商机阶段漏斗</div></div>
            <div class="card opp-funnel">
              <div v-for="(f,fi) in oppStat.funnel" :key="fi" class="fbar" :class="'fbar--'+(fi+1)">
                <div class="fbar__head">
                  <span class="fbar__label">{{f.label}}</span>
                  <span class="fbar__cnt">{{f.cnt}} 单</span>
                </div>
                <div class="fbar__track">
                  <div class="fbar__fill" :style="{width: funnelWidth(f.cnt) + '%'}"></div>
                </div>
                <div class="fbar__meta">
                  <span>¥{{fmtMoney(f.amt)}}</span>
                  <span class="fbar__conv" v-if="oppStat.summary.total>0">占比 {{Math.round(f.cnt/(oppStat.summary.total||1)*100)}}%</span>
                </div>
              </div>
            </div>

            <!-- 失单分析 -->
            <div class="sec"><div class="sec__title"><span class="bar" style="background:#e94752;"></span>失单分析 <span class="sec__count">{{oppStat.lost.total}} 单</span></div></div>
            <div v-if="!oppStat.lost.total" class="empty">暂无失单</div>
            <div v-else class="card opp-lost">
              <div v-for="(r,ri) in oppStat.lost.reasons" :key="ri" v-show="r.cnt>0" class="lbar">
                <div class="lbar__head"><span>{{r.label}}</span><span>{{r.cnt}} 单</span></div>
                <div class="lbar__track"><div class="lbar__fill" :style="{width: lostWidth(r.cnt) + '%'}"></div></div>
              </div>
            </div>
          </div>

          <div class="opp-stat__loading" v-else>加载中…</div>
        </div>
      </van-popup>

      <!-- ===== 销售合同管理统计（右滑） ===== -->
      <van-popup v-model="contractStatShow" position="right" :style="{width:'100%',height:'100%'}" class="opp-stat-pop">
        <div class="opp-stat">
          <div class="opp-stat__nav">
            <div class="opp-stat__back" @click="contractStatShow=false">‹ 返回</div>
            <div class="opp-stat__title">合同统计</div>
            <div class="opp-stat__spacer"></div>
          </div>

          <div class="opp-stat__body" v-if="!contractStatLoading">
            <!-- hero 6 cells -->
            <div class="ct-hero">
              <div class="ct-hero__cell">
                <div class="ct-hero__num">{{contractStat.summary.contractCount || 0}}</div>
                <div class="ct-hero__label">合同总数</div>
              </div>
              <div class="ct-hero__cell">
                <div class="ct-hero__num">¥{{fmtMoney(contractStat.summary.amount)}}</div>
                <div class="ct-hero__label">合同总金额</div>
              </div>
              <div class="ct-hero__cell">
                <div class="ct-hero__num ct-hero__num--green">¥{{fmtMoney(contractStat.summary.paid)}}</div>
                <div class="ct-hero__label">已收金额</div>
              </div>
              <div class="ct-hero__cell">
                <div class="ct-hero__num">¥{{fmtMoney(contractStat.summary.receivables)}}</div>
                <div class="ct-hero__label">应收金额</div>
              </div>
              <div class="ct-hero__cell">
                <div class="ct-hero__num">¥{{fmtMoney(contractStat.summary.refund)}}</div>
                <div class="ct-hero__label">退款金额</div>
              </div>
              <div class="ct-hero__cell">
                <div class="ct-hero__num ct-hero__num--green">{{contractStat.summary.collectionRate || 0}}%</div>
                <div class="ct-hero__label">收款率</div>
              </div>
            </div>

            <!-- 合同种类构成 -->
            <div class="sec"><div class="sec__title"><span class="bar" style="background:#2b5fd9;"></span>合同种类构成</div></div>
            <div class="card">
              <div v-for="(c,ci) in contractStat.category" :key="ci" class="fbar" :class="'fbar--'+((ci%4)+1)">
                <div class="fbar__head">
                  <span class="fbar__label">{{c.label}}</span>
                  <span class="fbar__cnt">{{c.cnt}} 单</span>
                </div>
                <div class="fbar__track"><div class="fbar__fill" :style="{width: catWidth(c.cnt) + '%'}"></div></div>
                <div class="fbar__meta">
                  <span>¥{{fmtMoney(c.amt)}}</span>
                  <span class="fbar__conv" v-if="contractStat.summary.contractCount>0">占比 {{Math.round(c.cnt/(contractStat.summary.contractCount||1)*100)}}%</span>
                </div>
              </div>
            </div>

            <!-- 步骤构成 -->
            <div class="sec"><div class="sec__title"><span class="bar" style="background:#7c5cf6;"></span>合同步骤分布</div></div>
            <div class="card">
              <div v-for="(s,si) in contractStat.stage" :key="si" class="fbar" :class="'fbar--'+((si%4)+1)">
                <div class="fbar__head"><span class="fbar__label">{{s.label}}</span><span class="fbar__cnt">{{s.cnt}} 单</span></div>
                <div class="fbar__track"><div class="fbar__fill" :style="{width: stageWidth(s.cnt) + '%'}"></div></div>
                <div class="fbar__meta"><span class="fbar__conv" v-if="contractStat.summary.contractCount>0">占比 {{Math.round(s.cnt/(contractStat.summary.contractCount||1)*100)}}%</span></div>
              </div>
            </div>

            <!-- 回款单 -->
            <div class="sec"><div class="sec__title"><span class="bar" style="background:#1aa260;"></span>回款单 <span class="sec__count">已收 {{contractStat.payment.paid.cnt}} / 未收 {{contractStat.payment.unpaid.cnt}}</span></div></div>
            <div class="card">
              <div class="fbar__head" style="padding:10px 14px 2px;">
                <span class="fbar__label">已收金额</span>
                <span class="fbar__cnt">¥{{fmtMoney(contractStat.payment.paid.amt)}}</span>
              </div>
              <div class="fbar__head" style="padding:0 14px 10px;">
                <span class="fbar__label">未收金额</span>
                <span class="fbar__cnt">¥{{fmtMoney(contractStat.payment.unpaid.amt)}}</span>
              </div>
              <div v-for="(p,pi) in contractStat.payment.byStatus" :key="pi" class="fbar" :class="'fbar--'+((pi%4)+1)">
                <div class="fbar__head"><span class="fbar__label">{{p.label}}</span><span class="fbar__cnt">{{p.cnt}} 笔</span></div>
                <div class="fbar__track"><div class="fbar__fill" :style="{width: payWidth(p.cnt) + '%'}"></div></div>
                <div class="fbar__meta"><span>¥{{fmtMoney(p.amt)}}</span></div>
              </div>
            </div>

            <!-- 退款单 -->
            <div class="sec"><div class="sec__title"><span class="bar" style="background:#e94752;"></span>退款单 <span class="sec__count">未退 {{contractStat.refund.unrefunded.cnt}} 笔</span></div></div>
            <div v-if="!contractStat.refund.unrefunded.cnt" class="empty">暂无退款</div>
            <div v-else class="card opp-lost">
              <div v-for="(r,ri) in contractStat.refund.byStatus" :key="ri" class="lbar">
                <div class="lbar__head"><span>{{r.label}}</span><span>{{r.cnt}} 笔 · ¥{{fmtMoney(r.amt)}}</span></div>
                <div class="lbar__track"><div class="lbar__fill" :style="{width: refundWidth(r.cnt) + '%'}"></div></div>
              </div>
            </div>

            <!-- 发票 -->
            <div class="sec"><div class="sec__title"><span class="bar" style="background:#f0a020;"></span>发票 <span class="sec__count">{{contractStat.invoice.total.cnt}} 张 · ¥{{fmtMoney(contractStat.invoice.total.amt)}}</span></div></div>
            <div class="card">
              <div v-for="(iv,ivi) in contractStat.invoice.byType" :key="ivi" class="fbar" :class="'fbar--'+((ivi%4)+1)">
                <div class="fbar__head"><span class="fbar__label">{{iv.label}}</span><span class="fbar__cnt">{{iv.cnt}} 张</span></div>
                <div class="fbar__track"><div class="fbar__fill" :style="{width: invWidth(iv.cnt) + '%'}"></div></div>
                <div class="fbar__meta"><span>¥{{fmtMoney(iv.amt)}}</span></div>
              </div>
            </div>

            <!-- 合同 vs 订单业绩 -->
            <div class="sec"><div class="sec__title"><span class="bar" style="background:#323233;"></span>合同 vs 订单业绩</div></div>
            <div class="card ct-compare">
              <div class="ct-compare__row"><span>合同总金额</span><b>¥{{fmtMoney(contractStat.summary.amount)}}</b></div>
              <div class="ct-compare__row"><span>订单业绩总额</span><b>¥{{fmtMoney(contractStat.summary.orderAmount)}}</b></div>
              <div class="ct-compare__row ct-compare__row--muted"><span>订单数</span><span>{{contractStat.summary.orderCount}} 单</span></div>
            </div>
          </div>

          <div class="opp-stat__loading" v-else>加载中…</div>
        </div>
      </van-popup>

      <!-- ===== 销售订单管理统计（右滑） ===== -->
      <van-popup v-model="ordersStatShow" position="right" :style="{width:'100%',height:'100%'}" class="opp-stat-pop">
        <div class="opp-stat">
          <div class="opp-stat__nav">
            <div class="opp-stat__back" @click="ordersStatShow=false">‹ 返回</div>
            <div class="opp-stat__title">订单统计</div>
            <div class="opp-stat__spacer"></div>
          </div>
          <div class="opp-stat__body" v-if="!ordersStatLoading">
            <div class="ct-hero">
              <div class="ct-hero__cell">
                <div class="ct-hero__num">{{ordersStat.summary.orderCount || 0}}</div>
                <div class="ct-hero__label">订单总数</div>
              </div>
              <div class="ct-hero__cell">
                <div class="ct-hero__num">¥{{fmtMoney(ordersStat.summary.salesAmount)}}</div>
                <div class="ct-hero__label">销售金额</div>
              </div>
              <div class="ct-hero__cell">
                <div class="ct-hero__num">¥{{fmtMoney(ordersStat.summary.paymentAmount)}}</div>
                <div class="ct-hero__label">已支付</div>
              </div>
              <div class="ct-hero__cell">
                <div class="ct-hero__num">¥{{fmtMoney(ordersStat.summary.pendingAmount)}}</div>
                <div class="ct-hero__label">待支付</div>
              </div>
              <div class="ct-hero__cell">
                <div class="ct-hero__num">¥{{fmtMoney(ordersStat.summary.refundAmount)}}</div>
                <div class="ct-hero__label">退款</div>
              </div>
              <div class="ct-hero__cell">
                <div class="ct-hero__num">¥{{fmtMoney(ordersStat.summary.balanceAmount)}}</div>
                <div class="ct-hero__label">余额</div>
              </div>
            </div>

            <div class="sec"><div class="sec__title"><span class="bar" style="background:#2b5fd9;"></span>订单类型构成</div></div>
            <div class="card">
              <div v-for="(c,ci) in ordersStat.type" :key="ci" class="fbar" :class="'fbar--'+((ci%4)+1)">
                <div class="fbar__head"><span class="fbar__label">{{c.label}}</span><span class="fbar__cnt">{{c.cnt}} 单</span></div>
                <div class="fbar__track"><div class="fbar__fill" :style="{width: orderTypeWidth(c.cnt) + '%'}"></div></div>
                <div class="fbar__meta"><span>¥{{fmtMoney(c.amt)}}</span><span class="fbar__conv" v-if="ordersStat.summary.orderCount>0">占比 {{Math.round(c.cnt/(ordersStat.summary.orderCount||1)*100)}}%</span></div>
              </div>
            </div>

            <div class="sec"><div class="sec__title"><span class="bar" style="background:#1aa260;"></span>审核状态</div></div>
            <div class="card">
              <div v-for="(s,si) in ordersStat.status" :key="si" class="fbar" :class="'fbar--'+((si%4)+1)">
                <div class="fbar__head"><span class="fbar__label">{{s.label}}</span><span class="fbar__cnt">{{s.cnt}} 单</span></div>
                <div class="fbar__track"><div class="fbar__fill" :style="{width: orderStatusWidth(s.cnt) + '%'}"></div></div>
                <div class="fbar__meta"><span>¥{{fmtMoney(s.amt)}}</span><span class="fbar__conv" v-if="ordersStat.summary.orderCount>0">占比 {{Math.round(s.cnt/(ordersStat.summary.orderCount||1)*100)}}%</span></div>
              </div>
            </div>

            <div class="sec"><div class="sec__title"><span class="bar" style="background:#7c5cf6;"></span>步骤分布</div></div>
            <div class="card">
              <div v-for="(st,sti) in ordersStat.stage" :key="sti" class="fbar" :class="'fbar--'+((sti%4)+1)">
                <div class="fbar__head"><span class="fbar__label">{{st.label}}</span><span class="fbar__cnt">{{st.cnt}} 单</span></div>
                <div class="fbar__track"><div class="fbar__fill" :style="{width: orderStageWidth(st.cnt) + '%'}"></div></div>
                <div class="fbar__meta"><span class="fbar__conv" v-if="ordersStat.summary.orderCount>0">占比 {{Math.round(st.cnt/(ordersStat.summary.orderCount||1)*100)}}%</span></div>
              </div>
            </div>
          </div>
          <div class="opp-stat__loading" v-else>加载中…</div>
        </div>
      </van-popup>

      <!-- ===== 添加联系人 表单 ===== -->
      <van-popup v-model="contactSheetShow" round position="bottom" class="form-sheet">
        <div class="form-sheet__head">
          <div class="form-sheet__title">{{contactSheetTitle}}</div>
          <div class="form-sheet__close" @click="closeContactSheet">×</div>
        </div>
        <div class="form-sheet__body">
          <div class="field"><label>姓名 <span class="req">*</span></label><input v-model="contactForm.name" placeholder="请输入联系人姓名" class="f-input"/></div>
          <div class="row2">
            <div class="field"><label>手机 <span class="req">*</span></label><input v-model="contactForm.phone" placeholder="请输入手机号" class="f-input"/></div>
            <div class="field"><label>性别</label>
              <div class="seg"><span :class="{on:contactForm.gender==1}" @click="contactForm.gender=1">男</span><span :class="{on:contactForm.gender==2}" @click="contactForm.gender=2">女</span></div>
            </div>
          </div>
          <div class="row2">
            <div class="field"><label>职务</label><input v-model="contactForm.position" placeholder="如：采购总监" class="f-input"/></div>
            <div class="field"><label>部门</label><input v-model="contactForm.department" placeholder="如：采购部" class="f-input"/></div>
          </div>
          <div class="row2">
            <div class="field"><label>微信</label><input v-model="contactForm.wx" placeholder="微信号" class="f-input"/></div>
            <div class="field"><label>邮箱</label><input v-model="contactForm.email" placeholder="电子邮箱" class="f-input"/></div>
          </div>
          <div class="field"><label>生日</label><div class="f-date-trigger" :class="{'is-empty':!contactForm.birthday}" @click="openDatePick('contact','birthday','选择生日')">{{contactForm.birthday || '请选择生日'}}</div></div>
          <div class="field"><label>重要联系人</label>
            <div class="switch"><div class="track" :class="{on:contactForm.is_important}" @click="toggleContactImportant"><div class="dot"></div></div><span class="switch-tip">标记为关键决策人</span></div>
          </div>
          <div class="field"><label>备注</label><textarea v-model="contactForm.remark" placeholder="关系、偏好、注意事项等" class="f-textarea"></textarea></div>
        </div>
        <div class="form-sheet__bar">
          <button class="btn-action btn-action--secondary" @click="closeContactSheet">取消</button>
          <button class="btn-action btn-action--primary" :class="{'is-disabled':contactSaving}" @click="submitContact">保存联系人</button>
        </div>
      </van-popup>

      <!-- ===== 添加回访 表单 ===== -->
      <van-popup v-model="visitSheetShow" round position="bottom" class="form-sheet">
        <div class="form-sheet__head">
          <div class="form-sheet__title">{{visitSheetTitle}}</div>
          <div class="form-sheet__close" @click="closeVisitSheet">×</div>
        </div>
        <div class="form-sheet__body">
          <!-- 【P95】一.02 回访标题改为系统自动生成，规则：【客户名称】【上门拜访/电话沟通】时间，【回访人】 -->
          <div class="field"><label>标题（自动生成）</label>
            <div class="f-auto-title">{{ visitTitlePreview() }}</div>
          </div>
          <div class="field"><label>关联联系人</label>
            <select v-model="visitForm.contact_sn" class="f-input">
              <option value="">不关联</option>
              <option v-for="(c,ci) in detailContacts" :key="'ctopt-'+(c.sn||ci)" :value="c.sn">{{c.name}}{{c.position ? '（'+c.position+'）' : ''}}</option>
            </select>
          </div>
          <div class="row2">
            <div class="field"><label>访问时间 <span class="req">*</span></label><div class="f-date-trigger" :class="{'is-empty':!visitForm.visit_time}" @click="openDatePick('visit','visit_time','选择访问时间')">{{visitForm.visit_time || '请选择访问时间'}}</div></div>
            <div class="field"><label>外勤状态</label>
              <select v-model="visitForm.field_status" class="f-input">
                <option>已上门</option><option>电话</option><option>线上会议</option>
              </select>
            </div>
          </div>
          <!-- 【P95】一.03 三字段改富文本（DB 三列本就是 longtext） -->
          <div class="field"><label>访问内容 <span class="req">*</span></label>
            <RichEditor v-model="visitForm.content" placeholder="沟通要点、客户反馈、需求等" />
          </div>
          <div class="field"><label>客户地址</label><input v-model="visitForm.customer_address" placeholder="拜访地点 / 客户地址" class="f-input"/></div>
          <div class="field"><label>下一步计划</label>
            <RichEditor v-model="visitForm.next_plan" placeholder="后续动作、时间节点" />
          </div>
          <div class="field"><label>备注</label>
            <RichEditor v-model="visitForm.remark" placeholder="补充说明" />
          </div>
        </div>
        <div class="form-sheet__bar">
          <button class="btn-action btn-action--secondary" @click="closeVisitSheet">取消</button>
          <button class="btn-action btn-action--primary" :class="{'is-disabled':visitSaving}" @click="submitVisit">保存回访</button>
        </div>
      </van-popup>

    </div>


</template>

<script>


 import {getRooms,getStores,getRoomDate,getClientOrderDetailData,getCustomersListData,getOpportunitiesListData,getOpportunitiesStatData,getContractsStatData,getOrdersStatData,getOrdersListData,getMessageListData,getCustomersOptionData,getCustomersDetailData,saveCustomersData,getOpportunitiesDetailData,saveOpportunitiesData,getOpportunitiesStageListData,deleteOpportunitiesData,isManagerData,getOrdersDetailData,saveOrdersData,getQiniuToken,getRoomOrderListData,getRoomOrderFormData,getRoomOrderDetailData,saveRoomOrderData,deleteRoomOrderData,getContractRoomOrderListData,getContractAddedServiceListData,getContractPaymentListData,getContractCollectionListData,getContractBalanceListData,getContractFinanceContractListData,getContractInvoiceListData,getContractRefundListData,getContractApprovalListData,customerAllocationAction,getManagedStaffData,customerAllocationBatch,saveContactData,saveVisitData,deleteContactData,deleteVisitData,getStatisticsDashboardData, getContractFlowData, getContractFlowDetailData,getLogListData,getMyProfileData,messageReadData,messageReadAllData,messageReadBatchData,messageDeleteData,customersDeletePrecheck,customersDelete,customersRecycleList,customersRecycleRestore,customersRecyclePurge } from "../api/api.js";
import { getStaff } from "@/api/staff.js";
import { billConfigs } from "./contract/index.js";
 import { ImagePreview } from "vant";
 import ContractDetail from "./contractDetail.vue";
import ClientLogin from "@/components/ClientLogin.vue";
// 【P95】一.03 回访「访问内容 / 下一步计划 / 备注」改富文本（自研 RichEditor，零第三方依赖）
import RichEditor from "@/components/RichEditor.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
// 【P92】全站单据列表统一组件（8 类共用；与合同详情内骨架/搜索/筛选/合计/详情完全一致）
import BillList from "@/components/BillList.vue";
/* 【P419】会议室订单筛选/卡片公共组件 */
import RoomFilter from '@/components/RoomFilter.vue'
import RoomCard from '@/components/RoomCard.vue'
import { isLoggedIn, logout, getAppScope, getProfile, cacheProfile } from "@/util/clientAuth.js";

/* 【P212 问题2-02】财务单据的 page_api 清单。
   这些消息的「正确落点」是关联的销售合同订单，而不是消息详情弹层。
   后端 _paymentApproval 写消息时把 page_sn 设为**销售合同 sn**，故可据此跳转。 */
const FIN_BILL_APIS = ['financial_payment', 'financial_refund', 'financial_contract', 'financial_invoice'];
import crmWs from '@/util/websocket.js'
import { suppressGlobalError } from "@/util/request.js"

/* 【P92】快捷入口 config key -> 后端 bill_type（8 类单据统一引擎的入参）
   config key 与 bill_type 不同名：added↔value、financeContract↔contract */
const QUICK_BILL_TYPE = {
  room: 'room',
  added: 'value',
  payment: 'payment',
  collection: 'collection',
  balance: 'balance',
  financeContract: 'contract',
  invoice: 'invoice',
  refund: 'refund'
};
  import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

  export default {
    name: "RoomStatus",
    components: {
      ContractDetail,
      ClientLogin,
      ConfirmDialog,
      BillList,
      RoomFilter,
      RoomCard,
      RichEditor,
      Editor,
      Toolbar
    },
    data() {
      return {
       /* 内嵌合同详情遮罩（整合到 client 页面，返回不跳路由） */
       contractDetailVisible: false,

       /* 登录层：未登录时显示内联登录，不跳转到 /login */
       showLogin: false,
       /* 【P120】屏幕宽度：未登录时用来决定渲染 H5 登录还是 PC 登录 */
       innerWidth: (typeof window !== "undefined" ? window.innerWidth : 0),
       contractDetailSn: "",
       contractDetailIdx: '',

       active: 0,
       /* 房态子视图：status=房态总览 / meeting=会议室预订（整合进房态tab） */
       roomSub: 'status',
       /* 快捷入口子视图：grid=九宫格 / message=消息 / stat=统计 */
       quickSub: 'grid',
       /* 【P114】本人画像（名称 / 部门 / 角色）—— 快捷入口头部展示用 */
       profile: {},
       /* 【P112】快捷入口下拉刷新：宫格（刷角标） / 统计报表（重拉看板） */
       quickGridRefreshing: false,
       statRefreshing: false,
       statLoading: false,
       statData: null,
       statNote: '',
       statTimeType: 'year',
       statOwnerId: 0,
       statTimeOpts: [
         { val:'year', label:'年' },
         { val:'quarter', label:'季' },
         { val:'month', label:'月' },
         { val:'week', label:'周' },
         { val:'day', label:'日' },
       ],
       stageColors: ['#9aa1ad','#5b8def','#22b07d','#f5a623','#e94752'],
       lostColors: ['#e94752','#f5a623','#5b8def','#22b07d','#9b6dff','#ff8a5b','#3ec6e0','#b8c0cc','#d98cba','#7c8aa0'],
       statPersonOpts: [],
      statPersonSheetShow: false,
      statFlow: null,
      statFlowLoading: false,
      statFlowPage: 1,
      flowDetailSn: null,
      flowDetail: null,
      flowDetailLoading: false,
       monthMax: 0,
       staffTargetMax: 0,
       funnelCntMax: 0,
       funnelAmtMax: 0,
       staffOppMax: 0,
       oppDistTotal: 0,
       quickItems: [
         { key:'meeting', label:'会议室订单', type:'contract', billKey:'room', icon:'<svg viewBox="0 0 24 24"><path d="M4 20V10l8-6 8 6v10H4z"/></svg>' },
         { key:'addedService', label:'增值服务', type:'contract', billKey:'added', icon:'<svg viewBox="0 0 24 24"><rect x="4" y="4" width="7" height="7" rx="1.5"/><rect x="13" y="4" width="7" height="7" rx="1.5"/><rect x="4" y="13" width="7" height="7" rx="1.5"/><rect x="13" y="13" width="7" height="7" rx="1.5"/></svg>' },
         { key:'payment', label:'支付单', type:'contract', billKey:'payment', icon:'<svg viewBox="0 0 24 24"><rect x="3" y="6" width="18" height="12" rx="2"/><path d="M3 10h18"/></svg>' },
         { key:'collection', label:'回款计划', type:'contract', billKey:'collection', icon:'<svg viewBox="0 0 24 24"><path d="M12 3v18M8 7h6a3 3 0 0 1 0 6H8"/></svg>' },
         { key:'balance', label:'余额明细', type:'contract', billKey:'balance', icon:'<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8"/><path d="M12 8v8M9 12h6"/></svg>' },
         { key:'financeContract', label:'财务合同', type:'contract', billKey:'financeContract', icon:'<svg viewBox="0 0 24 24"><path d="M7 3h7l4 4v14H7z"/><path d="M14 3v4h4M9 12h5M9 15h5"/></svg>' },
         { key:'invoice', label:'财务发票', type:'contract', billKey:'invoice', icon:'<svg viewBox="0 0 24 24"><path d="M6 3h9l3 3v15H6z"/><path d="M9 12h6M9 15h6"/></svg>' },
         { key:'refund', label:'退款单', type:'contract', billKey:'refund', icon:'<svg viewBox="0 0 24 24"><path d="M4 12a8 8 0 1 1 2.3 5.6"/><path d="M4 18v-4h4"/></svg>' },
         { key:'message', label:'消息', type:'sub', icon:'<svg viewBox="0 0 24 24"><path d="M4 19V5l8 4 8-4v14"/></svg>' },
         { key:'stat', label:'统计报表', type:'sub', icon:'<svg viewBox="0 0 24 24"><path d="M5 19V9M12 19V5M19 19v-7"/></svg>' },
         /* 【P439】回收站：仅「销售总经理 / 销售部负责人」可见（needDelRight 由 canCustomerDelete 控制） */
         { key:'recycle', label:'回收站', type:'sub', needDelRight:true, icon:'<svg viewBox="0 0 24 24"><path d="M4 7h16"/><path d="M9.5 7V4.5h5V7"/><path d="M6.5 7l1 12.5h9L17.5 7"/><path d="M10 10.5v6M14 10.5v6"/></svg>' },
       ],
       pendingBillKey: '',
      /* 【P95-B4 四.1.005】快捷入口「编辑」目标单据 sn：打开合同详情后自动拉起该单据编辑表单 */
      pendingEditSn: '',
      /* 快捷入口：单据类独立列表（[P92] 由 components/BillList.vue 统一渲染） */
      quickBillKey: '',
      /* 【P92】单据类型（bill_type）：config key 与 bill_type 不同名，故单独保存 */
      quickBillType: '',
      quickBillConfig: null,
      msgUnread: 0,
      msgDetailShow: false,
      msgDetailRow: null,
      /* 【P109】消息分类 tab */
      msgTab: 'all',
      /* 【P245-c】销售端消息 Tab = 4 个（用户 10-07 11:27 需求）：
         未读 · 待处理 · 待阅驳回 · 全部 */
      msgTabs: [
        { label: '未读',     value: 'unread' },
        { label: '待处理',   value: 'todo'   },
        { label: '待阅驳回', value: 'reject' },
        { label: '全部',     value: 'all'    }
      ],
      /* 【B5-Fix】全量消息（不随 Tab 切换而替换），专供角标计算 */
      msgAllRows: [],
      /* 【P247】批量操作状态：仅「未读」「全部」两个 Tab 开启批量模式 */
      msgPicked: [],
      msgBatchBusy: false,
      /* 【B4-02】批量二次确认弹窗（原用 $confirm，现统一走 ConfirmDialog 组件） */
      dialogMsgBatch: false,
      /* 【P108】我是否「管理人员」（管理员 ∪ 部门负责人 ∪ 任一单据 position=1 管理者）——
         决定商机/合同卡片上「删除」入口是否渲染；与后端 _canManageDelete 同源 */
      canManageDelete: false,
      /* 【P439】客户删除权限：仅「销售总经理 / 销售部负责人」。
         由 isManager() 的 can_customer_delete 下发，与后端 CustomerRecycleService::canDelete 同源；
         控制 客户详情「删除」按钮 + 快捷「回收站」入口 + 回收站页可达性 */
      canCustomerDelete: false,
      /* 【P439】客户回收站状态 */
      recycleRows: [],
      recyclePage: 1,
      recycleGen: 0,
      recycleLoading: false,
      recycleFinished: false,
      recycleRefreshing: false,
      recycleSearch: '',
      recycleTotal: 0,
      recycleBusySn: '',
      /* 【P439】删除客户 / 彻底删除 两个确认弹窗 */
      custDelShow: false,
      custDelBusy: false,
      custDelTarget: null,
      custDelDesc: '',
      purgeShow: false,
      purgeBusy: false,
      purgeTarget: null,
      purgeDesc: '',
      purgeForce: false,
      /* 【P108】从审核消息跳转时，合同详情里要高亮定位的会议室订单 sn */
      contractDetailRoomSn: '',
      /* 【P108】商机「提醒时间」日期+时间选择器 */
      remindPickShow: false,
      remindPickValue: new Date(),
      /* 【P108】商机备注富文本编辑器 */
      editorOppRemark: null,
      modeOppRemark: 'default',
      toolbarConfigOppRemark: { excludeKeys: ['uploadImage'] },
      editorConfigOppRemark: { placeholder: '请输入备注…', height: 200 },
      /* 客户分配：接收/拒绝（单条 + 批量多选） */
      batchMode: false,
      /* 【P140】批量模式的二级分类：pending = 我的待接收 / assign = 分配客户（后者仅管理人员可用） */
      batchSub: 'pending',
      selectedCustomers: [],
      assignPopupShow: false,
      assignStaffId: '',
      assignLoading: false,
      allocLoading: false,
       /* 当前房态详情对应的订单 sn，供房态详情「编辑」打开编辑表单 */
       currentDetailSn:'',
       tableContainerWith:0,

        roomCurDate:null,
        roomDateRangeValue:[],

        storeSN:null,
        storesData:[],

        roomData:[],
        /* 房态日期翻页：0 当前区间 / 1 上一区间 / 2 下一区间 */
        optionType:0,
        
        dialogDate:false,
        dialogDatePop:false,
        currentDate: new Date(),

        dialogDateType:0,
        beignDate:null,
        endDate:null,
        dialogDetail:false,
        // 【P37】房态详情弹窗「编辑」权限标记：由 getRoomOrderDetailData().can_edit 回填
        //  1=本人可编辑，0=他人订单只读，-1=尚未取到（此时不渲染任何编辑入口，避免闪显）
        detailCanEdit:-1,
        // 【P38】「查看销售合同」入口权限标记（同源：getRoomOrderDetailData().can_view_contract）
        //  口径与销售合同列表一致（部门级 / 本人），见后端 RoomOrder::contractScope()
        detailCanViewContract:-1,
        // 【P38】详情弹窗当前订单所关联的销售合同 sn（= 会议室订单 parent_sn），供跳转用
        detailContractSn:'',
        // 【P38】编辑表单里「查看销售合同」入口的权限标记：由 fillRoomOrderForm(row) 回填
        //  （列表行与详情 main 都带 can_view_contract）
        roomOrderCanViewContract:0,
        
        orderDetailData:[],


        refreshing:false,
        loading:false,
        finished:false,

        /* 【P40 列加载/分页修复】列表代次：每次「第一页请求」自增，用于作废仍在途的旧响应。
           背景：page 是 4 个列表共用的可变字段，请求期间会被 onLoad/onRefresh 改写，
           导致「请求页码 ≠ 回包数据」和「旧响应把第一页重复 concat」→ 分页失效、列表重复。 */
        listGen:0,

        page:1,
        pageSize:10, 
        searchText:null,
        
        data:[],
        customersList:[],
        opportunitiesList:[],
        oppStatShow:false,
        oppStatLoading:false,
        oppStat:{funnel:[],lost:{total:0,reasons:[]},summary:{}},
        contractStatShow:false,
        contractStatLoading:false,
        contractStat:{summary:{contractCount:0,amount:0,paid:0,receivables:0,refund:0,collectionRate:0,orderCount:0,orderAmount:0},category:[],stage:[],payment:{paid:{cnt:0,amt:0},unpaid:{cnt:0,amt:0},byStatus:[]},refund:{refunded:{cnt:0,amt:0},unrefunded:{cnt:0,amt:0},byStatus:[]},invoice:{total:{cnt:0,amt:0},byType:[]}},
        ordersStatShow:false,
        ordersStatLoading:false,
        ordersStat:{summary:{orderCount:0,totalAmount:0,salesAmount:0,paymentAmount:0,pendingAmount:0,refundAmount:0,balanceAmount:0},type:[],status:[],stage:[]},
        orderList:[],
        messageList:[],
        roomOrderList:[],
        /* 【P32-#2】会议室订单审核状态 tab：全部 / 审核中 / 审核通过 / 审核驳回 */
        roomOrderTabs:[
          {label:'全部', value:''},
          {label:'审核中', value:'2'},
          {label:'审核通过', value:'3'},
          {label:'审核驳回', value:'5'}
        ],
        roomOrderTab:'',
        /* 【P32-#4】会议室订单筛选表单 */
        roomOrderFilterShow:false,
        // 【P95】三.3.02 会议室筛选：在原「使用时间/时段/是否收费/会议室」基础上增加
        //   门店 / 客户 / 商机 / 销售合同 / 财务合同 / 审核状态
        roomOrderFilterForm:{ start_date:'', end_date:'', time_type:'', is_free:'', meeting_room_sn:'', room_name:'',
          stores_sn:'', store_name:'', customer_sn:'', customer_name:'',
          opportunitie_sn:'', opportunitie_name:'', parent_sn:'', order_name:'',
          contracts_sn:'', fc_name:'', approval_tab:'' },
        /* 【P419】RoomFilter 回显用的中文名（门店/会议室/客户…存的是 sn） */
        roomOrderFilterMeta:{},
        /* 【P419】顶部状态条文案（由 RoomFilter 计算，含中文名；原 roomOrderFilterActiveCount 只是计数） */
        roomOrderFilterLabels:[],
        // 审核状态筛选项（与后端 approval_tab 口径一致：2 审核中 / 3 通过 / 5 驳回）
        roomOrderApprovalTabs:[
          {text:'全部', value:''},
          {text:'审核中', value:'2'},
          {text:'审核通过', value:'3'},
          {text:'审核驳回', value:'5'}
        ],
        // 财务合同选择器（会议室外键筛选用）
        dialogFcPick:false,
        fcPickKeyword:'',
        fcPickList:[],
        fcPickLoading:false,
        roomOrderTimeTypeOptions:[
          {text:'全天', value:'1'},{text:'白天', value:'2'},{text:'上午', value:'3'},
          {text:'下午', value:'4'},{text:'晚上', value:'5'},{text:'小时', value:'6'},
          {text:'下午+晚上', value:'7'}
        ],
        roomOrderFreeOptions:[{text:'收费', value:'1'},{text:'免费', value:'2'}],
        roomOrderPickerShow:false,
        roomOrderPickerField:'',
        roomOrderPickerTitle:'',
        roomOrderPickerColumns:[],
        roomOrderDateShow:false,
        roomOrderDateField:'',
        roomOrderDateTitle:'',
        //【P33】使用时间滑动选择器（替代裸文本输入，默认 08:30 / 20:30）
        roomOrderTimeShow:false,
        roomOrderTimeValue:'08:30',
        roomOrderTimeWhich:'begin',
        roomOrderRoomSheetShow:false,
        roomOrderRoomColumns:[],
        roomOrderRoomList:[],

        customerFilterTabs:[
          {label:'全部客户', field:'', value:''},
          {label:'待接收', field:'publish_status', value:1},
          {label:'意向客户', field:'type', value:1},
          {label:'新客户', field:'type', value:2},
          {label:'老客户', field:'type', value:3}
        ],
        customerFilterTab:{label:'全部客户', field:'', value:''},
        customerHeaderH:0,
        dialogCustomerFilter:false,
        customerFilterForm:{source:'',industry:'',create_start:'',create_end:'',update_start:'',update_end:'',enquiry_start:'',enquiry_end:'',first_order_start:'',first_order_end:'',second_order_start:'',second_order_end:''},
        // 当前登录人 staff_id（用于接收/拒绝权限判断）
        currentStaffId:'',
        // 管理账号：可切换查看的团队成员
        staffFilter:'all',
        staffFilterLabel:'全部销售人员',
        managerSelfId:'',
        managedStaffList:[],
        staffSheetShow:false,
        filterPickerShow:false,
        filterPickerField:'',
        filterPickerColumns:[],
        filterPickerTitle:'',
        filterDateShow:false,
        filterDateField:'',
        filterDateValue:new Date(),
        filterDateTitle:'',

        // 商机/合同 头部筛选（服务端筛选）
        oppFilterShow:false,
        orderFilterShow:false,
        activeFilterTarget:'customer',   // customer | opp | order
        filterSelectField:'',
        oppFilterForm:{ stage:'', owner_id:'', start_time:'', end_time:'', amount_min:'', amount_max:'' },
        // 【P24-0-2】orderFilterForm 增加 signing_date_begin / signing_date_end（签约时间区间）
        orderFilterForm:{ stage:'', status:'', owner_id:'', start_time:'', end_time:'', signing_date_begin:'', signing_date_end:'' },
        // 【P24-0-1】合同列表：状态 TAB（全部/审核中/审核通过/审核驳回）+ 管理人员范围选择（与客户模块一致）
        orderFilterTabs:[
          {label:'全部合同', field:'', value:''},
          {label:'审核中', field:'status', value:0},
          {label:'审核通过', field:'status', value:1},
          {label:'审核驳回', field:'status', value:2}
        ],
        orderFilterTab:{label:'全部合同', field:'', value:''},
        orderStaffFilter:'all',
        orderStaffFilterLabel:'全部人员',
        orderStaffSheetShow:false,
        // 商机列表：阶段 TAB（数值与 oppStageOptions 保持一致）
        oppFilterTabs:[
          {label:'全部', field:'', value:''},
          {label:'待执行', field:'stage', value:1},
          {label:'沟通报价', field:'stage', value:2},
          {label:'合同预定', field:'stage', value:3},
          {label:'签约付款', field:'stage', value:4},
          {label:'失单', field:'stage', value:5}
        ],
        oppFilterTab:{label:'全部', field:'', value:''},
        oppStageOptions:[ {text:'待执行',value:1}, {text:'沟通报价',value:2}, {text:'合同预定',value:3}, {text:'签约付款',value:4}, {text:'失单',value:5} ],
        /* 【P214】阶段补全 5 档：待执行/已预定/已支付/全款/取消并退款
           （后端 t_pro_orders.stage 单列即可表达，无需求派生条件、无需 JOIN） */
        orderStageOptions:[
          {text:'待执行',value:1}, {text:'已预定',value:2}, {text:'已支付',value:3},
          {text:'全款',value:4}, {text:'取消并退款',value:5}
        ],
        // 【P24-0-1】合同状态文案统一为「审核中 / 审核通过 / 审核驳回」（与列表 TAB 口径一致）
        orderStatusOptions:[ {text:'审核中',value:0}, {text:'审核通过',value:1}, {text:'审核驳回',value:2} ],

        dialogCustomer:false,
        customerSaving:false,
        // 客户详情子视图
        detailShow:false,
        detailLoading:false,
        detailCustomer:{},
        detailContacts:[],
        contactExpanded:{},
        detailVisits:[],
        // 变更记录时间线
        changeLogShow:false,
        changeLogList:[],
        logPage:1,
        logLoading:false,
        logFinished:false,
        logRefreshing:false,
        /* 【P122】变更记录：筛选 + 总数（模板必须用到，未声明会整页白屏） */
        logFilter:'all',
        logTotal:0,
        // 添加 / 编辑 联系人
        contactSheetShow:false,
        /* 【P204 S2】「联系方式全网重复」二次确认（提示 + 允许强制保存） */
        contactDupShow:false,
        contactDupDesc:'',
        contactSheetTitle:'添加联系人',
        contactSaving:false,
        contactForm:{ sn:'', name:'', phone:'', gender:0, position:'', department:'', wx:'', email:'', birthday:'', is_important:0, remark:'' },
        // 添加 / 编辑 回访
        visitSheetShow:false,
        visitSheetTitle:'添加回访记录',
        visitSaving:false,
        visitForm:{ sn:'', title:'', contact_sn:'', visit_time:'', field_status:'已上门', content:'', customer_address:'', next_plan:'', remark:'', attachment_image:'' },
        // 删除确认
        delDialogShow:false,
        delDoing:false,
        delType:'',
        delSn:'',
        delName:'',
        // 退出登录确认（P46）
        logoutShow:false,
        customerForm:{
          sn:'',
          name:'',
          serial_number:'',
          type:1,
          publish_status:2,
          industry:'',
          source:'',
          enquiry_data:'',
          customer_name:'',
          customer_phone:'',
          customer_wx:'',
          use:'',
          use_date:'',
          number_people:'',
          store_sn:'',
          attachment_image:'',
          remark:''
        },
        customerOption:{type:[],publish_status:[],industry:[],source:[]},
        customerPickerShow:false,
        customerPickerTitle:'',
        customerPickerField:'',
        customerPickerColumns:[],
        dialogCustomerDate:false,
        customerDateField:'',
        customerCurrentDate:new Date(),
        customerImageUploading:false,
        customerImageList:[],
        custStorePickShow:false,
        custStorePickColumns:[],
        editorRemark:null,
        toolbarConfigRemark:{ toolbarKeys:['bold','italic','bulletedList','numberedList','blockquote'] },
        editorConfigRemark:{ placeholder:'请输入备注...' },
        modeRemark:'simple',

        /* 【P205 1.1.01】合同的备注已改用「简易富文本」RichEditor（零依赖、自管状态），
           原 wangEditor 的 editorOrderRemark / toolbarConfigOrderRemark /
           editorConfigOrderRemark / modeOrderRemark 四项目配置已移除 */

        /* ---------- 商机：新增 / 编辑 ---------- */
        dialogOpportunity:false,
        opportunitySaving:false,
        opportunityForm:{
          sn:'',
          name:'',
          serial_number:'',
          customer_sn:'',
          customer_name:'',
          stage:1,
          sales_amount:'',
          number_people:'',
          store:'',
          inquiry_data:'',
          on_site_time:'',
          off_site_time:'',
          remind_datetime:'',
          lost_reason_type:0,
          /* 【P440】新口径失单类型（21-30），30=其他原因才显示「失单说明」 */
          lost_reason_type2:0,
          lost_reason:'',
          is_lost:0,
          next_plan:'',
          follow_up_Content:'',
          remark:''
        },
        // 商机阶段：与后端 opportunitiesList 的 stage_name 口径一致
        opportunityStageColumns:[
          { text:'待执行', value:1 },
          { text:'沟通报价', value:2 },
          { text:'合同预定', value:3 },
          { text:'签约付款', value:4 },
          { text:'失单', value:5 }
        ],
        opportunityStageShow:false,
        oppStorePickShow:false,
        oppStorePickColumns:[],
        oppStorePickLoading:false,

        /* 失单类型（【P440】新口径，落 lost_reason_type2，与 PC 端同步；30=其他原因需填失单说明） */
        oppLostReasonShow:false,
        oppLostReasonColumns:[
          {text:'场地位置不符',value:21},
          {text:'场地环境不符',value:22},
          {text:'已选其他场地',value:23},
          {text:'无场地资源',value:24},
          {text:'预算不符',value:25},
          {text:'档期冲突',value:26},
          {text:'档期未定',value:27},
          {text:'活动取消/延期',value:28},
          {text:'无法建联客户',value:29},
          {text:'其他原因',value:30}
        ],
        /* 老口径（1-10）仅用于历史商机回显，选择器不再展示；lost_reason_type 已对用户隐藏
           ★ 用户清单里「已选其他场地」与「其他原因」原稿同为 23，已确认「其他原因」取 30 */
        oppLostReasonColumnsV1:[
          {text:'价格原因',value:1},
          {text:'场地位置不符合',value:2},
          {text:'场地环境不符合',value:3},
          {text:'客户关系原因',value:4},
          {text:'客户团队其他人已选好场地',value:5},
          {text:'客户预算原因',value:6},
          {text:'撞单',value:7},
          {text:'档期冲突',value:8},
          {text:'计划延期/取消',value:9},
          {text:'质量原因',value:10}
        ],

        /* 跟进内容 / 下一步计划：手机版富文本（wangEditor） */
        editorFollow:null,
        editorNext:null,
        toolbarConfigFollow:{ toolbarKeys:['bold','italic','bulletedList','numberedList','blockquote'] },
        editorConfigFollow:{ placeholder:'请输入跟进内容...' },
        modeFollow:'simple',
        toolbarConfigNext:{ toolbarKeys:['bold','italic','bulletedList','numberedList','blockquote'] },
        editorConfigNext:{ placeholder:'请输入下一步计划...' },
        modeNext:'simple',

        /* ---------- 商机详情 + 阶段时间线 ---------- */
        dialogOpportunityDetail:false,
        opportunityDetail:{},
        opportunityStageList:[],
        opportunityDetailIdx:-1,
        opportunityDeleting:false,
        oppDelShow:false,

        /* ---------- 合同：新增 / 编辑 ---------- */
        dialogOrder:false,
        orderSaving:false,
        orderForm:{
          sn:'',
          name:'',
          serial_number:'',
          customer_sn:'',
          customer_name:'',
          opportunitie_sn:'',
          opportunitie_name:'',
          signing_date:'',
          start_date:'',
          end_date:'',
          contacts:'',
          phone:'',
          weixin:'',
          remark:''
        },

        /* ---------- 会议室订单：新增 / 编辑 / 删除 ---------- */
        dialogRoomOrder:false,
        roomOrderSaving:false,
        roomOrderForm:{
          sn:'',
          parent_sn:'',
          order_name:'',
          customer_sn:'',
          customer_name:'',
          opportunitie_sn:'',
          opportunitie_name:'',
          stores_sn:'',
          store_name:'',
          meeting_room_sn:'',
          room_name:'',
          on_site_time:'',
          time_type:'',
          price:'',
          amount:'',
          discount:'',
          start_time:[],
          start_time_begin:'',
          start_time_end:'',
          number_people:'',
          table_types:[],
          option_service:[],
          is_free:1,
          remark:'',
          payment:[]
        },
        roomOrderFormData:{ time_type:[], is_free:[], table_types:[], option_service:[] },
        dialogRoomOrderDelete:false,
        roomOrderDeleteSn:'',
        dialogTimeTypePick:false,
        dialogIsFreePick:false,
        /* ---------- 合同选择器（会议室订单用） ---------- */
        dialogOrderPick:false,
        orderPickKeyword:'',
        orderPickList:[],
        oppPickTarget:'',      // 'order' | 'roomorder'
        /* ---------- 公共：门店选择器 ---------- */
        dialogStorePick:false,
        storePickKeyword:'',
        storePickList:[],
        /* ---------- 公共：会议室选择器（依赖门店+日期） ---------- */
        dialogRoomPick:false,
        roomPickKeyword:'',
        roomPickList:[],

        /* ---------- 公共：客户选择器 ---------- */
        dialogCustPick:false,
        custPickTarget:'',      // 'opportunity' | 'order'
        custPickKeyword:'',
        custPickList:[],

        /* ---------- 公共：商机选择器（合同关联商机） ---------- */
        dialogOppPick:false,
        oppPickKeyword:'',
        oppPickList:[],

        /* ---------- 公共：日期选择器 ---------- */
        dialogDatePick:false,
        datePickTarget:'',      // 'opportunity' | 'order' | 'roomorder'
        datePickField:'',
        datePickTitle:'请选择日期',
        datePickValue:new Date(),

        /* 回款计划日期选择器 */
        dialogPaymentDatePick:false,
        paymentDatePickIdx:-1,

        orderRoomDetailData:[],

        value: '',
        showPicker: false,
 


      };
    },
    computed: {
      /* 【P439】快捷宫格实际渲染项：回收站入口仅对「销售总经理 / 销售部负责人」可见
         （普通销售看不到入口，后端也会 403 拦一次，双保险） */
      quickTileList(){
        const all = this.quickItems || []
        if(this.canCustomerDelete){ return all }
        return all.filter(q => !q.needDelRight)
      },
      /* 【P114】快捷入口头部：头像首字 / 部门 / 角色（来源 = clientAuth 归一化后的 profile 缓存） */
      avatarText(){
        /* 兼容两种字段名：缓存归一化后是 staff_name，接口原样返回是 name */
        const n = this.profile.staff_name || this.profile.name || ''
        return n ? String(n).slice(0, 1) : '员'
      },
      deptText(){
        const d = this.profile.dept_names
        return (d && d.length) ? d.join(' · ') : ''
      },
      roleText(){
        const r = this.profile.role_names || this.profile.role_name
        if (Array.isArray(r)) { return r.length ? r.join(' · ') : '' }
        return r || ''
      },
      /* 【P210】构建/环境标识：本项目反复出现「已改但看的是旧包」的误判，
         故在快捷页常驻一行极小标识（环境 + 入口 bundle hash），便于一眼判断版本。 */
      buildTag(){
        let hash = ''
        try {
          const s = document.querySelector('script[src*="/static/js/app."]')
          const m = s ? /app\.([a-f0-9]{8})/.exec(s.getAttribute('src') || '') : null
          if (m) { hash = '构建 ' + m[1] }
        } catch (e) { hash = '' }
        let env = ''
        try {
          const h = window.location.hostname || ''
          /* 【P395】cs8 已升级为生产环境；cs10 为独立环境，补上标签避免环境标识空白 */
          if (h.indexOf('cs10') >= 0) { env = 'CS10' }
          else if (h.indexOf('cs8') >= 0) { env = 'CS8 生产' }
          else if (h.indexOf('cs9') >= 0) { env = 'CS9' }
          else if (h.indexOf('cs7') >= 0 || h.indexOf('crm.liubai') >= 0) { env = 'CS7 正式' }
        } catch (e) { env = '' }
        return [env, hash].filter(Boolean).join(' · ')
      },
      /* 【P140】是否「销售管理人员」—— 决定批量模式是否出现二级分类。
         判据用后端 isManager()（is_admin ∪ is_dept_head ∪ has_mgr_join，已落 canManageDelete），
         不再用 managedStaffList.length>0 这种数据驱动的隐式判据（会出现「有下属但非负责人」误显）。 */
      batchIsManager(){
        return !!this.canManageDelete || (this.managedStaffList || []).length > 0
      },
      /* 【P204 S4】销售人员筛选胶囊是否显示：
         · 有下属（managedStaffList 非空）才显示 —— 普通销售无此维度
         · 只在「全部客户」tab 下显示 —— 选了「待接收/意向客户」等状态时，
           再叠加销售人员会造成口径歧义（且 staffFilter 会被后端 owner_id 覆盖） */
      showStaffScopeBar(){
        if(!(this.managedStaffList || []).length) return false
        const t = this.customerFilterTab || {}
        return !t.field
      },
      /* 【P204 S5】客户列表「搜索条件标签集合」：
         把当前生效的全部筛选维度摊平成可读标签，供用户一眼看清「这个列表被什么条件限制」，
         并支持逐项移除 / 一键清空。三个来源：
           1) 关键词搜索 searchText
           2) 高级筛选 customerFilterForm（12 项，日期区间两侧合并为一个标签）
           3) 销售人员 staffFilter（S4 新增维度，此前无任何回显）
         ★ 顺序固定：关键词 → 来源/行业 → 各日期区间 → 销售人员（与用户心智一致）。
         ★ 日期区间：起止都有 → "创建时间 2026-01-01~2026-02-01"；只有一侧 → 保留该侧。 */
      customerFilterTags(){
        let tags = []
        /* 1) 关键词 */
        if(this.searchText){
          tags.push({ key:'search', label:'关键词：' + this.searchText })
        }
        /* 2) 下拉筛选：来源 / 行业
             ★ customerOption 可能尚未异步加载 ⇒ customerText 返回 ''，
               此时退化为直接显示原始值，避免出现「来源：」这种空标签。 */
        const f = this.customerFilterForm || {}
        const textOf = (field, val) => this.customerText(field, val) || val
        if(f.source){
          tags.push({ key:'source', label:'来源：' + textOf('source', f.source) })
        }
        if(f.industry){
          tags.push({ key:'industry', label:'行业：' + textOf('industry', f.industry) })
        }
        /* 3) 日期区间（起止合并为一个标签） */
        const ranges = [
          { k:'create',  name:'创建时间' },
          { k:'update',  name:'更新时间' },
          { k:'enquiry', name:'询价时间' },
          { k:'first_order',  name:'首单时间' },
          { k:'second_order', name:'复购时间' }
        ]
        ranges.forEach(r => {
          const s = f[r.k + '_start'] || ''
          const e = f[r.k + '_end'] || ''
          if(s || e){
            let txt
            if(s && e){ txt = s + '~' + e }
            else if(s){ txt = '≥' + s }
            else { txt = '≤' + e }
            tags.push({ key: r.k + '_range', label: r.name + ' ' + txt, startKey: r.k + '_start', endKey: r.k + '_end' })
          }
        })
        /* 4) 销售人员（S4 维度）
             ★ 不在此处重复展示：S4 已有独立胶囊（.customer-scope-bar）承担「显示当前销售人员 +
               一键清除」，同一信息两处显示会视觉冗余。标签集合只负责「高级筛选 + 关键词」。 */
        return tags
      },
      /* 兼容既有 .filter-status-bar 的计数用法（模板处直接可用） */
      customerFilterTagCount(){
        return (this.customerFilterTags || []).length
      },
      /* 【P109】按分类 tab 过滤后的消息列表（★ 必须放 computed：放 methods 会让 v-for 拿到函数、列表渲染为空） */
      filteredMessageList(){
        const arr = this.messageList || [];
        const t = this.msgTab;
        if(t === 'unread'){ return arr.filter(r => !this.isMsgRead(r)); }
        if(t === 'todo'){ return arr.filter(r => this.msgStatus(r).text === '待处理'); }
        /* 【P257-b】★「待阅驳回」原来**没有分支**，直接落到最后 `return arr`
           ⇒ 该 Tab 显示的是**全量消息**（实测徐虹 Tab 里塞着客户分配消息 #10243、
           会议室订单等），与角标口径完全不符。用户在这Tab 里点「客户分配」消息时
           误以为是自己那条消息，实际点到的是别类消息 ⇒ 表现为「点进去没有接收操作」。
           口径必须与 msgTabCount('reject') 完全一致：type===2（驳回）且未读。 */
        if(t === 'reject'){ return arr.filter(r => Number(r.type) === 2 && !this.isMsgRead(r)); }
        return arr;
      },
      /* ================= 【P247/B4/B5】消息批量操作 ================= */
      /** 【P247】只有「未读」「全部」支持批量操作 */
      msgBatchMode(){ return this.msgTab === 'unread' || this.msgTab === 'all'; },
      /* 【B4-01】★ 必须与模板渲染用的 filteredMessageList **同源**（本项曾被误放进 methods 块，
         *   导致 this.msgRows 是函数 ⇒ togglePickAll 里 .map 报「not a function」）。
       *   原先 msgRows = messageList（不过滤），而列表渲染走 filteredMessageList（会过滤）
       *   ⇒ 两个数据源条数不一致，全选框状态失真，表现为「点全部 Tab 时默认勾上」。 */
      msgRows(){ return this.filteredMessageList || []; },
      /** 【B4-01】全选框只反映「当前列表内**全部**都被勾选」 */
      msgPickedAll(){
        const rows = this.msgRows || [];
        if (!Array.isArray(rows) || rows.length === 0) { return false; }
        const keys = new Set(this.msgPicked.map(String));
        return rows.every(r => keys.has(String(r.sn)));
      },
      /* ---- 【B5】批量确认弹窗文案（随 Tab 变）---- */
      /* 【B6】删除已改为物理删除 ⇒ 标题与文案强调「不可恢复」 */
      msgBatchTitle(){ return this.msgTab === 'unread' ? '确认标记已读' : '确认彻底删除'; },
      msgBatchDesc(){
        const n = this.msgPicked.length;
        return this.msgTab === 'unread'
          ? '确定将所选的 ' + n + ' 条消息标记为已读吗？'
          : '确定彻底删除所选的 ' + n + ' 条消息吗？**删除后不可恢复**。';
      },
      msgBatchConfirmText(){ return this.msgTab === 'unread' ? '标记已读' : '删除'; },
      msgBatchLoadingText(){ return this.msgTab === 'unread' ? '处理中' : '删除中'; },
    /* 【P95】三.3.02 已激活筛选项计数（模板当「值」用 → 必须放 computed；
       原先误放在 methods 里，导致 v-if="...>0" 恒为 false，筛选提示条永不出现） */
    /* 【P419】RoomFilter 的回显值：把 roomOrderFilterForm 里的旧键名反译成组件键名
       （组件只认 room_sn / on_site_time_begin 这套 BillList 引擎口径） */
    roomOrderFilterApplied() {
      const f = this.roomOrderFilterForm || {};
      const o = {};
      if (f.start_date) { o.on_site_time_begin = f.start_date; }
      if (f.end_date) { o.on_site_time_end = f.end_date; }
      if (f.time_type !== '' && f.time_type !== undefined && f.time_type !== null) { o.time_type = f.time_type; }
      if (f.is_free !== '' && f.is_free !== undefined && f.is_free !== null) { o.is_free = f.is_free; }
      if (f.approval_tab !== '' && f.approval_tab !== undefined && f.approval_tab !== null) { o.approval_tab = f.approval_tab; }
      if (f.meeting_room_sn) { o.room_sn = f.meeting_room_sn; }
      if (f.stores_sn) { o.stores_sn = f.stores_sn; }
      ;['customer_sn', 'opportunitie_sn', 'parent_sn', 'contracts_sn'].forEach(k => {
        if (f[k]) { o[k] = f[k]; }
      });
      return o;
    },
    roomOrderFilterActiveCount() {
      const f = this.roomOrderFilterForm || {};
      const has = (v) => !(v === '' || v === undefined || v === null);
      let n = 0;
      if (f.start_date) n++;
      if (f.end_date) n++;
      if (has(f.time_type)) n++;
      if (has(f.is_free)) n++;
      if (f.meeting_room_sn) n++;
      if (f.stores_sn) n++;
      if (f.customer_sn) n++;
      if (f.opportunitie_sn) n++;
      if (f.parent_sn) n++;
      if (f.contracts_sn) n++;
      if (has(f.approval_tab)) n++;
      return n;
    },


      // 批量分配：当前选中的目标销售姓名
      assignStaffName(){
        if(!this.assignStaffId) return '';
        const s = this.managedStaffList.find(x => x.id === this.assignStaffId);
        return s ? s.name : '';
      },

      // 商机/合同 已激活的筛选条件数（用于顶部「已筛选 N 项」提示）
      oppFilterActiveCount(){
        return Object.keys(this.oppFilterForm).filter(k => this.oppFilterForm[k] !== '' && this.oppFilterForm[k] !== null && this.oppFilterForm[k] !== undefined).length;
      },
      orderFilterActiveCount(){
        return Object.keys(this.orderFilterForm).filter(k => this.orderFilterForm[k] !== '' && this.orderFilterForm[k] !== null && this.orderFilterForm[k] !== undefined).length;
      },

      // 商机阶段名称（与后端 opportunitiesList 的 stage_name 口径保持一致）
      opportunityStageText(){
        let v=this.opportunityForm.stage;
        for(let i=0;i<this.opportunityStageColumns.length;i++){
          if(this.opportunityStageColumns[i].value==v){
            return this.opportunityStageColumns[i].text;
          }
        }
        return '';
      },

      // 失单类型文本（【P440】新口径 type2 优先；老数据回显回落 v1 字典，避免历史商机显示空白）
      oppLostReasonText(){
        const v2=Number(this.opportunityForm.lost_reason_type2)||0;
        if(v2>0){
          for(let i=0;i<this.oppLostReasonColumns.length;i++){
            if(Number(this.oppLostReasonColumns[i].value)===v2){ return this.oppLostReasonColumns[i].text; }
          }
        }
        const v1=Number(this.opportunityForm.lost_reason_type)||0;
        if(v1>0){
          for(let i=0;i<this.oppLostReasonColumnsV1.length;i++){
            if(Number(this.oppLostReasonColumnsV1[i].value)===v1){ return this.oppLostReasonColumnsV1[i].text; }
          }
        }
        return '';
      },

      // 【P440】失单类型已选值在 columns 中的下标（打开选择器时定位用，避免每次都停在第一项）
      oppLostReasonIndex(){
        const v2=Number(this.opportunityForm.lost_reason_type2)||0;
        if(v2<=0){ return 0; }
        for(let i=0;i<this.oppLostReasonColumns.length;i++){
          if(Number(this.oppLostReasonColumns[i].value)===v2){ return i; }
        }
        return 0;
      },

      // 会议室订单表单标题（房态详情「编辑」入口与列表编辑共用同一套表单）
      roomOrderTitle(){
        return this.roomOrderForm.sn ? '编辑会议室订单' : '新增会议室订单';
      },

      //【P36】合同关联锁：编辑态且订单已挂销售合同（parent_sn）→ 合同字段只读。
      //  与「销售合同 → 会议室预订单」Tab 编辑口径一致（合同由上下文带出、不可改选）；
      //  后端 save() 同步做「不可解绑」兜底，前端只负责表现层。
      roomOrderContractLocked(){
        return !!(this.roomOrderForm.sn && this.roomOrderForm.parent_sn);
      },

      // 会议室订单折扣率：销售价格 / 市场价格 * 10，保留两位小数
      roomOrderDiscountText(){
        let price=parseFloat(this.roomOrderForm.price);
        let amount=parseFloat(this.roomOrderForm.amount);
        if(!price || price<=0 || isNaN(amount)) return '';
        return (amount/price*10).toFixed(2) + ' 折';
      },

      timeTypeText(){
        let arr=this.roomOrderFormData.time_type||[];
        let hit=arr.find(t=>String(t.value)===String(this.roomOrderForm.time_type));
        return hit ? hit.label : '';
      },

      isFreeText(){
        let arr=this.roomOrderFormData.is_free||[];
        let hit=arr.find(t=>t.value===this.roomOrderForm.is_free);
        return hit ? hit.label : '';
      },

      // 批量模式：是否全部「待接收」客户已选中
      allPendingSelected(){
        /* 【P140】按二级分类判定「全选」状态：
           pending → 只看待接收；assign → 看本页全部 */
        const scope = (this.batchSub === 'pending')
          ? this.customersList.filter(c => c.publish_status === 1)
          : this.customersList.slice();
        if(scope.length === 0) return false;
        return scope.every(c => this.selectedCustomers.indexOf(c.sn) > -1);
      },

      // 管理账号：iOS 滚轮选择器可切换查看的成员（去掉「的客户」「手机号」）
      /* 【P204 S4】改为「筛选销售人员」语义：加「全部销售人员」并明确列出各销售；
         「我的客户」由 staffFilter=managerSelfId 表达，语义比「我的客户」更直白。 */
      staffPickerColumns(){
        let cols = [
          { text: '全部销售人员', value: 'all' },
          { text: '我的客户', value: this.managerSelfId }
        ];
        (this.managedStaffList || []).forEach(s => {
          cols.push({ text: s.name, value: s.id });
        });
        return cols;
      },
      orderStaffPickerColumns(){
        let cols = [
          { text: '全部人员', value: 'all' },
          { text: '我的合同', value: this.managerSelfId }
        ];
        (this.managedStaffList || []).forEach(s => {
          cols.push({ text: s.name, value: s.id });
        });
        return cols;
      },
      statPersonPickerColumns(){
        const opts = [{ text:'全部', value:0 }];
        const me = this.currentStaffId;
        const sub = (this.managedStaffList||[]).map(s=>({text:s.name, value:s.id}));
        if(sub.length){
          if(me) opts.push({ text:'我', value:me });
          sub.forEach(s=>opts.push(s));
        } else if(me){
          opts.push({ text:'我', value:me });
        }
        return opts;
      },
      statOwnerLabel(){
        const col = this.statPersonPickerColumns.find(c=> String(c.value)===String(this.statOwnerId));
        return col ? col.text : '全部';
      },
      statPersonDefaultIndex(){
        const i = this.statPersonPickerColumns.findIndex(c=> String(c.value)===String(this.statOwnerId));
        return i < 0 ? 0 : i;
      },

    },
    created() {
      // 【P94-fix】自愈：非销售端账号（财务/市场/运营）误入 /client 时直接送回自己的端，
      // 避免「财务登录后停在销售人员页面」（刷新页面也能自愈）。
      const __sc = getAppScope();
      if (__sc === 'market' || __sc === 'finance' || __sc === 'operation') {
        this.$router.replace({ path: '/' + __sc });
        return;
      }
      this.showLogin = !isLoggedIn();
      // 监听 token 失效事件（由 request.js 在 450 时派发）：在 client 页内直接弹出内嵌登录层
      this._onAuthExpired = () => { this.showLogin = true; crmWs.close(); };
      window.addEventListener("auth:expired", this._onAuthExpired);
    },

    beforeDestroy() {
      if (this._onAuthExpired) {
        window.removeEventListener("auth:expired", this._onAuthExpired);
      }
      if (this._offUnread) this._offUnread();
    },
    
    methods: {

      intPage(){
        this.getRoomDateData();
      },

      // 内联登录成功：关闭登录层并原地重新加载房态数据（不跳路由）
      onLoginSuccess(token, profile) {
        // 【P94-fix】内联登录层同样要按「角色端」分流：
        // 财务 / 市场 / 运营账号从销售端登录层登录后，不能停留在销售端页面。
        const scope = (profile && profile.app_scope) || getAppScope();
        if (scope === 'market' || scope === 'finance' || scope === 'operation') {
          this.showLogin = false;
          this.$router.replace({ path: '/' + scope });
          return;
        }
        this.showLogin = false;
        /* 【P212 问题2-01】登录成功后必须**回填画像**，否则快捷头部一直显示「—」。
           根因：client.vue 是「内嵌登录层」——登录成功只是 showLogin=false，
           **组件并没有卸载重挂**，所以 mounted() 里的 getProfile() 不会重跑；
           而 mounted() 是在「未登录」状态下执行的，那时 profile 是空对象。
           之前只有整页刷新才能看到姓名（mounted 重跑 → 读到已落盘的缓存）。 */
        this.applyLoginProfile(profile);
        // 【P30】新 token 必须强制重建连接（reconnect）才会被送去鉴权：
        // 旧 socket 带着已失效 token，connect() 因连接健康不会重建 -> 角标永远拉不到。
        crmWs.reconnect();
        crmWs.refresh();
        this.$nextTick(() => {
          this.intPage();
        });
      },

      /* 【P212 问题2-01】把 fetchProfile 返回的画像写进组件 + 回写缓存。
         - 入参有值（登录链路已探明）→ 直接用，并 cacheProfile 落盘；
         - 入参为空（个别端未返回）→ 兜底再拉一次 myProfile，避免头部空白。 */
      applyLoginProfile(profile){
        const p = (profile && typeof profile === 'object') ? profile : null;
        if(p && (p.staff_name || p.name)){
          try{
            this.profile = cacheProfile(Object.assign({}, this.profile || {}, p)) || Object.assign({}, this.profile || {}, p);
          }catch(e){
            this.profile = Object.assign({}, this.profile || {}, p);
          }
          return;
        }
        // 兜底：缓存里有就直接用
        const cached = getProfile();
        if(cached && (cached.staff_name || cached.name)){
          this.profile = Object.assign({}, cached);
          return;
        }
        // 都没有 → 拉一次（fetchMyProfile 自带重试）
        this.fetchMyProfile();
      },


      onConfirm(e){
        console.log(e);
      },

      onCancel(e){
        console.log(e);
      },

      onChange(e){
        console.log(e);
      },

      //获得合同
      //获得门店
      //获得会议室
      



      getIntData(){
          const now = new Date();
          // 本月1号：年、月不变，日期设为1
          const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
          // 本月最后一天：月份+1，日期设为0（自动回退）
          const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

          // 补零函数：1→01，9→09，10+保持不变（处理月份/日期）
          const addZero = num => num < 10 ? `0${num}` : num;

          // 格式化函数：把Date对象转成 YYYY-MM-DD 格式
          const formatDate = date => {
            const year = date.getFullYear();
            const month = addZero(date.getMonth() + 1); // 月份是0基，需+1再补零
            const day = addZero(date.getDate());
              return `${year}-${month}-${day}`;
          };

          let firstDayF=formatDate(firstDay);
          let lastDayF=formatDate(lastDay);

          this.getRoomsListData();

      },

      getStoresData(){
          let data={};
          getStores(data).then(response => {
              if(response.code == 200) {
                this.storesData=response.data||[];
                if(this.storesData.length>0){
                  this.storeSN=this.storesData[0].sn;
                  this.getRoomsData();
                }
              }
            })
            .catch(error => {
              console.log(error);
            });
      },

      getRoomDateData(){

        let data={};
        getRoomDate(data).then(response => {
            if(response.code == 200) {
              this.roomCurDate=response.data;
              this.roomDateRangeValue =response.data["weekRangeValue"];
              this.beignDate=this.roomDateRangeValue[0];
              this.endDate =this.roomDateRangeValue[1];
              this.getStoresData();
            }
          })
          .catch(error => {
            console.log(error);
          });

      },

      getRoomsData(){

          if(!Array.isArray(this.roomDateRangeValue)){
            this.getRoomDateData();
            return;
          }

        let data={
            "option":this.optionType,
            "storeSN":this.storeSN,
            "roomDateRangeValue":this.roomDateRangeValue,
        };
        getRooms(data).then(response => {
            if(response.code == 200) {
                this.roomData=response.data||{};
                // 门店无会议室时后端也会返回 dateRange，这里再兜一层防止白屏
                const dateRange=this.roomData['dateRange']||[];
                this.tableContainerWith=dateRange.length * 80;
            }
          })
          .catch(error => {
            console.log(error);
          });

      },

      handleDialogDate(){
        this.dialogDatePop=true;
      },

      dateConfirm(){

        this.dialogDate=false;


        const date = new Date(this.currentDate);
        // 获取年月日
        const year = date.getFullYear();
        const month = date.getMonth() + 1;  // 月份从0开始，需要+1
        const day = date.getDate();
        // 格式：2026-06-30
        const formattedDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        console.log(formattedDate); // "2026-06-30"
        if(this.dialogDateType==0){
          this.beignDate=formattedDate;
        }

        if(this.dialogDateType==1){
          this.endDate=formattedDate;
        }

      },

      dateCancel(){
        this.dialogDate=false;
      },

      selectDate(e){
        this.dialogDateType=e;
        this.dialogDate=true;
      },

      searchConfirm(){
        this.roomDateRangeValue=[ this.beignDate,this.endDate];
        this.getRoomsData();
      },

      searchStore(sn){
        this.storeSN = sn;
        this.getRoomsData();
      },

      /* 房态子视图切换：总览 <-> 会议室预订
         关键修复：切换时重置所有列表共用的 refreshing/loading/finished/page，
         避免从一个子视图切到另一个时残留的 loading/finished 卡死加载（表现为「接口报错」「切不回去」）。
         切回总览时若总览数据为空则重新拉取，避免空白。 */
      switchRoomSub(tab){
        this.roomSub = tab;
        // 重置共用列表刷新状态，确保目标子视图的 van-pull-refresh/van-list 能正常触发
        this.refreshing = false;
        this.loading = false;
        this.finished = false;
        this.page = 1;
        this.$nextTick(()=>{
          if(tab==='meeting'){
            const el = this.$refs.roomOrderHeader;
            if(el) this.customerHeaderH = el.offsetHeight;
          }
        });
        if(tab==='meeting'){
          this.roomOrderList = [];
          this.onRefresh();
        }else{
          // 切回房态总览：若总览数据缺失则补拉，防止切回后空白
          if(!this.roomData || (this.roomData && Array.isArray(this.roomData.dateRange) && this.roomData.dateRange.length===0)){
            this.getRoomsData();
          }
        }
      },

      /* 从房态详情弹窗「编辑」：拉取订单详情并打开会议室订单编辑表单（与列表「编辑」共用
         fillRoomOrderForm + 同一接口 getRoomOrderDetailData + 同一保存接口） */
      openEditRoom(){
        let sn=this.currentDetailSn;
        if(!sn){ this.$toast('未获取到当前订单'); return; }
        // ⚠️ 不要先关详情弹窗：编辑表单数据拿到之前关掉，一旦接口失败/为空会「详情没了、编辑也没开」
        //    表现为「点编辑就关了、没反应」。这里改为拿到数据并成功打开编辑表单后再关闭详情。
        getRoomOrderDetailData({sn:sn}).then(response=>{
            if(response && response.code==200 && response.data && response.data.main){
              // 【P37】以服务端 can_edit 为准（与后端 save()/delete() 的 assertOwnership 同口径）：
              //  房态网格展示的是全量占用订单，他人订单一律不给编辑入口。
              if(Number(response.data.main.can_edit || 0) !== 1){
                this.detailCanEdit = 0;
                this.$toast('无权编辑他人的会议室订单');
                return;
              }
              /* 【P133-01】审核中禁止修改：房态详情「编辑」是第二入口，此处同样拦截
                    （列表按钮已置灰，但本入口直连详情接口，必须独立校验） */
              if(this.roomOrderLocked(response.data.main)){
                this.$toast('审核中不能修改会议室订单内容');
                return;
              }
              this.fillRoomOrderForm(response.data.main, response.data.payment);
              this.dialogDetail=false;
            } else {
              // 【P37】原兜底分支会用详情弹窗已加载的数据直接打开编辑表单，
              //  该路径绕过了 can_edit 归属校验 → 已改为 fail-closed：拿不到权威详情就不放行编辑。
              this.$toast('未获取到订单详情，无法编辑');
            }
          })
          .catch(error=>{
            console.log(error);
            this.$toast('获取订单详情失败，请重试');
          });
      },

      handlDetail(sn,edit=0){

          this.currentDetailSn = sn;
          // 【P37】房态网格点开的是「全量占用订单」，可能是他人订单：
          //  权限标记先置 -1（未知，不渲染入口），并行的 getRoomOrderDetailData 回填真实 can_edit
          this.detailCanEdit = -1;
          // 【P38】合同可见性同样先置未知，拿到服务端判定后再决定是否渲染「销售合同」入口
          this.detailCanViewContract = -1;
          this.detailContractSn = '';
          let data={
            "sn":sn
          }
          // 走 client 应用的实现：返回 customers/staff/contact/orders_meeting_room/added_services
          // 与本页面详情弹窗口径一致；admin 版返回的是 *_text 口径，字段对不上会导致弹窗全空
          getClientOrderDetailData(data).then(response => {
              if(response.code == 200) {
                  // 详情弹窗用 orderDetailData + dialogDetail；
                  // 原代码赋值给了模板不使用的 orderRoomDetailData，且从未打开 dialogDetail
                  this.orderDetailData=response.data;
                  this.dialogDetail=true;
              }
          })
            .catch(error => {
              console.log(error);
          })

          // 【P37/P38】解析该订单归属（can_edit）与该销售合同可见性（can_view_contract）
          getRoomOrderDetailData({sn:sn}).then(r=>{
              if(r && r.code==200 && r.data && r.data.main){
                  const m = r.data.main;
                  this.detailCanEdit = Number(m.can_edit || 0);
                  // 【P38】「销售合同」入口：仅当该合同对当前账号可见时开放
                  this.detailCanViewContract = Number(m.can_view_contract || 0);
                  this.detailContractSn = m.order_sn || m.parent_sn || '';
              } else {
                  this.detailCanEdit = 0;
                  this.detailCanViewContract = 0;
                  this.detailContractSn = '';
              }
          }).catch(()=>{
              this.detailCanEdit = 0;
              this.detailCanViewContract = 0;
              this.detailContractSn = '';
          });

      },

      getCustomersList(){
          // 【P40】固化页码与代次：page 为 4 个列表共用，请求期间会被 onLoad/onRefresh 改写，
          // 直接读 this.page 会造成「请求页码 ≠ 回包数据」；第一页请求自增 listGen 以作废在途旧响应
          const reqPage = this.page;
          if(reqPage === 1){ this.listGen++; }
          const gen = this.listGen;

          let data={
            searchText:this.searchText,
            page:reqPage,
            pageSize:this.pageSize
          };
          if(this.customerFilterTab && this.customerFilterTab.field){
            data[this.customerFilterTab.field]=this.customerFilterTab.value;
          }
          const f=this.customerFilterForm;
          if(f.source) data.source=f.source;
          if(f.industry) data.industry=f.industry;
          if(f.create_start) data.create_start=f.create_start;
          if(f.create_end) data.create_end=f.create_end;
          if(f.update_start) data.update_start=f.update_start;
          if(f.update_end) data.update_end=f.update_end;
          if(f.enquiry_start) data.enquiry_start=f.enquiry_start;
          if(f.enquiry_end) data.enquiry_end=f.enquiry_end;
          if(f.first_order_start) data.first_order_start=f.first_order_start;
          if(f.first_order_end) data.first_order_end=f.first_order_end;
          if(f.second_order_start) data.second_order_start=f.second_order_start;
          if(f.second_order_end) data.second_order_end=f.second_order_end;
          if(this.staffFilter && this.staffFilter !== 'all'){ data.owner_id = this.staffFilter; }
          /* 【P141】批量「01 我的待接收」：收敛为「只与我本人相关」的待接收（owner_id = 我）。
             不传 owner_id 时，部门负责人会落到「管辖范围全员」分支，会把下属的待接收也带出来。
             放在 staffFilter 之后覆盖它，保证批量待接收口径恒定。 */
          if(this.batchMode && this.batchSub === 'pending' && this.currentStaffId){
            data.owner_id = this.currentStaffId;
          }
          // 【P40】先占住 loading，阻止 van-list 在挂载/刷新瞬间并发触发 load（避免 page 竞态，对齐 getRoomOrderList）
          this.loading = true;
      
         getCustomersListData(data).then(response => {
            if(gen !== this.listGen){ return; }   // 【P40】已被新一轮刷新取代 → 丢弃过期回包
            if(response && response.code == 200) {
                this.data=response.data;
                const rows = (response.data && response.data.data) || [];
                // 【P40】第一页直接替换（幂等），后续页追加
                this.customersList = (reqPage === 1) ? rows.slice() : this.customersList.concat(rows);
                if(this.customersList.length==0 || !response.data.data || response.data.data.length < this.pageSize){
                   this.finished=true;
                }
                console.log(response.data);

             } else {
                // 【P40】非 200 也必须收口，否则 loading 永久为 true → 一直「加载中」
                this.finished = true;
             }
          })
          .catch(error => {
            console.log(error);
            this.finished = true;                 // 【P40】失败即收口，避免无限重试卡死
          })
          .finally(() => {
            // 【P40】成功/失败/过期都释放加载态；仅当次代未变时才释放，避免误放新一轮请求的 loading
            if(gen === this.listGen){
              this.refreshing=false;
              this.loading=false;
            }
          });

      },

      // 拉取当前登录人 staff 信息（用于接收/拒绝权限判断）
      /* 【P114】拉本人画像（名称 / 部门 / 角色）—— 供快捷入口头部展示。
         缓存优先（登录时已落 localStorage.profile），接口回来后再合并覆盖，
         保证「换部门 / 改角色后重进页面」也能拿到最新值。 */
      /* 【P210】画像拉取：失败自动重试 1 次 + 结果回写 localStorage（自愈）。
         此前只合并内存、不落库 ⇒ 一旦某次 myProfile 失败（网络抖动 / token 临期），
         头部就**永久**退回兜底文案（表现为「只显示『销售人员』、看不到姓名」）。 */
      fetchMyProfile(retry){
        const left = (retry === undefined) ? 1 : retry;
        getMyProfileData({}).then(res => {
          if(res && res.code == 200 && res.data){
            this.profile = cacheProfile(Object.assign({}, this.profile || {}, res.data)) || this.profile;
          } else if(left > 0){
            setTimeout(() => { this.fetchMyProfile(left - 1); }, 1200);
          }
        }).catch(() => {
          if(left > 0){ setTimeout(() => { this.fetchMyProfile(left - 1); }, 1200); }
        });
      },

      fetchCurrentStaff(){
        getStaff({}).then(response => {
          if(response && response.code == 200 && response.data){
            this.currentStaffId = response.data.id || '';
          }
        }).catch(() => {});
      },

      // 管理账号：拉取自己管理的成员列表（无管理权限则返回空）
      fetchManagedStaff(){
        getManagedStaffData({}).then(response => {
          if(response && response.code == 200 && response.data){
            this.managerSelfId = response.data.self || '';
            this.managedStaffList = (response.data.list && response.data.list.length) ? response.data.list : [];
          } else {
            this.managedStaffList = [];
          }
        }).catch(() => { this.managedStaffList = []; });
      },

      // 选择成员（iOS 滚轮选择器确认）：设置 owner_id 过滤并刷新列表
      /* 【P204 S4】改为「独立筛选胶囊」后，**不再改写 tab[0] 的文案** ——
         原先会把「全部客户」改成销售名字，导致 tab 语义被污染。 */
      onSelectStaff(val){
        const id = (val && val.value !== undefined) ? val.value : (val && val.id);
        const text = (val && val.text !== undefined) ? val.text : (val && val.name);
        this.staffFilter = id;
        this.staffFilterLabel = text;
        this.staffSheetShow = false;
        this.page = 1;
        this.customersList = [];
        this.finished = false;
        this.loading = true;
        if(this.active == 1){
          this.getCustomersList();
        }
      },
      // 【P204 S4】清除销售人员筛选，回到「全部客户」
      clearStaffScope(){
        this.staffFilter = 'all';
        this.staffFilterLabel = '全部销售人员';
        this.page = 1;
        this.customersList = [];
        this.finished = false;
        this.loading = true;
        if(this.active == 1){
          this.getCustomersList();
        }
      },

      getOpportunitiesList(){
          // 【P40】固化页码与代次（同 getCustomersList）
          const reqPage = this.page;
          if(reqPage === 1){ this.listGen++; }
          const gen = this.listGen;

          let data={
            searchText:this.searchText,
            page:reqPage,
            pageSize:this.pageSize
          };
          const f=this.oppFilterForm || {};
          // 阶段 TAB 快速筛选（优先于弹层里的 stage）
          if(this.oppFilterTab && this.oppFilterTab.field){
            data[this.oppFilterTab.field]=this.oppFilterTab.value;
          }
          if(f.stage!=='' && f.stage!==null && f.stage!==undefined) data.stage=f.stage;
          if(f.owner_id!=='' && f.owner_id!==null && f.owner_id!==undefined) data.owner_id=f.owner_id;
          if(f.start_time) data.start_time=f.start_time;
          if(f.end_time) data.end_time=f.end_time;
          if(f.amount_min!=='' && f.amount_min!==null && f.amount_min!==undefined) data.amount_min=f.amount_min;
          if(f.amount_max!=='' && f.amount_max!==null && f.amount_max!==undefined) data.amount_max=f.amount_max;
          // 【P40】先占住 loading，阻止 van-list 并发触发 load
          this.loading = true;
      
         getOpportunitiesListData(data).then(response => {
            if(gen !== this.listGen){ return; }   // 【P40】丢弃过期回包
            if(response && response.code == 200) {
                const listData = (response.data && response.data.list) || {};
                const rows = listData.data || [];
                this.data = listData;
                // 【P40】第一页替换，后续页追加
                this.opportunitiesList = (reqPage === 1) ? rows.slice() : this.opportunitiesList.concat(rows);
                console.log(response.data);
                if(this.opportunitiesList.length==0 || rows.length < this.pageSize){
                   this.finished=true;
                }
             } else {
                this.finished = true;              // 【P40】非 200 收口，避免一直「加载中」
             }
          })
          .catch(error => {
            console.log(error);
            this.finished = true;                 // 【P40】失败收口
          })
          .finally(() => {
            // 【P40】全路径释放加载态（对齐 getRoomOrderList）
            if(gen === this.listGen){
              this.refreshing=false;
              this.loading=false;
            }
          });

      },

      getOrderList(){
          // 【P40】固化页码与代次（同 getCustomersList）
          const reqPage = this.page;
          if(reqPage === 1){ this.listGen++; }
          const gen = this.listGen;

          let data={
            searchText:this.searchText,
            page:reqPage,
            pageSize:this.pageSize
          };
          const f=this.orderFilterForm || {};
          if(f.stage!=='' && f.stage!==null && f.stage!==undefined) data.stage=f.stage;
          if(f.status!=='' && f.status!==null && f.status!==undefined) data.status=f.status;
          if(f.owner_id!=='' && f.owner_id!==null && f.owner_id!==undefined) data.owner_id=f.owner_id;
          if(f.start_time) data.start_time=f.start_time;
          if(f.end_time) data.end_time=f.end_time;
          // 状态 TAB 快速筛选（优先于弹层筛选）
          if(this.orderFilterTab && this.orderFilterTab.field){
            data[this.orderFilterTab.field]=this.orderFilterTab.value;
          }
          // 管理人员范围：按人员查看合同（全部人员时不限 owner_id）
          if(this.orderStaffFilter && this.orderStaffFilter !== 'all'){
            data.owner_id = this.orderStaffFilter;
          }
          // 【P40】先占住 loading，阻止 van-list 并发触发 load
          this.loading = true;
      
         getOrdersListData(data).then(response => {
            if(gen !== this.listGen){ return; }   // 【P40】丢弃过期回包
            if(response && response.code == 200) {
                const rows = (response.data && response.data.data) || [];
                this.data=response.data;
                // 【P40】第一页替换，后续页追加
                this.orderList = (reqPage === 1) ? rows.slice() : this.orderList.concat(rows);
                console.log(response.data);
                // 空列表 或 本页不足一页 → 到底了；缺失该判断会让 van-list 无限触发 load（一直转圈）
                if(this.orderList.length==0 || rows.length < this.pageSize){
                   this.finished=true;
                }
             } else {
                this.finished = true;              // 【P40】非 200 收口
             }
          })
          .catch(error => {
            console.log(error);
            this.finished = true;                 // 【P40】失败收口
          })
          .finally(() => {
            // 【P40】全路径释放加载态（对齐 getRoomOrderList）
            if(gen === this.listGen){
              this.refreshing=false;
              this.loading=false;
            }
          });

      },

      // 实时未读角标（websocket.js 推送）：更新角标；若正在看消息列表则自动刷新
      onUnread(d) {
        const total = (d && d.total) ? d.total : 0;
        this.msgUnread = total;
        if (this.active === 4 && this.quickSub === 'message' && this._lastUnread !== total && !this.loading) {
          this.onRefresh();
        }
        this._lastUnread = total;
      },

      /* 【P154】切换消息分类 tab（全部/未读/待处理）。
         过滤已下沉到服务端（msg_tab），切 tab 必须「清列表 + 归位页码 + 重发请求」，
         否则沿用上一 tab 的行数会让 van-list 误判内容不满屏而连续自动翻页。
         ★ loading 必须同步置真再发请求（BUG-B 定式），否则 van-list 抢跑 onLoad 会把 page 1→2。 */
      switchMsgTab(v){
        if(v === this.msgTab && (this.messageList || []).length) return;
        this.msgTab = v;
        this.msgPicked = [];            /* 【P247】切 Tab 清空勾选，避免跨 Tab 误操作 */
        /* 【B5-Fix】角标固定用「全部」口径：切走时把当前数据留作全量 */
        if(v !== 'all'){ this.msgAllRows = this.messageList || []; }
        this.messageList = [];
        this.page = 1;
        this.finished = false;
        this.loading = true;
        this.getMessageList();
      },

      getMessageList(){
          // 【P40】固化页码与代次（同 getCustomersList）
          const reqPage = this.page;
          if(reqPage === 1){ this.listGen++; }
          const gen = this.listGen;

          let data={
            searchText:this.searchText,
            page:reqPage,
            pageSize:this.pageSize,
            /* 【P154】分类 tab 交给服务端过滤，保证「每页返回行数 = 实际渲染行数」。
               否则客户端 filter 后行数不足一屏，van-list 会判定内容不满屏而连续自动翻页。 */
            msg_tab:this.msgTab
          };
          // 【P40】先占住 loading，阻止 van-list 并发触发 load
          this.loading = true;
      
         getMessageListData(data).then(response => {
            if(gen !== this.listGen){ return; }   // 【P40】丢弃过期回包
            if(response && response.code == 200) {
                const rows = (response.data && response.data.data) || [];
                this.data=response.data;
                // 【P40】第一页替换，后续页追加
                this.messageList = (reqPage === 1) ? rows.slice() : this.messageList.concat(rows);
                /* 【B5-Fix】拉的是「全部」时，同步一份给角标用（切到其它 Tab 不受影响） */
                if(this.msgTab === 'all' && reqPage === 1){ this.msgAllRows = rows.slice(); }
                console.log(response.data);
                /* 【P154】finished 以服务端分页为准（last_page），不再只看「本页是否满页」。
                   服务端已按 msg_tab 过滤，页行数与渲染行数一致，van-list 不会再自动连翻到底。 */
                const __lastPage = parseInt((response.data && response.data.last_page) || 0, 10) || 0;
                if(this.messageList.length==0 || rows.length < this.pageSize || (__lastPage > 0 && reqPage >= __lastPage)){
                   this.finished=true;
                }
             } else {
                this.finished = true;              // 【P40】非 200 收口，避免一直「加载中」
             }
          })
          .catch(error => {
            console.log(error);
            this.finished = true;                 // 【P40】失败收口
          })
          .finally(() => {
            // 【P40】全路径释放加载态（对齐 getRoomOrderList）
            if(gen === this.listGen){
              this.refreshing=false;
              this.loading=false;
            }
          });
      },

      /* ================= 消息列表（新版 UI） ================= */
      /* 【P109】各 tab 的计数（0 时不显示角标；filteredMessageList 是 computed，见下） */
      /* 【P245-c】各 Tab 计数（「全部」不显示角标） */
      /* ================= 【P247】消息批量操作 ================= */
      isMsgPicked(row){ return this.msgPicked.indexOf(String(row.sn)) >= 0; },
      togglePickOne(row){
        const k = String(row.sn), i = this.msgPicked.indexOf(k);
        if(i >= 0) this.msgPicked.splice(i,1); else this.msgPicked.push(k);
      },
      togglePickAll(e){
        const on = e && e.target && e.target.checked;
        /* ★ 用 filteredMessageList（模板渲染的同一份数据），
         *   否则会出现「全选框勾上了但勾选数仍是 0」的错位 —— 两者必须同源。 */
        const rows = Array.isArray(this.filteredMessageList) ? this.filteredMessageList : [];
        this.msgPicked = on ? Array.from(new Set(rows.map(r => String(r.sn)))) : [];
      },
      /** 【B4-02】点「批量已读 / 批量删除」→ 先开自研弹窗，点确认才真执行 */
      onMsgBatch(){
        if(this.msgBatchBusy) return;
        if(!this.msgPicked.length){ this.$toast('请先勾选'); return; }
        this.dialogMsgBatch = true;
      },
      /** 【B4-02】弹窗点确认 → 执行 */
      doMsgBatch(){
        if(this.msgBatchBusy) return;
        this.msgBatchBusy = true;
        const isUnread = this.msgTab === 'unread';
        const sns = Array.from(new Set(this.msgPicked.map(String)));
        const req = isUnread ? messageReadBatchData({ sns }) : messageDeleteData({ sns });
        req.then(res => {
          this.msgBatchBusy = false;
          this.dialogMsgBatch = false;
          if(res && res.code === 200){
            /* 【B6】提示文案直接用后端返回（区分「已彻底删除」/「已标记已读」） */
            this.$toast(res.msg || '操作成功');
            this.msgPicked = [];
            this.getMessageList();
            /* 【B6】删除后角标基线也要刷新（msgAllRows 可能已含被删项） */
            this.msgAllRows = (this.msgAllRows || []).filter(r => sns.indexOf(String(r.sn)) < 0);
          } else {
            this.$toast((res && res.msg) || '操作失败');
          }
        }).catch(() => { this.msgBatchBusy = false; this.dialogMsgBatch = false; });
      },
      /* 【B5-Fix】角标必须基于「全量消息」算，不能用当前 Tab 的列表 ——
         页面按 Tab 分别请求（切 Tab 会整体替换 messageList），
         拿当前列表算的话，切到「全部」后每个 Tab 角标都按全量统计 ⇒ 失真
         （实测出现「切到全部，待驳回角标却显示 1」）。 */
      msgTabCount(v){
        const arr = Array.isArray(this.msgAllRows) ? this.msgAllRows : [];
        if(!arr.length) return 0;
        if(v === 'unread'){ return arr.filter(r => !this.isMsgRead(r)).length; }
        if(v === 'todo'){   return arr.filter(r => Number(r.type) === 1 && Number(r.is_action) === 0).length; }
        if(v === 'reject'){ return arr.filter(r => Number(r.type) === 2 && !this.isMsgRead(r)).length; }
        return 0;
      },
      isMsgRead(row){
        const v = row ? row.is_read : undefined;
        return String(v) === '1' || v === 1 || v === true;
      },
      msgRaw(row){
        if(!row){ return ''; }
        const c = (row.content !== undefined && row.content !== null) ? row.content : (row.item && row.item.content);
        return String(c === null || c === undefined ? '' : c).trim();
      },
      /* 抽出 [xx] / 【xx】 内的片段 */
      _msgSegs(text){
        const out = []; const re = /[【\[]([^】\]]+)[】\]]/g; let m;
        while((m = re.exec(text)) !== null){ out.push(m[1]); }
        return out;
      },
      _msgBizMap(){
        return {
          crm_orders:                  {text:'订单',   color:'#2b5fd9', bg:'#eef2fb'},
          financial_payment:           {text:'回款单', color:'#00a62a', bg:'#e8ffea'},
          crm_paymentOrders:           {text:'回款单', color:'#00a62a', bg:'#e8ffea'},
          financial_refund:            {text:'退款单', color:'#f53f3f', bg:'#ffece8'},
          crm_customers:               {text:'客户',   color:'#7c4dff', bg:'#f2edff'},
          market_customers:            {text:'客户',   color:'#7c4dff', bg:'#f2edff'},
          operation_meetingRoomOrders: {text:'会议室', color:'#0f9bb0', bg:'#e6f7fa'}
        };
      },
      msgBadgeText(row){
        const hit = this._msgBizMap()[(row && row.page_api) || ''];
        return hit ? hit.text : '通知';
      },
      msgBadgeStyle(row){
        const hit = this._msgBizMap()[(row && row.page_api) || ''];
        return hit ? {background:hit.bg, color:hit.color} : {background:'#f1f4f8', color:'#64748b'};
      },
      /* 【P122】处理状态修正
         后端语义（与老系统 StatisticsControllerT 的待处理计数口径一致）：
           is_action=0 → 待处理（待接收 / 待审批）    is_action=1 → 已处理
         原实现写成「t==='1' || is_action==='1' → 待处理」，两个错误叠加：
           ① type=1 是最常见的通知类型 ⇒ 几乎所有消息恒显示「待处理」；
           ② is_action=1 恰恰代表「已处理」，却被反向判成待处理
              ⇒ 销售点「接收 / 拒绝」后后端已写 is_action=1，前端状态依然显示待处理（本次修复的 BUG）。 */
      /* 【P132·消息语义定版】严格按业务定义分两类：
           · type=0 通知   → 只有「已读 / 未读」，**没有「已处理」概念**（完成判据 = is_read）
           · type=1 待处理 → 完成判据 = is_action（0=待处理 / 1=已处理）
           · type=2 驳回   → 结果类通知
         ⚠️ 旧实现把 `is_action==='1' → 已处理` 放在 type 判定之前、且不加 type 限定，
            而 t_saas_data_message.is_action **列默认值就是 1**（未显式写入即为 1）
            ⇒ **所有 type=0 通知被误标成「已处理」**，与角标（m1 按 is_read 计未读）自相矛盾，
              用户看到的就是「列表说已处理、红点却还在」。
         ⚠️ 「待处理」tab 的过滤依赖本方法返回的 text==='待处理'，改动时勿破坏。 */
      msgStatus(row){
        const t = String((row && row.type !== undefined && row.type !== null) ? row.type : '');
        /* 【P141】已失效的分配消息优先显示「已失效」（比「已处理」更准确，
           且不影响「待处理」tab 过滤 —— 它本就 is_action=1，不会落进待处理） */
        if(this.msgInvalid(row)){ return {text:'已失效', cls:'tag-danger'}; }
        if(t === '2'){ return {text:'已驳回', cls:'tag-danger'}; }
        if(t === '1'){
          const ai = (row && row.is_action !== undefined && row.is_action !== null) ? String(row.is_action) : '';
          return ai === '1' ? {text:'已处理', cls:'tag-receive'} : {text:'待处理', cls:'tag-wait'};
        }
        /* type=0 及其它 = 通知类：无「已处理」概念 */
        return {text:'通知', cls:'tag-allot'};
      },
      /* 【P122】变更记录：筛选计数 / 过滤 / 按天分组 */
      logFilters(){
        const all = this.changeLogList || [];
        const cnt = (a) => all.filter(r => r.action === a).length;
        return [
          { label:'全部', value:'all',    count: all.length },
          { label:'新增', value:'add',    count: cnt('add') },
          { label:'编辑', value:'edit',   count: cnt('edit') },
          { label:'删除', value:'delete', count: cnt('delete') }
        ];
      },
      logFilteredList(){
        const all = this.changeLogList || [];
        if(this.logFilter === 'all'){ return all; }
        return all.filter(r => r.action === this.logFilter);
      },
      logGrouped(){
        const out = [];
        const map = {};
        this.logFilteredList().forEach(it => {
          const day = it._day || '更早';
          if(!map[day]){ map[day] = { day: day, items: [] }; out.push(map[day]); }
          map[day].items.push(it);
        });
        return out;
      },
      msgTimeText(row){
        const s = String((row && (row.create_time || row.update_time)) || '');
        const m = s.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
        if(!m){ return s; }
        const pad = (n) => { n = String(n); return n.length < 2 ? '0' + n : n; };
        const now = new Date();
        const today = now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());
        if(m[1] + '-' + m[2] + '-' + m[3] === today){ return m[4] + ':' + m[5]; }
        if(m[1] === String(now.getFullYear())){ return m[2] + '-' + m[3] + ' ' + m[4] + ':' + m[5]; }
        return m[1] + '-' + m[2] + '-' + m[3];
      },
      msgTitle(row){
        const c = this.msgRaw(row);
        if(!c){ return '消息'; }
        const biz = this.msgBadgeText(row);
        let segs = this._msgSegs(c);
        // 首段与业务名重复（如 [回款单][客户…] / [客户][张三]）→ 丢弃
        if(segs.length){
          const s0 = segs[0];
          if(s0 === biz || s0.replace(/单$/, '') === biz.replace(/单$/, '') || (biz && s0.indexOf(biz) >= 0)){
            segs = segs.slice(1);
          }
        }
        const api = (row && row.page_api) || '';
        if(api === 'crm_orders' && segs.length >= 2){
          const store = segs[0] || ''; let room = segs[1] || '';
          if(store && room.indexOf(store) === 0){ room = room.slice(store.length); }
          const t = [store, room].filter(Boolean).join(' · ');
          if(t){ return t; }
        }
        if(api === 'operation_meetingRoomOrders'){ return '会议室预订变更'; }
        let t = segs.length ? segs[0] : '';
        if(!t){ t = c.split(/[，,。;；]/)[0]; }
        t = String(t).replace(/^客户/, '').split('通过')[0].split('_')[0].trim();
        if(!t){ t = c.split(/[，,。;；]/)[0]; }
        return t.length > 28 ? (t.slice(0, 28) + '…') : t;
      },
      /* 正文：去掉开头连续的 [..]/【..】 段，剩下的就是动作描述 */
      msgBody(row){
        const c = this.msgRaw(row);
        if(!c){ return ''; }
        const m = c.match(/^(?:[【\[](?:[^】\]]+)[】\]])+/);
        let body = m ? c.slice(m[0].length) : c;
        return body.replace(/^[，,。;；、\s]+/, '').trim();
      },
      /* chips：金额 / 日期 / 时段 / 支付方式 / 折扣 */
      msgChips(row){
        const c = this.msgRaw(row); const out = [];
        if(!c){ return out; }
        const grab = (re) => { const m = c.match(re); return m ? m[1] : ''; };
        const price  = grab(/销售价格[:：]\s*([0-9.]+)/);
        const market = grab(/市场价格[:：]\s*([0-9.]+)/);
        const disc   = grab(/折扣率[:：]\s*([0-9.]+)/);
        const amount = grab(/支付\s*([0-9.]+)\s*元/);
        const pay    = grab(/通过([^\s，,]{2,8}支付)/);
        const date   = grab(/[【\[](\d{4}-\d{2}-\d{2})[】\]]/);
        const span   = grab(/[【\[](上午|下午|晚上|全天|白天)[】\]]/);
        if(date){ out.push({text:date}); }
        if(span){ out.push({text:span}); }
        if(amount){ out.push({text:'¥' + amount, key:true}); }
        else if(price){ out.push({text:'销售 ¥' + price, key:true}); }
        if(pay){ out.push({text:pay}); }
        if(market){ out.push({text:'市场 ¥' + market}); }
        if(disc){ out.push({text:'折扣 ' + disc}); }
        return out.slice(0, 4);
      },
      /* 是否可跳转到 H5 对应单据 */
      msgJumpable(row){
        const api = (row && row.page_api) || '';
        if(api === 'crm_customers' || api === 'market_customers'){ return !!row.parent_sn; }
        if(api === 'crm_orders'){ return !!(row.parent_sn || row.page_sn); }
        /* 【P212 问题2-02】财务单据（回款单/退款单/财务合同…）的审核消息：
           正确落点是**关联的销售合同订单**，而不是消息详情弹层。
           销售合同 sn 从 page_url 的 order_sn= 参数解析（见 msgOrderSn）。 */
        if(FIN_BILL_APIS.indexOf(api) > -1){ return !!this.msgOrderSn(row); }
        return false;
      },
      /* 【P141】消息是否已作废 —— 客户被改派他人后，发给原接收人的分配消息会被后端
         追加「（已失效）」后缀并置 status=0/is_action=1/is_read=1。用 content 后缀判定，
         避免改派到的其它「status=0」消息被误判。 */
      msgInvalid(row){
        return String((row && row.content) || '').indexOf('（已失效）') > -1;
      },
      /* 【P128】消息卡片点击：可跳转的直接去「去处理」，不再先弹详情让用户二次确认 */
      onMsgCardClick(rowOrIdx){
        const row = (rowOrIdx && typeof rowOrIdx === 'object') ? rowOrIdx : this.messageList[rowOrIdx];
        if(!row){ return; }
        /* 【P141】已失效的分配消息：告知原因，不再跳转（客户已改派他人，跳过去是别人的客户） */
        if(this.msgInvalid(row)){
          this.openMsgDetail(rowOrIdx);
          this.$toast('该消息已失效（客户已被重新分配）');
          return;
        }
        if(this.msgJumpable(row)){ this.jumpMsg(row); return; }
        this.openMsgDetail(rowOrIdx);
      },
      /* 【P128】本地扣减未读角标（不等 WS 推送） */
      /* 【P130】进入消息列表时把「我的全部消息」标记已读 → 通知类气泡随即清零 */
      markAllMsgRead(cb){
        /* 【P130】标记「我的全部消息」已读（清气泡）。cb 用于串行化：先标已读再拉列表，
           否则标记与拉取并发会导致列表仍显示未读。 */
        const done = () => { if(typeof cb === 'function'){ cb(); } };
        try{
          messageReadAllData().then(res=>{
            if(res && res.code === 200){ this.msgUnread = 0; this._lastUnread = 0; }
            done();
          }).catch(()=>{ done(); });
        }catch(e){ done(); }
      },
      decUnread(n){
        const step = Math.max(1, parseInt(n || 1, 10));
        this.msgUnread = Math.max(0, (parseInt(this.msgUnread, 10) || 0) - step);
        this._lastUnread = this.msgUnread;
      },
      openMsgDetail(rowOrIdx){
        /* 【P109】兼容两种入参：行对象（分类 tab 下索引不可靠）或「全部」列表的下标 */
        const row = (rowOrIdx && typeof rowOrIdx === 'object') ? rowOrIdx : this.messageList[rowOrIdx];
        if(!row){ return; }
        this.msgDetailRow = row;
        this.msgDetailShow = true;
        /* 【P130】打开详情即视为已读
           【P258】type===2（待阅驳回）例外：保留未读，避免驳回结果被静默吃掉。 */
        if(typeof this.isMsgRead === 'function' && this.isMsgRead(row) === false){ this.decUnread(1); }
        if(row.sn && Number(row.type) !== 2){ try{ messageReadData({ sn: row.sn }); }catch(e){} }
      },
      jumpMsg(row){
        if(!row){ return; }
        /* 【P258】★ 「待阅驳回」类消息（type=2，会议室/合同审批**驳回**通知）
           **不因跳转而置已读**。原实现无条件 messageReadData ⇒ 刘哥驳回后，
           销售点进合同详情的那一刻消息就被吃掉未读（实测 9 条 type=2 全部 is_read=1），
           角标与「待阅驳回」Tab 一起空掉，销售根本不知道自己被驳回了。
           口径：type===2 只减本地角标、不上报后端；其余类型维持 P128/P130 原行为。 */
        const __isReject = Number(row.type) === 2;
        /* 【P128】点「去处理」即视为已读：本地先扣 1，不等 WS 推送，避免气泡滞留 */
        if(typeof this.isMsgRead === 'function' && this.isMsgRead(row) === false){ this.decUnread(1); }
        /* 【P130】同步上报后端置 is_read=1（否则 type=0 通知的 m1 计数永不减、气泡不消）
           【P258】type===2 例外：保留未读，交由销售自行查阅后手动标记。 */
        if(row.sn && !__isReject){ try{ messageReadData({ sn: row.sn }); }catch(e){} }
        const api = row.page_api || '';
        this.msgDetailShow = false;
        if(api === 'crm_customers' || api === 'market_customers'){
          const sn = row.parent_sn;
          if(!sn){ this.$toast('缺少客户编号'); return; }
          this.quickSub = 'grid';
          this.$nextTick(() => { this.openCustomerDetail({sn: sn, item: {}}); });
          return;
        }
        /* 【P212 问题2-02】财务单据审核消息 → 打开关联的**销售合同订单详情**。
           order_sn 来自 page_url 查询参数（后端 _paymentApproval 写入），
           不取 parent_sn（那是支付单自身 sn）、不取 page_sn（页面配置 sn）。 */
        if(FIN_BILL_APIS.indexOf(api) > -1){
          const sn = this.msgOrderSn(row);
          if(!sn){ this.$toast('该消息暂不支持跳转'); return; }
          this.quickSub = 'grid';
          this.pendingEditSn = '';
          this.contractDetailIdx = -1;
          this.contractDetailSn = sn;
          this.contractDetailRoomSn = '';
          this.contractDetailVisible = true;
          return;
        }
        if(api === 'crm_orders'){
          const sn = row.parent_sn || row.page_sn;
          if(!sn){ this.$toast('缺少单据编号'); return; }
          this.quickSub = 'grid';
          this.pendingEditSn = '';
          this.contractDetailIdx = -1;
          this.contractDetailSn = sn;
          /* 【P214】销售端审批「待处理」消息进入**销售合同页**（合同主页），
             不再自动切到会议室订单单据页 —— 与 P212 财务单据消息分支口径一致。 */
          this.contractDetailRoomSn = '';
          this.contractDetailVisible = true;
          return;
        }
        this.$toast('该消息暂不支持跳转');
      },

      tabIco(active){
        return { width:'24px', height:'24px', stroke: active ? '#2b5fd9' : '#969799', fill:'none', strokeWidth:1.8 };
      },
      onTabbarChange(){

        /* 【P439】切到「快捷」一律回到宫格
           原实现 quickSub 跨 tab 保留 ⇒「进过回收站 / 消息 / 单据列表 → 切到客户 / 合同 →
           再点快捷」会停在**上一个子视图**，而且子视图数据是旧的（刚删的客户在回收站里看不到）。
           与「房态」tab 复位 roomSub='status' 同口径：切 tab 就是回到该 tab 的入口页。 */
        if(this.active==4 && this.quickSub!=='grid'){ this.quickSub='grid'; }

        this.refreshing=false;
        this.loading=false;
        this.finished=false;

        this.searchText=null;
        this.page=1;
        this.pageSize=10;


        if(this.active==0){
          /* 点击底部「房态」tab 时，回到房态总览（而非停留在会议室预订子视图） */
          this.roomSub='status';
        }else{
           this.onRefresh();
        }

        if(this.active==1){
          this.measureCustHeader();
          this.getCustomersOption();
        } else if(this.active==2 || this.active==3){
          this.measureCustHeader();
        } else if(this.active==0 && this.roomSub==='meeting'){
          this.measureCustHeader();
        }

    

      },

      measureCustHeader(){
        this.$nextTick(()=>{
          const refMap = {1:'custHeader', 2:'oppHeader', 3:'orderHeader', 5:'roomOrderHeader'};
          const el = this.$refs[refMap[this.active]];
          if(el){
            this.customerHeaderH = el.offsetHeight;
          }
        });
      },

      onRefresh(){
          console.log("onRefresh");


          this.page=1;
          this.finished=false;
          if(this.active==1){
             this.customersList=[];
             this.getCustomersList();
          }

          if(this.active==2){
            this.opportunitiesList=[];
            this.getOpportunitiesList();
          }

          if(this.active==3){
            this.orderList=[];
            this.getOrderList();
          }

          if(this.active==4){
            this.messageList=[];
            this.getMessageList();
            crmWs.refresh();
          }

          if(this.active==0 && this.roomSub==='meeting'){
            this.finished=false;
            this.page=1;
            this.roomOrderList=[];
            this.getRoomOrderList();
          }


      },

      onLoad(){

         console.log("onLoad");
         // 【P40】先识别当前视图是否真的有分页列表
         const isTabList  = (this.active==1 || this.active==2 || this.active==3);
         const isMsgList  = (this.active==4 && this.quickSub==='message');
         const isRoomList = (this.active==0 && this.roomSub==='meeting');
         if(!isTabList && !isMsgList && !isRoomList){
            // 无列表的视图（房态总览 / 快捷入口九宫格）收到 load 事件时：不推进 page，并释放 loading，
            // 否则 van-list 会永久停在「加载中」，同时 page 被无端自增导致后续分页错位
            this.loading = false;
            return;
         }
         // 【P40】并发不需要在此拦截：各列表函数在发请求前已把 loading 置 true，
         // van-list 的 check() 判定 innerLoading(=loading) 为真后就不会再 emit load。
         // ⚠️ 切勿写成 if(this.loading) return —— 子组件是先 emit('input',true) 把 loading 置真，
         // 再 emit('load')，那样写会让加载更多永远进不来（分页彻底失效）。
         if(this.finished){ return; }

         this.page=this.page+1;
         if(this.active==1){
            this.getCustomersList();
         }

         if(this.active==2){
          this.getOpportunitiesList();
         }

         if(this.active==3){
          this.getOrderList();
         }

         // 【P40】补齐缺失的「消息列表」分支：原实现无此分支，page 自增但请求不发，
         // van-list 永久卡在「加载中」（快捷 → 消息 分页失效）
         if(isMsgList){
          this.getMessageList();
         }

         if(isRoomList){
          this.getRoomOrderList();
         }

      },

      onMore(e){


        if(this.active==1){
          if(this.customersList[e].item.is_show==0){
            this.customersList[e].item.is_show=1;
          }else{
            this.customersList[e].item.is_show=0;
          }
        }
  
        if(this.active==2){
          if(this.opportunitiesList[e].item.is_show==0){
              this.opportunitiesList[e].item.is_show=1;
            }else{
              this.opportunitiesList[e].item.is_show=0;
          }
        }

        if(this.active==3){
         if(this.orderList[e].item.is_show==0){
            this.orderList[e].item.is_show=1;
          }else{
            this.orderList[e].item.is_show=0;
          }
        }

        if(this.active==0 && this.roomSub==='meeting'){
         if(this.roomOrderList[e].is_show==0){
            this.roomOrderList[e].is_show=1;
          }else{
            this.roomOrderList[e].is_show=0;
          }
        }

      },
      
      search(){
        this.onRefresh();
        /* 【P204 S5】关键词搜索会新增/移除「关键词：xxx」标签 ⇒ 重测头部占位高度 */
        this.measureCustHeader();
      },

      getCustomersOption(callback){
        if(this.customerOption.industry && this.customerOption.industry.length>0){
          if(callback){ callback(); }
          return;
        }
        let data={};
        getCustomersOptionData(data).then(response => {
            if(response && response.code == 200) {
              this.customerOption=response.data;
              if(callback){ callback(); }
            }
          })
          .catch(error => {
            console.log(error);
          });
      },

      openCustomerAdd(){
        this.customerForm={
          sn:'',
          name:'',
          serial_number:'',
          type:1,
          publish_status:2,
          industry:'',
          source:'',
          enquiry_data:'',
          customer_name:'',
          customer_phone:'',
          customer_wx:'',
          use:'',
          use_date:'',
          number_people:'',
          store_sn:'',
          store_name:'',
          remark:'',
          /* 【P204 M1】当前负责人（只读展示，仅编辑态有值） */
          owner_name:''
        };
        this.customerImageList=[];
        this.customerDateField='';
        this.dialogCustomer=true;
        this.getCustomersOption();
      },

      onSortClick(){
        this.getCustomersOption();
        this.dialogCustomerFilter=true;
      },

      onFilterConfirm(){
        this.dialogCustomerFilter=false;
        this.page=1;
        this.customersList=[];
        this.finished=false;
        this.getCustomersList();
        /* 【P204 S5】高级筛选确认后标签条可能出现 ⇒ 重测头部占位高度 */
        this.measureCustHeader();
      },

      onFilterReset(){
        this.customerFilterForm={source:'',industry:'',create_start:'',create_end:'',update_start:'',update_end:'',enquiry_start:'',enquiry_end:'',first_order_start:'',first_order_end:'',second_order_start:'',second_order_end:''};
      },

      openFilterPicker(field,title){
        this.activeFilterTarget='customer';
        this.filterPickerField=field;
        this.filterPickerTitle=title;
        this.filterPickerColumns=this.customerOption[field]?this.customerOption[field]:[];
        this.filterPickerShow=true;
      },
      onFilterPickerConfirm(value){
        if(this.activeFilterTarget==='opp' && value){
          this.oppFilterForm[this.filterSelectField]=value.value;
        } else if(this.activeFilterTarget==='order' && value){
          this.orderFilterForm[this.filterSelectField]=value.value;
        } else if(this.filterPickerField && value){
          this.customerFilterForm[this.filterPickerField]=value.value;
        }
        this.filterPickerShow=false;
      },

      openFilterDate(field,title){
        this.activeFilterTarget='customer';
        this.filterDateField=field;
        this.filterDateTitle=title;
        this.filterDateValue=this.customerFilterForm[field]?new Date(this.customerFilterForm[field]):new Date();
        this.filterDateShow=true;
      },
      onFilterDateConfirm(){
        const d=this.filterDateValue;
        const y=d.getFullYear();
        const m=String(d.getMonth()+1).padStart(2,'0');
        const day=String(d.getDate()).padStart(2,'0');
        const val=y+'-'+m+'-'+day;
        if(this.activeFilterTarget==='opp'){
          this.oppFilterForm[this.filterDateField]=val;
        } else if(this.activeFilterTarget==='order'){
          this.orderFilterForm[this.filterDateField]=val;
        } else {
          this.customerFilterForm[this.filterDateField]=val;
        }
        this.filterDateShow=false;
      },

      /* ===== 商机/合同 头部筛选 ===== */
      filterText(options, value){
        if(value===''||value===null||value===undefined) return '';
        for(let i=0;i<options.length;i++){ if(options[i].value==value){ return options[i].text; } }
        return '';
      },
      ownerFilterLabel(target){
        const form = target==='opp'? this.oppFilterForm : this.orderFilterForm;
        if(!form.owner_id) return '';
        const s=(this.managedStaffList||[]).find(x=>x.id===form.owner_id);
        return s? s.name : '';
      },
      openSelect(target, field, title, columns){
        this.activeFilterTarget=target;
        this.filterSelectField=field;
        this.filterPickerTitle=title;
        this.filterPickerColumns=columns;
        this.filterPickerShow=true;
      },
      openDateSelect(target, field, title){
        this.activeFilterTarget=target;
        this.filterDateField=field;
        this.filterDateTitle=title;
        const form = target==='opp'? this.oppFilterForm : this.orderFilterForm;
        this.filterDateValue = form[field]? new Date(form[field]) : new Date();
        this.filterDateShow=true;
      },
      openOwnerSelect(target){
        const cols=(this.managedStaffList||[]).map(s=>({text:s.name, value:s.id}));
        if(cols.length===0){ this.$toast('当前账号无可选负责人'); return; }
        this.openSelect(target,'owner_id','负责人',cols);
      },
      openOppFilter(){ this.activeFilterTarget='opp'; this.oppFilterShow=true; },
      openOrderFilter(){ this.activeFilterTarget='order'; this.orderFilterShow=true; },
      onOppFilterConfirm(){
        this.oppFilterShow=false;
        // 弹层里的「阶段」与顶部阶段 TAB 是同一字段，确认后同步 TAB 高亮，避免两处状态打架
        const st=this.oppFilterForm.stage;
        const hit=(this.oppFilterTabs||[]).find(t=>t.field==='stage' && String(t.value)===String(st));
        this.oppFilterTab = hit || this.oppFilterTabs[0];
        this.page=1; this.finished=false; this.opportunitiesList=[];
        this.getOpportunitiesList();
      },
      onOrderFilterConfirm(){
        this.orderFilterShow=false;
        this.page=1; this.finished=false; this.orderList=[];
        this.getOrderList();
      },
      onOppFilterReset(){
        this.oppFilterForm={ stage:'', owner_id:'', start_time:'', end_time:'', amount_min:'', amount_max:'' };
      },
      onOrderFilterReset(){
        // 【P24-0-2 修复】重置必须清空签约时间区间，否则「重置」后筛选条件仍残留
        this.orderFilterForm={ stage:'', status:'', owner_id:'', start_time:'', end_time:'', signing_date_begin:'', signing_date_end:'' };
      },
      clearOppFilter(){ this.onOppFilterReset(); this.onOppFilterConfirm(); },
      clearOrderFilter(){ this.onOrderFilterReset(); this.onOrderFilterConfirm(); },

      /* 【P204 S5】逐项移除标签：按 key 复位对应维度后刷新列表
         ★ 标签集合不含 staff 维度（由 S4 胶囊承担清除），故无 staff 分支。
         ★ 标签条显隐会改变 .customer-header 高度 ⇒ 必须重测占位高度。 */
      removeCustomerFilterTag(tag){
        if(!tag || !tag.key){ return; }
        const k = tag.key;
        if(k === 'search'){
          this.searchText = null;
        }else if(k === 'source' || k === 'industry'){
          this.customerFilterForm[k] = '';
        }else if(tag.startKey && tag.endKey){
          this.customerFilterForm[tag.startKey] = '';
          this.customerFilterForm[tag.endKey] = '';
        }
        this.page = 1;
        this.customersList = [];
        this.finished = false;
        this.loading = true;          // 【P40】先占住 loading，防 van-list 并发
        this.getCustomersList();
        this.measureCustHeader();
      },
      /* 【P204 S5】一键清空全部搜索条件（关键词 + 高级筛选 + 销售人员），并刷新
         ★ 销售人员维度虽不在标签集合里展示（由 S4 胶囊承担），但「清空全部」语义上
           应把当前列表的**所有**限制条件复位 —— 否则用户点了「清空全部」列表仍被员工过滤，
           会产生「清空无效」的困惑。 */
      clearCustomerFilter(){
        this.searchText = null;
        this.customerFilterForm = {
          source:'', industry:'',
          create_start:'', create_end:'',
          update_start:'', update_end:'',
          enquiry_start:'', enquiry_end:'',
          first_order_start:'', first_order_end:'',
          second_order_start:'', second_order_end:''
        };
        this.staffFilter = 'all';
        this.staffFilterLabel = '全部销售人员';
        this.page = 1;
        this.customersList = [];
        this.finished = false;
        this.loading = true;
        this.getCustomersList();
        this.measureCustHeader();
      },


      onCustomerFilterClick(){
        this.$toast('筛选功能开发中');
      },

      onCustomerFilterTabClick(tab, idx){
        /* 【P204 S4】销售人员已是独立胶囊，状态 tab 不再兼职打开人员选择器。
           切到任何非「全部客户」状态时，自动清除销售人员维度，避免两个筛选项打架。 */
        if(tab && tab.field && this.staffFilter !== 'all'){
          this.staffFilter = 'all';
          this.staffFilterLabel = '全部销售人员';
        }
        this.customerFilterTab=tab;
        this.page=1;
        this.customersList=[];
        this.finished=false;
        this.loading=true;          // 【P40】先占住 loading，防 van-list 并发触发
        this.getCustomersList();
        // 【P204 S4】胶囊显隐随 tab 变化（.customer-header 是 fixed，必须重算占位高度）
        this.measureCustHeader();
      },

      /* ===== 商机列表：阶段 TAB（全部/待执行/沟通报价/合同预定/签约付款/失单） ===== */
      onOppFilterTabClick(tab, idx){
        if(this.oppFilterTab && this.oppFilterTab.label === tab.label && this.page === 1 && this.opportunitiesList.length > 0){
          return;
        }
        this.oppFilterTab=tab;
        this.page=1;
        this.opportunitiesList=[];
        this.finished=false;
        this.loading=true;
        this.getOpportunitiesList();
      },

      /* ===== 合同列表：状态 TAB + 管理人员范围选择（与客户模块一致） ===== */
      onOrderFilterTabClick(tab, idx){
        // 管理人员：第一个 tab 是「人员范围选择器」，点击打开下拉
        if(idx === 0 && this.managedStaffList.length > 0){
          this.orderStaffSheetShow = true;
          return;
        }
        this.orderFilterTab=tab;
        this.page=1;
        this.orderList=[];
        this.finished=false;
        this.getOrderList();
      },
      onSelectOrderStaff(val){
        const id = (val && val.value !== undefined) ? val.value : (val && val.id);
        const text = (val && val.text !== undefined) ? val.text : (val && val.name);
        this.orderStaffFilter = id;
        this.orderStaffFilterLabel = text;
        // 同步更新第一个 tab 的显示文本（全部人员 / 我的合同 / 销售X）
        this.orderFilterTabs[0].label = text;
        this.orderFilterTab = this.orderFilterTabs[0];
        this.orderStaffSheetShow = false;
        if(this.active == 3){
          this.onRefresh();
        }
      },

      previewImage(url){
        if(!url){ return; }
        ImagePreview([url]);
      },
      openCustomerEdit(idx){
        let row=this.customersList[idx];
        if(!row){ return; }
        let item=row.item?row.item:{};
        let publish=(item.publish_status===0||item.publish_status)?item.publish_status:(row.publish_status?row.publish_status:0);
        this.customerForm={
          sn:row.sn,
          name:item.name?item.name:'',
          serial_number:item.serial_number?item.serial_number:'',
          type:item.type?item.type:1,
          publish_status:publish,
          industry:row.industry?row.industry:'',
          source:row.source?row.source:'',
          enquiry_data:item.enquiry_data?item.enquiry_data:'',
          customer_name:item.customer_name?item.customer_name:'',
          customer_phone:item.customer_phone?item.customer_phone:'',
          customer_wx:item.customer_wx?item.customer_wx:'',
          use:item.use?item.use:'',
          use_date:item.use_date?item.use_date:'',
          number_people:item.number_people?item.number_people:'',
          store_sn:item.store_sn?item.store_sn:'',
          store_name:item.store_name?item.store_name:'',
          remark:item.remark?item.remark:'',
          /* 【P204 M1】当前负责人（只读展示）；真实值由 customersDetail 的 owner_name 覆盖 */
          owner_name:''
        };
        this.customerImageList=[];
        this.dialogCustomer=true;
        this.getCustomersOption(() => {
          let data={ "sn":row.sn };
          getCustomersDetailData(data).then(response => {
              if(response && response.code == 200) {
                this.customerForm=Object.assign({},this.customerForm,response.data);
                if(this.customerForm.attachment_image){
                  this.customerImageList=[{url:this.customerForm.attachment_image,isImage:true}];
                }
              }
            })
            .catch(error => {
              console.log(error);
            });
        });
      },

      /* ===== 客户分配：接收 / 拒绝（单条 + 批量） ===== */
      /* 【P140】进入/退出批量：进入时按二级分类收敛列表范围，退出时还原进入前的筛选 */
      toggleBatch(){
        this.batchMode = !this.batchMode;
        if(this.batchMode){
          this.batchSub = 'pending';        // 每次进入都从「我的待接收」开始
          this.selectedCustomers = [];
          this.applyBatchScope(true);
        }else{
          this.selectedCustomers = [];
          this.applyBatchScope(false);
        }
        this.$nextTick(()=> this.measureCustHeader());
      },
      /* 【P140】切换二级分类（仅管理人员可切到 assign；普通销售强制停留在 pending） */
      setBatchSub(sub){
        if(sub === 'assign' && !this.batchIsManager){ sub = 'pending'; }
        if(sub === this.batchSub) return;
        this.batchSub = sub;
        this.selectedCustomers = [];
        this.applyBatchScope(true);
      },
      /* 【P140】按二级分类设定列表筛选并重拉第一页
         pending → 只看「待接收」(publish_status=1)
         assign  → 我管辖范围内的全部客户（清掉状态筛选）
         退出批量时还原进入前的筛选条件 */
      applyBatchScope(active){
        if(active && !this._batchPrevTab){ this._batchPrevTab = this.customerFilterTab; }
        if(active){
          this.customerFilterTab = (this.batchSub === 'pending')
            ? { label:'待接收', field:'publish_status', value:1 }
            : { label:'全部客户', field:'', value:'' };
        }else if(this._batchPrevTab){
          this.customerFilterTab = this._batchPrevTab;
          this._batchPrevTab = null;
        }
        this.page = 1;
        this.finished = false;
        this.customersList = [];
        this.loading = true;          // 【P40】先占住 loading，防 van-list 并发触发 onLoad
        this.getCustomersList();
      },
      isSelected(sn){ return this.selectedCustomers.indexOf(sn) > -1; },
      onSelectCustomer(sn, checked){
        if(checked){
          if(this.selectedCustomers.indexOf(sn) < 0) this.selectedCustomers.push(sn);
        }else{
          this.selectedCustomers = this.selectedCustomers.filter(s => s !== sn);
        }
      },
      toggleSelectAll(val){
        if(val){
          /* 【P140】「我的待接收」只全选待接收行；「分配客户」全选本页 */
          this.selectedCustomers = (this.batchSub === 'pending')
            ? this.customersList.filter(c => c.publish_status === 1).map(c => c.sn)
            : this.customersList.map(c => c.sn);
        }else{
          this.selectedCustomers = [];
        }
      },
      allocOne(sn, action){
        if(this.allocLoading) return;
        this.allocLoading = true;
        customerAllocationAction({ customer_sn: sn, action: action }).then(res => {
          if(res && res.code === 200){
            this.$toast(action === 'receive' ? '已接收' : '已拒绝');
            /* 【P128】处理掉一条待办消息 → 本地立即扣减角标（不等 WS） */
            this.decUnread(1);
            this.afterAlloc();
          }else{
            suppressGlobalError();
            this.$toast((res && res.msg) ? res.msg : '操作失败');
          }
        }).catch(() => {
          this.$toast('网络错误，请重试');
        }).finally(() => {
          this.allocLoading = false;
        });
      },
      /* 【P125】客户详情页的接收 / 拒绝：与列表 allocOne 同一接口，
         成功后刷新详情（状态变了按钮会自动消失）+ 刷新列表与未读角标 */
      allocOneFromDetail(action){
        const sn = (this.detailCustomer && this.detailCustomer.sn) ? this.detailCustomer.sn : '';
        if(!sn){ this.$toast('客户信息缺失'); return; }
        if(this.allocLoading) return;
        this.allocLoading = true;
        customerAllocationAction({ customer_sn: sn, action: action }).then(res => {
          if(res && res.code === 200){
            this.$toast(action === 'receive' ? '已接收' : '已拒绝');
            /* 【P128】处理掉一条待办消息 → 本地立即扣减角标（不等 WS） */
            this.decUnread(1);
            this.fetchCustomerDetail();
            this.afterAlloc();
          }else{
            suppressGlobalError();
            this.$toast((res && res.msg) ? res.msg : '操作失败');
          }
        }).catch(() => {
          this.$toast('网络错误，请重试');
        }).finally(() => {
          this.allocLoading = false;
        });
      },
      batchAlloc(action){
        if(this.allocLoading) return;
        if(this.selectedCustomers.length === 0){ this.$toast('请先选择客户'); return; }
        this.allocLoading = true;
        const sns = this.selectedCustomers.slice();
        let done = 0, ok = 0;
        sns.forEach(sn => {
          customerAllocationAction({ customer_sn: sn, action: action }).then(res => {
            if(res && res.code === 200) ok++;
          }).catch(() => {}).finally(() => {
            done++;
            if(done === sns.length){
              this.allocLoading = false;
              this.batchMode = false;
              this.selectedCustomers = [];
              this.$toast('已处理 ' + ok + ' / ' + sns.length + ' 个');
              this.afterAlloc();
            }
          });
        });
      },
      afterAlloc(){
        this.onRefresh();
        crmWs.refresh();
      },

      // 销售管理员：打开批量分配给其他销售人员的弹层
      openBatchAssign(){
        if(this.selectedCustomers.length === 0){ this.$toast('请先选择客户'); return; }
        if(this.managedStaffList.length === 0){ this.$toast('当前账号无下属销售，无法分配'); return; }
        this.assignStaffId = '';
        this.assignPopupShow = true;
      },

      // 销售管理员：确认批量分配
      confirmBatchAssign(){
        if(!this.assignStaffId){ this.$toast('请选择销售人员'); return; }
        if(this.selectedCustomers.length === 0){ this.$toast('请先选择客户'); return; }
        this.assignLoading = true;
        customerAllocationBatch({
          customer_sn: this.selectedCustomers.join(','),
          to_staff_id: this.assignStaffId
        }).then(res => {
          if(res && res.code === 200){
            this.$toast('已分配给 ' + (this.assignStaffName || '销售'));
            this.assignPopupShow = false;
            this.batchMode = false;
            this.selectedCustomers = [];
            this.afterAlloc();
          }else{
            suppressGlobalError();
            this.$toast((res && res.msg) ? res.msg : '分配失败');
          }
        }).catch(() => {
          this.$toast('网络错误，请重试');
        }).finally(() => {
          this.assignLoading = false;
        });
      },

      beforeReadCustomerImage(file){
        if(file.type!=='image/jpeg' && file.type!=='image/png' && file.type!=='image/jpg' && file.type!=='image/gif'){
          this.$toast('请上传 jpg/png/gif 图片');
          return false;
        }
        return true;
      },
      afterReadCustomerImage(file){
        this.customerImageUploading=true;
        getQiniuToken({}).then(response => {
          if(response && response.code == 200){
            const token=response.data;
            const formData=new FormData();
            formData.append('token',token);
            formData.append('file',file.file);
            const axios=require('axios');
            axios.post(this.$store.state.qiniupUrl, formData, {
              headers:{'Content-Type':'multipart/form-data'}
            }).then(res => {
              this.customerImageUploading=false;
              if(res.data && res.data.key){
                const url=this.$store.state.qiniuSrcUrl + res.data.key;
                this.customerForm.attachment_image=url;
                this.customerImageList=[{url:url,isImage:true}];
              }else{
                this.$toast('上传失败，请重试');
                this.customerImageList=[];
              }
            }).catch(err => {
              this.customerImageUploading=false;
              this.$toast('上传失败');
              console.log(err);
              this.customerImageList=[];
            });
          }else{
            this.customerImageUploading=false;
            this.$toast('获取上传凭证失败');
          }
        }).catch(error => {
          this.customerImageUploading=false;
          console.log(error);
        });
      },
      onCustomerImageDelete(){
        this.customerForm.attachment_image='';
        this.customerImageList=[];
      },

      onCustomerPick(field){
        let title='请选择';
        if(field=='type'){ title='客户类别'; }
        if(field=='publish_status'){ title='客户状态'; }
        if(field=='industry'){ title='所属行业'; }
        if(field=='source'){ title='客户来源'; }
        if(field=='use'){ title='用途'; }
        this.customerPickerTitle=title;
        this.customerPickerField=field;
        this.customerPickerColumns=this.customerOption[field]?this.customerOption[field]:[];
        this.customerPickerShow=true;
      },

      onCustomerPickerConfirm(value){
        let field=this.customerPickerField;
        if(field && value){
          this.customerForm[field]=value.value;
        }
        this.customerPickerShow=false;
      },

      openCustomerDate(field,title){
        this.customerDateField=field;
        this.customerCurrentDate=this.customerForm[field]?new Date(this.customerForm[field]):new Date();
        this.dialogCustomerDate=true;
      },
      onCustomerDateConfirm(){
        this.dialogCustomerDate=false;
        const date=new Date(this.customerCurrentDate);
        const year=date.getFullYear();
        const month=date.getMonth()+1;
        const day=date.getDate();
        this.customerForm[this.customerDateField]=year+'-'+String(month).padStart(2,'0')+'-'+String(day).padStart(2,'0');
      },

      customerText(field,value){
        let list=this.customerOption[field]?this.customerOption[field]:[];
        for(let i=0;i<list.length;i++){
          if(list[i].value==value){
            return list[i].text;
          }
        }
        return '';
      },

      openCustStorePick(){
        this.custStorePickShow=true;
        let data={ searchText:'', page:1, pageSize:200 };
        getStores(data).then(response => {
            if(response && response.code==200){
              let list=(response.data&&response.data.data)?response.data.data:(Array.isArray(response.data)?response.data:[]);
              this.custStorePickColumns=list.map(row=>{ return { text:row.title||row.name||row.sn, value:row.sn, raw:row }; });
            } else {
              this.custStorePickColumns=[];
            }
          }).catch(()=>{ this.custStorePickColumns=[]; });
      },
      onCustStorePickConfirm(value){
        if(value){
          this.customerForm.store_sn=value.value;
          this.customerForm.store_name=value.text;
        }
        this.custStorePickShow=false;
      },
      onRemarkCreated(editor){ this.editorRemark=Object.seal(editor); },

      submitCustomer(){
        if(!this.customerForm.name){
          this.$toast('请填写客户名称');
          return;
        }
        if(!this.customerForm.industry){
          this.$toast('请选择行业');
          return;
        }
        if(!this.customerForm.source){
          this.$toast('请选择来源');
          return;
        }
        this.customerSaving=true;
        saveCustomersData(this.customerForm).then(response => {
            this.customerSaving=false;
            if(response && response.code == 200) {
              this.$toast(response.msg);
              this.dialogCustomer=false;
              this.onRefresh();
            } else {
              suppressGlobalError();
              this.$toast((response && response.msg) ? response.msg : '保存失败');
            }
          })
          .catch(error => {
            this.customerSaving=false;
            console.log(error);
          });
      },

      closeCustomer(){
        this.dialogCustomer=false;
      },

      /* ================= 客户详情 / 联系人 / 回访 ================= */

      openCustomerDetail(item){
        if(this.detailLoading){ return; }
        const base = (item && item.item) ? item.item : {};
        this.detailCustomer = Object.assign({}, base, { sn: item ? item.sn : '' });
        this.detailContacts = [];
        this.detailVisits = [];
        this.detailShow = true;
        this.fetchCustomerDetail();
      },

      fetchCustomerDetail(){
        if(!this.detailCustomer.sn){ return; }
        this.detailLoading = true;
        getCustomersDetailData({ sn: this.detailCustomer.sn }).then(response => {
          this.detailLoading = false;
          if(response && response.code == 200){
            const d = response.data || {};
            this.detailCustomer = Object.assign({}, this.detailCustomer, d);
            this.detailContacts = d.contacts || [];
            this.contactExpanded = {};
            this.detailVisits = d.visits || [];
          } else {
            suppressGlobalError();
            this.$toast((response && response.msg) ? response.msg : '加载失败');
          }
        }).catch(() => { this.detailLoading = false; });
      },

      closeCustomerDetail(){
        this.detailShow = false;
      },

      /* 变更记录时间线 */
      openChangeLog(){
        if(!this.detailCustomer || !this.detailCustomer.sn){ this.$toast('客户信息缺失'); return; }
        this.changeLogShow = true;
        this.changeLogList = [];
        this.logPage = 1;
        this.logFinished = false;
        this.logLoading = false;
        /* 【P122】每次打开重置筛选与总数 */
        this.logFilter = 'all';
        this.logTotal = 0;
        this.loadChangeLog();
      },
      closeChangeLog(){
        this.changeLogShow = false;
      },
      onLogRefresh(){
        this.changeLogList = [];
        this.logPage = 1;
        this.logFinished = false;
        this.loadChangeLog();
      },
      loadChangeLog(){
        if(this.logLoading || this.logFinished){ return; }
        this.logLoading = true;
        const parentSn = (this.detailCustomer && this.detailCustomer.sn) ? this.detailCustomer.sn : '';
        getLogListData({ parent_sn: parentSn, page: this.logPage, limit: 20 }).then(response => {
          this.logLoading = false;
          this.logRefreshing = false;
          if(response && response.code == 200){
            const data = response.data || {};
            const list = Array.isArray(data.list) ? data.list : [];
            /* 【P122】记录总数（顶部展示 + 判断是否还有下一页更准） */
            this.logTotal = Number(data.total || 0);
            const decorated = list.map(it => this.decorateLog(it));
            this.changeLogList = this.changeLogList.concat(decorated);
            if(list.length < 20){ this.logFinished = true; }
            this.logPage = this.logPage + 1;
          } else {
            suppressGlobalError();
            this.logFinished = true;
            this.$toast((response && response.msg) ? response.msg : '加载失败');
          }
        }).catch(() => {
          this.logLoading = false;
          this.logRefreshing = false;
          this.logFinished = true;
        });
      },
      decorateLog(it){
        let changes = [];
        try { changes = it.changes ? JSON.parse(it.changes) : []; } catch(e){ changes = []; }
        let snapshot = null;
        try { snapshot = it.snapshot ? JSON.parse(it.snapshot) : null; } catch(e){ snapshot = null; }
        const snapRows = [];
        if(snapshot && typeof snapshot === 'object'){
          const skip = ['is_delete','formsrc'];
          for(const k in snapshot){
            if(skip.indexOf(k) >= 0) continue;
            let v = snapshot[k];
            if(v === null || v === undefined) v = '';
            if(typeof v === 'object') v = JSON.stringify(v);
            snapRows.push({ k:k, v:v });
          }
        }
        const actionMap = { add:'新增', edit:'编辑', delete:'删除' };
        const moduleMap = { customer:'客户', contact:'联系人', visit:'回访', opportunity:'商机', order:'合同', payment:'回款', invoice:'发票' };
        const lvlMap = { add:4, edit:2, delete:5 };
        /* 【P122】新增：操作图标 / 日期分组标签 / 简短时间 */
        const iconMap = { add:'plus', edit:'edit', delete:'delete-o' };
        const raw = String(it.create_time || '');
        const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
        let day = '更早', timeShort = raw;
        if(m){
          timeShort = m[4] + ':' + m[5];
          const nd = new Date();
          const pad = (n) => (String(n).length < 2 ? '0' + n : String(n));
          const ds = m[1] + '-' + m[2] + '-' + m[3];
          const today = nd.getFullYear() + '-' + pad(nd.getMonth() + 1) + '-' + pad(nd.getDate());
          const yd = new Date(nd.getTime() - 86400000);
          const yday = yd.getFullYear() + '-' + pad(yd.getMonth() + 1) + '-' + pad(yd.getDate());
          if(ds === today){ day = '今天'; }
          else if(ds === yday){ day = '昨天'; }
          else if(m[1] === String(nd.getFullYear())){ day = m[2] + '-' + m[3]; }
          else { day = ds; }
        }
        return Object.assign({}, it, {
          _changes: Array.isArray(changes) ? changes : [],
          _snapshot: snapshot,
          _snapRows: snapRows,
          _actionText: actionMap[it.action] || it.action || '',
          _moduleText: moduleMap[it.module] || it.module || '',
          _lvl: lvlMap[it.action] || 2,
          _icon: iconMap[it.action] || 'records',
          _day: day,
          _timeShort: timeShort
        });
      },

      /* 客户详情底部「编辑客户」：关详情 → 打开客户编辑表单（与商机详情 editFromDetail 同款交互） */
      editCustomerFromDetail(){
        const sn = this.detailCustomer.sn;
        if(!sn){ this.$toast('客户信息缺失'); return; }
        const idx = this.customersList.findIndex(function(r){ return r && r.sn === sn; });
        if(idx < 0){ this.$toast('未找到该客户，请返回列表重试'); return; }
        this.detailShow=false;
        this.openCustomerEdit(idx);
      },

      visitContactName(sn){
        if(!sn){ return ''; }
        const c = this.detailContacts.find(x => x.sn === sn);
        return c ? c.name : sn;
      },

      /* 联系人卡片：展开 / 收起 详情 */
      toggleContactExpand(c){
        const k = c.sn || ('_'+(c.name||'x'));
        this.$set(this.contactExpanded, k, !this.contactExpanded[k]);
      },

      /* 添加 / 编辑 联系人 */
      openContactSheet(c){
        if(c && c.sn){
          this.contactForm = {
            sn: c.sn,
            name: c.name||'',
            phone: c.phone||'',
            gender: c.gender||0,
            position: c.position||'',
            department: c.department||'',
            wx: c.wx||'',
            email: c.email||'',
            birthday: c.birthday||'',
            is_important: c.is_important?1:0,
            remark: c.remark||''
          };
          this.contactSheetTitle = '编辑联系人';
        } else {
          this.contactForm = { sn:'', name:'', phone:'', gender:0, position:'', department:'', wx:'', email:'', birthday:'', is_important:0, remark:'' };
          this.contactSheetTitle = '添加联系人';
        }
        this.contactSheetShow = true;
      },
      closeContactSheet(){
        this.contactSheetShow = false;
      },
      toggleContactImportant(){
        this.contactForm.is_important = this.contactForm.is_important ? 0 : 1;
      },
      submitContact(){
        if(!this.contactForm.name){ this.$toast('请填写联系人姓名'); return; }
        if(!this.contactForm.phone){ this.$toast('请填写手机号'); return; }
        if(!this.detailCustomer.sn){ this.$toast('客户信息缺失'); return; }
        this.doSaveContact(false);
      },
      /* 【P204 S2】强制保存：用户在重复提醒里点了「仍要保存」⇒ 带 __force=1 重提 */
      forceSaveContact(){
        this.doSaveContact(true);
      },
      /* 统一的联系人保存入口（__force=false 普通保存 / true 强制覆盖重复提醒） */
      doSaveContact(__force){
        this.contactSaving = true;
        const payload = Object.assign({ customer_sn: this.detailCustomer.sn }, this.contactForm);
        if(__force){ payload.__force = 1; }
        saveContactData(payload).then(response => {
          this.contactSaving = false;
          const code = response && response.code;
          if(code == 200){
            this.contactDupShow = false;
            this.$toast(this.contactForm.sn ? '联系人已更新' : '联系人已添加');
            this.contactSheetShow = false;
            this.fetchCustomerDetail();
            return;
          }
          /* 【P204 S2】409 = 手机号/微信号已在「其他客户」下存在：不落库，弹二次确认，
             用户点「仍要保存」由 forceSaveContact() 带 __force=1 重提。
             注意 suppressGlobalError() 必须最先调用，压掉全局红色兜底提示，避免双提示。 */
          if(code == 409){
            suppressGlobalError();
            const d = (response && response.data) || {};
            this.contactDupDesc = this.buildContactDupDesc(d.conflicts || []);
            this.contactDupShow = true;
            return;
          }
          suppressGlobalError();
          this.$toast((response && response.msg) ? response.msg : '保存失败');
        }).catch(() => { this.contactSaving = false; });
      },
      /* 把后端 conflicts 明细拼成一句人话（最多列 3 条，其余折叠） */
      buildContactDupDesc(list){
        const arr = (list || []).slice(0, 3).map(c => {
          const who = c.customer_name ? '「' + c.customer_name + '」' : '其他客户';
          const ct  = c.contact_name ? '（联系人：' + c.contact_name + '）' : '';
          return (c.label || '联系方式') + ' ' + (c.value || '') + ' 已用于' + who + ct;
        });
        const more = (list || []).length > 3 ? '\n另有 ' + (list.length - 3) + ' 条重复未列出。' : '';
        return arr.join('\n') + more + '\n\n继续保存将产生重复数据，是否仍要保存？';
      },

      /* 添加 / 编辑 回访 */
      openVisitSheet(v){
        if(v && v.sn){
          this.visitForm = {
            sn: v.sn,
            title: v.title||'',
            contact_sn: v.contact_sn||'',
            visit_time: v.visit_time||'',
            field_status: v.field_status||'已上门',
            content: v.content||'',
            customer_address: v.customer_address||'',
            next_plan: v.next_plan||'',
            remark: v.remark||'',
            attachment_image: v.attachment_image||''
          };
          this.visitSheetTitle = '编辑回访记录';
        } else {
          this.visitForm = { sn:'', title:'', contact_sn:'', visit_time:'', field_status:'已上门', content:'', customer_address:'', next_plan:'', remark:'', attachment_image:'' };
          this.visitSheetTitle = '添加回访记录';
        }
        this.visitSheetShow = true;
      },
      closeVisitSheet(){
        this.visitSheetShow = false;
      },
      // 【P95】一.02 回访标题自动生成预览
      // 规则：【客户名称】【上门拜访/电话沟通】时间，【回访人】
      visitTitlePreview(){
        const name = (this.detailCustomer && (this.detailCustomer.name || this.detailCustomer.customer_name)) || '';
        const wayMap = { '已上门':'上门拜访', '电话':'电话沟通', '线上会议':'线上会议' };
        const way = wayMap[this.visitForm.field_status] || this.visitForm.field_status || '上门拜访';
        const t = this.visitForm.visit_time || '';
        const stamp = t ? (t.length > 10 ? t : t + ' ' + this.nowHM()) : this.nowDate();
        const who = localStorage.getItem('staff_name') || '';
        return '【' + name + '】【' + way + '】' + stamp + (who ? '，【' + who + '】' : '');
      },
      nowHM(){ const d = new Date(); const p = n => (n < 10 ? '0' + n : '' + n); return p(d.getHours()) + ':' + p(d.getMinutes()); },
      nowDate(){ const d = new Date(); const p = n => (n < 10 ? '0' + n : '' + n); return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' ' + this.nowHM(); },

      submitVisit(){
        // 【P95】一.02 标题不再要求用户填写（自动生成），仅校验访问内容与客户
        if(!this.visitForm.content){ this.$toast('请填写访问内容'); return; }
        if(!this.detailCustomer.sn){ this.$toast('客户信息缺失'); return; }
        this.visitForm.title = this.visitTitlePreview();
        this.visitSaving = true;
        const payload = Object.assign({ customer_sn: this.detailCustomer.sn }, this.visitForm);
        saveVisitData(payload).then(response => {
          this.visitSaving = false;
          if(response && response.code == 200){
            this.$toast(this.visitForm.sn ? '回访已更新' : '回访已添加');
            this.visitSheetShow = false;
            this.fetchCustomerDetail();
          } else {
            suppressGlobalError();
            this.$toast((response && response.msg) ? response.msg : '保存失败');
          }
        }).catch(() => { this.visitSaving = false; });
      },

      /* ================= 商机：新增 / 编辑 ================= */

      openOppStat(){
        this.oppStatShow=true;
        this.loadOppStat();
      },
      loadOppStat(){
        this.oppStatLoading=true;
        getOpportunitiesStatData({}).then(res=>{
          if(res.code==200){
            this.oppStat=res.data||{funnel:[],lost:{total:0,reasons:[]},summary:{}};
          }
          this.oppStatLoading=false;
        }).catch(()=>{ this.oppStatLoading=false; });
      },
      fmtMoney(n){ return (Math.round(n||0)).toLocaleString('en-US'); },
      funnelWidth(cnt){
        const arr=this.oppStat.funnel||[];
        const max=arr.reduce((m,x)=>Math.max(m,x.cnt),1);
        return max>0?Math.round(cnt/max*100):0;
      },
      lostWidth(cnt){
        const arr=(this.oppStat.lost&&this.oppStat.lost.reasons)||[];
        const max=arr.reduce((m,x)=>Math.max(m,x.cnt),1);
        return max>0?Math.round(cnt/max*100):0;
      },
      openContractStat(){
        this.contractStatShow=true;
        this.loadContractStat();
      },
      loadContractStat(){
        this.contractStatLoading=true;
        getContractsStatData({}).then(res=>{
          if(res.code==200){
            this.contractStat=res.data||this.contractStat;
          }
          this.contractStatLoading=false;
        }).catch(()=>{ this.contractStatLoading=false; });
      },
      catWidth(cnt){ const a=this.contractStat.category||[]; const max=a.reduce((m,x)=>Math.max(m,x.cnt),1); return max>0?Math.round(cnt/max*100):0; },
      stageWidth(cnt){ const a=this.contractStat.stage||[]; const max=a.reduce((m,x)=>Math.max(m,x.cnt),1); return max>0?Math.round(cnt/max*100):0; },
      payWidth(cnt){ const a=this.contractStat.payment.byStatus||[]; const max=a.reduce((m,x)=>Math.max(m,x.cnt),1); return max>0?Math.round(cnt/max*100):0; },
      refundWidth(cnt){ const a=this.contractStat.refund.byStatus||[]; const max=a.reduce((m,x)=>Math.max(m,x.cnt),1); return max>0?Math.round(cnt/max*100):0; },
      invWidth(cnt){ const a=this.contractStat.invoice.byType||[]; const max=a.reduce((m,x)=>Math.max(m,x.cnt),1); return max>0?Math.round(cnt/max*100):0; },
      openOrdersStat(){
        this.ordersStatShow=true;
        this.loadOrdersStat();
      },
      loadOrdersStat(){
        this.ordersStatLoading=true;
        getOrdersStatData({}).then(res=>{
          if(res.code==200){
            this.ordersStat=res.data||this.ordersStat;
          }
          this.ordersStatLoading=false;
        }).catch(()=>{ this.ordersStatLoading=false; });
      },
      orderTypeWidth(cnt){ const a=this.ordersStat.type||[]; const max=a.reduce((m,x)=>Math.max(m,x.cnt),1); return max>0?Math.round(cnt/max*100):0; },
      orderStatusWidth(cnt){ const a=this.ordersStat.status||[]; const max=a.reduce((m,x)=>Math.max(m,x.cnt),1); return max>0?Math.round(cnt/max*100):0; },
      orderStageWidth(cnt){ const a=this.ordersStat.stage||[]; const max=a.reduce((m,x)=>Math.max(m,x.cnt),1); return max>0?Math.round(cnt/max*100):0; },
      openOpportunityAdd(){
        this.opportunityForm={
          sn:'',
          name:'',
          serial_number:'',
          customer_sn:'',
          customer_name:'',
          stage:1,
          sales_amount:'',
          number_people:'',
          store:'',
          inquiry_data:'',
          on_site_time:'',
          off_site_time:'',
          remind_datetime:'',
          lost_reason_type:0,
          /* 【P440】新口径失单类型（21-30），30=其他原因才显示「失单说明」 */
          lost_reason_type2:0,
          lost_reason:'',
          is_lost:0,
          next_plan:'',
          follow_up_Content:'',
          remark:''
        };
        this.dialogOpportunity=true;
      },

      openOpportunityEdit(idx){
        let row=this.opportunitiesList[idx];
        if(!row){ return; }
        let item=row.item?row.item:{};
        this.opportunityForm={
          sn:row.sn,
          name:row.name?row.name:'',
          serial_number:row.serial_number?row.serial_number:'',
          customer_sn:row.customer_sn?row.customer_sn:'',
          customer_name:item.customer_name?item.customer_name:'',
          stage:row.stage?row.stage:1,
          sales_amount:(row.sales_amount===0||row.sales_amount)?row.sales_amount:'',
          number_people:(row.number_people===0||row.number_people)?row.number_people:'',
          store:row.store?row.store:'',
          inquiry_data:row.inquiry_data?row.inquiry_data:'',
          on_site_time:row.on_site_time?row.on_site_time:'',
          off_site_time:row.off_site_time?row.off_site_time:'',
          remind_datetime:row.remind_datetime?row.remind_datetime:(row.remind_date?row.remind_date:''),
          lost_reason_type:row.lost_reason_type?row.lost_reason_type:0,
          /* 【P440】新口径失单类型；列表接口未下发时先 0，由详情接口 Object.assign 校正 */
          lost_reason_type2:row.lost_reason_type2?row.lost_reason_type2:0,
          lost_reason:row.lost_reason?row.lost_reason:'',
          is_lost:row.is_lost?row.is_lost:0,
          next_plan:row.next_plan?row.next_plan:'',
          follow_up_Content:row.follow_up_Content?row.follow_up_Content:'',
          remark:row.remark?row.remark:''
        };
        this.dialogOpportunity=true;
        // 用详情接口校正，避免列表字段裁剪导致回填不完整
        let data={ "sn":row.sn };
        getOpportunitiesDetailData(data).then(response => {
            if(response && response.code == 200) {
              this.opportunityForm=Object.assign({},this.opportunityForm,response.data);
            }
          })
          .catch(error => {
            console.log(error);
          });
      },

      onOpportunityStageConfirm(value){
        if(value){ this.opportunityForm.stage=value.value; }
        this.opportunityStageShow=false;
      },

      /* 【P440】打开失单类型选择器：先定位到当前已选值（Vant2 Picker 的 setColumnIndex 才能改选中项） */
      openLostReasonPicker(){
        this.oppLostReasonShow=true;
        this.$nextTick(()=>{
          const p=this.$refs.oppLostPicker;
          if(p && typeof p.setColumnIndex==='function'){ p.setColumnIndex(0, this.oppLostReasonIndex); }
        });
      },

      onOppLostReasonConfirm(value){
        /* 【P440】只写新口径 lost_reason_type2；老 lost_reason_type 由后端原值保留、前端不对用户暴露 */
        if(value && value.value!==undefined){ this.opportunityForm.lost_reason_type2=value.value; }
        this.oppLostReasonShow=false;
      },

      onFollowCreated(editor){ this.editorFollow=Object.seal(editor); },
      onNextCreated(editor){ this.editorNext=Object.seal(editor); },

      openOppStorePick(){
        this.oppStorePickShow=true;
        this.oppStorePickLoading=true;
        let data={ searchText:'', page:1, pageSize:200 };
        getStores(data).then(response => {
            this.oppStorePickLoading=false;
            if(response && response.code==200){
              let list=(response.data&&response.data.data)?response.data.data:(Array.isArray(response.data)?response.data:[]);
              this.oppStorePickColumns=list.map(row=>{ return { text:row.title||row.name||row.sn, value:row.sn, raw:row }; });
            } else {
              this.oppStorePickColumns=[];
            }
          })
          .catch(error => {
            this.oppStorePickLoading=false;
            this.oppStorePickColumns=[];
            console.log(error);
          });
      },
      onOppStorePickConfirm(value){
        if(value && value.text){ this.opportunityForm.store=value.text; }
        this.oppStorePickShow=false;
      },

      submitOpportunity(){
        if(!this.opportunityForm.customer_sn){
          this.$toast('请选择所属客户');
          return;
        }
        /* 【P440b】阶段=失单必须填失单原因（新口径 type2 优先；历史商机老 type 有值也算已填，
           避免 5000+ 条存量失单在编辑时被无谓拦下）。 */
        if(Number(this.opportunityForm.stage)===5){
          const t2=Number(this.opportunityForm.lost_reason_type2)||0;
          const t1=Number(this.opportunityForm.lost_reason_type)||0;
          if(t2<=0 && t1<=0){
            this.$toast('阶段为「失单」时必须选择失单原因');
            return;
          }
        }
        this.opportunitySaving=true;
        saveOpportunitiesData(this.opportunityForm).then(response => {
            this.opportunitySaving=false;
            if(response && response.code == 200) {
              this.$toast(response.msg);
              this.dialogOpportunity=false;
              this.onRefresh();
            } else {
              suppressGlobalError();
              this.$toast((response && response.msg) ? response.msg : '保存失败');
            }
          })
          .catch(error => {
            this.opportunitySaving=false;
            console.log(error);
          });
      },

      closeOpportunity(){
        this.dialogOpportunity=false;
      },

      /* ================= 商机详情 + 阶段时间线 ================= */
      oppStageName(stage){
        const y={1:'待执行',2:'沟通报价',3:'合同预定',4:'签约付款',5:'失单'};
        return y[stage]||'未知';
      },
      oppStageTagClass(stage){
        if(stage==3) return 'tag-allot';
        if(stage==4) return 'tag-receive';
        if(stage==5) return 'tag-danger';
        return 'tag-wait';
      },
      formatMoney(v){
        let n=Number(v||0);
        if(isNaN(n)){ n=0; }
        return n.toLocaleString('en-US');
      },
      openOpportunityDetail(idx){
        let row=this.opportunitiesList[idx];
        if(!row){ return; }
        this.opportunityDetailIdx=idx;
        this.dialogOpportunityDetail=true;
        this.opportunityDetail={};
        this.opportunityStageList=[];
        let sn=row.sn;
        getOpportunitiesDetailData({sn:sn}).then(response=>{
          if(response && response.code==200){ this.opportunityDetail=response.data||{}; }
        }).catch(error=>{ console.log(error); });
        getOpportunitiesStageListData({sn:sn}).then(response=>{
          if(response && response.code==200){ this.opportunityStageList=response.data||[]; }
        }).catch(error=>{ console.log(error); });
      },
      closeOpportunityDetail(){
        this.dialogOpportunityDetail=false;
      },
      editFromDetail(){
        this.dialogOpportunityDetail=false;
        if(this.opportunityDetailIdx>=0){ this.openOpportunityEdit(this.opportunityDetailIdx); }
      },
      askDeleteOpportunity(){
        /* 【P108f】删除仅管理人员（与后端同口径；按钮已按 canManageDelete 隐藏，此处为防御） */
        if(!this.canManageDelete){ this.$toast('只有管理人员可以删除商机'); return; }
        this.oppDelShow=true;
      },
      confirmDeleteOpportunity(){
        if(!this.opportunityDetail.sn){ return; }
        this.opportunityDeleting=true;
        deleteOpportunitiesData({sn:this.opportunityDetail.sn}).then(response=>{
          this.opportunityDeleting=false;
          if(response && response.code==200){
            this.$toast(response.msg||'删除成功');
            this.oppDelShow=false;
            this.dialogOpportunityDetail=false;
            this.onRefresh();
          }else{
            suppressGlobalError();
            this.$toast((response&&response.msg)||'删除失败');
          }
        }).catch(error=>{
          this.opportunityDeleting=false;
          console.log(error);
        });
      },

      /* ================= 合同：新增 / 编辑 ================= */

      openOrderAdd(){
        this.orderForm={
          sn:'',
          name:'',
          serial_number:'',
          customer_sn:'',
          customer_name:'',
          opportunitie_sn:'',
          opportunitie_name:'',
          signing_date:'',
          start_date:'',
          end_date:'',
          contacts:'',
          phone:'',
          weixin:'',
          remark:''
        };
        this.dialogOrder=true;
      },

      openOrderEdit(idx){
        let row=this.orderList[idx];
        if(!row){ return; }
        let item=row.item?row.item:{};
        this.orderForm={
          sn:row.sn,
          name:row.name?row.name:'',
          serial_number:row.serial_number?row.serial_number:'',
          customer_sn:row.customer_sn?row.customer_sn:'',
          customer_name:item.customer_name?item.customer_name:'',
          opportunitie_sn:row.opportunitie_sn?row.opportunitie_sn:'',
          opportunitie_name:row.opportunitie_text?row.opportunitie_text:'',
          signing_date:row.signing_date?row.signing_date:'',
          start_date:row.start_date?row.start_date:'',
          end_date:row.end_date?row.end_date:'',
          contacts:row.contacts?row.contacts:'',
          phone:row.phone?row.phone:'',
          weixin:row.weixin?row.weixin:'',
          remark:row.remark?row.remark:''
        };
        this.dialogOrder=true;
        let data={ "sn":row.sn };
        getOrdersDetailData(data).then(response => {
            if(response && response.code == 200) {
              this.orderForm=Object.assign({},this.orderForm,response.data);
            }
          })
          .catch(error => {
            console.log(error);
          });
      },

      submitOrder(){
        if(!this.orderForm.name){
          if(this.orderForm.customer_name){
            this.orderForm.name=this.orderForm.customer_name+'_销售合同_'+this.genContractNum();
          } else {
            this.$toast('请先选择所属客户');
            return;
          }
        }
        if(!this.orderForm.customer_sn){
          this.$toast('请选择所属客户');
          return;
        }
        /* 【P348】关联商机改为必选（用户 10-14 需求）：销售合同是商机与下游单据的源头，
           商机缺失会让会议室订单/支付单无从继承，故此处强校验。 */
        if(!this.orderForm.opportunitie_sn){
          this.$toast('请选择关联商机');
          return;
        }
        this.orderSaving=true;
        saveOrdersData(this.orderForm).then(response => {
            this.orderSaving=false;
            if(response && response.code == 200) {
              this.$toast(response.msg);
              this.dialogOrder=false;
              this.onRefresh();
            } else {
              suppressGlobalError();
              this.$toast((response && response.msg) ? response.msg : '保存失败');
            }
          })
          .catch(error => {
            this.orderSaving=false;
            console.log(error);
          });
      },

      closeOrder(){
        this.dialogOrder=false;
      },

      /* ================= 会议室订单 ================= */

      /* ==================== 【P32-#2/#4】会议室订单 tab + 筛选 ==================== */
      /* 【P32-#1】销售合同审核状态标签配色：0=审核中(橙) 1=审核通过(绿) 2=审核驳回(红) */
      contractStatusClass(st){
        if(st==0) return 'tag-wait';
        if(st==2) return 'tag-danger';
        if(st==1) return 'tag-receive';
        return 'tag-allot';
      },
      /* 审核状态标签配色：2=审核中(橙) 3=通过(绿) 5/6=驳回(红) */
      roomOrderApprovalClass(st){
        if(st==2) return 'tag-wait';
        if(st==5 || st==6) return 'tag-danger';
        return 'tag-receive';
      },
      onRoomOrderTabClick(tab){
        if(this.roomOrderTab === tab.value) return;
        this.roomOrderTab = tab.value;
        this.reloadRoomOrderList();
      },
      /* 重载会议室订单列表（重置分页后拉第一页） */
      reloadRoomOrderList(){
        this.page = 0;
        this.roomOrderList = [];
        this.finished = false;
        this.getRoomOrderList();
      },
      openRoomOrderFilter(){ this.roomOrderFilterShow = true; },
      /* ============================================================
       * 【P419】RoomFilter 确定：组件键名 → 本页 roomOrderFilterForm 键名
       * ------------------------------------------------------------
       * 为什么需要映射：RoomFilter 的 payload 对齐 BillList 引擎口径
       *   （room_sn / on_site_time_begin|_end），而本页列表走的仍是
       *   client/roomOrder/getListData（meeting_room_sn / start_date|end_date）。
       * 集中在此转换一次，getRoomOrderList 一行都不用改，后端也不动。
       * ============================================================ */
      onRoomFilterApply(payload, labels, meta){
        const p = payload || {};
        const m = meta || {};
        const f = this.roomOrderFilterForm;
        this.roomOrderFilterLabels = labels || [];
        this.roomOrderFilterMeta = m;
        f.start_date      = p.on_site_time_begin || '';
        f.end_date        = p.on_site_time_end || '';
        f.time_type       = (p.time_type === undefined || p.time_type === null) ? '' : p.time_type;
        f.is_free         = (p.is_free === undefined || p.is_free === null) ? '' : p.is_free;
        f.meeting_room_sn = p.room_sn || '';
        f.room_name       = m.room_sn || '';
        f.stores_sn       = p.stores_sn || '';
        f.store_name      = m.stores_sn || '';
        f.customer_sn     = p.customer_sn || '';
        f.customer_name   = m.customer_sn || '';
        f.opportunitie_sn = p.opportunitie_sn || '';
        f.opportunitie_name = m.opportunitie_sn || '';
        f.parent_sn       = p.parent_sn || '';
        f.order_name      = m.parent_sn || '';
        f.contracts_sn    = p.contracts_sn || '';
        f.fc_name         = m.contracts_sn || '';
        f.approval_tab    = (p.approval_tab === undefined || p.approval_tab === null) ? '' : p.approval_tab;
        /* 顶部还有一排审核状态 Tab，与筛选面板同维度 ⇒ 以面板为准同步，避免两处矛盾 */
        this.roomOrderTab = f.approval_tab === '' ? '' : String(f.approval_tab);
        this.reloadRoomOrderList();
      },
      onRoomOrderFilterReset(){
        this.roomOrderFilterForm = { start_date:'', end_date:'', time_type:'', is_free:'', meeting_room_sn:'', room_name:'',
          stores_sn:'', store_name:'', customer_sn:'', customer_name:'',
          opportunitie_sn:'', opportunitie_name:'', parent_sn:'', order_name:'',
          contracts_sn:'', fc_name:'', approval_tab:'' };
      },
      clearRoomOrderFilter(){
        this.onRoomOrderFilterReset();
        /* 【P419】RoomFilter 的展示态一起清，否则状态条与面板回显会残留 */
        this.roomOrderFilterMeta = {};
        this.roomOrderFilterLabels = [];
        this.roomOrderTab = '';
        this.onRoomOrderFilterConfirm();
      },
      /* 【P205 1.1.02.002】chips 面板逐字段「清除」：只清指定字段（可一次传多个）。
         注意：单选类字段同时要清掉「值 + 展示名」两个 key（如 stores_sn / store_name），
         否则 UI 上会残留旧的名称文本。 */
      clearRoomOrderFilterField(){
        var fields = Array.prototype.slice.call(arguments);
        var pairs = {
          room_name:['meeting_room_sn','room_name'],
          store_name:['stores_sn','store_name'],
          customer_name:['customer_sn','customer_name'],
          opportunitie_name:['opportunitie_sn','opportunitie_name'],
          order_name:['parent_sn','order_name'],
          fc_name:['contracts_sn','fc_name']
        };
        fields.forEach(function(f){
          if(!f){ return; }
          var keys = pairs[f] || [f];
          var self = this;
          keys.forEach(function(k){
            if(self.roomOrderFilterForm.hasOwnProperty(k)){ self.roomOrderFilterForm[k] = ''; }
          });
        }, this);
      },
      onRoomOrderFilterConfirm(){
        this.roomOrderFilterShow = false;
        this.reloadRoomOrderList();
      },
      /* 通用单选：打开选择器 */
      openRoomOrderSelect(field, title, options){
        this.roomOrderPickerField = field;
        this.roomOrderPickerTitle = title;
        this.roomOrderPickerColumns = options.map(o => ({ text:o.text, value:o.value }));
        this.roomOrderPickerShow = true;
      },
      /* 【P95】三.3.02 修复：vant 2.13 单列 picker 的 @confirm 只回调一个参数（{text,value}），
         原来写成 (picker,value) 再取 value.value → 恒为 undefined，导致「时段/是否收费」筛选点了没反应。 */
      onRoomOrderPickerConfirm(value){
        if (value && value.value !== undefined) {
          this.roomOrderFilterForm[this.roomOrderPickerField] = value.value;
        }
        this.roomOrderPickerShow = false;
      },
      /* 使用时间：日期选择 */
      //【P33】使用时间：打开滑动选择器（开始默认 08:30 / 结束默认 20:30）
      openRoomOrderTimePick(which){
        this.roomOrderTimeWhich = which==='end' ? 'end' : 'begin';
        const cur = this.roomOrderTimeWhich==='end'
          ? this.roomOrderForm.start_time_end : this.roomOrderForm.start_time_begin;
        this.roomOrderTimeValue = cur || (this.roomOrderTimeWhich==='end' ? '20:30' : '08:30');
        this.roomOrderTimeShow = true;
      },
      //【P33】使用时间：确认写入（兼容 Vant 回传 Date 或 'HH:mm' 字符串）
      onRoomOrderTimeConfirm(value){
        let t = value;
        if(t instanceof Date){
          t = ('0'+t.getHours()).slice(-2)+':'+('0'+t.getMinutes()).slice(-2);
        }
        t = String(t==null?'':t).trim().replace(/：/g, ':');
        if(!t){ this.roomOrderTimeShow=false; return; }
        if(this.roomOrderTimeWhich==='end'){ this.roomOrderForm.start_time_end = t; }
        else { this.roomOrderForm.start_time_begin = t; }
        // 同步 start_time 数组，保证提交值与选择器一致
        this.roomOrderForm.start_time = [this.roomOrderForm.start_time_begin, this.roomOrderForm.start_time_end];
        this.roomOrderTimeShow = false;
      },

      openRoomOrderDate(field, title){
        this.roomOrderDateField = field;
        this.roomOrderDateTitle = title;
        this.roomOrderDateShow = true;
      },
      onRoomOrderDateConfirm(value){
        const d = value instanceof Date ? value : new Date(value);
        const s = d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0');
        this.roomOrderFilterForm[this.roomOrderDateField] = s;
        this.roomOrderDateShow = false;
      },
      /* 会议室选择：复用表单下拉接口的会议室数据（懒加载一次） */
      openRoomOrderRoomSelect(){
        if(this.roomOrderRoomList.length === 0){
          getRoomOrderFormData({}).then(response => {
            if(response && response.code == 200 && response.data){
              let d = response.data;
              this.roomOrderRoomList = (d.meeting_room || d.rooms || d.meeting_room_list || []) || [];
            }
            this.buildRoomOrderRoomColumns();
            this.roomOrderRoomSheetShow = true;
          }).catch(() => {
            this.buildRoomOrderRoomColumns();
            this.roomOrderRoomSheetShow = true;
          });
          return;
        }
        this.buildRoomOrderRoomColumns();
        this.roomOrderRoomSheetShow = true;
      },
      buildRoomOrderRoomColumns(){
        const cols = [{ text:'全部会议室', value:'' }];
        (this.roomOrderRoomList || []).forEach(r => {
          cols.push({
            text: (r.name || '') + (r.room_number || ''),
            value: r.sn || r.value || ''
          });
        });
        this.roomOrderRoomColumns = cols;
      },
      /* 【P95】三.3.02 修复：同上，单列 picker 只回调一个参数；原来取 value.value 恒 undefined →
         会议室筛选点了没反应。 */
      onRoomOrderRoomConfirm(value){
        if (!value) { this.roomOrderRoomSheetShow = false; return; }
        const v = (value.value === undefined || value.value === null) ? '' : value.value;
        this.roomOrderFilterForm.meeting_room_sn = v;
        this.roomOrderFilterForm.room_name = (v === '') ? '' : (value.text || '');
        this.roomOrderRoomSheetShow = false;
      },

      getRoomOrderList(){
        // searchText 可能为 null（tab 切换时置空），转成空串避免后端收到 null 触发异常
        let data={ searchText:this.searchText||'', page:this.page, pageSize:this.pageSize };
        // 【P32-#2】审核状态 tab
        if(this.roomOrderTab !== '' && this.roomOrderTab !== undefined){ data.approval_tab = this.roomOrderTab; }
        // 【P32-#4】筛选条件（使用时间/时段/是否收费/会议室）
        let f = this.roomOrderFilterForm || {};
        if(f.start_date) data.start_date = f.start_date;
        if(f.end_date) data.end_date = f.end_date;
        if(f.time_type !== '' && f.time_type !== undefined) data.time_type = f.time_type;
        if(f.is_free !== '' && f.is_free !== undefined) data.is_free = f.is_free;
        if(f.meeting_room_sn) data.meeting_room_sn = f.meeting_room_sn;
        /* 【P95】三.3.02 新增筛选条件下发 */
        if(f.stores_sn) data.stores_sn = f.stores_sn;
        if(f.customer_sn) data.customer_sn = f.customer_sn;
        if(f.opportunitie_sn) data.opportunitie_sn = f.opportunitie_sn;
        if(f.parent_sn) data.parent_sn = f.parent_sn;
        if(f.contracts_sn) data.contracts_sn = f.contracts_sn;
        if(f.approval_tab !== '' && f.approval_tab !== undefined && f.approval_tab !== null) data.approval_tab = f.approval_tab;
        // 置 loading=true，阻止 van-list 在首次挂载/刷新时与本次请求并发触发（避免 page 竞态）
        this.loading=true;
        getRoomOrderListData(data).then(response => {
            if(response && response.code == 200){
              // 兼容两种返回结构：data 直接是数组，或 data.data 才是数组
              let arr = Array.isArray(response.data) ? response.data
                        : (response.data && response.data.data ? response.data.data : []);
              arr=arr.map(r=>Object.assign({}, r, {is_show:0}));
              this.roomOrderList=this.roomOrderList.concat(arr);
              // 当本页返回条数少于分页大小，说明已无更多数据
              if(arr.length < this.pageSize){ this.finished=true; }
              else { this.finished=false; }
            } else {
              suppressGlobalError();
              this.$toast(response && response.msg ? response.msg : '会议室订单加载失败');
            }
          })
          .catch(error => {
            console.log(error);
            this.$toast('会议室订单接口异常');
          })
          .finally(() => {
            // 无论成功/失败/异常都释放加载态，避免 van-pull-refresh/van-list 卡在转圈
            this.refreshing=false;
            this.loading=false;
          });
      },

      openRoomOrderAdd(){
        this.roomOrderForm={
          sn:'', parent_sn:'', order_name:'', customer_sn:'', customer_name:'',
          opportunitie_sn:'', opportunitie_name:'', stores_sn:'', store_name:'',
          meeting_room_sn:'', room_name:'', on_site_time:'', time_type:'', price:'', amount:'',
          // 【P24-8】使用时间默认 08:30 ~ 20:30（创建时预填，可改）
          discount:'', start_time:['08:30','20:30'], start_time_begin:'08:30', start_time_end:'20:30', number_people:'',
          table_types:[], option_service:[], is_free:1, remark:'', payment:[]
        };
        // 【P38】新增场景无关联合同，重置入口权限
        this.roomOrderCanViewContract = 0;
        this.loadRoomOrderFormData();
        this.dialogRoomOrder=true;
      },

      /* 【P133-01】列表卡片「编辑」统一入口（收 idx）：
           · status===0（审核中）→ 仅提示，不打开表单（按钮同时置灰 is-disabled，视觉与行为一致）
           · 其余 → 走 openRoomOrderEdit(idx) 正常打开
         置灰用 :class 而非 pointer-events:none，是为了让点击仍能给出「为什么点不动」的反馈。 */
      onRoomOrderEdit(idx){
        const row=this.roomOrderList[idx];
        if(!row){ return; }
        if(this.roomOrderLocked(row)){ this.$toast('审核中不能修改会议室订单内容'); return; }
        this.openRoomOrderEdit(idx);
      },
      openRoomOrderEdit(idx){
        let row=this.roomOrderList[idx];
        if(!row){ return; }
        // 【P37】防御性二次校验：按钮已按 can_edit 隐藏，此处再拦一次
        if(Number(row.can_edit)!==1){ this.$toast('无权编辑他人的会议室订单'); return; }
        /* 【P133-01】审核中禁止修改（对齐 PC 端）：
             t_pro_orders_meeting_room.status —— 0=审核中 / 1=审核通过 / 2=审批驳回。
             审核中说明该单正卡在负责人审批流里，改了内容会让审批人看到的事由与单据不符，
             故与 PC 端一致硬拦截。按钮已置灰，此处是入口二次防护（房态详情走 openEditRoom）。 */
        if(this.roomOrderLocked(row)){ this.$toast('审核中不能修改会议室订单内容'); return; }
        this.fillRoomOrderForm(row);
      },
      /* 【P133-01】审核中判定：status===0 即锁。统一收口，列表/详情/表单多入口共用。 */
      roomOrderLocked(row){
        if(!row){ return false; }
        const st=(row.status!==undefined && row.status!==null && row.status!=='') ? Number(row.status) : null;
        return st===0;
      },

      /* 用订单数据填充会议室订单编辑表单并打开 dialogRoomOrder（列表编辑 / 房态详情「编辑」共用） */
      fillRoomOrderForm(row, paymentData){
        if(!row){ return; }
        // 安全解析：后端个别订单的 start_time/table_types/option_service 可能是 "19-21" 这类非 JSON 字符串，
        // 直接 JSON.parse 会抛异常导致整个编辑表单渲染失败（被 .catch 吞掉、表单打不开）——这里兜底成空值
        const safeParse=(v, fb)=>{
          if(v===undefined || v===null || v==='') return fb;
          if(typeof v!=='string') return v;
          try { return JSON.parse(v); } catch(e){ return fb; }
        };
        // 使用时间起止：优先 start_time_text（旧数据格式如 "9-21"），缺失时回退到 start_time JSON 数组。
        // ⚠️ 新数据只写 start_time（如 ["08:30","19:00"]），start_time_text 为 NULL —— 若不回退，
        //    编辑时「使用时间」两个输入框会是空白，且 submitRoomOrder 会用空白反推出 start_time=[]，
        //    保存后原有的使用时间被清空（房态/详情里显示为「无」）。
        const deriveRoomTime=(r)=>{
          if(!r){ return { begin:'', end:'' }; }
          if(r.start_time_text && String(r.start_time_text).trim()){
            const p=String(r.start_time_text).trim().split('-');
            return { begin:(p[0]||'').trim(), end:(p[1]||'').trim() };
          }
          const arr=safeParse(r.start_time, []);
          if(Array.isArray(arr) && arr.length){
            return { begin:String(arr[0]||'').trim(), end:String(arr[1]||arr[0]||'').trim() };
          }
          return { begin:'', end:'' };
        };
        const _st=deriveRoomTime(row);
        this.roomOrderForm={
          sn:row.sn,
          parent_sn:row.parent_sn||'',
          order_name:row.order_name||'',
          customer_sn:row.customer_sn||'',
          customer_name:row.customer_name||'',
          opportunitie_sn:row.opportunitie_sn||'',
          opportunitie_name:row.opportunitie_name||'',
          stores_sn:row.stores_sn||'',
          store_name:row.store_name||'',
          meeting_room_sn:row.meeting_room_sn||'',
          room_name:row.room_name||'',
          on_site_time:row.on_site_time||'',
          time_type:row.time_type||'',
          price:row.price||'',
          amount:row.amount||'',
          discount:row.discount||'',
          start_time: safeParse(row.start_time, []),
          start_time_begin: _st.begin,
          start_time_end: _st.end,
          number_people:row.number_people||'',
          table_types: this.normChipIds(row.table_types, this.roomOrderFormData.table_types),
          option_service: this.normChipIds(row.option_service, this.roomOrderFormData.option_service),
          is_free: (row.is_free!==undefined && row.is_free!==null)? row.is_free : 1,
          remark:row.remark||'',
          payment:[]
        };
        // 【P38】回填「查看销售合同」入口权限：列表行与详情 main 均带 can_view_contract，
        //   0/缺省 → 不渲染入口（不会出现点得进去却看不到的错觉）
        this.roomOrderCanViewContract = Number(row.can_view_contract||0);
        this.loadRoomOrderFormData();
        this.dialogRoomOrder=true;
        const applyPayment = (pay)=>{
          if(pay && Array.isArray(pay)){
            this.roomOrderForm.payment=pay.map(p=>({
              payment_date:p.payment_date||'',
              amount:p.amount!==undefined?p.amount:'',
              customer_sn:p.customer_sn||'',
              stores_sn:p.stores_sn||'',
              meeting_room_sn:p.meeting_room_sn||'',
              order_sn:p.order_sn||'',
              opportunitie_sn:p.opportunitie_sn||''
            }));
          }
        };
        // paymentData 已提供（来自详情接口）则直接用，避免重复请求；否则按 sn 拉取详情补全
        if(paymentData && Array.isArray(paymentData)){
          applyPayment(paymentData);
        } else {
          getRoomOrderDetailData({sn:row.sn}).then(response=>{
              if(response && response.code==200 && response.data && response.data.main){
                let m=response.data.main;
                this.roomOrderForm.customer_sn=m.customer_sn||this.roomOrderForm.customer_sn;
                this.roomOrderForm.customer_name=m.customer_name||this.roomOrderForm.customer_name;
                this.roomOrderForm.stores_sn=m.stores_sn||this.roomOrderForm.stores_sn;
                this.roomOrderForm.store_name=m.store_name||this.roomOrderForm.store_name;
                this.roomOrderForm.meeting_room_sn=m.meeting_room_sn||this.roomOrderForm.meeting_room_sn;
                this.roomOrderForm.room_name=m.room_name||this.roomOrderForm.room_name;
                this.roomOrderForm.parent_sn=m.parent_sn||this.roomOrderForm.parent_sn;
                this.roomOrderForm.order_name=m.order_name||this.roomOrderForm.order_name;
                this.roomOrderForm.opportunitie_sn=m.opportunitie_sn||this.roomOrderForm.opportunitie_sn;
                this.roomOrderForm.opportunitie_name=(m.opportunitie_name!==undefined)?m.opportunitie_name:this.roomOrderForm.opportunitie_name;
                if(m.table_types){ this.roomOrderForm.table_types=this.normChipIds(m.table_types, this.roomOrderFormData.table_types); }
                if(m.option_service){ this.roomOrderForm.option_service=this.normChipIds(m.option_service, this.roomOrderFormData.option_service); }
                // 列表行通常不带 start_time/start_time_text，详情兜回来后再补一次，避免「使用时间」空白
                const _t=deriveRoomTime(m);
                if(_t.begin || _t.end){ this.roomOrderForm.start_time_begin=_t.begin; this.roomOrderForm.start_time_end=_t.end; }
                applyPayment(response.data.payment);
              }
            })
            .catch(error=>{ console.log(error); });
        }
      },

      loadRoomOrderFormData(){
        getRoomOrderFormData({}).then(response=>{
            if(response && response.code==200 && response.data){
              this.roomOrderFormData=response.data;
              //【P33】选项就绪后把已回填的芯片值再归一一次：
              //  编辑态若先于选项加载完成，历史中文名无法映射成 id，这里补一次映射。
              if(this.roomOrderForm && this.roomOrderForm.sn){
                this.roomOrderForm.table_types = this.normChipIds(
                  this.roomOrderForm.table_types, this.roomOrderFormData.table_types);
                this.roomOrderForm.option_service = this.normChipIds(
                  this.roomOrderForm.option_service, this.roomOrderFormData.option_service);
              }
            }
          })
          .catch(error=>{ console.log(error); });
      },

      closeRoomOrder(){ this.dialogRoomOrder=false; },

      /* 【P214】keepOpen=true（保存并继续）：保存成功后不关弹层，清空表单继续录下一单 */
      submitRoomOrder(keepOpen){
        if(this.roomOrderSaving){ return; }        // 防连点
        let f=this.roomOrderForm;
        let isFree=Number(f.is_free)===2;
        if(!f.customer_sn){ this.$toast('请选择所属客户'); return; }
        /* 【P348】所属商机必填（继承自上级销售合同，用户 10-14 需求）。
           正常路径下 onPickOrder 会自动带入；若为空说明所选合同没有商机，
           直接拦截并提示去改合同，避免订单与合同商机口径不一致。 */
        if(!f.opportunitie_sn){ this.$toast('所选销售合同未关联商机，请先在销售合同中补齐商机'); return; }
        if(!f.stores_sn){ this.$toast('请选择所属门店'); return; }
        if(!f.meeting_room_sn){ this.$toast('请选择会议室'); return; }
        if(!f.on_site_time){ this.$toast('请选择使用日期'); return; }
        if(!f.time_type){ this.$toast('请选择时段'); return; }
        // 【P24-9】免费单不校验销售价格（后端落 0 元），仅收费单必填
        if(!isFree && !f.amount){ this.$toast('请输入销售价格'); return; }
        let begin=(f.start_time_begin||'').trim();
        let end=(f.start_time_end||'').trim();
        if(begin && end){ f.start_time=[begin,end]; }
        else if(begin){ f.start_time=[begin,begin]; }
        else { f.start_time=[]; }
        if(!f.number_people){ this.$toast('请输入人数'); return; }
        if(!f.table_types || f.table_types.length==0){ this.$toast('请选择桌型'); return; }
        if(isFree){ f.amount=0; f.price=0; }        // 【P24-9】免费单金额归零
        if(!f.price){ f.price=f.amount||0; }
        // 【P24-9】回款计划：免费单不校验、不提交（后端免费单分支同样不要求）
        if(isFree){
          f.payment=[];
        } else if(f.payment && f.payment.length){
          f.payment=f.payment.filter(p=>p.payment_date && p.amount!=='').map(p=>{
            return {
              payment_date:p.payment_date,
              amount:parseFloat(p.amount),
              customer_sn:p.customer_sn||f.customer_sn,
              stores_sn:p.stores_sn||f.stores_sn,
              meeting_room_sn:p.meeting_room_sn||f.meeting_room_sn,
              order_sn:p.order_sn||f.parent_sn,
              opportunitie_sn:p.opportunitie_sn||f.opportunitie_sn
            };
          });
        }
        this.roomOrderSaving=true;
        saveRoomOrderData(f).then(response=>{
            this.roomOrderSaving=false;
            if(response && response.code==200){
              this.$toast(response.msg||(keepOpen?'保存成功，可继续添加':'保存成功'));
              this.onRefresh();
              if(keepOpen){
                /* 复用 openRoomOrderAdd()：它已含「重置为空白新增态 + 重拉选项」全套逻辑 */
                this.openRoomOrderAdd();
              } else {
                this.dialogRoomOrder=false;
              }
            } else {
              suppressGlobalError();
              this.$toast((response&&response.msg)||'保存失败');
            }
          })
          .catch(error=>{ this.roomOrderSaving=false; console.log(error); });
      },

      onRoomOrderDelete(idx){
        let row=this.roomOrderList[idx];
        if(!row){ return; }
        // 【P37】防御性二次校验：非本人订单不开放删除
        if(Number(row.can_edit)!==1){ this.$toast('无权删除他人的会议室订单'); return; }
        this.roomOrderDeleteSn=row.sn;
        this.dialogRoomOrderDelete=true;
      },

      confirmRoomOrderDelete(){
        if(!this.roomOrderDeleteSn){ return; }
        deleteRoomOrderData({sn:this.roomOrderDeleteSn}).then(response=>{
            if(response && response.code==200){
              this.$toast(response.msg||'删除成功');
              this.dialogRoomOrderDelete=false;
              this.roomOrderDeleteSn='';
              this.onRefresh();
            } else {
              suppressGlobalError();
              this.$toast((response&&response.msg)||'删除失败');
            }
          })
          .catch(error=>{ console.log(error); });
      },

      /* 门店选择器 */
      openStorePick(target){
        /* 【P95】三.3.02 支持 roomfilter 目标（会议室筛选用） */
        this.storePickTarget=target||'';
        this.storePickKeyword='';
        this.storePickList=[];
        this.dialogStorePick=true;
        this.loadStorePick();
      },
      loadStorePick(){
        let data={ searchText:this.storePickKeyword||'', page:1, pageSize:50 };
        getStores(data).then(response=>{
            if(response && response.code==200){
              this.storePickList=(response.data&&response.data.data)?response.data.data:(Array.isArray(response.data)?response.data:[]);
            }
          })
          .catch(error=>{ console.log(error); });
      },
      onStorePickSelect(row){
        /* 【P95】三.3.02 会议室筛选：选门店写进 roomOrderFilterForm */
        if(this.storePickTarget=='roomfilter'){
          this.roomOrderFilterForm.stores_sn=row.sn;
          this.roomOrderFilterForm.store_name=row.title||row.name||'';
          this.dialogStorePick=false;
          return;
        }
        this.roomOrderForm.stores_sn=row.sn;
        this.roomOrderForm.store_name=row.title||row.name;
        this.roomOrderForm.meeting_room_sn='';
        this.roomOrderForm.room_name='';
        this.roomPickList=[];
        this.dialogStorePick=false;
      },

      /* 会议室选择器（依赖门店 + 日期） */
      openRoomPick(){
        if(!this.roomOrderForm.stores_sn){ this.$toast('请先选择门店'); return; }
        this.roomPickList=[];
        this.dialogRoomPick=true;
        this.loadRoomPick();
      },
      loadRoomPick(){
        let date=this.roomOrderForm.on_site_time || this.todayStr();
        let data={ storeSN:this.roomOrderForm.stores_sn, roomDateRangeValue:[date,date] };
        getRooms(data).then(response=>{
            if(response && response.code==200 && response.data){
              this.roomPickList=response.data.rooms||[];
            }
          })
          .catch(error=>{ console.log(error); });
      },
      onRoomPickSelect(row){
        this.roomOrderForm.meeting_room_sn=row.sn;
        this.roomOrderForm.room_name=row.room_number||row.name;
        this.dialogRoomPick=false;
      },
      todayStr(){
        let d=new Date();
        return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');
      },

      /* 内嵌合同详情：直接在当前页弹层展示，返回只关闭遮罩不跳路由 */
      goContractDetail(idx){
        let row=this.orderList[idx];
        if(!row){ return; }
        let sn=row.sn;
        if(!sn){ this.$toast('缺少合同编号，无法查看详情'); return; }
        this.pendingEditSn='';
        this.contractDetailIdx=idx;
        this.contractDetailSn=sn;
        this.contractDetailVisible=true;
      },

      /* 【P105 修正】审核操作的位置：**不在合同列表**，而在「合同详情页 → 审核 → 列表」内，
         故此处不再提供列表级入口（原 goContractApproval / fetchApprovalBadge 已移除）。 */

      /* 【P38】房态会议室订单 → 直达其关联销售合同（t_pro_orders）的详情页
         source='detail' 时用详情弹窗的上下文；缺省用编辑表单的上下文。
         权限口径与销售合同列表完全一致（部门级 / 本人）：入口已按 can_view_contract 隐藏，
         这里再拦一次，避免任何代码路径绕过。 */
      openContractFromRoomOrder(source){
        const fromDetail = (source==='detail');
        const sn = fromDetail
          ? this.detailContractSn
          : (this.roomOrderForm && this.roomOrderForm.parent_sn);
        const allow = fromDetail
          ? Number(this.detailCanViewContract)===1
          : Number(this.roomOrderCanViewContract)===1;
        if(!sn){ this.$toast('该会议室订单未关联销售合同'); return; }
        if(!allow){ this.$toast('无权查看该销售合同'); return; }
        this.pendingEditSn = '';
        this.contractDetailIdx = -1;
        this.contractDetailSn = sn;
        this.contractDetailVisible = true;
      },

      /* 【P154】合同详情内部发生了会改变列表口径的变更（审批通过/驳回等）：
         先打脏标记，返回时统一重拉列表 + 角标。 */
      onContractChanged(){
        this._contractDirty = true;
      },
      /* 【P154】返回时必须按需刷新：审批结果会改变列表卡片状态与红色气泡，
         原实现只关遮罩不刷新 ⇒ 用户看到「审批完了返回，状态和红色气泡还在」。 */
      closeContractDetail(){
        this.contractDetailVisible=false;
        this.pendingBillKey='';
        this.pendingEditSn='';
        if(this._contractDirty){
          this._contractDirty = false;
          this.reloadAfterContractChange();
        }
      },
      /* 【P154】合同变更后的定向刷新（复用共享 page/listGen，与 onContractDeleted 同口径） */
      reloadAfterContractChange(){
        try {
          if(this.active==3){
            this.page=1; this.orderList=[]; this.finished=false; this.loading=false;
            this.getOrderList();
          }
          if(this.active==4 && this.quickSub==='message'){
            this.messageList=[]; this.page=1; this.finished=false; this.loading=true;
            this.getMessageList();
          }
          /* 角标（未读消息数）由 WebSocket 推送 → 重连一次以拉齐最新值 */
          try { crmWs.refresh(); } catch(e) {}
        } catch(e) {}
      },
      onContractEdit(){
        // 详情页「编辑合同」统一复用列表编辑弹层（openOrderEdit）
        this.contractDetailVisible=false;
        this.pendingBillKey='';
        this.pendingEditSn='';
        if(this.contractDetailIdx!=='' && this.contractDetailIdx!=null){
          this.openOrderEdit(this.contractDetailIdx);
        }
      },
      /* 【P95】三.1.01 详情页删除合同后：关闭详情并刷新合同列表（列表用共享 page/listGen） */
      onContractDeleted(){
        this.contractDetailVisible=false;
        this.pendingBillKey='';
        this.pendingEditSn='';
        this.$toast('合同已删除');
        try {
          this.page = 1;
          this.orderList = [];
          this.finished = false;
          this.loading = false;
          this.getOrderList();
        } catch(e) {}
      },

      /* 快捷入口：点 tile 分流 */
      /* 退出登录（P46）：快捷入口 → 账号 → 退出登录
         二次确认走全站统一的 ConfirmDialog；
         执行时先关掉 WS、清本地鉴权、再回登录页（与 market 端 logout() 同一实现）。 */
      askLogout(){
        this.logoutShow = true;
      },

      doLogout(){
        this.logoutShow = false;
        try { crmWs.close(); } catch(e) {}
        logout();
      },

      quickGo(q){
        if(q.type==='sub'){
          if(q.key==='stat'){ this.quickSub='stat'; this.loadStatistics(); }
          /* 【P439】回收站：仅销售总经理 / 销售部负责人可进；进页先清空并复位分页 */
          else if(q.key==='recycle'){
            if(!this.canCustomerDelete){ this.$toast('无客户回收站权限'); return; }
            this.quickSub='recycle';
            this.recyclePage=1;
            this.recycleFinished=false;
            this.recycleRefreshing=false;
            this.recycleRows=[];
            this.recycleTotal=0;
            this.recycleSearch='';
            this.getRecycleList();
          }
          else if(q.key==='message'){
            this.quickSub='message';
            this.messageList=[]; this.page=1; this.finished=false;
            /* 【P132-fix】此处**必须同步占住 loading=true**（旧代码写 false，是首屏空白的根因）：
               P130 把首发请求放进了 markAllMsgRead 的异步回调，窗口期内 loading=false
               ⇒ van-list 立刻 emit('load') ⇒ onLoad 执行 `this.page=this.page+1` 把 page 从 1 改成 2
               ⇒ 回调里的 getMessageList() 实际请求 page=2（total=1）⇒ 列表空白且立即 finished("没有更多了")。
               置 true 后 van-list 的 check() 判定 innerLoading 为真，不再 emit load；
               请求由 getMessageList() 接续，其 .finally() 全路径复位 loading=false（含失败收口）。 */
            this.loading=true;
            this.markAllMsgRead(() => { this.getMessageList(); });
          }
        } else {
          /* 账单类：打开独立列表，按当前登录人 create_user 过滤（后端 global=1），不跳转合同 */
          this.openQuickBill(q.billKey);
        }
      },

      /* 打开单据类独立列表
         【P92】改为交给统一组件 BillList：后端走 client/billList（scope=self，等价原 global=1），
         与合同详情内 8 类列表共用同一套骨架/搜索/筛选/合计/卡片/详情/分页 */
      openQuickBill(billKey){
        const cfg = billConfigs.find(c => c.key === billKey);
        if(!cfg){ return; }
        this.quickBillType = QUICK_BILL_TYPE[billKey] || billKey;
        this.quickBillConfig = cfg;
        this.quickBillKey = billKey;
        this.pendingEditSn = '';
        this.quickSub = 'billlist';
      },
      /* 【P95-B4 四.1.005】快捷入口：编辑单据
         单据都挂在销售合同下（编辑需要合同上下文：关联会议室订单/增值订单/财务合同选项都按合同收敛），
         故「编辑」跳进该单据所属合同的详情页，并由 pendingEditSn 自动拉起编辑表单。
         归属判断已在后端下发 can_edit（本行归我 / 我所辖人员）后才显示按钮。 */
      onQuickBillEdit(item){
        if(!item || !item.sn){ return; }
        const pSn = item.parent_sn || item.order_sn || item.contracts_sn || '';
        if(!pSn){
          this.$toast('该单据未关联销售合同，请在合同详情内编辑');
          return;
        }
        this.pendingBillKey = this.quickBillKey || '';
        this.pendingEditSn = item.sn;
        this.contractDetailIdx = -1;
        this.contractDetailSn = pSn;
        this.contractDetailVisible = true;
      },
      /* 快捷入口：删除单据（沿用各单据配置的 deleteFn，二次确认） */
      onQuickBillDelete(item){
        const cfg = this.quickBillConfig;
        if(!cfg || typeof cfg.deleteFn !== 'function'){ return; }
        this.$dialog.confirm({
          title: '删除确认',
          message: '确定删除该条' + (cfg.title || '单据') + '？删除后不可恢复。'
        }).then(()=>{
          return cfg.deleteFn({ sn: item.sn }).then(res=>{
            if(res && res.code === 200){
              this.$toast('删除成功');
              if(this.$refs.billList){ this.$refs.billList.onRefresh(); }
            } else {
              this.$toast((res && res.msg) || '删除失败');
            }
          });
        }).catch(()=>{});
      },
      rowField(row, f){
        if(!row || f==null) return '—';
        const v = row[f];
        if(v===0 || v==='0') return '0';
        return (v===undefined || v===null || v==='') ? '—' : v;
      },

      /* 统计：前端聚合（合同列表金额 + 单据数量，有界 N+1） */
      loadStatistics(){
        this.statLoading = true;
        this.statNote = '';
        this.loadContractFlow();
        // 构建人员选项：全部 + 我（+ 下属，若为管理者）
        const opts = [{ id:0, name:'全部' }];
        const me = this.currentStaffId;
        const sub = (this.managedStaffList || []).map(s=>({id:s.id, name:s.name}));
        if(sub.length){
          if(me) opts.push({ id:me, name:'我' });
          sub.forEach(s=>opts.push(s));
        } else if(me){
          opts.push({ id:me, name:'我' });
        }
        const seen={}; this.statPersonOpts = opts.filter(o=> seen[o.id] ? false : (seen[o.id]=true));
        /* 【P112】返回 Promise：下拉刷新据此收尾（否则只能轮询 statLoading） */
        return getStatisticsDashboardData({ time_type:this.statTimeType, owner_id:this.statOwnerId }).then(res=>{
          if(res && res.code==200){
            const d = res.data || {};
            this.statData = d;
            this.statNote = '';
            const mc = d.monthComparison||[];
            this.monthMax = mc.reduce((m,x)=>Math.max(m,x.target,x.sales),0);
            this.staffTargetMax = (d.staffTargets||[]).reduce((m,x)=>Math.max(m,x.target),0);
            this.funnelCntMax = (d.funnelCount||[]).reduce((m,x)=>Math.max(m,x.cnt),0);
            this.funnelAmtMax = (d.funnelAmt||[]).reduce((m,x)=>Math.max(m,x.amt_wan),0);
            this.staffOppMax = (d.staffOpps||[]).reduce((m,x)=>Math.max(m,x.opp_cnt),0);
            this.oppDistTotal = (d.oppDist||[]).reduce((s,x)=>s+(x.cnt||0),0);
          } else {
            this.statData = null;
            this.statNote = (res && res.msg) ? res.msg : '统计加载失败';
          }
          this.statLoading = false;
        }).catch(e=>{
          this.statData = null;
          this.statNote = '统计加载失败：'+(e && e.message ? e.message : e);
          this.statLoading = false;
        });
      },
      /* 【P112】快捷入口 · 宫格下拉刷新
         宫格页没有列表数据，页面上唯一会变的是「角标」（未读消息数等），
         而角标由 WebSocket 推送（onUnread）→ 这里触发一次重连+重取即可。
         给 600ms 最短动效时长，否则 loading 一闪而过、用户看不到反馈。 */
      onQuickGridRefresh(){
        try { crmWs.refresh(); } catch(e) {}
        setTimeout(()=>{ this.quickGridRefreshing = false; }, 600);
      },
      /* 【P112】快捷入口 · 统计报表下拉刷新：重拉当前筛选（时间/人员）下的看板 */
      onStatRefresh(){
        this.statRefreshing = true;
        const done = ()=>{ this.statRefreshing = false; };
        let p = null;
        try { p = this.loadStatistics(); } catch(e) { done(); return; }
        if(p && typeof p.then === 'function'){ p.then(done, done); }
        else { setTimeout(done, 800); }
      },
      onStatTime(val){
        if(this.statTimeType !== val){ this.statTimeType = val; this.loadStatistics(); }
      },
      onStatPerson(id){
        if(this.statOwnerId !== id){ this.statOwnerId = id; this.loadStatistics(); }
      },
      onStatPersonPick(val){
        const id = (val && val.value !== undefined) ? val.value : (val && val.id);
        this.statPersonSheetShow = false;
        this.onStatPerson(id);
      },
      loadContractFlow(){
        this.statFlowLoading = true;
        getContractFlowData({ time_type:this.statTimeType, owner_id:this.statOwnerId, page:1, pageSize:10 }).then(res=>{
          if(res && res.code==200){
            const d = res.data || {};
            const list = d.list || { data:[], total:0, current_page:1, last_page:1 };
            this.statFlow = {
              list: list,
              total_amount: Number(d.total_amount)||0,
              total_paid: Number(d.total_paid)||0,
              total_invoice: Number(d.total_invoice)||0,
              total_refund: Number(d.total_refund)||0
            };
            this.statFlowPage = 1;
          } else {
            this.statFlow = { list:{data:[],total:0,current_page:1,last_page:1}, total_amount:0, total_paid:0, total_invoice:0, total_refund:0 };
          }
          this.statFlowLoading = false;
        }).catch(e=>{
          this.statFlow = { list:{data:[],total:0,current_page:1,last_page:1}, total_amount:0, total_paid:0, total_invoice:0, total_refund:0 };
          this.statFlowLoading = false;
        });
      },
      loadContractFlowMore(){
        if(this.statFlowLoading) return;
        const next = this.statFlowPage + 1;
        if(!this.statFlow || !this.statFlow.list || next > (this.statFlow.list.last_page||1)) return;
        this.statFlowLoading = true;
        getContractFlowData({ time_type:this.statTimeType, owner_id:this.statOwnerId, page:next, pageSize:10 }).then(res=>{
          if(res && res.code==200){
            const d = res.data || {};
            const list = d.list || {};
            const merged = (this.statFlow.list.data||[]).concat(list.data||[]);
            this.statFlow = Object.assign({}, this.statFlow, {
              list: { data:merged, total:list.total, current_page:list.current_page, last_page:list.last_page }
            });
            this.statFlowPage = next;
          }
          this.statFlowLoading = false;
        }).catch(()=>{ this.statFlowLoading = false; });
      },
      toggleFlowDetail(sn){
        if(this.flowDetailSn === sn){ this.flowDetailSn = null; }
        else { this.loadContractFlowDetail(sn); }
      },
      loadContractFlowDetail(sn){
        this.flowDetailSn = sn;
        this.flowDetailLoading = true;
        getContractFlowDetailData({ sn:sn, owner_id:this.statOwnerId }).then(res=>{
          if(res && res.code==200 && res.data){
            this.flowDetail = res.data;
          } else {
            this.flowDetail = { allowed:false, payments:[], invoices:[], refunds:[] };
          }
          this.flowDetailLoading = false;
        }).catch(()=>{
          this.flowDetail = { allowed:false, payments:[], invoices:[], refunds:[] };
          this.flowDetailLoading = false;
        });
      },
      statusCls(type, status){
        if(status===1) return 'ok';
        if(status===2) return 'danger';
        return 'warn';
      },
      sumFlow(arr, key){
        if(!Array.isArray(arr)) return 0;
        return arr.reduce((s,x)=>s+(Number(x[key])||0),0);
      },
      fmtNum(n){
        n = Number(n)||0;
        if(n>=100000000) return (n/100000000).toFixed(2)+'亿';
        if(n>=10000) return (n/10000).toFixed(1)+'万';
        return n.toLocaleString('en-US');
      },
      clampPct(v){ return Math.max(0, Math.min(100, Number(v)||0)); },
      barPct(val, max){ return max>0 ? Math.round((Number(val)||0)/max*100) : 0; },
      stackPct(cnt, total){ return total>0 ? Math.round(cnt/total*100) : 0; },
      donutGradient(list){
        const total = (list||[]).reduce((s,x)=>s+(x.cnt||0),0);
        if(total<=0) return '#eef0f3';
        let acc=0; const segs=[];
        (list||[]).forEach((x,i)=>{
          const ang=(x.cnt/total)*360;
          const c=this.lostColors[i%this.lostColors.length];
          segs.push(c+' '+acc.toFixed(2)+'deg '+(acc+ang).toFixed(2)+'deg');
          acc+=ang;
        });
        return 'conic-gradient('+segs.join(',')+')';
      },

      /* ================= 公共：客户选择器 ================= */

      openCustPick(target){
        this.custPickTarget=target;
        this.custPickKeyword='';
        this.custPickList=[];
        this.dialogCustPick=true;
        this.loadCustPick();
      },

      loadCustPick(){
        let data={
          searchText:this.custPickKeyword?this.custPickKeyword:'',
          page:1,
          pageSize:30
        };
        getCustomersListData(data).then(response => {
            if(response && response.code == 200) {
              this.custPickList=(response.data && response.data.data)?response.data.data:[];
            }
          })
          .catch(error => {
            console.log(error);
          });
      },

      onCustPickSelect(row){
        let name=(row.item && row.item.name)?row.item.name:(row.name?row.name:'');
        /* 【P95】三.3.02 会议室筛选：选客户写进 roomOrderFilterForm */
        if(this.custPickTarget=='roomfilter'){
          this.roomOrderFilterForm.customer_sn=row.sn;
          this.roomOrderFilterForm.customer_name=name;
          this.dialogCustPick=false;
          return;
        }
        if(this.custPickTarget=='opportunity'){
          this.opportunityForm.customer_sn=row.sn;
          this.opportunityForm.customer_name=name;
        }else if(this.custPickTarget=='order'){
          this.orderForm.customer_sn=row.sn;
          this.orderForm.customer_name=name;
          // 换客户后原关联商机不再匹配，清空
          this.orderForm.opportunitie_sn='';
          this.orderForm.opportunitie_name='';
          // 新合同：按「客户名_销售合同_yymmddHHmmss」自动生成合同名称
          if(!this.orderForm.sn){
            this.orderForm.name=name+'_销售合同_'+this.genContractNum();
          }
        }else if(this.custPickTarget=='roomorder'){
          this.roomOrderForm.customer_sn=row.sn;
          this.roomOrderForm.customer_name=name;
          // 换客户后原关联商机不再匹配，清空
          this.roomOrderForm.opportunitie_sn='';
          this.roomOrderForm.opportunitie_name='';
        }
        this.dialogCustPick=false;
      },

      // 合同编号后缀：yymmddHHmmss（与后端 parent::getCustomers 自动命名规则一致）
      genContractNum(){
        const d=new Date();
        const p=n=>String(n).padStart(2,'0');
        return ''+(d.getFullYear()%100)+p(d.getMonth()+1)+p(d.getDate())+p(d.getHours())+p(d.getMinutes())+p(d.getSeconds());
      },

      // 合同类型标签（t_pro_orders.type：1=预定合同（普通合同），2=充值合同，0/其他=未定）
      contractTypeLabel(t){
        const n=Number(t);
        if(n===2) return '充值合同';
        if(n===1) return '预定合同（普通合同）';
        return '未定';
      },

      /* ================= 公共：商机选择器 ================= */

      openOppPick(target){
        this.oppPickTarget=target || 'order';
        this.oppPickKeyword='';
        this.oppPickList=[];
        this.dialogOppPick=true;
        this.loadOppPick();
      },

      loadOppPick(){
        let data={
          searchText:this.oppPickKeyword?this.oppPickKeyword:'',
          page:1,
          pageSize:30
        };
        // 二级联动：按当前表单已选客户过滤商机（合同→orderForm；会议室订单→roomOrderForm）
        let cs = (this.oppPickTarget==='roomorder') ? this.roomOrderForm.customer_sn : this.orderForm.customer_sn;
        if(cs){
          data.customer_sn=cs;
        }
        getOpportunitiesListData(data).then(response => {
            if(response && response.code == 200 && response.data && response.data.list){
              this.oppPickList=(response.data.list.data)?response.data.list.data:[];
            }else{
              this.oppPickList=[];
            }
          })
          .catch(error => {
            console.log(error);
          });
      },

      onOppPickSelect(row){
        let name=(row.item && row.item.name)?row.item.name:(row.name?row.name:'');
        /* 【P95】三.3.02 会议室筛选：选商机写进 roomOrderFilterForm */
        if(this.oppPickTarget=='roomfilter'){
          this.roomOrderFilterForm.opportunitie_sn=row.sn;
          this.roomOrderFilterForm.opportunitie_name=name;
          this.dialogOppPick=false;
          return;
        }
        if(this.oppPickTarget=='roomorder'){
          this.roomOrderForm.opportunitie_sn=row.sn;
          this.roomOrderForm.opportunitie_name=name;
          if(!this.roomOrderForm.customer_sn && row.customer_sn){
            this.roomOrderForm.customer_sn=row.customer_sn;
            this.roomOrderForm.customer_name=(row.item && row.item.customer_name)?row.item.customer_name:'';
          }
        }else{
          this.orderForm.opportunitie_sn=row.sn;
          this.orderForm.opportunitie_name=name;
          // 合同未选客户时，顺带把商机的客户带过来
          if(!this.orderForm.customer_sn && row.customer_sn){
            this.orderForm.customer_sn=row.customer_sn;
            this.orderForm.customer_name=(row.item && row.item.customer_name)?row.item.customer_name:'';
          }
        }
        this.dialogOppPick=false;
      },

      /* ================= 公共：合同选择器（会议室订单用） ================= */

      openOrderPick(){
        this.orderPickKeyword='';
        /* 【P95】三.3.02 支持 roomfilter 目标（会议室筛选用） */
        this.orderPickTarget=target||'';
        this.orderPickKeyword='';
        this.orderPickList=[];
        this.dialogOrderPick=true;
        this.loadOrderPick();
      },

      loadOrderPick(){
        let data={
          searchText:this.orderPickKeyword?this.orderPickKeyword:'',
          page:1,
          pageSize:30
        };
        getOrdersListData(data).then(response => {
            if(response && response.code == 200) {
              this.orderPickList=(response.data && response.data.data)?response.data.data:[];
            }
          })
          .catch(error => { console.log(error); });
      },

      onOrderPickSelect(row){
        const __nm=(row.item && row.item.name)?row.item.name:(row.name?row.name:'');
        /* 【P95】三.3.02 会议室筛选：选销售合同写进 roomOrderFilterForm */
        if(this.orderPickTarget=='roomfilter'){
          this.roomOrderFilterForm.parent_sn=row.sn;
          this.roomOrderFilterForm.order_name=__nm;
          this.dialogOrderPick=false;
          return;
        }
        this.roomOrderForm.parent_sn=row.sn;
        this.roomOrderForm.order_name=__nm;
        if(!this.roomOrderForm.customer_sn && row.customer_sn){
          this.roomOrderForm.customer_sn=row.customer_sn;
          this.roomOrderForm.customer_name=(row.item && row.item.customer_name)?row.item.customer_name:'';
        }
        /* 【P348 / P349 修正】所属商机**继承上级销售合同**，与合同保持一致（用户 10-14 需求：
           商机不再单独选择，避免出现「订单商机 ≠ 合同商机」的数据口径分裂）。
           ★【P349 修正】接口 `client/ordersList` 真实返回的商机名称列是 **`opportunitie_text`**
             （t_pro_orders 表列名，例：'Amy洋玲_商机_261012134418'），
             **不是 opportunitie_name**（该列不存在！）⇒ P348 首版漏了这个字段名，
             导致「商机已继承但名称空白」。现按实测口径补全，并保留旧名兜底。 */
        const __oppSn = row.opportunitie_sn || row.opportunities_sn || '';
        const __oppNm = row.opportunitie_text || row.opportunitie_name || row.opportunities_name || '';
        if(__oppSn){
          this.roomOrderForm.opportunitie_sn=__oppSn;
          this.roomOrderForm.opportunitie_name=__oppNm;
        }
        this.dialogOrderPick=false;
      },

      /* 【P95】三.3.02 财务合同选择器（会议室外键筛选） */
      openFcPick(){
        this.fcPickKeyword='';
        this.fcPickList=[];
        this.dialogFcPick=true;
        this.loadFcPick();
      },
      loadFcPick(){
        this.fcPickLoading=true;
        getContractFinanceContractListData({ searchText:this.fcPickKeyword||'', page:1, pageSize:30 })
          .then(response=>{
            if(response && response.code==200){
              this.fcPickList=(response.data && response.data.data)?response.data.data:(Array.isArray(response.data)?response.data:[]);
            }
          })
          .catch(()=>{})
          .finally(()=>{ this.fcPickLoading=false; });
      },
      onFcPickSelect(row){
        this.roomOrderFilterForm.contracts_sn=row.sn;
        this.roomOrderFilterForm.fc_name=row.name||row.title||row.serial_number||'';
        this.dialogFcPick=false;
      },

      /* ================= 会议室订单：回款计划 ================= */

      addRoomOrderPayment(){
        this.roomOrderForm.payment.push({
          payment_date:'',
          amount:'',
          customer_sn:this.roomOrderForm.customer_sn,
          stores_sn:this.roomOrderForm.stores_sn,
          meeting_room_sn:this.roomOrderForm.meeting_room_sn,
          order_sn:this.roomOrderForm.parent_sn,
          opportunitie_sn:this.roomOrderForm.opportunitie_sn
        });
      },

      removeRoomOrderPayment(idx){
        this.roomOrderForm.payment.splice(idx, 1);
      },

      /* chip 多选：桌型 / 增值服务 */
      isChipOn(arr, id){
        return (arr||[]).some(v=>String(v)===String(id));
      },

      //【P33 修复】多选字段归一：把后端返回的「二维 [[248],[249]] / 一维 [248,249] /
      //  JSON 串 / 中文名逗号串」统一拍平成一维值数组，供芯片回显与提交。
      //  老系统落库口径是二维（读取端 array_column 取第 0 列），若不拍平，
      //  数组里会混入 [248] 这类子数组，编辑保存时结构不稳定（易产生重复项）。
      normChipIds(raw, opts){
        if(raw===undefined || raw===null || raw==='') return [];
        let arr = raw;
        if(typeof raw==='string'){
          const t = raw.trim();
          if(!t) return [];
          let parsed=null;
          try{ parsed = JSON.parse(t); }catch(e){ parsed=null; }
          arr = Array.isArray(parsed) ? parsed : t.split(',').filter(s=>s!=='');
        }
        if(!Array.isArray(arr)) return [];
        const list = opts || [];
        const out=[];
        arr.forEach(it=>{
          const v = Array.isArray(it) ? it[0] : it;
          if(v===undefined || v===null || v==='') return;
          const s = String(v).trim();
          if(!s) return;
          if(out.some(x=>String(x)===s)) return;      // 去重
          const hit = list.find(o=>String(o.id)===s || String(o.name)===s);
          out.push(hit ? hit.id : v);
        });
        return out;
      },

      toggleTableType(id){
        let arr=this.roomOrderForm.table_types||[];
        let i=arr.findIndex(v=>String(v)===String(id));
        if(i>=0){ arr.splice(i,1); } else { arr.push(id); }
        this.roomOrderForm.table_types=arr;
      },

      toggleOptionService(id){
        let arr=this.roomOrderForm.option_service||[];
        let i=arr.findIndex(v=>String(v)===String(id));
        if(i>=0){ arr.splice(i,1); } else { arr.push(id); }
        this.roomOrderForm.option_service=arr;
      },

      /* ================= 【P108】管理人员标志 / 审核消息定位 ================= */

      /** 拉取「我是否管理人员」，用于删除入口显隐（失败时保守按「不是」处理） */
      fetchIsManager(){
        isManagerData({}).then(res=>{
          if(res && res.code===200 && res.data){
            this.canManageDelete = Number(res.data.is_manager)===1;
            /* 【P439】客户删除权限：仅销售总经理 / 销售部负责人（后端同源判定） */
            this.canCustomerDelete = Number(res.data.can_customer_delete)===1;
            /* 没权限却停在回收站页（例如权限被临时收回）→ 退回宫格 */
            if(!this.canCustomerDelete && this.quickSub==='recycle'){ this.quickSub='grid'; }
          }
        }).catch(()=>{});
      },

      /** 从消息行解析会议室订单 sn（page_url 形如 /crm_orders/info/detail?room_sn=xxx） */
      msgRoomSn(row){
        if(!row) return '';
        const u = String(row.page_url || '') + String(row.page_sn || '');
        const m = /room_sn=([A-Za-z0-9]+)/.exec(u);
        return m ? m[1] : '';
      },

      /* 【P212 问题2-02】从财务单据审核消息解析**关联销售合同 sn**。
         后端 _paymentApproval 把 page_url 写成
         /financial_payment/info/detail?order_sn=<销售合同sn>（沿用 P108 的 room_sn 范式）。
         ⚠️ 不能用 row.parent_sn：它是**支付单自身**的 sn；
         ⚠️ 也不能用 row.page_sn：它是「页面配置 sn」（菜单角标按它聚合）。 */
      msgOrderSn(row){
        if(!row) return '';
        const u = String(row.page_url || '');
        const m = /order_sn=([A-Za-z0-9]+)/.exec(u);
        return m ? m[1] : '';
      },

      /* ================= 【P108】商机「提醒时间」日期+时间选择器 ================= */
      openRemindPick(){
        const cur = this.opportunityForm.remind_datetime || '';
        this.remindPickValue = cur ? new Date(String(cur).replace(/-/g,'/')) : new Date();
        this.remindPickShow = true;
      },
      onRemindPickConfirm(){
        this.remindPickShow = false;
        const d = new Date(this.remindPickValue);
        const p = n => String(n).padStart(2,'0');
        this.opportunityForm.remind_datetime = d.getFullYear()+'-'+p(d.getMonth()+1)+'-'+p(d.getDate())
          +' '+p(d.getHours())+':'+p(d.getMinutes())+':00';
      },
      /* 商机备注富文本 */
      onOppRemarkCreated(editor){ this.editorOppRemark = editor; },

      /* ================= 公共：日期选择器 ================= */

      openDatePick(target, field, title){
        this.datePickTarget=target;
        this.datePickField=field;
        this.datePickTitle=title?title:'请选择日期';
        let cur='';
        if(target=='opportunity'){ cur=this.opportunityForm[field]; }
        if(target=='order'){ cur=this.orderForm[field]; }
        if(target=='roomorder'){ cur=this.roomOrderForm[field]; }
        if(target=='contact'){ cur=this.contactForm[field]; }
        if(target=='visit'){ cur=this.visitForm[field]; }
        this.datePickValue=cur ? new Date(String(cur).replace(/-/g,'/')) : new Date();
        this.dialogDatePick=true;
      },

      onDatePickConfirm(){
        this.dialogDatePick=false;
        const d=new Date(this.datePickValue);
        const s=d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');
        if(this.datePickTarget=='opportunity'){
          this.opportunityForm[this.datePickField]=s;
        }
        if(this.datePickTarget=='order'){
          this.orderForm[this.datePickField]=s;
        }
        if(this.datePickTarget=='roomorder'){
          this.roomOrderForm[this.datePickField]=s;
        }
        if(this.datePickTarget=='contact'){
          this.contactForm[this.datePickField]=s;
        }
        if(this.datePickTarget=='visit'){
          this.visitForm[this.datePickField]=s;
        }
      },

      /* 删除确认（联系人 / 回访） */
      /* ==================================================================
       * 【P439】客户删除 / 回收站
       * ------------------------------------------------------------------
       * 权限：仅「销售总经理 / 销售部负责人」（canCustomerDelete ← isManager.can_customer_delete）
       * 口径：删除 = 软删（is_delete=1 + delete_user/delete_time），关联单据一律不动；
       *       回收站内可「恢复」或「彻底删除」（有单据时后端 409，二次确认后带 force=1）
       * 后端唯一实现在 app/common/service/CustomerRecycleService.php
       * ================================================================== */

      /** 客户详情 → 删除客户（先预检名下单据数量，再弹确认） */
      askDeleteCustomer(){
        if(!this.canCustomerDelete){ this.$toast('无删除客户权限'); return; }
        const c = this.detailCustomer || {};
        if(!c.sn){ this.$toast('客户不存在'); return; }
        this.custDelTarget = c;
        this.custDelDesc = '确定要删除客户「' + (c.name || '') + '」吗？删除后可在「快捷 → 回收站」中恢复。';
        this.custDelShow = true;
        /* 预检：把名下单据数量补进提示文案，让操作人知道「单据不会被删」
           （失败不改文案，也不阻塞删除 —— 预检只是提示，不参与门禁） */
        customersDeletePrecheck({ sn: c.sn }).then(res => {
          if(!this.custDelShow){ return; }                       // 用户已关闭弹窗
          if(!res || res.code !== 200 || !res.data){ return; }
          const d = res.data;
          const lm = d.labels || {};
          const parts = [];
          ['opportunities','orders','contracts','invoices','rooms','contacts','visits'].forEach(k => {
            const n = Number(d[k] || 0);
            if(n > 0){ parts.push((lm[k] || k) + ' ' + n); }
          });
          if(parts.length){
            this.custDelDesc = '「' + (c.name || '') + '」名下还有 ' + parts.join('、')
                             + '。\n删除客户不会删除这些单据，删除后可在「回收站」恢复。';
          }
        }).catch(() => {});
      },
      confirmDeleteCustomer(){
        const c = this.custDelTarget;
        if(!c || !c.sn){ this.custDelBusy = false; return; }
        this.custDelBusy = true;
        customersDelete({ sn: c.sn }).then(res => {
          this.custDelBusy = false;
          if(res && res.code === 200){
            this.custDelShow = false;
            this.custDelTarget = null;
            this.$toast('已移入回收站');
            this.detailShow = false;            // 详情里的客户已失效 → 关闭详情
            this.reloadCustomerList();
          } else {
            suppressGlobalError();
            this.$toast((res && res.msg) ? res.msg : '删除失败');
          }
        }).catch(() => { this.custDelBusy = false; });
      },
      /** 删除/恢复后重拉客户列表（列表 4 个 tab 共用 page，需一并复位） */
      reloadCustomerList(){
        this.page = 1;
        this.finished = false;
        this.customersList = [];
        this.getCustomersList();
      },

      /* ---------------- 回收站：搜索 / 刷新 / 分页 ---------------- */
      onRecycleSearch(){
        this.recyclePage = 1;
        this.recycleFinished = false;
        this.recycleRows = [];
        this.getRecycleList();
      },
      clearRecycleSearch(){
        this.recycleSearch = '';
        this.onRecycleSearch();
      },
      onRecycleRefresh(){
        this.recyclePage = 1;
        this.recycleFinished = false;
        this.recycleRows = [];
        this.getRecycleList();
      },
      getRecycleList(){
        if(this.recycleLoading){ return; }
        const reqPage = this.recyclePage || 1;
        if(reqPage === 1){ this.recycleGen++; }
        const gen = this.recycleGen;
        this.recycleLoading = true;
        customersRecycleList({
          page: reqPage,
          pageSize: 20,
          searchText: this.recycleSearch
        }).then(res => {
          if(gen !== this.recycleGen){ return; }               // 丢弃过期回包
          if(res && res.code === 200 && res.data){
            const rows = res.data.data || [];
            this.recycleRows = (reqPage === 1) ? rows.slice() : this.recycleRows.concat(rows);
            this.recycleTotal = Number(res.data.total || 0);
            const lastPage = parseInt(res.data.last_page || 0, 10) || 0;
            if(!rows.length || (lastPage > 0 && reqPage >= lastPage)){
              this.recycleFinished = true;
            } else {
              this.recyclePage = reqPage + 1;
            }
          } else {
            suppressGlobalError();
            if(res && res.msg){ this.$toast(res.msg); }
            this.recycleFinished = true;
          }
        }).catch(() => {
          this.recycleFinished = true;
        }).finally(() => {
          if(gen === this.recycleGen){
            this.recycleLoading = false;
            this.recycleRefreshing = false;
          }
        });
      },

      /** 回收站 → 恢复（非破坏性，不弹确认） */
      askRestore(row){
        if(!row || !row.sn){ return; }
        this.recycleBusySn = row.sn;
        customersRecycleRestore({ sn: row.sn }).then(res => {
          this.recycleBusySn = '';
          if(res && res.code === 200){
            this.$toast('已恢复');
            this.recycleRows = this.recycleRows.filter(x => x.sn !== row.sn);
            this.recycleTotal = Math.max(0, this.recycleTotal - 1);
            this.reloadCustomerList();
          } else {
            suppressGlobalError();
            this.$toast((res && res.msg) ? res.msg : '恢复失败');
          }
        }).catch(() => { this.recycleBusySn = ''; });
      },

      /** 回收站 → 彻底删除（先普通确认；后端 409 时补一次带 force 的确认） */
      askPurge(row){
        if(!row || !row.sn){ return; }
        this.purgeTarget = row;
        this.purgeForce = false;
        this.purgeDesc = '确定要彻底删除「' + (row.name || '') + '」吗？彻底删除后数据不可恢复。';
        this.purgeShow = true;
      },
      confirmPurgeCustomer(){
        const row = this.purgeTarget;
        if(!row || !row.sn){ this.purgeBusy = false; return; }
        this.purgeBusy = true;
        customersRecyclePurge({ sn: row.sn, force: this.purgeForce ? 1 : 0 }).then(res => {
          this.purgeBusy = false;
          if(res && res.code === 200){
            this.purgeShow = false;
            this.purgeTarget = null;
            this.$toast('已彻底删除');
            this.onRecycleRefresh();
          } else if(res && res.code === 409){
            /* 名下有单据：后端拦住并回传数量 → 文案带上数量，用户再点一次即 force=1 */
            suppressGlobalError();
            this.purgeForce = true;
            this.purgeDesc = (res.msg || '该客户名下还有关联单据')
                           + '。\n再次点击「彻底删除」将继续执行，且不可恢复。';
          } else {
            suppressGlobalError();
            this.$toast((res && res.msg) ? res.msg : '彻底删除失败');
          }
        }).catch(() => { this.purgeBusy = false; });
      },

      askDelete(type, item){
        this.delType = type;
        this.delSn = item.sn || '';
        this.delName = type==='contact' ? (item.name||'该联系人') : (item.title||'该回访记录');
        this.delDialogShow = true;
      },
      confirmDelete(){
        if(!this.delSn){ this.$toast('缺少记录编号'); return; }
        this.delDoing = true;
        /* 【P108】支持商机 / 合同删除（管理人员专用）：走同一个 ConfirmDialog，
           删除后刷新对应列表（原实现只有 联系人/回访 + 刷新客户详情） */
        let fn = null, after = null;
        if(this.delType==='contact'){ fn = deleteContactData; after = () => this.fetchCustomerDetail(); }
        else if(this.delType==='visit'){ fn = deleteVisitData; after = () => this.fetchCustomerDetail(); }
        else if(this.delType==='opportunity'){ fn = deleteOpportunitiesData; after = () => { this.page=1; this.finished=false; this.opportunitiesList=[]; this.getOpportunitiesList(); }; }
        else if(this.delType==='order'){ fn = deleteOrdersData; after = () => { this.page=1; this.finished=false; this.orderList=[]; this.getOrderList(); }; }
        if(typeof fn !== 'function'){ this.delDoing = false; this.$toast('删除类型未配置'); return; }
        fn({ sn:this.delSn }).then(response => {
          this.delDoing = false;
          if(response && response.code==200){
            this.$toast('已删除');
            this.delDialogShow = false;
            if(after){ after(); }
          } else {
            suppressGlobalError();
            this.$toast((response && response.msg) ? response.msg : '删除失败');
          }
        }).catch(() => { this.delDoing = false; });
      },

      openPaymentDatePick(idx){
        this.paymentDatePickIdx=idx;
        let cur=this.roomOrderForm.payment[idx] ? this.roomOrderForm.payment[idx].payment_date : '';
        this.datePickValue=cur ? new Date(String(cur).replace(/-/g,'/')) : new Date();
        this.dialogPaymentDatePick=true;
      },

      onPaymentDateConfirm(){
        this.dialogPaymentDatePick=false;
        if(this.paymentDatePickIdx<0){ return; }
        const d=new Date(this.datePickValue);
        const s=d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');
        if(this.roomOrderForm.payment[this.paymentDatePickIdx]){
          this.roomOrderForm.payment[this.paymentDatePickIdx].payment_date=s;
        }
        this.paymentDatePickIdx=-1;
      }

    },

    mounted() {
      if (isLoggedIn()) {
        this.intPage();
        this.fetchCurrentStaff();
        this.fetchManagedStaff();
        /* 【P108】拉一次「我是否管理人员」，决定商机/合同卡片「删除」入口显隐 */
        this.fetchIsManager();
      }
      /* 【P114】读一次画像缓存（登录时 clientAuth 已落 localStorage.profile） */
      this.profile = getProfile() || {};
      /* 【P114】销售端此前没有画像接口 ⇒ 缓存永远为空、部门/角色显示不出来；本轮补齐 */
      this.fetchMyProfile();
      crmWs.connect();
      this._offUnread = crmWs.on('unread', (d) => this.onUnread(d));
      window.addEventListener('resize', this.measureCustHeader);
      window.addEventListener('orientationchange', this.measureCustHeader);
    },

  };
</script>

<style>
  .popupBox{
    padding:20px !important;
  }
  .van-cell {
    padding:15px 10px !important; 
  }
  .van-checkbox{
    padding:10px 10px !important; 
  }
</style>

<style>
        .html-container {
          white-space: pre-wrap;
        }

        /* 顶部导航 */
        .top-nav {
            background: #fff;
            height: 46px;
            line-height: 46px;
            text-align: center;
            font-size: 15px;
            font-weight: 500;
            box-shadow: 0 1px 4px #eee;
            position: sticky;
            top: 0;
            z-index: 99;
        }
        /* 搜索筛选 */
        .search-box {
            width:calc(100% - 35px);
            padding: 5px 5px;
            font-size:14px;
        }
        .search-input {
            width: 100%;
            height: 38px;
            border-radius: 8px;
            outline: none;
        }
        /* 已废弃：旧版让 .list-box 自带固定高度+滚动，会与下方新版 .list-box
           {height:auto;overflow:visible} 形成同名同权重声明互相覆盖（编译顺序决定胜负）。
           滚动统一交给 .client-root，这里不再声明高度/溢出。 */
        .list-box{
          width:100%;
        }
        /* 列表容器 */
        .crm-list {
            padding: 0 12px;
        }
        /* 客户卡片 */
        .crm-item {
            background: #fff;
            border-radius: 10px;
            margin-bottom: 12px;
            overflow: hidden;
        }
        /* 简约头部 默认显示 */
        .item-head {
            padding: 12px 15px;
            border-bottom: 1px solid #f5f5f5;
        }
        .head-top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 4px;
        }
        .cust-name {
            font-size: 15px;
            font-weight: 500;
        }
        .btn-more {
            color: #2d8cf0;
            font-size: 13px;
            white-space: nowrap;
        }
        .head-bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .cust-tip {
            font-size: 12px;
            color: #666;
        }
        /* 状态标签 */
        .status-tag {
            display: inline-block;
            padding: 2px 6px;
            border-radius: 4px;
            font-size: 12px;
            color: #fff;
        }

        .tag-danger {
            background: #F56C6C;
        }
        .tag-wait {
            background: #ff9500;
        }
        .tag-allot {
            background: #2d8cf0;
        }
        .tag-receive {
            background: #00b42a;
        }
        /* 展开详情区域 */
        .item-detail {
            padding: 12px 15px;
    
        }
        .item-detail.show {
            display: block;
        }
        /* 两排左右结构 信息行 */
        .info-row {
            display: flex;
            flex-wrap: wrap;
   
            overflow: hidden;
        }
        .info-col1 {
            display: flex;
            width: 100%;
            font-size: 13px;
            line-height: 2;
            margin-bottom:5px;
        }
        .info-col {
            display: flex;
            width: 50%;
            font-size: 13px;
            line-height: 2;
            margin-bottom:5px;
        }
        .label {
            color: #999;
        }
        /* 回访记录区块 */
        .record-block {
            margin-top: 10px;
            padding-top: 10px;
            border-top: 1px dashed #eee;
        }
        .record-title {
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 6px;
        }
        .record-item {
            font-size: 12px;
            color: #666;
            line-height: 1.5;
            background: #f9f9f9;
            padding: 6px 8px;
            border-radius: 6px;
            margin-bottom: 5px;
        }
</style>

 <style >  


  /* 全局关闭整个页面上下/左右弹性回弹 */


  /* 自定义滚动容器 单独关闭弹性 */
  .scroll-wrap {
    overflow: auto;
    overscroll-behavior: none;
    -webkit-overflow-scrolling: auto;
  }
  .room-status-page {
    background: #f5f7fa;
    color: #333;
    -webkit-tap-highlight-color: transparent;
  }

   /* 仅对房态总览板内的元素做 reset，避免影响整合进来的「会议室预订」区块（其样式独立） */
   .room-status-board  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;


  }

  
  /* 顶部日期导航 */
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    background: linear-gradient(135deg, #5b8def 0%, #3b6fd4 100%);
    color: #fff;
    position: sticky;
    top: 0;
    z-index: 99;
    font-size: 14px;
    box-shadow: 0 2px 8px rgba(59,111,212,.18);
  }
  .header__date { display: flex; align-items: center; gap: 6px; font-weight: 600; }
  .header__cal { font-size: 16px; }
  .header__range i { font-style: normal; opacity: .7; margin: 0 2px; }
  .header__btn {
    display: flex; align-items: center; gap: 2px;
    background: rgba(255,255,255,.18);
    border: 1px solid rgba(255,255,255,.35);
    padding: 5px 12px; border-radius: 16px;
    font-size: 13px;
  }
  
  /* 门店横向滚动 */
  .store-wrap {
    background: #fff;
    padding: 10px 12px;
    overflow-x: auto;
    white-space: nowrap;
    border-bottom: 1px solid #eee;
  }
  .store-wrap::-webkit-scrollbar {
    display: none; /* 直接隐藏 */
  }
  .store-item {
    display: inline-block;
    padding: 7px 14px;
    margin-right: 8px;
    border-radius: 16px;
    font-size: 13px;
    background: #eef2f7;
    color: #5b6472;
    border: 1px solid transparent;
    transition: all .15s ease;
  }
  .store-item.active {
    background: linear-gradient(135deg, #5b8def 0%, #3b6fd4 100%);
    color: #fff;
    box-shadow: 0 3px 8px rgba(59,111,212,.28);
  }
  
  /* 日期横向表头 + 内容同步滚动 */
  .scroll-wrapper {
    overflow-x: auto;
    overflow-y: auto;
    height: calc(100vh - 160px);
    overscroll-behavior: none;
    -webkit-overflow-scrolling: auto;
    background: #f5f7fa;
  }

  .scroll-wrapper::-webkit-scrollbar {
    display: none; /* 直接隐藏 */
  }
  .scroll-content {

  }

  .room-name{
      position: sticky;
      left: 0;
      z-index: 5;
      padding: 10px 10px;
      border-bottom: 1px solid #eef0f3;
      width: 88px;
      min-width: 88px;
      font-size: 13px;
      font-weight: 700;
      color: #2b3340;
      background: #eef2f7;
      display: flex;
      align-items: center;
      box-shadow: 2px 0 6px rgba(0,0,0,.04);
  }

  /* 日期横向表头 */
  .date-header {
      position: sticky;
      top: 0;
      background: #fff;
      display: flex;
      border-bottom: 1px solid #eef0f3;
      z-index:999;

  }
  .date-item {
    min-width: 84px;
    padding: 12px 5px;
    text-align: center;
    font-size: 12px;
    color: #5b6472;
    border-right: 1px solid #eef0f3;
  }
  .date-item.today {
    color: #3b6fd4;
    font-weight: 700;
    background: #eef4ff;
  }

  /* 房态列表 */
  .room-list {
    background: #fff;

  }
  .room-row {
    border-bottom: 1px solid #eef0f3;
  }
  .room-days {
    display: flex;
  }
  .day-cell {
    display:flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    min-width: 84px;
    padding: 6px 5px;
    border-right: 1px solid #eef0f3;
    min-height: 96px;

  }
  .status {
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 10px;
    font-size: 12px;
    margin: 3px 0;
    text-align: center;
    height: 82px;
    padding: 8px 6px;
    box-shadow: 0 2px 6px rgba(0,0,0,.08);
    box-sizing: border-box;
  }
  .status .item_name {
    width: 100%;
    height: 18px;
    line-height: 18px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .status .item_name:first-child {
    font-weight: 700;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
  }
  .status .item_name:not(:first-child) {
    opacity: .92;
    font-size: 11px;
    height: 16px;
    line-height: 16px;
    margin-top: 2px;
  }
  .status.empty {
    background: #f3f5f8;
    color: #aab2bd;
    box-shadow: none;
    border: 1px dashed #dfe3e8;
  }
  .status.booked {
    background: #f59e0b;
    color: #fff;
  }
  .item_name{
    width:100%;
    height:18px;
    overflow: hidden;
  }
  .tag {
    font-size: 10px;
    padding: 1px 1px;
    border-radius: 3px;
    background: rgba(255, 255, 255, 0.3);
    margin-top: 3px;
    display: inline-block;
  }
  



.content_status_1{
    background-color:#409EFF;
  }
  
  .status_color{
    font-size:12px;
    color:#fff;
  }
    

  .content_status_2{
    background-color:#f59e0b;
  }


  .content_status_3{
    background-color:#67C23A;
  }

 
  .content_status_4{
    background-color:#F56C6C;
  }

  .content_status_0{
    background-color:#f1f1f1;
  }

  /* 房态总览板容器 */
  .room-status-board {
    display: flex;
    flex-direction: column;
    background: #f5f7fa;
  }

  /* 会议室预订子视图容器 */
  .room-meeting-wrap {
    background: #f5f7fa;
    min-height: 100vh;
  }

  /* 未使用单元格 */
  .status--empty {
    background: #f3f5f8;
    border: 1px dashed #dfe3e8;
    box-shadow: none;
    color: #aab2bd;
  }
  .status--empty__txt { font-size: 11px; }

  /* ===== 房态详情弹窗（专业卡片式） ===== */
  .detail-popup .van-popup__close-icon { display: none; }
  .detail-sheet {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #f5f7fa;
  }
  .detail-sheet__hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 18px;
    background: linear-gradient(135deg, #5b8def 0%, #3b6fd4 100%);
    color: #fff;
    border-radius: 16px 16px 0 0;
  }
  .detail-sheet__title { font-size: 16px; font-weight: 700; }
  .detail-sheet__close { font-size: 20px; color: #fff; }
  .detail-sheet__body {
    flex: 1;
    overflow-y: auto;
    padding: 14px 14px 24px;
    -webkit-overflow-scrolling: auto;
  }
  /* 【P339-UI】客户名独占整行：原与「销售合同/编辑」按钮同一行 flex，
     按钮 flex-shrink:0 会把长客户名压成竖排单字（智者四海（北京）技术…）。
     客户名块 flex-basis:100% 换行到独立行，按钮行另起；word-break:break-word
     只在超长无空格串断行，中文正常折行。 */
  .detail-hero {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    background: #fff;
    border-radius: 14px;
    padding: 14px;
    box-shadow: 0 2px 10px rgba(0,0,0,.05);
    margin-bottom: 14px;
  }
  .detail-hero__main { flex: 1 1 100%; min-width: 0; }
  .detail-hero__name {
    font-size: 16px; font-weight: 700; color: #1f2733;
    line-height: 1.45; word-break: break-word; overflow-wrap: anywhere;
  }
  .detail-hero__sub { font-size: 12.5px; color: #8b94a3; margin-top: 4px; }
  .detail-hero__action {
    flex-shrink: 0;
    padding: 7px 14px;
    border-radius: 16px;
    background: #eef4ff;
    color: #3b6fd4;
    font-size: 13px;
    font-weight: 600;
  }
  /* 【P37】非本人订单：编辑入口置为不可点的只读态 */
  .detail-hero__action--disabled {
    background: #f2f3f5;
    color: #969799;
    font-weight: 500;
  }
  /* 【P38】hero 右侧动作区：可同时容纳「销售合同」与「编辑」两个入口
     【P339-UI】客户名已独占整行 ⇒ 动作区换行到第二行，加 margin-top 拉开间距 */
  .detail-hero__actions {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    flex-shrink: 0;
    flex: 1 1 100%;
    margin-top: 10px;
  }
  /* 【P38】「销售合同」入口用次级（描边）样式，与主操作「编辑」区分开 */
  .detail-hero__action--ghost {
    background: #fff;
    color: #3b6fd4;
    border: 1px solid #b9d0f5;
    font-weight: 500;
  }
  .detail-sec { margin-bottom: 14px; }
  .detail-sec__title {
    display: flex; align-items: center;
    font-size: 14px; font-weight: 700; color: #1f2733;
    margin: 4px 2px 10px;
  }
  .detail-sec__bar {
    width: 4px; height: 14px;
    border-radius: 2px;
    background: linear-gradient(180deg, #5b8def, #3b6fd4);
    margin-right: 8px;
  }
  .detail-cards { display: flex; flex-direction: column; gap: 10px; }
  .detail-card {
    background: #fff;
    border-radius: 12px;
    padding: 12px 14px;
    box-shadow: 0 2px 8px rgba(0,0,0,.04);
  }
  .detail-card--sm { padding: 10px 12px; }
  .detail-card__head {
    font-size: 14px; font-weight: 700; color: #1f2733;
    margin-bottom: 8px;
  }
  .detail-card__head em {
    font-style: normal;
    font-size: 12px; font-weight: 500; color: #8b94a3;
    margin-left: 6px;
  }
  .detail-card__row {
    display: flex;
    font-size: 13px;
    padding: 3px 0;
    line-height: 1.5;
  }
  .detail-card__label {
    width: 64px; flex-shrink: 0;
    color: #8b94a3;
  }
  .detail-card__val {
    flex: 1;
    color: #2b3340;
    word-break: break-all;
  }
  /* 【P312】备注富文本渲染：v-html 带进来的 p/ul/img 需要重置，否则会带默认外边距撑乱卡片 */
  .detail-rich { line-height: 1.7; }
  .detail-rich p { margin: 0 0 4px; }
  .detail-rich p:last-child { margin-bottom: 0; }
  .detail-rich ul, .detail-rich ol { margin: 2px 0 2px 18px; padding: 0; }
  .detail-rich img { max-width: 100%; border-radius: 6px; margin-top: 4px; }
  .detail-rich table { width: 100%; border-collapse: collapse; margin-top: 4px; }
  .detail-rich td, .detail-rich th { border: 1px solid #ebedf0; padding: 3px 5px; font-size: 12px; }
  .detail-empty {
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    text-align: center;
    color: #aab2bd;
    font-size: 13px;
  }

  /* ===== 房态详情「编辑」：复用会议室订单编辑表单（dialogRoomOrder） ===== */

  .dialogDate{
    width:100%;
    padding:20px;
  }

  .dialogDateRow{
    display: flex;
    justify-content: space-between;
    width:100%;
    padding:20px 10px 20px 10px;
  }

  .dialogDateLable{

  }
  .dialogDateValue{

  }

  .order_title{
    padding:10px 10px;
    font-size:14px;
    font-weight:bold;
  }

  .search-row{
    display: flex;
    align-items: center;
  }
  .search-row .search-input{
    flex:1;
  }
  .btn-add{
    margin-left:8px;
    padding:0 14px;
    height:38px;
    line-height:38px;
    background:#3b82f6;
    color:#fff;
    border-radius:8px;
    font-size:14px;
    white-space:nowrap;
  }
  .head-actions{
    display: flex;
    align-items: center;
  }
  .btn-edit{
    margin-right:14px;
    color:#3b82f6;
    font-size:13px;
    white-space:nowrap;
  }
  .form-page{
    display: flex;
    flex-direction: column;
    height:100%;
  }
  .form-title{
    padding:14px 16px;
    font-size:16px;
    font-weight:500;
    border-bottom:1px solid #eee;
  }
  .form-body{
    flex:1;
    overflow-y:auto;
  }
  .form-divider{
    padding:12px 16px 6px;
    font-size:13px;
    color:#999;
    background:#f5f7fa;
  }
  .form-group{
    background:#fff;
    border-radius:10px;
    margin:12px 12px;
    overflow:hidden;
    box-shadow:0 1px 4px rgba(0,0,0,.08);
    border:1px solid #eef0f2;
  }
  .form-group__hd{
    padding:11px 14px 5px;
    font-size:13px;
    font-weight:600;
    color:#1989fa;
    letter-spacing:.5px;
    border-left:3px solid #1989fa;
    margin:2px 0 2px;
  }
  /* 房间订单表单：灰底白卡，分组更醒目（与预览图一致） */
  .form-page--roomorder .form-body{
    background:#f5f6f8;
    padding:4px 0;
  }
  .form-page--roomorder .form-title{
    background:#fff;
  }

  /* ===== 会议室订单表单：自定义行 / chip / 回款计划（对齐预览图） ===== */
  .ro-field{
    display:flex;
    align-items:center;
    min-height:50px;
    padding:0 14px;
    border-top:1px solid #f2f3f5;
    background:#fff;
  }
  .ro-field:first-of-type{ border-top:none; }
  .ro-label{
    width:84px;
    flex:none;
    font-size:14px;
    color:#646566;
  }
  .ro-label .required{ color:#ee0a24; margin-right:2px; }
  .ro-val{
    flex:1;
    font-size:14px;
    color:#323233;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
  }
  .ro-val.placeholder{ color:#c8c9cc; }
  .ro-arrow{ margin-left:6px; color:#c8c9cc; font-size:16px; }
  /* 【P36】合同关联锁：已挂销售合同的订单，合同字段只读（与合同Tab编辑一致） */
  .ro-lock{ margin-left:6px; color:#969799; font-size:15px; display:flex; align-items:center; }
  .ro-field--lock .ro-val{ color:#646566; }
  /* 【P38】「查看销售合同详情」入口：紧跟在「合同」字段下方，仅当有权限时渲染 */
  .ro-contract-link{
    display:flex;
    align-items:center;
    min-height:44px;
    padding:0 14px;
    border-top:1px solid #f2f3f5;
    background:#f7faff;
    color:#3b6fd4;
    font-size:13.5px;
    font-weight:500;
  }
  .ro-contract-link:active{ background:#eef4ff; }
  .ro-contract-link__ico{ margin-right:6px; font-size:15px; }
  .ro-contract-link__txt{ flex:1; }
  .ro-contract-link__arrow{ margin-left:6px; color:#a8c1ea; font-size:16px; }
  .ro-input{
    flex:1;
    border:none;
    outline:none;
    background:transparent;
    font-size:14px;
    color:#323233;
    height:48px;
    width:100%;
  }
  .ro-input::placeholder{ color:#c8c9cc; }
  .ro-range{
    flex:1;
    display:flex;
    align-items:center;
    gap:8px;
  }
  .ro-range .ro-input{
    background:#f7f8fa;
    border-radius:8px;
    height:36px;
    padding:0 10px;
    min-width:0;
  }
  .ro-tilde{ color:#c8c9cc; }
  /* 【P33】使用时间：点击弹出滑动时间选择器（替代裸文本输入，避免 "0830" 这类格式错误） */
  .ro-input--pick{
    display:flex;
    align-items:center;
    justify-content:center;
    cursor:pointer;
    text-align:center;
  }
  .ro-input--pick span.placeholder{ color:#c8c9cc; }

  .ro-chips-wrap{
    padding:10px 14px 12px;
    border-top:1px solid #f2f3f5;
    background:#fff;
  }
  .ro-chips-label{
    font-size:14px;
    color:#646566;
    margin-bottom:8px;
  }
  .ro-chips{ display:flex; flex-wrap:wrap; gap:8px; }
  .ro-chip{
    font-size:13px;
    padding:6px 13px;
    border-radius:16px;
    background:#f2f3f5;
    color:#646566;
    border:1px solid transparent;
  }
  .ro-chip--on{
    background:#e8f3ff;
    color:#1989fa;
    border-color:#a9d3ff;
    font-weight:600;
  }

  .ro-pay{ padding:10px 14px 14px; background:#fff; }
  /* 【P24-9】免费单回款计划提示 */
  .ro-free-hint{
    padding:14px;
    font-size:13px;
    color:#969799;
    background:#fff;
  }
  .ro-payrow{
    display:flex;
    align-items:center;
    gap:8px;
    margin-top:8px;
  }
  .ro-payrow:first-child{ margin-top:0; }
  .ro-cell{
    flex:1;
    height:40px;
    background:#f7f8fa;
    border-radius:8px;
    display:flex;
    align-items:center;
    padding:0 10px;
    font-size:13px;
    color:#323233;
    border:none;
    outline:none;
    min-width:0;
  }
  .ro-cell.placeholder{ color:#c8c9cc; }
  .ro-cell--input::placeholder{ color:#c8c9cc; }
  .ro-del{
    width:30px;
    height:30px;
    flex:none;
    border-radius:50%;
    background:#fdeaea;
    color:#ee0a24;
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:17px;
  }
  .ro-addpay{
    margin-top:10px;
    height:40px;
    border:1px dashed #a9d3ff;
    border-radius:8px;
    color:#1989fa;
    font-size:14px;
    display:flex;
    align-items:center;
    justify-content:center;
    background:#f5faff;
  }

  .ro-textarea{ padding:10px 14px 14px; background:#fff; }
  .ro-textarea textarea{
    width:100%;
    height:74px;
    border:none;
    background:#f7f8fa;
    border-radius:8px;
    padding:10px;
    font-size:14px;
    color:#323233;
    outline:none;
    resize:none;
  }

  .ro-btn{
    flex:1;
    height:44px;
    margin:0 4px;
    border-radius:22px;
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:15px;
    font-weight:600;
  }
  .ro-btn--cancel{ background:#f2f3f5; color:#646566; }
  .ro-btn--save{ background:#1989fa; color:#fff; }
/* 【P214】「保存并继续」次要按钮：与 save 同族但用描边样式，视觉层级低于「保存」 */
.ro-btn--cont{background:#fff;color:#1989fa;border:1px solid #1989fa;}
.ro-btn--cont.ro-btn--busy{opacity:.6;}


  .form-footer{
    display: flex;
    padding:10px 16px 16px;
    border-top:1px solid #eee;
    background:#fff;
  }
  .form-footer .van-button{
    margin:0 4px;
  }

  .pick-search{
    padding:10px 16px;
    border-bottom:1px solid #eee;
  }
  .pick-body{
    flex:1;
    overflow-y:auto;
  }
  .pick-empty{
    padding:32px 0;
    text-align:center;
    color:#999;
    font-size:13px;
  }
  .pick-item{
    padding:12px 16px;
    border-bottom:1px solid #f2f4f7;
  }
  .pick-item:active{
    background:#f5f7fa;
  }
  .pick-name{
    font-size:14px;
    color:#1f2328;
  }
  .pick-sub{
    margin-top:2px;
    font-size:12px;
    color:#9aa1ab;
  }
</style>

<!-- ===== 非房态模块（客户/商机/合同/消息）专业视觉重写（不影响房态） ===== -->
<style>
.client-root {
  /* ⚠️ 关键：lib.min.css 把 #app,body,html 设成 height:100%; overflow:hidden，
     页面自身永远不能滚动。因此必须由 .client-root 承担滚动，否则
     客户/商机/合同/消息等列表（.list-box 已是 height:auto/overflow:visible）
     会被父级直接裁掉，表现为「列表滑不动」。
     房态/快捷等 tab 内部各有固定高度滚动区（.scroll-wrapper/.quick-entry），
     在本容器内正好占满一屏，不会产生双滚动条。 */
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  /* 手机端：扣掉顶栏与底部 tabbar 的占位，避免整页出现多余滚动 */
  min-height: calc(100vh - 115px);
  background: #f5f6f8;
  /* 底部 tabbar 的避让间距改由 .list-box 自己承担（padding-bottom:72px）——
     放在这里会让「房态/快捷」这类本身就精确占满一屏的 tab 多出 56px 空白滚动。 */
}

/* 底部 tabbar：简洁线条风（统一 SVG 图标 + 极淡上边框 + 微阴影） */
.van-tabbar{ height:56px; background:#fff; border-top:1px solid rgba(0,0,0,.04); box-shadow:0 -2px 10px rgba(31,58,110,.04); }
.van-tabbar-item{ font-size:11px; }
.van-tabbar-item__icon{ font-size:24px; }
.van-tabbar-item__text{ font-size:11px; line-height:1; }

/* 顶部栏：品牌渐变 */
.top-nav {
  background: linear-gradient(135deg, #2b5fd9 0%, #4a8af0 100%);
  height: 48px;
  line-height: 48px;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  position: sticky;
  top: 0;
  z-index: 99;
  box-shadow: 0 2px 8px rgba(43, 95, 217, 0.18);
  letter-spacing: 1px;
}

/* 搜索 + 新增 */
.search-box {
  width: 100%;
  padding: 14px 14px 10px;
  box-sizing: border-box;
}
.search-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.search-row .el-input {
  flex: 1;
}
.search-row .el-input__inner {
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
  border: none;
  background: #fff;
  font-size: 14px;
  padding-left: 16px;
  box-shadow: 0 2px 10px rgba(31, 58, 110, 0.06);
  transition: box-shadow .15s;
}
.search-row .el-input__inner:focus {
  box-shadow: 0 2px 12px rgba(43, 95, 217, 0.12);
}
.btn-add {
  flex-shrink: 0;
  background: linear-gradient(135deg, #2b5fd9 0%, #4a8af0 100%);
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  padding: 0 18px;
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(43, 95, 217, 0.25);
}

/* 列表容器：自然流（高度由内容撑开），滚动交给 .client-root；
   底部 72px 留白用于避让固定 tabbar（原挂在 .client-root 上） */
.list-box {
  width: 100%;
  height: auto;
  overflow: visible;
  padding: 0 14px 72px;
  box-sizing: border-box;
}

/* 卡片：参考稿风格——更大圆角、更柔和阴影 */
.crm-item {
  background: #fff;
  border-radius: 16px;
  margin-bottom: 14px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(31, 58, 110, 0.07);
  border-left: 4px solid #2b5fd9;
}
.item-head {
  padding: 16px 16px 14px;
  border-bottom: 1px solid #f2f3f5;
}
.head-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.cust-id {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.cust-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2b5fd9, #4a8af0);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 3px 8px rgba(43, 95, 217, .2);
  border: 2px solid rgba(255, 255, 255, .85);
}
.cust-name {
  font-size: 15px;
  font-weight: 600;
  color: #1d2129;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.head-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.btn-edit,
.btn-detail,
.btn-more {
  font-size: 11px;
  color: #2b5fd9;
  border: 1px solid #e8ecf8;
  background: #fff;
  border-radius: 12px;
  padding: 2px 10px;
  white-space: nowrap;
  cursor: pointer;
  transition: all .15s;
}
.btn-edit:active,
.btn-detail:active,
.btn-more:active {
  background: #eef2fb;
  border-color: #b9cdf2;
}
.head-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
.cust-tip {
  font-size: 12px;
  color: #8c8f94;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 8px;
}

/* 状态标签：柔和底色 + 饱和文字 + 状态圆点（专业 SaaS 风格） */
.status-tag {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 10px 2px 8px;
  border-radius: 11px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.6;
  flex-shrink: 0;
}
.status-tag::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  flex-shrink: 0;
}
.tag-danger { background: #ffece8; color: #f53f3f; }
.tag-wait { background: #fff7e8; color: #d9760a; }
.tag-allot { background: #eef2fb; color: #2b5fd9; }
.tag-receive { background: #e8ffea; color: #00a62a; }
/* 【P32-#6】会议室订单「是否免费」标签 */
.tag-free { background: #e8f4ff; color: #0a7fd9; }
.tag-charge { background: #f2f3f5; color: #6b7280; }
/* 【P32-#6】会议室订单卡片标记行 */
.roomorder-flags { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 4px; }
.roomorder-flags .status-tag { margin: 0; }
/* 【P32-#1】销售合同卡片审核状态行 */
.contract-status-row { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 4px; }
.contract-status-row .status-tag { margin: 0; }
/* 客户列表「待接收」：高饱和实底 + 呼吸圆点，提示需尽快处理 */
.tag-pending {
  background: #ff7d00;
  color: #fff;
  padding: 2px 10px 2px 8px;
  box-shadow: 0 1px 4px rgba(255, 125, 0, .38);
}
.tag-pending::before {
  background: #fff;
  animation: ct-pending-blink 1.6s ease-in-out infinite;
}
@keyframes ct-pending-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: .25; }
}
@media (prefers-reduced-motion: reduce) {
  .tag-pending::before { animation: none; }
}

/* 展开详情 */
.item-detail {
  padding: 14px 16px;
  background: #f8f9fb;
}
.info-row {
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
}
.info-col1 {
  display: flex;
  width: 100%;
  font-size: 13px;
  line-height: 1.9;
  margin-bottom: 4px;
}
.info-col {
  display: flex;
  width: 50%;
  font-size: 13px;
  line-height: 1.9;
  margin-bottom: 4px;
  box-sizing: border-box;
  padding-right: 8px;
}
.label {
  color: #969799;
  flex-shrink: 0;
}
.html-container {
  color: #323233;
}
.record-block {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #ebeef5;
}
.record-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #1d2129;
}
.record-item {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
  background: #f2f4f7;
  padding: 8px 10px;
  border-radius: 8px;
  margin-bottom: 5px;
}

/* 表单弹层（新增/编辑 + 选择器共用） */
.form-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.form-title {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #1d2129;
  padding: 16px 0 10px;
  border-bottom: 1px solid #f2f3f5;
}
.form-body {
  flex: 1;
  overflow-y: auto;
  padding: 4px;
}
.form-divider {
  font-size: 13px;
  font-weight: 600;
  color: #2b5fd9;
  padding: 14px 16px 8px;
  margin-top: 6px;
  border-left: 3px solid #2b5fd9;
  background: #fafbfc;
}
.form-footer {
  display: flex;
  gap: 12px;
  padding: 14px 16px;
  border-top: 1px solid #f2f3f5;
}
.form-footer .van-button {
  flex: 1;
  margin: 0;
  border-radius: 8px;
}

/* 商机表单：H5 卡片分组 + 阶段 chip + 门店滚轮 */
.opp-form-body{ background:#f5f7fb; padding:12px; }
.opp-form-card{ background:#fff; border-radius:16px; box-shadow:0 2px 12px rgba(20,40,80,.06); margin-bottom:12px; padding:0 14px 10px; border-left:4px solid #2b5fd9; }
.opp-form-card .card__title{ font-size:15px; font-weight:700; padding:14px 0 10px; display:flex; align-items:center; gap:7px; }
.opp-form-card .card__title .dot{ width:7px; height:7px; border-radius:50%; background:#2b5fd9; }
.opp-form-card .van-cell{ background:transparent; padding:12px 0; }
.opp-form-card .van-cell:not(:last-child)::after{ left:0; right:0; }
.opp-form-card .van-field__label{ color:#5a6478; font-weight:600; }
.opp-form-card .van-field__control{ text-align:right; }
.opp-form-card .van-field__control input{ text-align:right; }
.opp-form-row{ padding:12px 0; border-bottom:1px solid #f2f3f5; }
.opp-form-card .opp-form-row:last-child{ border-bottom:none; }
.opp-form-label{ font-size:14px; color:#323233; font-weight:600; margin-bottom:10px; }
.opp-form-label .req{ color:#ee0a24; margin-right:2px; }

  /* 富文本块外壳 */
  .rich-block{ background:#fff; padding:10px 16px 12px; border-bottom:1px solid #f0f2f5; }
  .rich-label{ font-size:14px; color:#333; margin-bottom:8px; }
  /* ⚠️【P205 1.1.01】原 .rich-toolbar / .rich-editor 两条是给 wangEditor 宿主元素的，
     但自研 RichEditor 组件根节点同名（.rich-editor），scoped 会命中子组件根节点，
     导致高度被锁 150px、圆角错乱。改用 wangEditor 独有的 .w-e-* 类名限定作用域。 */
  .rich-block .w-e-toolbar{ border:1px solid #e6e8eb; border-bottom:none; border-radius:8px 8px 0 0; background:#fafbfc; }
  .rich-block .w-e-text-container{ height:150px; border:1px solid #e6e8eb; border-top:none; border-radius:0 0 8px 8px; overflow-y:auto; }
.stage-chips{ display:flex; flex-wrap:wrap; gap:9px; }
.stage-chip{ padding:6px 13px; border-radius:999px; border:1px solid #e1e6ef; background:#fff; font-size:13px; color:#5a6478; font-weight:600; }
.stage-chip.active{ background:#2b5fd9; color:#fff; border-color:#2b5fd9; }

.form-uploader-row {
  display: flex;
  align-items: flex-start;
  padding: 10px 16px;
  background: #fff;
}
.form-uploader-label {
  width: 90px;
  flex-shrink: 0;
  font-size: 14px;
  color: #646566;
  line-height: 32px;
}
.form-uploader-row .van-uploader {
  flex: 1;
}

/* 选择器列表项 */
.pick-search {
  padding: 12px 16px;
  border-bottom: 1px solid #f2f3f5;
}
.pick-body {
  flex: 1;
  overflow-y: auto;
}
.pick-empty {
  padding: 32px 0;
  text-align: center;
  color: #999;
  font-size: 13px;
}
.pick-item {
  padding: 14px 16px;
  border-bottom: 1px solid #f2f3f5;
}
.pick-item:active {
  background: #eef2fb;
}
.pick-name {
  font-size: 14px;
  color: #1f2328;
  font-weight: 500;
}
.pick-sub {
  margin-top: 3px;
  font-size: 12px;
  color: #9aa1ab;
}

/* ===== 客户列表头部（参考 4.1客户-全部客户.png）===== */
.customer-header {
  padding: 12px 14px;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(31, 58, 110, 0.05);
}
.customer-header-spacer {
  width: 100%;
}
.customer-list-box {
  margin-top: 20px;
}
/* 商机 / 合同：顶部 TAB 与数据块之间留 20px，与客户列表标准一致 */
.list-box--gap {
  margin-top: 20px;
}
.customer-list-box--batch {
  padding-bottom: 72px;
}
.filter-field {
  margin-bottom: 14px;
}
.filter-label {
  font-size: 13px;
  color: #4e5969;
  margin-bottom: 6px;
}
.filter-range {
  display: flex;
  align-items: center;
  gap: 8px;
}
.filter-range .van-field {
  flex: 1;
  min-width: 0;
}
.filter-tilde {
  color: #c0c4cc;
  font-size: 13px;
  flex-shrink: 0;
}
.customer-header__top {
  display: flex;
  align-items: center;
  gap: 10px;
}
.customer-header__tabs {
  display: flex;
  gap: 18px;
  margin-top: 12px;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.customer-header__tabs::-webkit-scrollbar {
  display: none;
}
.filter-status-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 8px 12px 0;
  padding: 7px 12px;
  background: #eef3ff;
  border-radius: 10px;
  font-size: 13px;
}
.filter-status-bar__txt { color: #2b5fd9; font-weight: 500; }
.filter-status-bar__clear { color: #86909c; cursor: pointer; }
.filter-status-bar__clear:active { opacity: .6; }
/* 【P204 S5】客户列表搜索条件标签集合：横向可滚 + 每条可独立移除 */
.filter-status-bar--tags {
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
}
.filter-status-bar__tags {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 6px;
  flex: 1;
  min-width: 0;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.filter-status-bar__tags::-webkit-scrollbar { display: none; }
.filter-tag {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  max-width: 78vw;
  padding: 3px 8px;
  background: #fff;
  border: 1px solid #d6e0ff;
  border-radius: 12px;
  font-size: 12px;
  color: #2b5fd9;
  line-height: 1.5;
}
.filter-tag__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.filter-tag__close {
  margin-left: 5px;
  font-size: 11px;
  color: #9aa4b2;
  cursor: pointer;
}
.filter-tag__close:active { color: #2b5fd9; }
.filter-status-bar--tags .filter-status-bar__clear {
  flex: 0 0 auto;
  padding-top: 3px;
  white-space: nowrap;
}
.customer-header__tab {
  position: relative;
  font-size: 13px;
  color: #4e5969;
  padding-bottom: 6px;
  white-space: nowrap;
  cursor: pointer;
}
.customer-header__tab--active {
  color: #2b5fd9;
  font-weight: 600;
}
.customer-header__tab--active::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  background: #2b5fd9;
  border-radius: 2px;
}
.customer-header__tab-arrow {
  margin-left: 3px;
  font-size: 10px;
  color: #8c8f94;
}
.customer-header__tab--active .customer-header__tab-arrow {
  color: #2b5fd9;
}
/* 【P204 S4】销售人员独立筛选胶囊：常驻在状态 tab 下方，与 tab 解耦 */
.customer-scope-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}
.customer-scope-bar__pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  font-size: 12px;
  color: #5b6068;
  background: #f2f3f5;
  border: 1px solid #e5e6eb;
  border-radius: 16px;
  cursor: pointer;
  transition: all .15s;
}
.customer-scope-bar__pill--on {
  color: #2b5fd9;
  background: rgba(43, 95, 217, 0.08);
  border-color: rgba(43, 95, 217, 0.35);
  font-weight: 600;
}
.customer-scope-bar__pill .el-icon-arrow-down {
  font-size: 11px;
  opacity: .7;
}
.customer-scope-bar__clear {
  font-size: 12px;
  color: #8c8f94;
  padding: 4px 6px;
  cursor: pointer;
}
.customer-scope-bar__clear:active {
  color: #2b5fd9;
}
.customer-header__left {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  cursor: pointer;
}
.customer-header__manager {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 10px;
  padding: 5px 12px;
  font-size: 13px;
  color: #2b5fd9;
  background: rgba(43, 95, 217, 0.08);
  border: 1px solid rgba(43, 95, 217, 0.25);
  border-radius: 16px;
  cursor: pointer;
}
.customer-header__manager .el-icon-user {
  font-size: 14px;
}
.customer-header__manager-label {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.customer-header__title {
  font-size: 15px;
  font-weight: 600;
  color: #1d2129;
}
.customer-header__arrow {
  font-size: 11px;
  color: #8c8f94;
}
.customer-header__search {
  flex: 1;
  min-width: 0;
}
.customer-header__search .el-input__inner {
  height: 34px;
  line-height: 34px;
  border-radius: 17px;
  border: none;
  background: #f5f6f8;
  font-size: 13px;
  padding-left: 32px;
}
.customer-header__search .el-input__inner:focus {
  background: #f0f2f5;
}
.customer-header__search .el-input__prefix {
  left: 11px;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
}
.customer-header__search .el-icon-search {
  color: #c0c4cc;
  font-size: 14px;
}
.customer-header__actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}
.customer-header__btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  font-size: 10px;
  color: #1d2129;
  cursor: pointer;
}
.customer-header__btn i {
  font-size: 18px;
  color: #4e5969;
}
.customer-header__btn--primary i {
  color: #2b5fd9;
}

/* ===== 客户列表卡片（参考 4.1客户-全部客户.png）===== */
.customer-item.crm-item {
  border-left: none;
}
.opp-item.crm-item,
.order-item.crm-item {
  border-left: none;
}
.customer-card.item-head {
  border-bottom: none;
  padding: 14px 14px 12px;
}
.customer-card__main {
  display: flex;
  gap: 14px;
}
.customer-card__content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.customer-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
.customer-card__name-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.customer-card__name {
  font-size: 15px;
  font-weight: 600;
  color: #1d2129;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.customer-card__role {
  flex-shrink: 0;
  font-size: 10px;
  color: #2b5fd9;
  background: #eef2fb;
  border: 1px solid #d6e0f5;
  border-radius: 10px;
  padding: 1px 6px;
  font-weight: 500;
}
.customer-card__row {
  font-size: 12px;
  color: #4e5969;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.customer-card__row--muted {
  color: #8c8f94;
}
/* 合同：签约/起/止 日期行（弱化，与客户端 muted 行同一层次） */
.customer-card__row--dates {
  display: flex;
  gap: 10px;
  overflow: hidden;
}
.customer-card__row--dates span {
  flex-shrink: 0;
}
/* 商机 / 合同统一：金额单独成行，弱化标签 + 强调数值 */
.customer-card__amount {
  display: flex;
  align-items: baseline;
  gap: 6px;
  font-size: 12px;
  line-height: 1.5;
  margin-top: 1px;
}
.customer-card__amount-label {
  color: #8c8f94;
  flex-shrink: 0;
}
.customer-card__amount-value {
  color: #1d2129;
  font-size: 13px;
  font-weight: 600;
}
/* 6 个阶段 TAB 时收紧间距，保证首屏能露出「失单」 */
.customer-header__tabs--scroll {
  gap: 16px;
}
.customer-card__tags {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
  overflow: hidden;
  margin-top: 2px;
}
.customer-card__tag-label {
  flex-shrink: 0;
  font-size: 10px;
  color: #8c8f94;
}
.customer-card__tag {
  flex-shrink: 0;
  font-size: 10px;
  color: #4e5969;
  background: #f2f3f5;
  border-radius: 10px;
  padding: 2px 7px;
}
.customer-card__req {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 6px;
  padding: 6px 8px;
  background: #fbf7f0;
  border: 1px solid #f0e6d6;
  border-radius: 8px;
}
/* 客户分配：批量选择 + 接收/拒绝 */
.customer-item { position: relative; }
.customer-item.batch-on { padding-left: 34px; }
.customer-item__check {
  position: absolute;
  top: 14px;
  left: 8px;
  z-index: 3;
}
.batch-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 14px;
  background: #fff;
  border-bottom: 1px solid #eee;
  font-size: 13px;
  color: #4e5969;
}
/* 【P140】批量模式二级分类（仅销售管理人员可见；普通销售不渲染） */
.batch-bar__tabs {
  flex: 0 0 100%;
  display: flex;
  gap: 8px;
  padding-bottom: 6px;
  border-bottom: 1px dashed #eef1f6;
}
.batch-bar__tab {
  flex: 1 1 0;
  text-align: center;
  padding: 6px 0;
  border-radius: 8px;
  background: #f2f5fa;
  color: #6b7787;
  font-size: 12.5px;
  font-weight: 600;
}
.batch-bar__tab--on { background: #2b5fd9; color: #fff; }
.batch-bar__count { color: #2b5fd9; font-weight: 600; }
.alloc-batch-bar {
  position: fixed;
  left: 0; right: 0; bottom: 50px;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.08);
  border-top: 1px solid #eee;
}
.alloc-batch-bar__count { font-size: 13px; color: #4e5969; }
.alloc-batch-bar__actions { display: flex; gap: 10px; }
.btn-action.is-disabled { opacity: .5; pointer-events: none; }
.assign-popup { padding: 16px 14px 18px; max-height: 70vh; display: flex; flex-direction: column; }
.assign-popup__title { font-size: 16px; font-weight: 600; color: #1d2129; margin-bottom: 8px; text-align: center; }
.assign-popup .van-cell-group { max-height: 40vh; overflow-y: auto; border-radius: 10px; }
.assign-popup__actions { display: flex; gap: 10px; margin-top: 14px; }
.assign-popup__actions .van-button { flex: 1; border-radius: 8px; }
.customer-card__req-label {
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 600;
  color: #b07d2b;
  background: #f7ecd8;
  border-radius: 8px;
  padding: 1px 6px;
  margin-top: 1px;
}
.customer-card__req-body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 2px 10px;
  font-size: 11px;
  color: #6b5a3e;
  line-height: 1.6;
}
.customer-card__req-img {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #e7dcc8;
  cursor: pointer;
}
.customer-card__actions {
  display: flex;
  gap: 12px;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #f2f3f5;
}
.btn-action {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  font-size: 11px;
  font-weight: 500;
  border-radius: 8px;
  padding: 6px 0;
  cursor: pointer;
  transition: all .15s;
  border: none;
  -webkit-appearance: none;
  appearance: none;
}
.btn-action--secondary {
  color: #2b5fd9;
  background: #eef2fb;
}
.btn-action--secondary:active {
  background: #d6e0f5;
}
.btn-action--primary {
  color: #fff;
  background: linear-gradient(135deg, #2b5fd9, #4a8af0);
  box-shadow: 0 3px 10px rgba(43, 95, 217, .2);
}
.btn-action--primary:active {
  opacity: .9;
}

/* 合同详情内嵌遮罩：全屏覆盖，返回只关闭遮罩不跳路由 */
.contract-detail-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3000;
  background: #f5f6f8;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* 会议室订单：使用时间起止在同一行 */
.form-time-range {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px;
  background: #fff;
}
.form-time-range .van-field {
  flex: 1;
}
.form-time-range__sep {
  color: #969799;
  font-size: 14px;
}

/* 会议室订单：回款计划 */
.payment-plan {
  padding: 0 16px 12px;
  background: #fff;
}
.payment-plan__row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.payment-plan__row .van-field {
  flex: 1;
}
.payment-plan__del {
  flex-shrink: 0;
}

/* 必填星号 */
.required {
  color: #ee0a24;
}

/* ===== 快捷入口 ===== */
.top-nav { position: relative; }
/* 快捷入口整页绑定可视高度，整页不滚动（去掉竖滚动条）；内容超高时仅宫格内部隐形滚动 */
.quick-entry{ background:#f5f6f8; height: calc(100vh - 56px); display:flex; flex-direction:column; overflow:hidden; }
.quick-hero{ background:linear-gradient(135deg,#2b5fd9 0%,#4a86f0 100%); color:#fff; padding:20px 16px 18px; flex-shrink:0; }
/* 【P114】快捷入口头部：与财务端 .fn2-hero 同一套规格（渐变 / 头像 / 名称 / 部门 / 角色胶囊） */
.quick-hero__top{ display:flex; align-items:center; gap:10px; }
.quick-hero__avatar{ width:44px; height:44px; border-radius:50%; background:rgba(255,255,255,.22);
  display:flex; align-items:center; justify-content:center; font-size:18px; font-weight:600; flex:0 0 44px; }
.quick-hero__id{ flex:1; min-width:0; }
.quick-hero__name{ font-size:17px; font-weight:600; }
.quick-hero__dept{ font-size:12px; opacity:.82; margin-top:3px; }
.quick-hero__role{ font-size:12px; padding:3px 10px; border-radius:12px; background:rgba(255,255,255,.22); flex:0 0 auto; }
.quick-section{ background:#fff; border-radius:16px; margin:6px 12px 0; padding:6px 6px 12px; box-shadow:0 2px 10px rgba(31,58,110,.06); flex:1; display:flex; flex-direction:column; min-height:0; overflow:hidden; }
.quick-section__tit{ font-size:13px; color:#969799; padding:12px 12px 6px; font-weight:600; flex-shrink:0; }
.quick-grid{ display:grid; grid-template-columns:repeat(3,1fr); gap:8px; padding:4px 10px 8px; flex:1; align-content:space-evenly; min-height:0; overflow-y:auto; scrollbar-width:none; -ms-overflow-style:none; }
.quick-grid::-webkit-scrollbar{ display:none; }
.quick-tile{ position:relative; background:#fafbfc; border:1px solid #ebedf0; border-radius:14px; padding:14px 6px 10px; display:flex; flex-direction:column; align-items:center; gap:6px; }
.quick-tile:active{ transform:scale(.96); background:#eef2fb; }
.quick-tile__ic{ width:44px; height:44px; border-radius:14px; background:#eef2fb; display:flex; align-items:center; justify-content:center; }
.quick-tile__ic svg{ width:24px; height:24px; stroke:#2b5fd9; fill:none; stroke-width:1.8; }
.quick-tile__label{ font-size:13px; color:#323233; font-weight:500; text-align:center; line-height:1.25; }
.quick-badge{ position:absolute; top:-4px; right:6px; background:#ee4d3c; color:#fff; font-size:10px; min-width:16px; height:16px; border-radius:8px; display:flex; align-items:center; justify-content:center; padding:0 4px; }
.quick-tip{ flex-shrink:0; font-size:12px; color:#969799; text-align:center; padding:6px 18px 10px; line-height:1.6; }
.quick-ver{ flex-shrink:0; font-size:11px; color:#c8c9cc; text-align:center; padding:0 18px 10px; line-height:1.5; }
/* 【P112】快捷入口下拉刷新：让 .van-pull-refresh 自身成为滚动容器
   （与 .msg-page / .bill-list 同口径）。依据 vant/utils/dom/scroll.getScroller：
   它从元素自身开始向上找第一个 overflow-y 命中 scroll|auto|overlay 的节点 —— 所以
   「自身 overflow-y:auto」时 scrollEl 就是自己，scrollTop 恒 0 ⇒ 下拉必然可触发。 */
.quick-entry .van-pull-refresh{
  flex:1 1 auto; min-height:0; overflow-y:auto; -webkit-overflow-scrolling:touch;
  display:flex; flex-direction:column;
}
.quick-entry .van-pull-refresh__track{ display:flex; flex-direction:column; flex:1 1 auto; min-height:0; }
/* 账号区（P46 退出登录）：不参与 .quick-section 的 flex:1，避免与宫格抢高度 */
.quick-section--acct{ flex:0 0 auto; padding:6px 6px 6px; }
.acct-list{ padding:2px 10px 4px; }
.acct-row{ display:flex; align-items:center; gap:12px; padding:12px 10px; border-radius:12px; background:#fafbfc; border:1px solid #ebedf0; }
.acct-row:active{ transform:scale(.99); background:#eef2fb; }
.acct-row__ic{ width:34px; height:34px; border-radius:11px; background:#eef2fb; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
.acct-row__ic svg{ width:19px; height:19px; stroke:#2b5fd9; fill:none; stroke-width:1.8; stroke-linecap:round; stroke-linejoin:round; }
.acct-row__txt{ flex:1; min-width:0; display:flex; flex-direction:column; gap:3px; }
.acct-row__label{ font-size:14px; font-weight:600; color:#323233; }
.acct-row__sub{ font-size:11.5px; color:#969799; }
.acct-row__arrow{ color:#c8c9cc; font-size:14px; flex-shrink:0; }
/* 【P92】原 .quick-bill-* 简易卡样式已废弃（全站仅 6 行、无搜索/合计/详情/编辑，状态标签写死 tag-allot）
   快捷入口 8 类单据改由 components/BillList.vue + assets/css/bill-list.css 统一渲染，
   与合同详情内的同名单据列表骨架完全一致 */
.empty-tip{ text-align:center; color:#969799; padding:40px 0; font-size:13px; }
.top-nav__back{ position:absolute; left:12px; top:0; height:48px; display:flex; align-items:center; font-size:20px; color:#fff; }
/* ===== 统计报表 ===== */
.stat-page-wrap{ display:flex; flex-direction:column; height:calc(100vh - 56px); background:#f5f6f8; overflow:hidden; }
.stat-nav{ position:sticky; top:0; z-index:5; background:#fff; color:#323233; box-shadow:0 1px 4px #eee; }
.stat-nav .top-nav__back{ color:#323233; }
.stat-filter{ background:#fff; border-top:1px solid #f0f1f3; border-bottom:1px solid #f0f1f3; padding:10px 12px; }
.stat-filter__row{ display:flex; align-items:flex-start; margin-bottom:8px; }
.stat-filter__row:last-child{ margin-bottom:0; }
.stat-filter__lab{ font-size:12px; color:#969799; width:32px; flex:none; line-height:28px; }
.stat-chips{ display:flex; flex-wrap:wrap; gap:8px; flex:1; }
.stat-chip{ font-size:12px; color:#646566; background:#f2f3f5; border-radius:14px; padding:5px 12px; line-height:1; }
.stat-chip.on{ color:#fff; background:#2b5fd9; }
.stat-person{ display:flex; align-items:center; background:#f6f8fc; border:1px solid #e3e9f5; border-radius:12px; padding:11px 14px; cursor:pointer; }
.stat-person__lab{ font-size:12px; color:#969799; margin-right:8px; }
.stat-person__val{ font-size:14px; font-weight:600; color:#2b5fd9; flex:1; }
.stat-person__chev{ color:#c0c4cc; font-size:13px; }
.stat-body{ flex:1; overflow-y:auto; padding:12px; -webkit-overflow-scrolling:touch; }
/* 【P112】统计报表下拉刷新：把「滚动」从 .stat-body 上移到 .van-pull-refresh，
   否则 pull-refresh 会以 .stat-body 作为 scrollEl，头部下拉动画与列表滚动容易打架。 */
.stat-page-wrap .van-pull-refresh{ flex:1 1 auto; min-height:0; overflow-y:auto; -webkit-overflow-scrolling:touch; }
.stat-page-wrap .stat-body{ flex:none; overflow:visible; }
.stat-loading{ display:flex; justify-content:center; margin:40px auto; }
.stat-sec{ background:#fff; border:1px solid #ebedf0; border-radius:14px; padding:14px; margin-bottom:12px; }
.stat-sec__tit{ font-size:14px; color:#323233; font-weight:600; margin-bottom:12px; padding-left:9px; position:relative; display:flex; align-items:center; }
.stat-sec__tit::before{ content:""; position:absolute; left:0; top:3px; bottom:3px; width:3px; border-radius:2px; background:#2b5fd9; }
.stat-sec__tip{ font-size:11px; color:#969799; font-weight:400; margin-left:auto; }
.stat-cards{ display:grid; grid-template-columns:repeat(2,1fr); gap:10px; }
.stat-card{ background:#f7f9fc; border:1px solid #ebedf0; border-radius:12px; padding:12px 12px 14px; }
.stat-card__value{ font-size:18px; font-weight:700; color:#2b5fd9; line-height:1.2; }
.stat-card__value.is-pct{ color:#22b07d; }
.stat-card__unit{ font-size:11px; font-weight:600; margin-left:1px; font-style:normal; }
.stat-card__label{ font-size:12px; color:#969799; margin-top:5px; }
.stat-card__bar{ height:4px; border-radius:3px; background:#e9edf3; margin-top:8px; overflow:hidden; }
.stat-card__bar span{ display:block; height:100%; background:#22b07d; border-radius:3px; }
/* 月份对比 v2 */
.mc-list{ display:flex; flex-direction:column; gap:12px; }
.mc-row{ display:flex; align-items:center; gap:10px; }
.mc-month{ width:40px; flex:none; font-size:12px; color:#646566; font-weight:600; }
.mc-main{ flex:1; min-width:0; display:flex; flex-direction:column; gap:5px; }
.mc-line{ display:flex; align-items:center; gap:6px; height:16px; }
.mc-label{ width:28px; flex:none; font-size:10px; color:#969799; }
.mc-track{ flex:1; min-width:0; height:7px; background:#eef0f3; border-radius:4px; overflow:hidden; }
.mc-track i{ display:block; height:100%; border-radius:4px; }
.mc-track .bar-t{ background:#c2c8d1; }
.mc-track .bar-s{ background:linear-gradient(90deg,#4b7ff7,#2b5fd9); }
.mc-val{ width:56px; flex:none; text-align:right; font-size:11px; color:#323233; font-weight:600; font-variant-numeric:tabular-nums; }
.mc-badge{ width:58px; flex:none; text-align:right; }
.mc-pct{ display:inline-block; font-size:10px; font-weight:700; padding:2px 6px; border-radius:999px; white-space:nowrap; }
.mc-pct.ok{ color:#22b07d; background:#e6f7f0; }
.mc-pct.warn{ color:#f5a623; background:#fdf2e2; }
.mc-pct.danger{ color:#e94752; background:#fdeaea; }
.mc-pct.gray{ color:#969799; background:#f4f6fa; }

/* 排行榜行（销售人员目标/商机） */
.rank-list{ display:flex; flex-direction:column; gap:11px; }
.rank-row{ display:flex; align-items:center; gap:8px; }
.rank-idx{ width:20px; height:20px; border-radius:50%; display:flex; align-items:center; justify-content:center; font-size:10px; font-weight:700; color:#969799; background:#f4f6fa; flex:none; }
.rank-idx.gold{ background:#fff3d6; color:#dca11b; }
.rank-idx.silver{ background:#eef1f6; color:#7a8ba6; }
.rank-idx.bronze{ background:#fbebe0; color:#c47b4a; }
.rank-name{ width:110px; flex:none; font-size:13px; color:#1f2533; font-weight:600; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.rank-barwrap{ flex:1; min-width:0; display:flex; align-items:center; gap:8px; }
.rank-track{ flex:1; min-width:0; height:10px; background:#eef0f3; border-radius:5px; overflow:hidden; }
.rank-track i{ display:block; height:100%; border-radius:5px; background:linear-gradient(90deg,#5b8def,#2b5fd9); }
.rank-track.o i{ background:linear-gradient(90deg,#f7c663,#f5a623); }
.rank-val{ width:58px; flex:none; text-align:right; font-size:13px; color:#323233; font-weight:700; font-variant-numeric:tabular-nums; }

/* 漏斗/分布等横向条（保持结构，优化对齐） */
.stat-hbars{ display:flex; flex-direction:column; gap:10px; }
.stat-hbar{ display:flex; align-items:center; gap:8px; }
.stat-hbar__name{ width:110px; flex:none; font-size:13px; color:#1f2533; font-weight:600; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.stat-hbar__fill{ height:10px; border-radius:5px; background:#2b5fd9; flex:none; min-width:2px; }
.stat-hbar__fill.bar-f{ background:#5b8def; }
.stat-hbar__fill.bar-f2{ background:#22b07d; }
.stat-hbar__fill.bar-o{ background:#f5a623; }
.stat-hbar b{ width:58px; flex:none; text-align:right; font-size:13px; color:#323233; font-weight:700; font-variant-numeric:tabular-nums; }
.stat-stack{ display:flex; height:22px; border-radius:6px; overflow:hidden; background:#eef0f3; }
.stat-stack__seg{ height:100%; }
.stat-legend{ display:flex; flex-wrap:wrap; gap:10px 14px; margin-top:10px; }
.stat-legend__it{ display:flex; align-items:center; font-size:12px; color:#646566; }
.stat-legend__it i{ width:10px; height:10px; border-radius:3px; margin-right:5px; display:inline-block; }
.stat-donut-row{ display:flex; align-items:center; gap:14px; }
.stat-donut{ width:96px; height:96px; border-radius:50%; flex:none; position:relative; }
.stat-donut::after{ content:""; position:absolute; inset:26px; background:#fff; border-radius:50%; }
.stat-note{ font-size:12px; color:#969799; padding:6px 2px 14px; line-height:1.6; }

/* 合同执行 · 四流合一 */
.cf-sum{ display:flex; gap:6px; margin-bottom:12px; }
.cf-sum .s{ flex:1; min-width:0; background:#f7f9fc; border:1px solid #ebedf0; border-radius:10px; padding:8px 6px; text-align:center; }
.cf-sum .s .n{ font-size:14px; font-weight:700; color:#323233; }
.cf-sum .s.ok .n{ color:#22b07d; }
.cf-sum .s.warn .n{ color:#f5a623; }
.cf-sum .s.danger .n{ color:#e94752; }
.cf-sum .s .l{ font-size:11px; color:#969799; margin-top:2px; }
.cf-tag{ font-size:11px; padding:2px 8px; border-radius:999px; background:#eaf1ff; color:#2b5fd9; font-weight:500; }
.crm-item .cf-top{ display:flex; justify-content:space-between; align-items:center; margin-bottom:2px; }
.crm-item .cf-cust{ font-size:15px; font-weight:600; color:#1f2533; }
.crm-item .cf-sn{ font-size:11px; color:#969799; font-family:monospace; margin-bottom:2px; }
.crm-item .cf-amt{ font-size:19px; font-weight:700; color:#2b5fd9; margin:2px 0 10px; }
.crm-item .cf-amt small{ font-size:12px; color:#969799; font-weight:400; }
.crm-item .cf-flow{ display:flex; align-items:center; gap:6px; margin:6px 0; font-size:13px; }
.crm-item .cf-lab{ width:42px; flex:none; color:#969799; }
.crm-item .cf-bar{ flex:1; height:8px; background:#eef0f3; border-radius:6px; overflow:hidden; }
.crm-item .cf-bar > i{ display:block; height:100%; border-radius:6px; }
.crm-item .cf-bar.paid > i{ background:#22b07d; }
.crm-item .cf-bar.inv > i{ background:#f5a623; }
.crm-item .cf-v{ width:78px; flex:none; text-align:right; color:#323233; font-weight:500; }
.crm-item .cf-metrics{ display:flex; gap:8px; margin-top:10px; }
.crm-item .cf-m{ flex:1; min-width:0; background:#f7f9fc; border:1px solid #ebedf0; border-radius:10px; padding:7px 4px; text-align:center; }
.crm-item .cf-m .n{ font-size:13px; font-weight:700; color:#323233; }
.crm-item .cf-m .l{ font-size:10px; color:#969799; margin-top:2px; }
.crm-item .cf-m.ok .n{ color:#22b07d; }
.crm-item .cf-m.warn .n{ color:#f5a623; }
.crm-item .cf-m.danger .n{ color:#e94752; }
.cf-more{ text-align:center; margin-top:8px; }
.cf-more__btn{ display:inline-block; font-size:13px; color:#2b5fd9; background:#eaf1ff; border-radius:14px; padding:7px 18px; cursor:pointer; }
.crm-item.is-open{ box-shadow:0 8px 22px rgba(43,95,217,.16); border-color:#c9d8ff; }
.cf-caret{ width:18px; height:18px; flex:none; margin-left:6px; position:relative; transition:transform .2s ease; }
.cf-caret::after{ content:""; position:absolute; top:3px; left:5px; width:7px; height:7px; border-right:2px solid #969799; border-bottom:2px solid #969799; transform:rotate(45deg); }
.cf-caret.up{ transform:rotate(180deg); }
.cf-detail{ margin-top:12px; border-top:1px dashed #e6e9ef; padding-top:10px; }
.cf-dblock{ margin-bottom:12px; }
.cf-dblock:last-child{ margin-bottom:0; }
.cf-dh{ display:flex; justify-content:space-between; align-items:center; font-size:13px; font-weight:600; color:#1f2533; margin-bottom:6px; }
.cf-damt{ color:#22b07d; font-weight:700; }
.cf-damt.danger{ color:#e94752; }
.cf-dempty{ font-size:12px; color:#969799; padding:4px 0 6px; }
.cf-drow{ background:#f7f9fc; border:1px solid #ebedf0; border-radius:9px; padding:7px 9px; margin-bottom:6px; }
.cf-dr1{ display:flex; align-items:center; gap:8px; }
.cf-dsn{ font-size:11px; color:#969799; font-family:monospace; flex:1; min-width:0; }
.cf-it{ font-size:11px; color:#646566; background:#eef1f6; border-radius:6px; padding:1px 6px; flex:none; }
.cf-dr2{ display:flex; align-items:center; gap:10px; margin-top:4px; font-size:12px; color:#646566; }
.cf-dr2 > span:first-child{ color:#969799; }
.cf-dm{ flex:1; min-width:0; }
.cf-dbuyer{ flex:1; min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.cf-da{ margin-left:auto; font-weight:600; color:#323233; }
.cf-da.danger{ color:#e94752; }
.cf-st{ font-size:11px; font-weight:500; border-radius:999px; padding:1px 8px; flex:none; }
.cf-st.ok{ color:#22b07d; background:#e6f7f0; }
.cf-st.warn{ color:#f5a623; background:#fdf2e2; }
.cf-st.danger{ color:#e94752; background:#fdeaea; }
.cf-dl{ font-size:12px; color:#969799; padding:6px 0; text-align:center; }

/* ===== 客户详情 子视图 ===== */
/* ===== 客户详情 子视图（精修 v2） ===== */
.cust-detail-pop{ background:#f4f6fa; }
.cust-detail{ position:relative; display:flex; flex-direction:column; height:100%; box-sizing:border-box; }
.cust-detail__nav{ height:48px; display:flex; align-items:center; padding:0 10px; background:#fff; box-shadow:0 1px 0 #eef0f4; flex:0 0 auto; }
.cust-detail__back{ font-size:16px; color:#323233; width:72px; cursor:pointer; }
.cust-detail__title{ flex:1; text-align:center; font-size:17px; font-weight:600; }
.cust-detail__spacer{ width:72px; }
.cust-detail__action{ width:72px; text-align:right; color:#2b5fd9; font-size:15px; font-weight:600; }
.cust-detail__body{ flex:1; overflow:auto; padding:0 0 84px; box-sizing:border-box; }
.cust-detail__loading{ padding:40px; text-align:center; color:#969799; font-size:14px; }

/* hero 头部 */
.cust-hero{ background:linear-gradient(135deg,#2b5fd9,#5b86e8); color:#fff; border-radius:18px; padding:18px 16px; margin:12px 12px 0; box-shadow:0 8px 20px rgba(43,95,217,.28); }
.cust-hero__name{ font-size:19px; font-weight:700; line-height:1.25; }
.cust-hero__code{ font-size:12px; opacity:.85; margin-top:3px; }
.cust-hero__tags{ margin-top:13px; display:flex; gap:8px; flex-wrap:wrap; }
.pill{ background:rgba(255,255,255,.16); color:#fff; font-size:12px; padding:4px 11px; border-radius:20px; font-weight:500; border:1px solid rgba(255,255,255,.26); }

/* 卡片 */
.card{ background:#fff; border-radius:16px; box-shadow:0 2px 12px rgba(20,40,80,.06); margin:12px; padding:15px; }
.card__title{ font-size:14px; font-weight:700; display:flex; align-items:center; gap:7px; margin-bottom:12px; }
.card__title .dot{ width:7px; height:7px; border-radius:50%; background:#2b5fd9; }

/* 信息列表（scoped 到详情）单列对齐布局：标签右对齐 + 值左对齐 */
.cust-detail .info-list{ display:flex; flex-direction:column; gap:13px; }
.cust-detail .info-item{ display:flex; align-items:flex-start; gap:10px; }
.cust-detail .info-item__label{ flex:0 0 80px; font-size:13px; color:#8a909c; line-height:1.45; text-align:right; padding-top:1px; }
.cust-detail .info-item__value{ flex:1; min-width:0; font-size:14px; color:#1f2329; font-weight:500; line-height:1.45; word-break:break-word; }
.cust-detail .info-item__value.empty{ color:#c0c4cc; font-weight:400; }
.cust-detail .info-item--remark .info-item__value{ line-height:1.55; color:#323233; }

/* 区块标题 */
.sec{ display:flex; align-items:center; justify-content:space-between; padding:6px 16px 0; }
.sec__title{ font-size:15px; font-weight:700; display:flex; align-items:center; gap:8px; }
.sec__title .bar{ width:4px; height:16px; border-radius:3px; background:#2b5fd9; }
.sec__count{ font-size:12px; color:#8a909c; background:#f4f6fa; padding:3px 10px; border-radius:20px; }

/* 空态 */
.empty{ text-align:center; color:#8a909c; font-size:13px; padding:14px; }

/* 联系人 */
.contact{ display:flex; gap:12px; align-items:flex-start; }
.contact__avatar{ width:42px; height:42px; border-radius:13px; background:#f1ecff; color:#7c5cf6; display:flex; align-items:center; justify-content:center; font-weight:700; font-size:17px; flex:0 0 auto; }
.contact__main{ flex:1; min-width:0; }
.contact__name{ font-size:15px; font-weight:700; display:flex; align-items:center; gap:6px; }
.contact__name-txt{ flex:1; min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.contact__caret{ flex:0 0 auto; color:#aab0bb; font-size:14px; transition:transform .2s ease; }
.contact__caret.up{ transform:rotate(180deg); color:#7c5cf6; }
.contact__detail{ margin-top:11px; padding-top:11px; border-top:1px dashed #ebedf0; }
.contact__detail-empty{ font-size:12px; color:#aeb4bf; padding:1px 0; }
.contact__sub{ font-size:12px; color:#8a909c; margin-top:2px; }
.contact__rows{ margin-top:9px; display:flex; flex-direction:column; gap:7px; }
.contact__row{ display:flex; align-items:center; gap:9px; font-size:13px; color:#3a4150; }
.contact__row .ic{ font-size:14px; color:#9098a5; flex:0 0 auto; width:16px; text-align:center; }
.tag-imp{ background:#fff0f0; color:#e54d42; font-size:11px; padding:2px 8px; border-radius:20px; font-weight:600; }

/* 回访 */
.visit__head{ display:flex; justify-content:space-between; align-items:center; gap:10px; }
.visit__title{ font-size:15px; font-weight:700; }
.visit__date{ font-size:12px; color:#8a909c; background:#f4f6fa; padding:3px 11px; border-radius:20px; flex:0 0 auto; }
.visit__who{ font-size:12px; color:#8a909c; margin-top:7px; }
.visit__content{ margin-top:9px; background:#f4f6fa; border-radius:10px; padding:10px 12px; font-size:13px; color:#3a4150; line-height:1.55; word-break:break-word; }
.visit__next{ margin-top:9px; font-size:13px; color:#8a909c; font-weight:500; display:flex; align-items:center; gap:5px; }
.visit__next .ic{ font-size:13px; }

/* 卡片操作（编辑 / 删除） */
.card__actions{ display:flex; gap:10px; margin-top:12px; padding-top:11px; border-top:1px solid #f0f1f3; }
.card__actions .act{ flex:1; display:flex; align-items:center; justify-content:center; gap:4px; padding:9px 0; border-radius:10px; font-size:13px; font-weight:600; border:1px solid #ebedf0; background:#fafbfc; cursor:pointer; -webkit-appearance:none; appearance:none; }
.card__actions .act:active{ transform:scale(.97); }
.card__actions .act--edit{ color:#2b5fd9; border-color:#dbe6ff; background:#f4f8ff; }
.card__actions .act--del{ color:#e54d42; border-color:#ffdcd6; background:#fff5f4; }

/* 手机版日期选择器触发（替换原生 input[type=date]） */
.f-date-trigger{ position:relative; min-height:44px; display:flex; align-items:center; padding:0 14px; border-radius:10px; background:#f5f6f8; font-size:14px; color:#1f2329; cursor:pointer; }
.f-date-trigger.is-empty{ color:#b7bcc4; }
.f-date-trigger::after{ content:'›'; position:absolute; right:12px; top:50%; transform:translateY(-50%) rotate(90deg); color:#c0c4cc; font-size:16px; }

/* 删除确认弹层 */
/* 删除确认弹窗已全站统一到 components/ConfirmDialog.vue（居中弹窗），
   原 .confirm-sheet 底部弹层样式（3 套并存）已下线，勿再启用。 */

/* 底部操作栏 */
.cust-detail__bar{ position:absolute; left:0; right:0; bottom:0; display:flex; gap:8px; padding:10px; background:#fff; box-shadow:0 -2px 10px rgba(0,0,0,.05); flex:0 0 auto; }
/* 详情底部按钮改小（客户/商机详情共用） */
.cust-detail__bar .btn{ flex:1; display:flex; align-items:center; justify-content:center; gap:4px; padding:8px 0; border-radius:18px; font-size:13px; font-weight:600; border:none; -webkit-appearance:none; appearance:none; cursor:pointer; }
.btn--primary{ background:#2b5fd9; color:#fff; }
.btn--secondary{ background:#eaf1ff; color:#2b5fd9; }
/* 【P125】详情页「拒绝」按钮 + 操作中禁用态 */
.btn--danger{ background:#fdeaea; color:#e23b3b; }
.cust-detail__bar .btn:disabled{ opacity:.55; cursor:not-allowed; }

/* ===== 表单弹层（添加联系人 / 回访，交互保持不变） ===== */
.form-sheet{ display:flex; flex-direction:column; max-height:88%; }
.form-sheet__head{ display:flex; align-items:center; justify-content:space-between; padding:14px 16px 8px; border-bottom:1px solid #f0f2f5; flex:0 0 auto; }
.form-sheet__title{ font-size:17px; font-weight:700; }
.form-sheet__close{ font-size:24px; color:#9aa1ad; cursor:pointer; line-height:1; }
.form-sheet__body{ padding:8px 16px; overflow:auto; flex:1; }
.form-sheet__bar{ display:flex; gap:10px; padding:12px 16px; flex:0 0 auto; border-top:1px solid #f0f2f5; }
.form-sheet__bar .btn-action{ padding:13px 0; font-size:15px; font-weight:600; border-radius:10px; }
.field{ margin:14px 0; }
.field label{ display:block; font-size:13px; color:#5a6170; margin-bottom:7px; }
.field .req{ color:#e54d42; }
.f-input{ width:100%; border:1px solid #e6e9ef; border-radius:10px; padding:10px 12px; font-size:14px; background:#fbfcfe; color:#1f2329; outline:none; box-sizing:border-box; }
.f-input:focus{ border-color:#2b5fd9; background:#fff; }
.f-textarea{ width:100%; border:1px solid #e6e9ef; border-radius:10px; padding:10px 12px; font-size:14px; background:#fbfcfe; color:#1f2329; outline:none; box-sizing:border-box; resize:vertical; min-height:70px; font-family:inherit; }
.f-textarea:focus{ border-color:#2b5fd9; background:#fff; }
.row2{ display:flex; gap:10px; }
.row2 .field{ flex:1; }
.seg{ display:flex; gap:8px; }
.seg span{ flex:1; text-align:center; padding:10px 0; border:1px solid #e6e9ef; border-radius:10px; font-size:14px; background:#fbfcfe; cursor:pointer; }
.seg span.on{ background:#eaf2ff; border-color:#2b5fd9; color:#2b5fd9; font-weight:600; }
.switch{ display:flex; align-items:center; gap:8px; }
.switch .track{ width:44px; height:26px; border-radius:13px; background:#d6dae2; position:relative; transition:.2s; cursor:pointer; flex:0 0 auto; }
.switch .track.on{ background:#2b5fd9; }
.switch .dot{ position:absolute; top:3px; left:3px; width:20px; height:20px; border-radius:50%; background:#fff; transition:.2s; }
.switch .track.on .dot{ left:21px; }
.switch-tip{ font-size:13px; color:#969799; }

/* ===== 商机漏斗统计（右滑） ===== */
.opp-stat-pop{ background:#f4f6fa; }
.opp-stat{ position:relative; display:flex; flex-direction:column; height:100%; box-sizing:border-box; }
.opp-stat__nav{ height:48px; display:flex; align-items:center; padding:0 10px; background:#fff; box-shadow:0 1px 0 #eef0f4; flex:0 0 auto; }
.opp-stat__back{ font-size:16px; color:#323233; width:72px; cursor:pointer; }
.opp-stat__title{ flex:1; text-align:center; font-size:17px; font-weight:600; }
.opp-stat__spacer{ width:72px; }
.opp-stat__body{ flex:1; overflow:auto; padding:0 0 24px; box-sizing:border-box; }
.opp-stat__loading{ padding:40px; text-align:center; color:#969799; font-size:14px; }

/* hero 三宫格 */
.opp-hero{ background:linear-gradient(135deg,#2b5fd9,#5b86e8); color:#fff; border-radius:18px; padding:16px 12px; margin:12px 12px 0; box-shadow:0 8px 20px rgba(43,95,217,.28); display:flex; }
.opp-hero__cell{ flex:1; text-align:center; position:relative; }
.opp-hero__cell + .opp-hero__cell::before{ content:""; position:absolute; left:0; top:14%; height:72%; width:1px; background:rgba(255,255,255,.25); }
.opp-hero__num{ font-size:22px; font-weight:800; line-height:1.1; }
.opp-hero__num--green{ color:#ffe27a; }
.opp-hero__label{ font-size:12px; opacity:.9; margin-top:6px; }

/* 漏斗条 */
.opp-funnel .fbar{ padding:10px 14px 12px; }
.fbar + .fbar{ border-top:1px solid #f0f2f6; }
.fbar__head{ display:flex; justify-content:space-between; align-items:center; }
.fbar__label{ font-size:15px; font-weight:600; color:#2c3340; }
.fbar__cnt{ font-size:13px; color:#6b7280; }
.fbar__track{ height:10px; border-radius:6px; background:#eef1f6; margin:8px 0 6px; overflow:hidden; }
.fbar__fill{ height:100%; border-radius:6px; transition:width .4s ease; min-width:4px; }
.fbar--1 .fbar__fill{ background:linear-gradient(90deg,#2b5fd9,#5b86e8); }
.fbar--2 .fbar__fill{ background:linear-gradient(90deg,#3d7be0,#7aa6f0); }
.fbar--3 .fbar__fill{ background:linear-gradient(90deg,#7c5cf6,#a78bfa); }
.fbar--4 .fbar__fill{ background:linear-gradient(90deg,#1aa260,#43c98a); }
.fbar__meta{ display:flex; justify-content:space-between; font-size:12px; color:#969799; }
.fbar__conv{ color:#2b5fd9; font-weight:600; }

/* 失单条 */
.opp-lost{ padding:6px 14px 12px; }
.lbar{ padding:8px 0; }
.lbar + .lbar{ border-top:1px solid #f0f2f6; }
.lbar__head{ display:flex; justify-content:space-between; font-size:13px; color:#4a5160; margin-bottom:6px; }
.lbar__track{ height:9px; border-radius:6px; background:#fbe9eb; overflow:hidden; }
.lbar__fill{ height:100%; border-radius:6px; background:linear-gradient(90deg,#e94752,#f4747f); }

/* 合同统计 hero：2×3 宫格 */
.ct-hero{ background:linear-gradient(135deg,#1f9d6b,#43c98a); color:#fff; border-radius:18px; padding:14px 6px; margin:12px 12px 0; box-shadow:0 8px 20px rgba(31,157,107,.28); display:flex; flex-wrap:wrap; }
.ct-hero__cell{ width:33.333%; text-align:center; padding:8px 0; box-sizing:border-box; position:relative; }
.ct-hero__cell:nth-child(3n+1)::after, .ct-hero__cell:nth-child(3n+2)::after{ content:""; position:absolute; right:0; top:18%; height:64%; width:1px; background:rgba(255,255,255,.22); }
.ct-hero__num{ font-size:19px; font-weight:800; line-height:1.15; word-break:break-all; }
.ct-hero__num--green{ color:#ffe27a; }
.ct-hero__label{ font-size:11px; opacity:.92; margin-top:5px; }

/* 合同 vs 订单业绩 对比 */
.ct-compare{ padding:6px 14px 12px; }
.ct-compare__row{ display:flex; justify-content:space-between; align-items:center; padding:9px 0; font-size:14px; color:#2c3340; }
.ct-compare__row + .ct-compare__row{ border-top:1px solid #f0f2f6; }
.ct-compare__row b{ font-size:16px; font-weight:800; color:#1f9d6b; }
.ct-compare__row--muted{ color:#969799; font-size:13px; }
.ct-compare__row--muted span{ font-weight:600; }

/* ===== 商机详情 hero ===== */
/* 商机详情页顶部 hero（限定 .cust-detail 内，避免被统计页 .opp-hero display:flex 污染） */
.cust-detail .opp-hero{ background:linear-gradient(135deg,#3b6ff0,#2b5fd9); border-radius:18px; padding:18px 16px; margin:12px 12px 0; color:#fff; box-shadow:0 8px 22px rgba(43,95,217,.32); position:relative; overflow:hidden; display:flex; flex-direction:column; }
.cust-detail .opp-hero:after{ content:""; position:absolute; right:-40px; top:-40px; width:160px; height:160px; background:rgba(255,255,255,.08); border-radius:50%; z-index:0; }
.cust-detail .opp-hero__cust{ display:inline-block; background:rgba(255,255,255,.18); padding:3px 10px; border-radius:999px; font-size:12px; align-self:flex-start; position:relative; z-index:1; }
.cust-detail .opp-hero__name{ font-size:19px; font-weight:700; margin:12px 0 3px; letter-spacing:.3px; line-height:1.3; word-break:break-all; position:relative; z-index:1; }
.cust-detail .opp-hero__code{ font-size:12px; opacity:.85; margin-top:3px; position:relative; z-index:1; }
.cust-detail .opp-hero__row{ display:flex; align-items:flex-end; justify-content:space-between; margin-top:14px; position:relative; z-index:1; }
.cust-detail .opp-hero__amount{ font-size:26px; font-weight:800; font-variant-numeric:tabular-nums; letter-spacing:.5px; }
.cust-detail .opp-hero__amount small{ font-size:14px; font-weight:500; opacity:.85; margin-right:2px; }
.cust-detail .opp-hero__exact{ font-size:11px; opacity:.8; margin-top:3px; font-variant-numeric:tabular-nums; }
.cust-detail .opp-hero .status-tag{ flex-shrink:0; margin-bottom:2px; }

/* 金额高亮 */
.cust-detail .info-item__value.amt{ color:#2b5fd9; font-weight:700; font-variant-numeric:tabular-nums; }
.cust-detail .info-item__value .exact{ font-size:11px; color:#8a909c; font-weight:400; margin-left:5px; }

/* 底部删除按钮 */
.cust-detail__bar .opp-del{ background:#fff5f4; color:#e54d42; }
/* 【P439】客户详情「删除客户」：图标按钮（固定宽，不参与 flex:1 均分，避免 4 个文字按钮在 375px 屏挤爆） */
.cust-detail__bar .btn--icon-del{ flex:0 0 40px; padding:0; background:#fff5f4; color:#e54d42; }
.cust-detail__bar .btn--icon-del svg{
  width:18px; height:18px; fill:none; stroke:currentColor;
  stroke-width:1.6; stroke-linecap:round; stroke-linejoin:round;
}
.cust-detail__bar .btn--icon-del:active{ background:#ffe6e2; }

/* 时间线 */
.tl{ position:relative; padding:6px 0 8px 4px; }
.tl-item{ position:relative; padding:0 0 20px 26px; }
.tl-item:before{ content:""; position:absolute; left:7px; top:18px; bottom:-4px; width:2px; background:#eef1f7; }
.tl-item:last-child:before{ display:none; }
.tl .dot{ position:absolute; left:0; top:3px; width:16px; height:16px; border-radius:50%; background:#fff; border:3px solid #8a93a6; z-index:1; box-sizing:border-box; }
.tl .dot.s1{ border-color:#5b7bd6; }
.tl .dot.s2{ border-color:#5b7bd6; }
.tl .dot.s3{ border-color:#e08c1a; }
.tl .dot.s4{ border-color:#16a34a; }
.tl .dot.s5{ border-color:#e23b3b; }
.tl-item.cur .dot{ width:18px; height:18px; box-shadow:0 0 0 4px rgba(43,95,217,.15); }
.tl-item.cur .dot.s3{ background:#e08c1a; }
.tl-item.cur .dot.s4{ background:#16a34a; }
.tl-item.cur .dot.s5{ background:#e23b3b; }
.tl-name{ font-size:14.5px; font-weight:700; color:#1f2533; display:flex; align-items:center; gap:8px; }
.tl-time{ font-size:12.5px; color:#8a93a6; margin-top:3px; }
.cur-badge{ font-size:11px; font-weight:700; color:#fff; background:#2b5fd9; padding:1px 8px; border-radius:999px; }
.tl-empty{ font-size:13px; color:#8a93a6; padding:6px 0 10px; }

/* ===== 变更记录 时间线 弹层 ===== */
.changelog{ display:flex; flex-direction:column; height:100%; background:#f4f6fb; }
.changelog__nav{ display:flex; align-items:center; height:48px; padding:0 12px; background:#fff; border-bottom:1px solid #eef1f7; flex:0 0 auto; }
.changelog__back{ font-size:15px; color:#2b5fd9; cursor:pointer; }
.changelog__title{ flex:1; text-align:center; font-size:16px; font-weight:700; color:#1f2533; }
.changelog__spacer{ width:48px; }
.changelog__body{ flex:1; overflow-y:auto; padding:12px 14px 24px; }

/* ===== 【P122】变更记录 · 重做（独立 cl-* 命名空间，不复用旧 .tl* 以免影响别处） ===== */
.chg-pop{ background:#f5f7fb; }
.cl{ display:flex; flex-direction:column; height:100%; background:#f5f7fb; }
.chg__nav{ display:flex; align-items:center; height:52px; padding:0 14px; background:#fff; flex:0 0 auto; box-shadow:0 1px 0 rgba(16,24,40,.05); z-index:2; }
.chg__back{ width:32px; height:32px; border-radius:10px; display:flex; align-items:center; justify-content:center; color:#2b5fd9; font-size:17px; background:#f0f4fd; cursor:pointer; }
.chg__title{ flex:1; text-align:center; font-size:16.5px; font-weight:800; color:#141a26; letter-spacing:.3px; }
.chg__count{ font-size:12px; font-weight:700; color:#2b5fd9; background:#e9f0fe; padding:3px 10px; border-radius:999px; }
.chg__spacer{ width:32px; }

.chg__filter{ display:flex; gap:8px; padding:12px 14px 10px; background:#fff; flex:0 0 auto; overflow-x:auto; }
.chg__fitem{ flex:0 0 auto; font-size:13px; font-weight:600; color:#5b6577; background:#f2f5fa; border-radius:999px; padding:6px 13px; cursor:pointer; transition:all .18s; display:flex; align-items:center; gap:5px; }
.chg__fitem.is-on{ background:#2b5fd9; color:#fff; box-shadow:0 3px 10px rgba(43,95,217,.28); }
.chg__fnum{ font-size:11px; font-weight:800; background:rgba(0,0,0,.06); border-radius:999px; padding:0 6px; min-width:16px; text-align:center; }
.chg__fitem.is-on .chg__fnum{ background:rgba(255,255,255,.24); }

.chg__body{ flex:1; min-height:0; }
.chg__pr{ height:100%; overflow-y:auto; }

.chg__empty{ padding:84px 30px 60px; text-align:center; }
.chg__empty-icon{ font-size:52px; line-height:1; color:#cbd5e6; }
.chg__empty-t{ margin-top:14px; font-size:15px; font-weight:700; color:#8494a8; }
.chg__empty-s{ margin-top:6px; font-size:12.5px; color:#a9b4c6; line-height:1.7; }

.chg__group{ padding:14px 14px 0; }
.chg__day{ display:flex; align-items:center; gap:10px; margin:0 0 10px; }
.chg__day-t{ font-size:12.5px; font-weight:800; color:#5b6577; letter-spacing:.4px; flex:0 0 auto; }
.chg__day-line{ flex:1; height:1px; background:linear-gradient(90deg,#e2e8f2,rgba(226,232,242,0)); }

.chg-card{ display:flex; gap:11px; background:#fff; border-radius:14px; padding:13px 14px; margin-bottom:10px; box-shadow:0 1px 3px rgba(16,24,40,.06); border:1px solid #eef2f8; }
.chg-card__ico{ flex:0 0 auto; width:32px; height:32px; border-radius:10px; display:flex; align-items:center; justify-content:center; font-size:16px; }
.chg-card.is-add .chg-card__ico{ background:#e8f7ee; color:#16a34a; }
.chg-card.is-edit .chg-card__ico{ background:#e9f0fe; color:#2b5fd9; }
.chg-card.is-delete .chg-card__ico{ background:#fdeaea; color:#e23b3b; }
.chg-card__main{ flex:1; min-width:0; }
.chg-card__head{ display:flex; align-items:center; gap:7px; }
.chg-card__act{ font-size:11.5px; font-weight:800; padding:2px 8px; border-radius:6px; flex:0 0 auto; }
.chg-card__act.is-add{ background:#e8f7ee; color:#16a34a; }
.chg-card__act.is-edit{ background:#e9f0fe; color:#2b5fd9; }
.chg-card__act.is-delete{ background:#fdeaea; color:#e23b3b; }
.chg-card__mod{ font-size:13px; font-weight:700; color:#2b3446; }
.chg-card__time{ margin-left:auto; font-size:12px; color:#98a3b6; flex:0 0 auto; }
.chg-card__title{ margin-top:7px; font-size:13.5px; font-weight:600; color:#1f2533; word-break:break-all; }
.chg-card__who{ margin-top:5px; font-size:12px; color:#8494a8; display:flex; align-items:center; gap:4px; }
.chg-card__none{ margin-top:8px; font-size:12.5px; color:#a9b4c6; }

.chg-diff{ margin-top:9px; border-radius:10px; background:#f8fafd; padding:2px 10px; }
.chg-diff__row{ display:flex; align-items:flex-start; gap:10px; font-size:12.5px; padding:8px 0; border-top:1px dashed #e8edf5; }
.chg-diff__row:first-child{ border-top:none; }
.chg-diff__f{ flex:0 0 66px; color:#8494a8; font-weight:600; line-height:1.55; }
.chg-diff__vals{ flex:1; min-width:0; display:flex; align-items:center; gap:7px; flex-wrap:wrap; line-height:1.55; }
.chg-diff__b{ color:#a3adbf; text-decoration:line-through; word-break:break-all; }
.chg-diff__ar{ font-size:11px; color:#c2cbdb; flex:0 0 auto; }
.chg-diff__a{ color:#0f7b3f; font-weight:700; word-break:break-all; }
/* 新增：值用正文色（不是「变化」故不用绿色强调），并弱化左侧字段名 */
.chg-diff__row.is-add .chg-diff__a{ color:#243044; font-weight:600; }
.chg-diff__row.is-add .chg-diff__f{ color:#9aa5b8; }

.chg-snap{ margin-top:9px; border-radius:10px; background:#fdf7f7; border:1px dashed #f3d5d5; padding:9px 11px; }
.chg-snap__h{ font-size:11.5px; font-weight:800; color:#c0392b; margin-bottom:6px; }
.chg-snap__row{ display:flex; gap:8px; font-size:12px; padding:2px 0; }
.chg-snap__k{ flex:0 0 90px; color:#a08b8b; }
.chg-snap__v{ flex:1; color:#6b5252; word-break:break-all; }

/* 客户详情 nav 右侧「变更记录」入口 */
.cust-detail__action{ font-size:13px; color:#2b5fd9; font-weight:600; padding:4px 10px; border:1px solid #d4e0fb; border-radius:999px; cursor:pointer; }

/* 时间线条目内的标签 */
.tag-mod{ font-size:11px; font-weight:700; color:#fff; padding:1px 8px; border-radius:999px; flex:0 0 auto; }
.tag-add{ background:#16a34a; }
.tag-edit{ background:#2b5fd9; }
.tag-delete{ background:#e23b3b; }
.tl-mod{ font-size:13px; font-weight:600; color:#5b6577; }
.tl-who{ font-size:12.5px; color:#8a93a6; margin-left:auto; }

/* 卡片 */
.tl-card{ margin-top:6px; background:#fff; border:1px solid #eef1f7; border-radius:12px; padding:10px 12px; }
.tl-title{ font-size:13.5px; color:#1f2533; font-weight:600; margin-bottom:6px; }
.tl-note{ font-size:12.5px; color:#8a93a6; }
.tl-chg__row{ display:flex; align-items:center; gap:6px; font-size:12.5px; padding:3px 0; border-top:1px dashed #f0f2f7; }
.tl-chg__row:first-child{ border-top:none; }
.tl-chg__f{ color:#8a93a6; flex:0 0 auto; min-width:56px; }
.tl-chg__b{ color:#9aa1ad; text-decoration:line-through; flex:1; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.tl-chg__ar{ color:#c2c8d2; flex:0 0 auto; }
.tl-chg__a{ color:#1f2533; font-weight:600; flex:1; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }

/* 删除快照 */
.tl-snap{ background:#fbf3f3; border:1px solid #f2d9d9; border-radius:10px; padding:8px 10px; }
.tl-snap__h{ font-size:12px; color:#c0392b; margin-bottom:4px; }
.tl-snap__row{ display:flex; gap:8px; font-size:12px; padding:2px 0; }
.tl-snap__k{ color:#8a93a6; flex:0 0 120px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.tl-snap__v{ color:#1f2533; flex:1; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }

/* ===== 消息列表（新 UI）===== */
.top-nav__cnt{ position:absolute; right:14px; top:0; height:48px; line-height:48px; font-size:12px; font-weight:400; opacity:.92; }
/* 【P110】消息页布局：头部(top-nav) + 分类 tab 固定，**只有列表区能滚动**
   （与 .quick-entry / .stat-page-wrap 同一套「固定高度 flex 列」模式；56px = 底部 tabbar） */
.msg-page{
  display:flex; flex-direction:column;
  height: calc(100vh - 56px);
  overflow:hidden;
  background:#f5f6f8;
}
/* 头部不再 sticky —— 它是 flex 头，本身就不参与滚动 */
.msg-page .top-nav{ position:static; flex:0 0 auto; }
.msg-page .msg-tabs{ flex:0 0 auto; }
/* 仅这一块滚动：PullRefresh 自身即滚动容器，下拉手势在顶部依然生效 */
.msg-page .van-pull-refresh{
  flex:1 1 auto;
  min-height:0;
  overflow-y:auto;
  -webkit-overflow-scrolling:touch;
}
/* 覆盖全局 .list-box 的 72px 底部留白（那是给整页滚动的主列表用的，这里已有独立滚动区） */
.msg-page .msg-list-box{ padding-bottom:16px; }

/* 【P109】消息卡片去掉左侧蓝条（.crm-item 全局带 4px 蓝边，消息列表里显得很脏） */
.crm-item.msg-card, .crm-item.msg-card--read{ border-left:none; border-radius:16px; }
.msg-card{ padding:14px 15px 11px; }
.msg-card--read{ box-shadow:0 2px 10px rgba(31,58,110,.05); }
/* 【P109】列表与顶部导航的间距（原来卡片顶在最上沿，太挤） */
.msg-page .msg-list-box{ padding-top:12px; }
.msg-page .list-box{ padding-left:12px; padding-right:12px; }

/* ================= 【P439】客户回收站（快捷 → 回收站） =================
   与消息列表同一套骨架：顶部导航 + 搜索条 + 单块滚动区；
   卡片沿用 .crm-item，但显式去掉左侧蓝条（新组件一律不要彩色边）。 */
.recycle-page{
  display:flex; flex-direction:column;
  height: calc(100vh - 56px);
  overflow:hidden;
  background:#f5f6f8;
}
.recycle-page .top-nav{ position:static; flex:0 0 auto; }

.recycle-search{
  flex:0 0 auto; display:flex; align-items:center; gap:8px;
  padding:10px 12px; background:#fff; border-bottom:.5px solid #ebedf0;
}
.recycle-search__box{
  flex:1 1 auto; display:flex; align-items:center; gap:6px;
  height:38px; padding:0 10px; border-radius:19px; background:#f2f3f5;
}
.recycle-search__ic{ flex:0 0 auto; font-size:15px; color:#9aa1ac; }
.recycle-search__ipt{
  flex:1 1 auto; min-width:0; height:100%; border:none; outline:none;
  background:transparent; font-size:14px; color:#1f2937;
}
.recycle-search__ipt::-webkit-search-cancel-button{ display:none; }
.recycle-search__clr{ flex:0 0 auto; padding:0 2px; font-size:12px; color:#9aa1ac; }
.recycle-search__btn{
  flex:0 0 auto; height:38px; padding:0 14px; border:none; border-radius:19px;
  background:#2b5fd9; color:#fff; font-size:13px; font-weight:600;
  -webkit-appearance:none; appearance:none; cursor:pointer;
}

/* 仅这一块滚动：PullRefresh 自身即滚动容器，下拉手势在顶部依然生效 */
.recycle-body{ flex:1 1 auto; min-height:0; overflow-y:auto; -webkit-overflow-scrolling:touch; }
.recycle-list-box{ padding:12px; }
.recycle-list-box .van-list{ padding-bottom:8px; }

/* 卡片：白底圆角，无左侧色条（与消息卡片同口径） */
.crm-item.recycle-card{ border-left:none; border-radius:16px; padding:14px 15px 12px; }
.recycle-card__title{
  font-size:15px; font-weight:700; color:#1f2937; line-height:1.35;
  overflow:hidden; text-overflow:ellipsis; white-space:nowrap;
}
.recycle-card__meta{
  display:flex; flex-wrap:wrap; gap:4px 12px; margin-top:7px;
  font-size:12px; color:#6b7280;
}
.recycle-card__meta--del{ color:#9aa1ac; }
.recycle-card__acts{ display:flex; gap:8px; margin-top:11px; }
.rc-btn{
  flex:1; height:34px; border-radius:17px; border:none;
  font-size:13px; font-weight:600; -webkit-appearance:none; appearance:none; cursor:pointer;
}
.rc-btn:disabled{ opacity:.55; cursor:not-allowed; }
.rc-btn--restore{ background:#eef3ff; color:#2b5fd9; }
.rc-btn--purge{ background:#fff5f4; color:#e54d42; }

/* 空态 */
.recycle-empty{ padding:64px 24px 24px; text-align:center; }
.recycle-empty__ic{ display:block; width:44px; height:44px; margin:0 auto; color:#c8cdd6; }
.recycle-empty__tx{ margin-top:10px; font-size:14px; font-weight:600; color:#6b7280; }
.recycle-empty__sub{ margin-top:5px; font-size:12px; color:#a3a9b4; }
/* 【P109】消息分类 tab（与全站 tab 风格一致） */
/* 【P248】消息 Tab 手机端易操作版
   改前：胶囊 + gap:8px + flex:none ⇒ 触摸区仅 ~30px，窄屏还会换行
   改后：flex:1 等宽四等分 + padding:13px 0（~46px 触摸区）+ 下划线指示当前 */
.msg-tabs{
  display:flex;
  background:#fff;
  border-bottom:.5px solid #ebedf0;
  position:sticky; top:0; z-index:6;
}
/* 【P248】手机端易操作版
   改前：胶囊 + flex:none + padding:6px 14px ⇒ 触摸区仅 ~30px，窄屏还会换行
   改后：flex:1 等宽四等分 + padding:13px 2px ⇒ 触摸区 ~46px，任何机型不换行 */
.msg-tab{
  position:relative; flex:1 1 0; min-width:0;
  padding:13px 2px 11px;
  text-align:center;
  border-bottom:2.5px solid transparent;
  -webkit-tap-highlight-color:transparent;
}
.msg-tab:active{ background:#f2f3f5; }
.msg-tab__tx{ font-size:14px; font-weight:500; color:#8b949e; white-space:nowrap; }
.msg-tab--active{ border-bottom-color:#2b5fd9; }
.msg-tab--active .msg-tab__tx{ color:#2b5fd9; font-weight:600; }
.msg-tab__cnt{
  display:inline-block; margin-left:5px; min-width:16px; height:16px; line-height:16px;
  padding:0 4px; border-radius:8px; font-size:10px; text-align:center;
  background:#ee4d3c; color:#fff; vertical-align:1px;
}
.msg-tab--active .msg-tab__cnt{ background:rgba(255,255,255,.28); }
.msg-card--read .msg-title{ color:#646a73; font-weight:600; }
.msg-card--read .msg-text{ color:#9aa1ab; }
.msg-card--read .msg-badge{ filter:grayscale(.55); opacity:.72; }
.msg-card--read .msg-go{ color:#9aa1ab; }
.msg-top{ display:flex; align-items:center; gap:9px; }
.msg-badge{ flex:none; display:inline-flex; align-items:center; gap:5px; font-size:11px; font-weight:700; letter-spacing:.2px; padding:3px 9px; border-radius:7px; background:#eef2fb; color:#2b5fd9; }
.msg-badge i{ width:5px; height:5px; border-radius:50%; background:currentColor; display:block; }
.msg-time{ margin-left:auto; flex:none; font-size:11px; color:#a3aab5; }
.msg-dot{ flex:none; width:8px; height:8px; border-radius:50%; background:#f53f3f; box-shadow:0 0 0 3px rgba(245,63,63,.13); }
/* 【P245-c】标题同样完整展示（原为单行 + ellipsis 截断） */
.msg-title{ margin-top:10px; font-size:15px; font-weight:700; color:#1d2129; line-height:1.35;
  overflow:visible !important; text-overflow:clip !important;
  white-space:normal !important; word-break:break-word; }
/* 【P245-c】消息描述**完整展示，不做缩略**：
   原 -webkit-line-clamp:2 + overflow:hidden 把长文案截成 2 行 ⇒ 就是缩略。
   ★ 关键：产物构建会把 CSS 抽取重排，本规则可能排到旧规则**前面**，
     导致旧的 line-clamp:2 反而生效（实测浏览器算出 line-clamp=2）。
     所以这里全部加 !important 兜底，不依赖先后顺序。 */
.msg-text{ margin-top:5px; font-size:12.5px; line-height:1.62; color:#5c636e;
  display:block !important;
  -webkit-line-clamp:none !important;
  line-clamp:none !important;
  -webkit-box-orient:horizontal !important;
  overflow:visible !important;
  height:auto !important; max-height:none !important;
  white-space:pre-wrap !important;
  word-break:break-word !important; }
/* 【P245-c】Tab 红色气泡角标 */
/* 【P247】消息批量操作条 */
.msg-batch{ display:flex; align-items:center; gap:10px; margin:10px 12px; padding:9px 11px;
  background:#eef1f5; border-radius:9px; }
.msg-batch__all{ display:inline-flex; align-items:center; gap:6px; font-size:13px; color:#1f2328; }
.msg-batch__all input, .msg-card__pick input{ width:16px; height:16px; accent-color:#2b5fd9; }
.msg-batch__n{ font-size:12px; color:#5b636b; margin-left:auto; }
.msg-batch__n b{ color:#1f2328; }
.msg-batch__btn{ flex:0 0 auto; padding:7px 15px; border:none; border-radius:7px;
  background:#2b5fd9; color:#fff; font-size:12.5px; }
.msg-batch__btn:disabled{ background:#c9cdd4; }
.msg-card__pick{ display:flex; align-items:flex-start; padding-top:2px; }

/* 【P248】红色气泡：绝对定位到文字右上角，不再与文字串行混排 */
.msg-tab__dot{
  position:absolute; top:7px; left:calc(50% + 20px);
  min-width:17px; height:17px; padding:0 5px;
  border-radius:9px; background:#d93026; color:#fff;
  font-size:10.5px; line-height:17px; text-align:center;
  font-style:normal; box-sizing:border-box;
}
.msg-chips{ display:flex; flex-wrap:wrap; gap:6px; margin-top:9px; }
.msg-chip{ font-size:11px; line-height:1; padding:4px 8px; border-radius:6px; background:#f4f6fa; color:#5c636e; white-space:nowrap; }
.msg-chip.key{ background:#eef2fb; color:#2b5fd9; font-weight:600; }
.msg-foot{ display:flex; align-items:center; gap:8px; margin-top:11px; padding-top:10px; border-top:1px solid #f2f4f8; }
.msg-foot__sp{ flex:1; }
.msg-go{ display:inline-flex; align-items:center; gap:3px; font-size:12px; font-weight:600; color:#2b5fd9; }
/* 消息详情弹层 */
.msg-detail{ padding:18px 18px 16px; }
.msg-detail__hd{ display:flex; align-items:center; gap:9px; }
.msg-detail__time{ margin-left:auto; font-size:11px; color:#a3aab5; }
.msg-detail__close{ font-size:16px; color:#969799; margin-left:10px; }
.msg-detail__title{ margin-top:14px; font-size:17px; font-weight:700; color:#1d2129; line-height:1.4; }
.msg-detail__body{ margin-top:10px; font-size:13.5px; line-height:1.75; color:#3f4652; word-break:break-all; max-height:40vh; overflow-y:auto; }
.msg-detail__ft{ display:flex; gap:12px; margin-top:18px; }

  /* 【P95】三.3.05 详情卡片里的回款计划多行展示 */
  .detail-plan{ display:inline-block; margin-bottom:2px; }
</style>





// WEBPACK FOOTER //
// src/pages/client.vue